/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	Query:{
		getContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHomePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHomePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHomePage:{
			data:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMediumGallery:{
			by:{
				type:"MediumGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMediumGallery:{
			filter:{
				type:"MediumGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumGalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMediumGallery:{
			filter:{
				type:"MediumGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumGalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMediumGallery:{
			data:{
				type:"MediumGalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMediumGallery:{
			by:{
				type:"MediumGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MediumGalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMediumGalleryItem:{
			by:{
				type:"MediumGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMediumGalleryItem:{
			filter:{
				type:"MediumGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumGalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMediumGalleryItem:{
			filter:{
				type:"MediumGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumGalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMediumGalleryItem:{
			data:{
				type:"MediumGalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMediumGalleryItem:{
			by:{
				type:"MediumGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MediumGalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMember:{
			by:{
				type:"MemberUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMember:{
			filter:{
				type:"MemberWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MemberOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMember:{
			filter:{
				type:"MemberWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MemberOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMember:{
			data:{
				type:"MemberCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMember:{
			by:{
				type:"MemberUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MemberUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMemberItem:{
			by:{
				type:"MemberItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMemberItem:{
			filter:{
				type:"MemberItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MemberItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMemberItem:{
			filter:{
				type:"MemberItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MemberItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMemberItem:{
			data:{
				type:"MemberItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMemberItem:{
			by:{
				type:"MemberItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MemberItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMemberList:{
			by:{
				type:"MemberListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMemberList:{
			filter:{
				type:"MemberListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MemberListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMemberList:{
			filter:{
				type:"MemberListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MemberListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMemberList:{
			data:{
				type:"MemberListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMemberList:{
			by:{
				type:"MemberListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MemberListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getShow:{
			by:{
				type:"ShowUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listShow:{
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShow:{
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateShow:{
			data:{
				type:"ShowCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateShow:{
			by:{
				type:"ShowUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ShowUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getShowList:{
			by:{
				type:"ShowListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listShowList:{
			filter:{
				type:"ShowListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShowList:{
			filter:{
				type:"ShowListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateShowList:{
			data:{
				type:"ShowListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateShowList:{
			by:{
				type:"ShowListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ShowListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getShowYear:{
			by:{
				type:"ShowYearUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listShowYear:{
			filter:{
				type:"ShowYearWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowYearOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShowYear:{
			filter:{
				type:"ShowYearWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowYearOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateShowYear:{
			data:{
				type:"ShowYearCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateShowYear:{
			by:{
				type:"ShowYearUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ShowYearUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getShowYearItem:{
			by:{
				type:"ShowYearItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listShowYearItem:{
			filter:{
				type:"ShowYearItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowYearItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShowYearItem:{
			filter:{
				type:"ShowYearItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowYearItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateShowYearItem:{
			data:{
				type:"ShowYearItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateShowYearItem:{
			by:{
				type:"ShowYearItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ShowYearItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getShowYearList:{
			by:{
				type:"ShowYearListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listShowYearList:{
			filter:{
				type:"ShowYearListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowYearListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShowYearList:{
			filter:{
				type:"ShowYearListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowYearListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateShowYearList:{
			data:{
				type:"ShowYearListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateShowYearList:{
			by:{
				type:"ShowYearListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ShowYearListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLink:{
			data:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLinkItem:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLinkItem:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLinkItem:{
			data:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLinkList:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLinkList:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLinkList:{
			data:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listVideo:{
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"VideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateVideo:{
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"VideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateVideo:{
			data:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listYoutubeVideo:{
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateYoutubeVideo:{
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateYoutubeVideo:{
			data:{
				type:"YoutubeVideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"YoutubeVideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterAddress:{
			by:{
				type:"FooterAddressUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterAddressWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterAddress:{
			filter:{
				type:"FooterAddressWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterAddressOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterAddress:{
			filter:{
				type:"FooterAddressWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterAddressOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterAddress:{
			data:{
				type:"FooterAddressCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterAddress:{
			by:{
				type:"FooterAddressUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterAddressUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPortfolioPage:{
			by:{
				type:"PortfolioPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PortfolioPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPortfolioPage:{
			filter:{
				type:"PortfolioPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PortfolioPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePortfolioPage:{
			filter:{
				type:"PortfolioPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PortfolioPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePortfolioPage:{
			data:{
				type:"PortfolioPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePortfolioPage:{
			by:{
				type:"PortfolioPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PortfolioPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getShowItem:{
			by:{
				type:"ShowItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listShowItem:{
			filter:{
				type:"ShowItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShowItem:{
			filter:{
				type:"ShowItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateShowItem:{
			data:{
				type:"ShowItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateShowItem:{
			by:{
				type:"ShowItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ShowItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSettings:{
			by:{
				type:"SettingsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SettingsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSettings:{
			filter:{
				type:"SettingsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SettingsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSettings:{
			filter:{
				type:"SettingsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SettingsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSettings:{
			data:{
				type:"SettingsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSettings:{
			by:{
				type:"SettingsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SettingsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterGeneralContact:{
			by:{
				type:"FooterGeneralContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterGeneralContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterGeneralContact:{
			filter:{
				type:"FooterGeneralContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterGeneralContactOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterGeneralContact:{
			filter:{
				type:"FooterGeneralContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterGeneralContactOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterGeneralContact:{
			data:{
				type:"FooterGeneralContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterGeneralContact:{
			by:{
				type:"FooterGeneralContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterGeneralContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	ContentBlock:{
		homePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		gallery:{
			filter:{
				type:"MediumGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		video:{
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		members:{
			filter:{
				type:"MemberListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		portfolio:{
			filter:{
				type:"ShowYearListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	UUID: "String",
	ContentBlockType: "enum",
	HomePage:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		blocks:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		blocksByGallery:{
			by:{
				type:"HomePageBlocksByGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		blocksByLink:{
			by:{
				type:"HomePageBlocksByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		blocksByMembers:{
			by:{
				type:"HomePageBlocksByMembersUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBlocks:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Linkable:{
		homePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		portfolioPage:{
			filter:{
				type:"PortfolioPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		showPage:{
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		redirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HomePageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HomePageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HomePageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HomePageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UUIDCondition:{
		and:{
			type:"UUIDCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"UUIDCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"UUID",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"UUID",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StringCondition:{
		and:{
			type:"StringCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"StringCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"String",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"String",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contains:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsWith:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsWith:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		containsCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsWithCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsWithCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		portfolioPage:{
			type:"PortfolioPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		showPage:{
			type:"ShowWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"RedirectWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkableWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkableWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PortfolioPageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"PortfolioPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"PortfolioPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"PortfolioPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		noIndex:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		noFollow:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ImageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ImageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IntCondition:{
		and:{
			type:"IntCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"IntCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Int",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Int",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BooleanCondition:{
		and:{
			type:"BooleanCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"BooleanCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Boolean",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Boolean",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OneCondition:{
		and:{
			type:"OneCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"OneCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"One",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"One",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	One: "enum",
	ShowWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterType:{
			type:"ShowPosterTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		showItem:{
			type:"ShowItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterSizeType:{
			type:"ShowPosterSizeTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		categoryYear:{
			type:"ShowYearWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		production:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		directors:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		starrings:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"MediumGalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		synopsis:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ShowWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ShowWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ShowWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowPosterTypeCondition:{
		and:{
			type:"ShowPosterTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ShowPosterTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ShowPosterTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ShowPosterType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ShowPosterType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ShowPosterType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ShowPosterType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ShowPosterType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ShowPosterType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ShowPosterType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ShowPosterType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowPosterType: "enum",
	ShowItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ShowListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		show:{
			type:"ShowWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ShowItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ShowItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ShowItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ShowItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ShowListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ShowListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ShowListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowPosterSizeTypeCondition:{
		and:{
			type:"ShowPosterSizeTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ShowPosterSizeTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ShowPosterSizeTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ShowPosterSizeType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ShowPosterSizeType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ShowPosterSizeType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ShowPosterSizeType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ShowPosterSizeType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ShowPosterSizeType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ShowPosterSizeType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ShowPosterSizeType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowPosterSizeType: "enum",
	ShowYearWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		showList:{
			type:"ShowWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ShowYearWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ShowYearWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ShowYearWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"MediumGalleryItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"MediumGalleryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"MediumGalleryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"MediumGalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"MediumTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"MediumGalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"VideoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"MediumGalleryItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"MediumGalleryItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"MediumGalleryItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumTypeCondition:{
		and:{
			type:"MediumTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"MediumTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"MediumTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"MediumType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"MediumType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumType: "enum",
	VideoWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		src:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		duration:{
			type:"FloatCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"VideoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"VideoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"VideoWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FloatCondition:{
		and:{
			type:"FloatCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"FloatCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"FloatCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Float",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Float",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"RedirectWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"RedirectWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"RedirectWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentBlockTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"MediumGalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"VideoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		members:{
			type:"MemberListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		portfolio:{
			type:"ShowYearListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentBlockWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentBlockWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockTypeCondition:{
		and:{
			type:"ContentBlockTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ContentBlockTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ContentBlockTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ContentBlockType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ContentBlockType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"LinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkTypeCondition:{
		and:{
			type:"LinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"LinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"LinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"LinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"LinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkType: "enum",
	MemberListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"MemberItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"MemberListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"MemberListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"MemberListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"MemberListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		member:{
			type:"MemberWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"MemberItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"MemberItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"MemberItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		firstName:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		lastName:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		telephone:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"MemberWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"MemberWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"MemberWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ShowYearItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ShowYearListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ShowYearListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ShowYearListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ShowYearListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		showYear:{
			type:"ShowYearWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ShowYearItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ShowYearItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ShowYearItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PortfolioPage:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Seo:{
		ogImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Show:{
		poster:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		showItem:{
			filter:{
				type:"ShowItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		categoryYear:{
			filter:{
				type:"ShowYearWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		gallery:{
			filter:{
				type:"MediumGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShowItem:{
			filter:{
				type:"ShowItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ShowItem:{
		list:{
			filter:{
				type:"ShowListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		show:{
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ShowList:{
		items:{
			filter:{
				type:"ShowItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"ShowItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ShowItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ShowListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		show:{
			type:"ShowOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OrderDirection: "enum",
	ShowListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterType:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterSizeType:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		categoryYear:{
			type:"ShowYearOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		production:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		directors:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		starrings:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"MediumGalleryOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		synopsis:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		noIndex:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		noFollow:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		portfolioPage:{
			type:"PortfolioPageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		showPage:{
			type:"ShowOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"RedirectOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PortfolioPageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYear:{
		showList:{
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		showListByShowItem:{
			by:{
				type:"ShowYearShowListByShowItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		showListByGallery:{
			by:{
				type:"ShowYearShowListByGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		showListBySeo:{
			by:{
				type:"ShowYearShowListBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		showListByLink:{
			by:{
				type:"ShowYearShowListByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShowList:{
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ShowYearShowListByShowItemUniqueWhere:{
		showItem:{
			type:"ShowItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearShowListByGalleryUniqueWhere:{
		gallery:{
			type:"MediumGalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"MediumGalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearShowListBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearShowListByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		portfolioPage:{
			type:"PortfolioPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		showPage:{
			type:"ShowUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"RedirectUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"MediumGalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		members:{
			type:"MemberListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"MemberItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PortfolioPageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		showItem:{
			type:"ShowItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"MediumGalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGallery:{
		items:{
			filter:{
				type:"MediumGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumGalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"MediumGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumGalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	MediumGalleryItem:{
		gallery:{
			filter:{
				type:"MediumGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		video:{
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Video:{
		poster:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	MediumGalleryItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"MediumGalleryOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"VideoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		src:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		duration:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Redirect:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		target:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentBlockOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"MediumGalleryOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"VideoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		members:{
			type:"MemberListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		portfolio:{
			type:"ShowYearListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageBlocksByGalleryUniqueWhere:{
		gallery:{
			type:"MediumGalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageBlocksByLinkUniqueWhere:{
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageBlocksByMembersUniqueWhere:{
		members:{
			type:"MemberListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Link:{
		internalLink:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	MemberList:{
		items:{
			filter:{
				type:"MemberItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MemberItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"MemberItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MemberItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	MemberItem:{
		list:{
			filter:{
				type:"MemberListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		member:{
			filter:{
				type:"MemberWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Member:{
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	MemberItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"MemberListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		member:{
			type:"MemberOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		firstName:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		lastName:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		telephone:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearList:{
		items:{
			filter:{
				type:"ShowYearItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowYearItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"ShowYearItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowYearItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ShowYearItem:{
		list:{
			filter:{
				type:"ShowYearListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		showYear:{
			filter:{
				type:"ShowYearWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ShowYearItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ShowYearListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		showYear:{
			type:"ShowYearOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"ContentBlockCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ContentBlockCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"ContentBlockCreateVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentBlockCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		members:{
			type:"ContentBlockCreateMembersEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		portfolio:{
			type:"ContentBlockCreatePortfolioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateHomePageEntityRelationInput:{
		connect:{
			type:"HomePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageWithoutBlocksCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HomePageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutHomePageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		portfolioPage:{
			type:"LinkableCreatePortfolioPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showPage:{
			type:"LinkableCreateShowPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreatePortfolioPageEntityRelationInput:{
		connect:{
			type:"PortfolioPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PortfolioPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PortfolioPageWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PortfolioPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PortfolioPageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoCreateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		noIndex:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		noFollow:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreateOgImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateShowPageEntityRelationInput:{
		connect:{
			type:"ShowUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterType:{
			type:"ShowPosterType",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"ShowCreatePosterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showItem:{
			type:"ShowCreateShowItemEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		posterSizeType:{
			type:"ShowPosterSizeType",
			array:false,
			arrayRequired:false,
			required:false
		},
		categoryYear:{
			type:"ShowCreateCategoryYearEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		production:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		directors:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		starrings:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ShowCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ShowCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		synopsis:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowCreatePosterEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowCreateShowItemEntityRelationInput:{
		connect:{
			type:"ShowItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowItemWithoutShowCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowItemWithoutShowCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ShowItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowItemCreateListEntityRelationInput:{
		connect:{
			type:"ShowListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ShowItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowCreateCategoryYearEntityRelationInput:{
		connect:{
			type:"ShowYearUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowYearWithoutShowListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		showList:{
			type:"ShowUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearWithoutShowListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowCreateGalleryEntityRelationInput:{
		connect:{
			type:"MediumGalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumGalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"MediumGalleryCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryCreateItemsEntityRelationInput:{
		connect:{
			type:"MediumGalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumGalleryItemWithoutGalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryItemWithoutGalleryCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"MediumGalleryItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"MediumGalleryItemCreateVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryItemCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryItemCreateVideoEntityRelationInput:{
		connect:{
			type:"VideoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"VideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		src:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		duration:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"VideoCreatePosterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoCreatePosterEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateRedirectEntityRelationInput:{
		connect:{
			type:"RedirectUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RedirectWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectCreateTargetEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		portfolioPage:{
			type:"LinkableCreatePortfolioPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showPage:{
			type:"LinkableCreateShowPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateHomePageEntityRelationInput:{
		connect:{
			type:"HomePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"HomePageCreateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateBlocksEntityRelationInput:{
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutHomePageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ContentBlockCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"ContentBlockCreateVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentBlockCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		members:{
			type:"ContentBlockCreateMembersEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		portfolio:{
			type:"ContentBlockCreatePortfolioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateGalleryEntityRelationInput:{
		connect:{
			type:"MediumGalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumGalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateVideoEntityRelationInput:{
		connect:{
			type:"VideoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"VideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkCreateInternalLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkCreateInternalLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateMembersEntityRelationInput:{
		connect:{
			type:"MemberListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MemberListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"MemberListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberListCreateItemsEntityRelationInput:{
		connect:{
			type:"MemberItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MemberItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		member:{
			type:"MemberItemCreateMemberEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberItemCreateMemberEntityRelationInput:{
		connect:{
			type:"MemberUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MemberCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		firstName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lastName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		telephone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"MemberCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreatePortfolioEntityRelationInput:{
		connect:{
			type:"ShowYearListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowYearListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ShowYearItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ShowYearListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearListCreateItemsEntityRelationInput:{
		connect:{
			type:"ShowYearItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowYearItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		showYear:{
			type:"ShowYearItemCreateShowYearEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearItemCreateShowYearEntityRelationInput:{
		connect:{
			type:"ShowYearUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowYearCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		showList:{
			type:"ShowYearCreateShowListEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearCreateShowListEntityRelationInput:{
		connect:{
			type:"ShowUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowWithoutCategoryYearCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowWithoutCategoryYearCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterType:{
			type:"ShowPosterType",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"ShowCreatePosterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showItem:{
			type:"ShowCreateShowItemEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		posterSizeType:{
			type:"ShowPosterSizeType",
			array:false,
			arrayRequired:false,
			required:false
		},
		production:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		directors:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		starrings:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ShowCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ShowCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ShowCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		synopsis:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutShowPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutShowPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		portfolioPage:{
			type:"LinkableCreatePortfolioPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"ContentBlockUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ContentBlockUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"ContentBlockUpdateVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentBlockUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		members:{
			type:"ContentBlockUpdateMembersEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		portfolio:{
			type:"ContentBlockUpdatePortfolioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateHomePageEntityRelationInput:{
		create:{
			type:"HomePageWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HomePageWithoutBlocksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertHomePageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HomePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageWithoutBlocksUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HomePageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutHomePageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutHomePageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		portfolioPage:{
			type:"LinkableUpdatePortfolioPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showPage:{
			type:"LinkableUpdateShowPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdatePortfolioPageEntityRelationInput:{
		create:{
			type:"PortfolioPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PortfolioPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertPortfolioPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PortfolioPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PortfolioPageWithoutLinkUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PortfolioPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PortfolioPageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PortfolioPageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateInput:{
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoUpdateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		noIndex:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		noFollow:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateOgImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SeoUpsertOgImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpsertOgImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PortfolioPageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertPortfolioPageRelationInput:{
		update:{
			type:"PortfolioPageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PortfolioPageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateShowPageEntityRelationInput:{
		create:{
			type:"ShowWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShowWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertShowPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ShowUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowWithoutLinkUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterType:{
			type:"ShowPosterType",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"ShowUpdatePosterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showItem:{
			type:"ShowUpdateShowItemEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		posterSizeType:{
			type:"ShowPosterSizeType",
			array:false,
			arrayRequired:false,
			required:false
		},
		categoryYear:{
			type:"ShowUpdateCategoryYearEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		production:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		directors:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		starrings:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ShowUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ShowUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		synopsis:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowUpdatePosterEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ShowUpsertPosterRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowUpsertPosterRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowUpdateShowItemEntityRelationInput:{
		create:{
			type:"ShowItemWithoutShowCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShowUpdateShowItemRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ShowUpsertShowItemRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ShowItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ShowItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ShowItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowUpdateShowItemRelationInput:{
		by:{
			type:"ShowItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ShowItemWithoutShowUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowItemWithoutShowUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ShowItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowItemUpdateListEntityRelationInput:{
		create:{
			type:"ShowListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShowListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ShowItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ShowListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowItemUpsertListRelationInput:{
		update:{
			type:"ShowListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowUpsertShowItemRelationInput:{
		by:{
			type:"ShowItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShowItemWithoutShowUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowItemWithoutShowCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowUpdateCategoryYearEntityRelationInput:{
		create:{
			type:"ShowYearWithoutShowListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShowYearWithoutShowListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ShowUpsertCategoryYearRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ShowYearUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearWithoutShowListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowUpsertCategoryYearRelationInput:{
		update:{
			type:"ShowYearWithoutShowListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowYearWithoutShowListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowUpdateGalleryEntityRelationInput:{
		create:{
			type:"MediumGalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MediumGalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ShowUpsertGalleryRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MediumGalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryUpdateInput:{
		items:{
			type:"MediumGalleryUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryUpdateItemsEntityRelationInput:{
		create:{
			type:"MediumGalleryItemWithoutGalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MediumGalleryUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MediumGalleryUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MediumGalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"MediumGalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"MediumGalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryUpdateItemsRelationInput:{
		by:{
			type:"MediumGalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"MediumGalleryItemWithoutGalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryItemWithoutGalleryUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"MediumGalleryItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"MediumGalleryItemUpdateVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryItemUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MediumGalleryItemUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryItemUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryItemUpdateVideoEntityRelationInput:{
		create:{
			type:"VideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"VideoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MediumGalleryItemUpsertVideoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"VideoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoUpdateInput:{
		src:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		duration:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"VideoUpdatePosterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoUpdatePosterEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"VideoUpsertPosterRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoUpsertPosterRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryItemUpsertVideoRelationInput:{
		update:{
			type:"VideoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"VideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryUpsertItemsRelationInput:{
		by:{
			type:"MediumGalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MediumGalleryItemWithoutGalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumGalleryItemWithoutGalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowUpsertGalleryRelationInput:{
		update:{
			type:"MediumGalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumGalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ShowUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertShowPageRelationInput:{
		update:{
			type:"ShowWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateRedirectEntityRelationInput:{
		create:{
			type:"RedirectWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RedirectWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertRedirectRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RedirectUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectWithoutLinkUpdateInput:{
		target:{
			type:"RedirectUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpdateTargetEntityRelationInput:{
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RedirectUpsertTargetRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		portfolioPage:{
			type:"LinkableUpdatePortfolioPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showPage:{
			type:"LinkableUpdateShowPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateHomePageEntityRelationInput:{
		create:{
			type:"HomePageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HomePageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertHomePageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HomePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageWithoutLinkUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"HomePageUpdateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateBlocksEntityRelationInput:{
		create:{
			type:"ContentBlockWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HomePageUpdateBlocksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageUpsertBlocksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateBlocksRelationInput:{
		by:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentBlockWithoutHomePageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutHomePageUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentBlockType",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ContentBlockUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"ContentBlockUpdateVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentBlockUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		members:{
			type:"ContentBlockUpdateMembersEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		portfolio:{
			type:"ContentBlockUpdatePortfolioEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateGalleryEntityRelationInput:{
		create:{
			type:"MediumGalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MediumGalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertGalleryRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MediumGalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertGalleryRelationInput:{
		update:{
			type:"MediumGalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumGalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateVideoEntityRelationInput:{
		create:{
			type:"VideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"VideoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertVideoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"VideoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertVideoRelationInput:{
		update:{
			type:"VideoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"VideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpdateInput:{
		type:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkUpdateInternalLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpdateInternalLinkEntityRelationInput:{
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkUpsertInternalLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpsertInternalLinkRelationInput:{
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateMembersEntityRelationInput:{
		create:{
			type:"MemberListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MemberListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertMembersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MemberListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberListUpdateInput:{
		items:{
			type:"MemberListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberListUpdateItemsEntityRelationInput:{
		create:{
			type:"MemberItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MemberListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MemberListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MemberItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"MemberItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"MemberItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberListUpdateItemsRelationInput:{
		by:{
			type:"MemberItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"MemberItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		member:{
			type:"MemberItemUpdateMemberEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberItemUpdateMemberEntityRelationInput:{
		create:{
			type:"MemberCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MemberUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MemberItemUpsertMemberRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MemberUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberUpdateInput:{
		firstName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lastName:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		telephone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"MemberUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MemberUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberItemUpsertMemberRelationInput:{
		update:{
			type:"MemberUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MemberCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberListUpsertItemsRelationInput:{
		by:{
			type:"MemberItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MemberItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MemberItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertMembersRelationInput:{
		update:{
			type:"MemberListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MemberListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdatePortfolioEntityRelationInput:{
		create:{
			type:"ShowYearListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShowYearListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertPortfolioRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ShowYearListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearListUpdateInput:{
		items:{
			type:"ShowYearListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearListUpdateItemsEntityRelationInput:{
		create:{
			type:"ShowYearItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShowYearListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ShowYearListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ShowYearItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ShowYearItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ShowYearItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearListUpdateItemsRelationInput:{
		by:{
			type:"ShowYearItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ShowYearItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		showYear:{
			type:"ShowYearItemUpdateShowYearEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearItemUpdateShowYearEntityRelationInput:{
		create:{
			type:"ShowYearCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShowYearUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ShowYearItemUpsertShowYearRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ShowYearUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		showList:{
			type:"ShowYearUpdateShowListEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearUpdateShowListEntityRelationInput:{
		create:{
			type:"ShowWithoutCategoryYearCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShowYearUpdateShowListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ShowYearUpsertShowListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ShowUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ShowUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ShowUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearUpdateShowListRelationInput:{
		by:{
			type:"ShowUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ShowWithoutCategoryYearUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowWithoutCategoryYearUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterType:{
			type:"ShowPosterType",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"ShowUpdatePosterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showItem:{
			type:"ShowUpdateShowItemEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		posterSizeType:{
			type:"ShowPosterSizeType",
			array:false,
			arrayRequired:false,
			required:false
		},
		production:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		directors:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		starrings:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ShowUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ShowUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ShowUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		synopsis:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutShowPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutShowPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ShowUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutShowPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		portfolioPage:{
			type:"LinkableUpdatePortfolioPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutShowPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutShowPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearUpsertShowListRelationInput:{
		by:{
			type:"ShowUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShowWithoutCategoryYearUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowWithoutCategoryYearCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearItemUpsertShowYearRelationInput:{
		update:{
			type:"ShowYearUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowYearCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearListUpsertItemsRelationInput:{
		by:{
			type:"ShowYearItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShowYearItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowYearItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertPortfolioRelationInput:{
		update:{
			type:"ShowYearListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowYearListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpsertBlocksRelationInput:{
		by:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockWithoutHomePageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertHomePageRelationInput:{
		update:{
			type:"HomePageWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpsertTargetRelationInput:{
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertRedirectRelationInput:{
		update:{
			type:"RedirectWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RedirectWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutHomePageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertHomePageRelationInput:{
		update:{
			type:"HomePageWithoutBlocksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HomePageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"HomePageCreateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HomePageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"HomePageUpdateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"MediumGalleryItemCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"MediumGalleryItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"MediumGalleryItemCreateVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryItemCreateGalleryEntityRelationInput:{
		connect:{
			type:"MediumGalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumGalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"MediumGalleryItemUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"MediumGalleryItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"MediumGalleryItemUpdateVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryItemUpdateGalleryEntityRelationInput:{
		create:{
			type:"MediumGalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MediumGalleryWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MediumGalleryItemUpsertGalleryRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MediumGalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumGalleryItemUpsertGalleryRelationInput:{
		update:{
			type:"MediumGalleryWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumGalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"MemberItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		member:{
			type:"MemberItemCreateMemberEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberItemCreateListEntityRelationInput:{
		connect:{
			type:"MemberListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MemberListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"MemberItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		member:{
			type:"MemberItemUpdateMemberEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberItemUpdateListEntityRelationInput:{
		create:{
			type:"MemberListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MemberListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MemberItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MemberListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MemberItemUpsertListRelationInput:{
		update:{
			type:"MemberListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MemberListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterType:{
			type:"ShowPosterType",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"ShowCreatePosterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showItem:{
			type:"ShowCreateShowItemEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		posterSizeType:{
			type:"ShowPosterSizeType",
			array:false,
			arrayRequired:false,
			required:false
		},
		categoryYear:{
			type:"ShowCreateCategoryYearEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		production:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		directors:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		starrings:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ShowCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ShowCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ShowCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		synopsis:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterType:{
			type:"ShowPosterType",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"ShowUpdatePosterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showItem:{
			type:"ShowUpdateShowItemEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		posterSizeType:{
			type:"ShowPosterSizeType",
			array:false,
			arrayRequired:false,
			required:false
		},
		categoryYear:{
			type:"ShowUpdateCategoryYearEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		production:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		directors:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		starrings:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ShowUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ShowUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ShowUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		synopsis:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ShowListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowListCreateItemsEntityRelationInput:{
		connect:{
			type:"ShowItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		show:{
			type:"ShowItemCreateShowEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowItemCreateShowEntityRelationInput:{
		connect:{
			type:"ShowUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowWithoutShowItemCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowWithoutShowItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterType:{
			type:"ShowPosterType",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"ShowCreatePosterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterSizeType:{
			type:"ShowPosterSizeType",
			array:false,
			arrayRequired:false,
			required:false
		},
		categoryYear:{
			type:"ShowCreateCategoryYearEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		production:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		directors:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		starrings:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ShowCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ShowCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ShowCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		synopsis:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowListUpdateInput:{
		items:{
			type:"ShowListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowListUpdateItemsEntityRelationInput:{
		create:{
			type:"ShowItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShowListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ShowListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ShowItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ShowItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ShowItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowListUpdateItemsRelationInput:{
		by:{
			type:"ShowItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ShowItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		show:{
			type:"ShowItemUpdateShowEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowItemUpdateShowEntityRelationInput:{
		create:{
			type:"ShowWithoutShowItemCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShowWithoutShowItemUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ShowItemUpsertShowRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ShowUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowWithoutShowItemUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterType:{
			type:"ShowPosterType",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"ShowUpdatePosterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		posterSizeType:{
			type:"ShowPosterSizeType",
			array:false,
			arrayRequired:false,
			required:false
		},
		categoryYear:{
			type:"ShowUpdateCategoryYearEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		production:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		directors:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		starrings:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ShowUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ShowUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ShowUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		synopsis:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowItemUpsertShowRelationInput:{
		update:{
			type:"ShowWithoutShowItemUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowWithoutShowItemCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowListUpsertItemsRelationInput:{
		by:{
			type:"ShowItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShowItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ShowYearItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showYear:{
			type:"ShowYearItemCreateShowYearEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearItemCreateListEntityRelationInput:{
		connect:{
			type:"ShowYearListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowYearListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ShowYearItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showYear:{
			type:"ShowYearItemUpdateShowYearEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearItemUpdateListEntityRelationInput:{
		create:{
			type:"ShowYearListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ShowYearListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ShowYearItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ShowYearListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowYearItemUpsertListRelationInput:{
		update:{
			type:"ShowYearListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ShowYearListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLink:{
		icon:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SocialLinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SocialLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SocialLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SocialLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"SocialLinkCreateIconEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SocialLinkCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkCreateIconEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		icon:{
			type:"SocialLinkUpdateIconEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"SocialLinkUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkUpdateIconEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SocialLinkUpsertIconRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkUpsertIconRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SocialLinkUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItem:{
		list:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		socialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SocialLinkList:{
		items:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SocialLinkItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"SocialLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SocialLinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SocialLinkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SocialLinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"SocialLinkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SocialLinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SocialLinkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SocialLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"SocialLinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"SocialLinkItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkItemCreateSocialLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemCreateListEntityRelationInput:{
		connect:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemCreateSocialLinkEntityRelationInput:{
		connect:{
			type:"SocialLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"SocialLinkItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkItemUpdateSocialLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUpdateListEntityRelationInput:{
		create:{
			type:"SocialLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialLinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SocialLinkItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUpsertListRelationInput:{
		update:{
			type:"SocialLinkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUpdateSocialLinkEntityRelationInput:{
		create:{
			type:"SocialLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SocialLinkItemUpsertSocialLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SocialLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemUpsertSocialLinkRelationInput:{
		update:{
			type:"SocialLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"SocialLinkListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListCreateItemsEntityRelationInput:{
		connect:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkItemCreateSocialLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListUpdateInput:{
		items:{
			type:"SocialLinkListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListUpdateItemsEntityRelationInput:{
		create:{
			type:"SocialLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialLinkListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SocialLinkListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListUpdateItemsRelationInput:{
		by:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"SocialLinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLink:{
			type:"SocialLinkItemUpdateSocialLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SocialLinkListUpsertItemsRelationInput:{
		by:{
			type:"SocialLinkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialLinkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		videoId:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"YoutubeVideoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"YoutubeVideoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"YoutubeVideoWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		videoId:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		videoId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	YoutubeVideoUpdateInput:{
		videoId:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Header:{
		logo:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		socialLinks:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HeaderUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"SocialLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HeaderWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HeaderWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HeaderWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"SocialLinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HeaderCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"HeaderCreateSocialLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateLogoEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateSocialLinksEntityRelationInput:{
		connect:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateInput:{
		logo:{
			type:"HeaderUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"HeaderUpdateSocialLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateLogoEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderUpsertLogoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpsertLogoRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateSocialLinksEntityRelationInput:{
		create:{
			type:"SocialLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialLinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderUpsertSocialLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpsertSocialLinksRelationInput:{
		update:{
			type:"SocialLinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Footer:{
		address:{
			filter:{
				type:"FooterAddressWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		members:{
			filter:{
				type:"MemberListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		logo:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		socialLinks:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		generalContact:{
			filter:{
				type:"FooterGeneralContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FooterAddress:{
		addressLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FooterAddressWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		addressLink:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FooterAddressWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FooterAddressWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FooterAddressWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterGeneralContactWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		info:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FooterGeneralContactWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FooterGeneralContactWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FooterGeneralContactWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		members:{
			type:"MemberListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		info:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"FooterAddressWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		members:{
			type:"MemberListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"SocialLinkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		generalContact:{
			type:"FooterGeneralContactWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FooterWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FooterWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FooterWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		info:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"FooterAddressOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		members:{
			type:"MemberListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"SocialLinkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		generalContact:{
			type:"FooterGeneralContactOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterAddressOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		addressLink:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterGeneralContactOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		info:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		info:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"FooterCreateAddressEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		members:{
			type:"FooterCreateMembersEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"FooterCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"FooterCreateSocialLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		generalContact:{
			type:"FooterCreateGeneralContactEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateAddressEntityRelationInput:{
		connect:{
			type:"FooterAddressUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterAddressCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterAddressUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		addressLink:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterAddressCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		addressLink:{
			type:"FooterAddressCreateAddressLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterAddressCreateAddressLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateMembersEntityRelationInput:{
		connect:{
			type:"MemberListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MemberListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateLogoEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateSocialLinksEntityRelationInput:{
		connect:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateGeneralContactEntityRelationInput:{
		connect:{
			type:"FooterGeneralContactUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterGeneralContactCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterGeneralContactUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterGeneralContactCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		info:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		info:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"FooterUpdateAddressEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		members:{
			type:"FooterUpdateMembersEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"FooterUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialLinks:{
			type:"FooterUpdateSocialLinksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		generalContact:{
			type:"FooterUpdateGeneralContactEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateAddressEntityRelationInput:{
		create:{
			type:"FooterAddressCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterAddressUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertAddressRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FooterAddressUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterAddressUpdateInput:{
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		addressLink:{
			type:"FooterAddressUpdateAddressLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterAddressUpdateAddressLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterAddressUpsertAddressLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterAddressUpsertAddressLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertAddressRelationInput:{
		update:{
			type:"FooterAddressUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterAddressCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateMembersEntityRelationInput:{
		create:{
			type:"MemberListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MemberListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertMembersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MemberListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertMembersRelationInput:{
		update:{
			type:"MemberListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MemberListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateLogoEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertLogoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertLogoRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateSocialLinksEntityRelationInput:{
		create:{
			type:"SocialLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SocialLinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertSocialLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SocialLinkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertSocialLinksRelationInput:{
		update:{
			type:"SocialLinkListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SocialLinkListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateGeneralContactEntityRelationInput:{
		create:{
			type:"FooterGeneralContactCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterGeneralContactUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertGeneralContactRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FooterGeneralContactUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterGeneralContactUpdateInput:{
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		info:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertGeneralContactRelationInput:{
		update:{
			type:"FooterGeneralContactUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterGeneralContactCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PortfolioPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PortfolioPageCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PortfolioPageCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PortfolioPageCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutPortfolioPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutPortfolioPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showPage:{
			type:"LinkableCreateShowPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PortfolioPageUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PortfolioPageUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PortfolioPageUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PortfolioPageUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutPortfolioPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutPortfolioPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PortfolioPageUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutPortfolioPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showPage:{
			type:"LinkableUpdateShowPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PortfolioPageUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutPortfolioPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutPortfolioPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ShowItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		show:{
			type:"ShowItemCreateShowEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ShowItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ShowItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		show:{
			type:"ShowItemUpdateShowEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Settings:{
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SettingsUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SettingsWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SettingsWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SettingsWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SettingsWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SettingsOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SettingsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SettingsCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SettingsCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SettingsUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SettingsUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SettingsUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SettingsUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SettingsUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"RedirectCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutRedirectCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutRedirectCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		portfolioPage:{
			type:"LinkableCreatePortfolioPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showPage:{
			type:"LinkableCreateShowPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpdateInput:{
		link:{
			type:"RedirectUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutRedirectCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutRedirectUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RedirectUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutRedirectUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		portfolioPage:{
			type:"LinkableUpdatePortfolioPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		showPage:{
			type:"LinkableUpdateShowPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutRedirectUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutRedirectCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	QueryTransaction:{
		getContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHomePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHomePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHomePage:{
			data:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMediumGallery:{
			by:{
				type:"MediumGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMediumGallery:{
			filter:{
				type:"MediumGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumGalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMediumGallery:{
			filter:{
				type:"MediumGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumGalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMediumGallery:{
			data:{
				type:"MediumGalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMediumGallery:{
			by:{
				type:"MediumGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MediumGalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMediumGalleryItem:{
			by:{
				type:"MediumGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMediumGalleryItem:{
			filter:{
				type:"MediumGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumGalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMediumGalleryItem:{
			filter:{
				type:"MediumGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumGalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMediumGalleryItem:{
			data:{
				type:"MediumGalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMediumGalleryItem:{
			by:{
				type:"MediumGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MediumGalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMember:{
			by:{
				type:"MemberUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMember:{
			filter:{
				type:"MemberWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MemberOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMember:{
			filter:{
				type:"MemberWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MemberOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMember:{
			data:{
				type:"MemberCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMember:{
			by:{
				type:"MemberUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MemberUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMemberItem:{
			by:{
				type:"MemberItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMemberItem:{
			filter:{
				type:"MemberItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MemberItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMemberItem:{
			filter:{
				type:"MemberItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MemberItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMemberItem:{
			data:{
				type:"MemberItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMemberItem:{
			by:{
				type:"MemberItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MemberItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMemberList:{
			by:{
				type:"MemberListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMemberList:{
			filter:{
				type:"MemberListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MemberListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMemberList:{
			filter:{
				type:"MemberListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MemberListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMemberList:{
			data:{
				type:"MemberListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMemberList:{
			by:{
				type:"MemberListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MemberListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getShow:{
			by:{
				type:"ShowUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listShow:{
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShow:{
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateShow:{
			data:{
				type:"ShowCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateShow:{
			by:{
				type:"ShowUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ShowUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getShowList:{
			by:{
				type:"ShowListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listShowList:{
			filter:{
				type:"ShowListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShowList:{
			filter:{
				type:"ShowListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateShowList:{
			data:{
				type:"ShowListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateShowList:{
			by:{
				type:"ShowListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ShowListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getShowYear:{
			by:{
				type:"ShowYearUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listShowYear:{
			filter:{
				type:"ShowYearWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowYearOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShowYear:{
			filter:{
				type:"ShowYearWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowYearOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateShowYear:{
			data:{
				type:"ShowYearCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateShowYear:{
			by:{
				type:"ShowYearUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ShowYearUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getShowYearItem:{
			by:{
				type:"ShowYearItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listShowYearItem:{
			filter:{
				type:"ShowYearItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowYearItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShowYearItem:{
			filter:{
				type:"ShowYearItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowYearItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateShowYearItem:{
			data:{
				type:"ShowYearItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateShowYearItem:{
			by:{
				type:"ShowYearItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ShowYearItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getShowYearList:{
			by:{
				type:"ShowYearListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listShowYearList:{
			filter:{
				type:"ShowYearListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowYearListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShowYearList:{
			filter:{
				type:"ShowYearListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowYearListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateShowYearList:{
			data:{
				type:"ShowYearListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateShowYearList:{
			by:{
				type:"ShowYearListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ShowYearListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLink:{
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLink:{
			data:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLinkItem:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLinkItem:{
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLinkItem:{
			data:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSocialLinkList:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSocialLinkList:{
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SocialLinkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSocialLinkList:{
			data:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listVideo:{
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"VideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateVideo:{
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"VideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateVideo:{
			data:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listYoutubeVideo:{
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateYoutubeVideo:{
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"YoutubeVideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateYoutubeVideo:{
			data:{
				type:"YoutubeVideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"YoutubeVideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterAddress:{
			by:{
				type:"FooterAddressUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterAddressWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterAddress:{
			filter:{
				type:"FooterAddressWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterAddressOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterAddress:{
			filter:{
				type:"FooterAddressWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterAddressOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterAddress:{
			data:{
				type:"FooterAddressCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterAddress:{
			by:{
				type:"FooterAddressUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterAddressUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPortfolioPage:{
			by:{
				type:"PortfolioPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PortfolioPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPortfolioPage:{
			filter:{
				type:"PortfolioPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PortfolioPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePortfolioPage:{
			filter:{
				type:"PortfolioPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PortfolioPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePortfolioPage:{
			data:{
				type:"PortfolioPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePortfolioPage:{
			by:{
				type:"PortfolioPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PortfolioPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getShowItem:{
			by:{
				type:"ShowItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listShowItem:{
			filter:{
				type:"ShowItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateShowItem:{
			filter:{
				type:"ShowItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ShowItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateShowItem:{
			data:{
				type:"ShowItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateShowItem:{
			by:{
				type:"ShowItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ShowItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSettings:{
			by:{
				type:"SettingsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SettingsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSettings:{
			filter:{
				type:"SettingsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SettingsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSettings:{
			filter:{
				type:"SettingsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SettingsOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSettings:{
			data:{
				type:"SettingsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSettings:{
			by:{
				type:"SettingsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SettingsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterGeneralContact:{
			by:{
				type:"FooterGeneralContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterGeneralContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterGeneralContact:{
			filter:{
				type:"FooterGeneralContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterGeneralContactOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterGeneralContact:{
			filter:{
				type:"FooterGeneralContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterGeneralContactOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterGeneralContact:{
			data:{
				type:"FooterGeneralContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterGeneralContact:{
			by:{
				type:"FooterGeneralContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterGeneralContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	Mutation:{
		createContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHomePage:{
			data:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMediumGallery:{
			data:{
				type:"MediumGalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMediumGallery:{
			by:{
				type:"MediumGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMediumGallery:{
			by:{
				type:"MediumGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MediumGalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMediumGallery:{
			by:{
				type:"MediumGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MediumGalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MediumGalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMediumGalleryItem:{
			data:{
				type:"MediumGalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMediumGalleryItem:{
			by:{
				type:"MediumGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMediumGalleryItem:{
			by:{
				type:"MediumGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MediumGalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMediumGalleryItem:{
			by:{
				type:"MediumGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MediumGalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MediumGalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMember:{
			data:{
				type:"MemberCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMember:{
			by:{
				type:"MemberUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMember:{
			by:{
				type:"MemberUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MemberUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMember:{
			by:{
				type:"MemberUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MemberUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MemberCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMemberItem:{
			data:{
				type:"MemberItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMemberItem:{
			by:{
				type:"MemberItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMemberItem:{
			by:{
				type:"MemberItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MemberItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMemberItem:{
			by:{
				type:"MemberItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MemberItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MemberItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMemberList:{
			data:{
				type:"MemberListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMemberList:{
			by:{
				type:"MemberListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMemberList:{
			by:{
				type:"MemberListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MemberListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMemberList:{
			by:{
				type:"MemberListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MemberListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MemberListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createShow:{
			data:{
				type:"ShowCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteShow:{
			by:{
				type:"ShowUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateShow:{
			by:{
				type:"ShowUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ShowUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertShow:{
			by:{
				type:"ShowUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ShowUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ShowCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createShowList:{
			data:{
				type:"ShowListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteShowList:{
			by:{
				type:"ShowListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateShowList:{
			by:{
				type:"ShowListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ShowListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertShowList:{
			by:{
				type:"ShowListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ShowListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ShowListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createShowYear:{
			data:{
				type:"ShowYearCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteShowYear:{
			by:{
				type:"ShowYearUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateShowYear:{
			by:{
				type:"ShowYearUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ShowYearUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertShowYear:{
			by:{
				type:"ShowYearUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ShowYearUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ShowYearCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createShowYearItem:{
			data:{
				type:"ShowYearItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteShowYearItem:{
			by:{
				type:"ShowYearItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateShowYearItem:{
			by:{
				type:"ShowYearItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ShowYearItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertShowYearItem:{
			by:{
				type:"ShowYearItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ShowYearItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ShowYearItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createShowYearList:{
			data:{
				type:"ShowYearListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteShowYearList:{
			by:{
				type:"ShowYearListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateShowYearList:{
			by:{
				type:"ShowYearListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ShowYearListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertShowYearList:{
			by:{
				type:"ShowYearListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ShowYearListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ShowYearListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLink:{
			data:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLinkItem:{
			data:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLinkList:{
			data:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createVideo:{
			data:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createYoutubeVideo:{
			data:{
				type:"YoutubeVideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"YoutubeVideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"YoutubeVideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"YoutubeVideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterAddress:{
			data:{
				type:"FooterAddressCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterAddress:{
			by:{
				type:"FooterAddressUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterAddressWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterAddress:{
			by:{
				type:"FooterAddressUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterAddressWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterAddressUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterAddress:{
			by:{
				type:"FooterAddressUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterAddressWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterAddressUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterAddressCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPortfolioPage:{
			data:{
				type:"PortfolioPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePortfolioPage:{
			by:{
				type:"PortfolioPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PortfolioPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePortfolioPage:{
			by:{
				type:"PortfolioPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PortfolioPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PortfolioPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPortfolioPage:{
			by:{
				type:"PortfolioPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PortfolioPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PortfolioPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PortfolioPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createShowItem:{
			data:{
				type:"ShowItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteShowItem:{
			by:{
				type:"ShowItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateShowItem:{
			by:{
				type:"ShowItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ShowItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertShowItem:{
			by:{
				type:"ShowItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ShowItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ShowItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSettings:{
			data:{
				type:"SettingsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSettings:{
			by:{
				type:"SettingsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SettingsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSettings:{
			by:{
				type:"SettingsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SettingsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SettingsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSettings:{
			by:{
				type:"SettingsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SettingsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SettingsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SettingsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterGeneralContact:{
			data:{
				type:"FooterGeneralContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterGeneralContact:{
			by:{
				type:"FooterGeneralContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterGeneralContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterGeneralContact:{
			by:{
				type:"FooterGeneralContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterGeneralContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterGeneralContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterGeneralContact:{
			by:{
				type:"FooterGeneralContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterGeneralContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterGeneralContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterGeneralContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		transaction:{
			options:{
				type:"MutationTransactionOptions",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		generateUploadUrl:{
			contentType:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			expiration:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			prefix:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		generateReadUrl:{
			objectKey:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			expiration:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	_MutationErrorType: "enum",
	MutationTransaction:{
		createContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHomePage:{
			data:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMediumGallery:{
			data:{
				type:"MediumGalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMediumGallery:{
			by:{
				type:"MediumGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMediumGallery:{
			by:{
				type:"MediumGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MediumGalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMediumGallery:{
			by:{
				type:"MediumGalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumGalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MediumGalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MediumGalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMediumGalleryItem:{
			data:{
				type:"MediumGalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMediumGalleryItem:{
			by:{
				type:"MediumGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMediumGalleryItem:{
			by:{
				type:"MediumGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MediumGalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMediumGalleryItem:{
			by:{
				type:"MediumGalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumGalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MediumGalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MediumGalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMember:{
			data:{
				type:"MemberCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMember:{
			by:{
				type:"MemberUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMember:{
			by:{
				type:"MemberUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MemberUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMember:{
			by:{
				type:"MemberUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MemberUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MemberCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMemberItem:{
			data:{
				type:"MemberItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMemberItem:{
			by:{
				type:"MemberItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMemberItem:{
			by:{
				type:"MemberItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MemberItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMemberItem:{
			by:{
				type:"MemberItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MemberItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MemberItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMemberList:{
			data:{
				type:"MemberListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMemberList:{
			by:{
				type:"MemberListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMemberList:{
			by:{
				type:"MemberListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MemberListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMemberList:{
			by:{
				type:"MemberListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MemberListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MemberListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MemberListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createShow:{
			data:{
				type:"ShowCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteShow:{
			by:{
				type:"ShowUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateShow:{
			by:{
				type:"ShowUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ShowUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertShow:{
			by:{
				type:"ShowUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ShowUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ShowCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createShowList:{
			data:{
				type:"ShowListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteShowList:{
			by:{
				type:"ShowListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateShowList:{
			by:{
				type:"ShowListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ShowListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertShowList:{
			by:{
				type:"ShowListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ShowListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ShowListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createShowYear:{
			data:{
				type:"ShowYearCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteShowYear:{
			by:{
				type:"ShowYearUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateShowYear:{
			by:{
				type:"ShowYearUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ShowYearUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertShowYear:{
			by:{
				type:"ShowYearUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ShowYearUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ShowYearCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createShowYearItem:{
			data:{
				type:"ShowYearItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteShowYearItem:{
			by:{
				type:"ShowYearItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateShowYearItem:{
			by:{
				type:"ShowYearItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ShowYearItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertShowYearItem:{
			by:{
				type:"ShowYearItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ShowYearItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ShowYearItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createShowYearList:{
			data:{
				type:"ShowYearListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteShowYearList:{
			by:{
				type:"ShowYearListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateShowYearList:{
			by:{
				type:"ShowYearListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ShowYearListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertShowYearList:{
			by:{
				type:"ShowYearListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowYearListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ShowYearListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ShowYearListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLink:{
			data:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLink:{
			by:{
				type:"SocialLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLinkItem:{
			data:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLinkItem:{
			by:{
				type:"SocialLinkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSocialLinkList:{
			data:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSocialLinkList:{
			by:{
				type:"SocialLinkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SocialLinkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SocialLinkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SocialLinkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createVideo:{
			data:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createYoutubeVideo:{
			data:{
				type:"YoutubeVideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"YoutubeVideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertYoutubeVideo:{
			by:{
				type:"YoutubeVideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"YoutubeVideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"YoutubeVideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"YoutubeVideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterAddress:{
			data:{
				type:"FooterAddressCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterAddress:{
			by:{
				type:"FooterAddressUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterAddressWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterAddress:{
			by:{
				type:"FooterAddressUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterAddressWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterAddressUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterAddress:{
			by:{
				type:"FooterAddressUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterAddressWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterAddressUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterAddressCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPortfolioPage:{
			data:{
				type:"PortfolioPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePortfolioPage:{
			by:{
				type:"PortfolioPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PortfolioPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePortfolioPage:{
			by:{
				type:"PortfolioPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PortfolioPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PortfolioPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPortfolioPage:{
			by:{
				type:"PortfolioPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PortfolioPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PortfolioPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PortfolioPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createShowItem:{
			data:{
				type:"ShowItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteShowItem:{
			by:{
				type:"ShowItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateShowItem:{
			by:{
				type:"ShowItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ShowItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertShowItem:{
			by:{
				type:"ShowItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ShowItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ShowItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ShowItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSettings:{
			data:{
				type:"SettingsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSettings:{
			by:{
				type:"SettingsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SettingsWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSettings:{
			by:{
				type:"SettingsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SettingsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SettingsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSettings:{
			by:{
				type:"SettingsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SettingsWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SettingsUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SettingsCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterGeneralContact:{
			data:{
				type:"FooterGeneralContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterGeneralContact:{
			by:{
				type:"FooterGeneralContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterGeneralContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterGeneralContact:{
			by:{
				type:"FooterGeneralContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterGeneralContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterGeneralContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterGeneralContact:{
			by:{
				type:"FooterGeneralContactUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterGeneralContactWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterGeneralContactUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterGeneralContactCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	MutationTransactionOptions:{
		deferForeignKeyConstraints:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Json: "String",
	_OnDeleteBehaviour: "enum",
	_RelationSide: "enum",
	_OrderByDirection: "enum"
}

export const ReturnTypes: Record<string,any> = {
	Query:{
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getHomePage:"HomePage",
		listHomePage:"HomePage",
		paginateHomePage:"HomePageConnection",
		validateCreateHomePage:"_ValidationResult",
		validateUpdateHomePage:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getMediumGallery:"MediumGallery",
		listMediumGallery:"MediumGallery",
		paginateMediumGallery:"MediumGalleryConnection",
		validateCreateMediumGallery:"_ValidationResult",
		validateUpdateMediumGallery:"_ValidationResult",
		getMediumGalleryItem:"MediumGalleryItem",
		listMediumGalleryItem:"MediumGalleryItem",
		paginateMediumGalleryItem:"MediumGalleryItemConnection",
		validateCreateMediumGalleryItem:"_ValidationResult",
		validateUpdateMediumGalleryItem:"_ValidationResult",
		getMember:"Member",
		listMember:"Member",
		paginateMember:"MemberConnection",
		validateCreateMember:"_ValidationResult",
		validateUpdateMember:"_ValidationResult",
		getMemberItem:"MemberItem",
		listMemberItem:"MemberItem",
		paginateMemberItem:"MemberItemConnection",
		validateCreateMemberItem:"_ValidationResult",
		validateUpdateMemberItem:"_ValidationResult",
		getMemberList:"MemberList",
		listMemberList:"MemberList",
		paginateMemberList:"MemberListConnection",
		validateCreateMemberList:"_ValidationResult",
		validateUpdateMemberList:"_ValidationResult",
		getShow:"Show",
		listShow:"Show",
		paginateShow:"ShowConnection",
		validateCreateShow:"_ValidationResult",
		validateUpdateShow:"_ValidationResult",
		getShowList:"ShowList",
		listShowList:"ShowList",
		paginateShowList:"ShowListConnection",
		validateCreateShowList:"_ValidationResult",
		validateUpdateShowList:"_ValidationResult",
		getShowYear:"ShowYear",
		listShowYear:"ShowYear",
		paginateShowYear:"ShowYearConnection",
		validateCreateShowYear:"_ValidationResult",
		validateUpdateShowYear:"_ValidationResult",
		getShowYearItem:"ShowYearItem",
		listShowYearItem:"ShowYearItem",
		paginateShowYearItem:"ShowYearItemConnection",
		validateCreateShowYearItem:"_ValidationResult",
		validateUpdateShowYearItem:"_ValidationResult",
		getShowYearList:"ShowYearList",
		listShowYearList:"ShowYearList",
		paginateShowYearList:"ShowYearListConnection",
		validateCreateShowYearList:"_ValidationResult",
		validateUpdateShowYearList:"_ValidationResult",
		getSocialLink:"SocialLink",
		listSocialLink:"SocialLink",
		paginateSocialLink:"SocialLinkConnection",
		validateCreateSocialLink:"_ValidationResult",
		validateUpdateSocialLink:"_ValidationResult",
		getSocialLinkItem:"SocialLinkItem",
		listSocialLinkItem:"SocialLinkItem",
		paginateSocialLinkItem:"SocialLinkItemConnection",
		validateCreateSocialLinkItem:"_ValidationResult",
		validateUpdateSocialLinkItem:"_ValidationResult",
		getSocialLinkList:"SocialLinkList",
		listSocialLinkList:"SocialLinkList",
		paginateSocialLinkList:"SocialLinkListConnection",
		validateCreateSocialLinkList:"_ValidationResult",
		validateUpdateSocialLinkList:"_ValidationResult",
		getVideo:"Video",
		listVideo:"Video",
		paginateVideo:"VideoConnection",
		validateCreateVideo:"_ValidationResult",
		validateUpdateVideo:"_ValidationResult",
		getYoutubeVideo:"YoutubeVideo",
		listYoutubeVideo:"YoutubeVideo",
		paginateYoutubeVideo:"YoutubeVideoConnection",
		validateCreateYoutubeVideo:"_ValidationResult",
		validateUpdateYoutubeVideo:"_ValidationResult",
		getHeader:"Header",
		listHeader:"Header",
		paginateHeader:"HeaderConnection",
		validateCreateHeader:"_ValidationResult",
		validateUpdateHeader:"_ValidationResult",
		getFooter:"Footer",
		listFooter:"Footer",
		paginateFooter:"FooterConnection",
		validateCreateFooter:"_ValidationResult",
		validateUpdateFooter:"_ValidationResult",
		getFooterAddress:"FooterAddress",
		listFooterAddress:"FooterAddress",
		paginateFooterAddress:"FooterAddressConnection",
		validateCreateFooterAddress:"_ValidationResult",
		validateUpdateFooterAddress:"_ValidationResult",
		getPortfolioPage:"PortfolioPage",
		listPortfolioPage:"PortfolioPage",
		paginatePortfolioPage:"PortfolioPageConnection",
		validateCreatePortfolioPage:"_ValidationResult",
		validateUpdatePortfolioPage:"_ValidationResult",
		getShowItem:"ShowItem",
		listShowItem:"ShowItem",
		paginateShowItem:"ShowItemConnection",
		validateCreateShowItem:"_ValidationResult",
		validateUpdateShowItem:"_ValidationResult",
		getSettings:"Settings",
		listSettings:"Settings",
		paginateSettings:"SettingsConnection",
		validateCreateSettings:"_ValidationResult",
		validateUpdateSettings:"_ValidationResult",
		getFooterGeneralContact:"FooterGeneralContact",
		listFooterGeneralContact:"FooterGeneralContact",
		paginateFooterGeneralContact:"FooterGeneralContactConnection",
		validateCreateFooterGeneralContact:"_ValidationResult",
		validateUpdateFooterGeneralContact:"_ValidationResult",
		getRedirect:"Redirect",
		listRedirect:"Redirect",
		paginateRedirect:"RedirectConnection",
		validateCreateRedirect:"_ValidationResult",
		validateUpdateRedirect:"_ValidationResult",
		transaction:"QueryTransaction",
		_info:"Info",
		schema:"_Schema",
		s3DummyQuery:"String"
	},
	ContentBlock:{
		_meta:"ContentBlockMeta",
		id:"UUID",
		order:"Int",
		type:"ContentBlockType",
		primaryText:"String",
		secondaryText:"String",
		homePage:"HomePage",
		gallery:"MediumGallery",
		video:"Video",
		link:"Link",
		members:"MemberList",
		portfolio:"ShowYearList"
	},
	ContentBlockMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		type:"FieldMeta",
		primaryText:"FieldMeta",
		secondaryText:"FieldMeta",
		homePage:"FieldMeta",
		gallery:"FieldMeta",
		video:"FieldMeta",
		link:"FieldMeta",
		members:"FieldMeta",
		portfolio:"FieldMeta"
	},
	FieldMeta:{
		readable:"Boolean",
		updatable:"Boolean"
	},
	HomePage:{
		_meta:"HomePageMeta",
		id:"UUID",
		name:"String",
		link:"Linkable",
		seo:"Seo",
		unique:"One",
		blocks:"ContentBlock",
		blocksByGallery:"ContentBlock",
		blocksByLink:"ContentBlock",
		blocksByMembers:"ContentBlock",
		paginateBlocks:"ContentBlockConnection"
	},
	HomePageMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		link:"FieldMeta",
		seo:"FieldMeta",
		unique:"FieldMeta",
		blocks:"FieldMeta"
	},
	Linkable:{
		_meta:"LinkableMeta",
		id:"UUID",
		url:"String",
		homePage:"HomePage",
		portfolioPage:"PortfolioPage",
		showPage:"Show",
		redirect:"Redirect"
	},
	LinkableMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		homePage:"FieldMeta",
		portfolioPage:"FieldMeta",
		showPage:"FieldMeta",
		redirect:"FieldMeta"
	},
	PortfolioPage:{
		_meta:"PortfolioPageMeta",
		id:"UUID",
		name:"String",
		link:"Linkable",
		seo:"Seo",
		unique:"One",
		title:"String",
		text:"String"
	},
	PortfolioPageMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		link:"FieldMeta",
		seo:"FieldMeta",
		unique:"FieldMeta",
		title:"FieldMeta",
		text:"FieldMeta"
	},
	Seo:{
		_meta:"SeoMeta",
		id:"UUID",
		description:"String",
		ogTitle:"String",
		ogDescription:"String",
		title:"String",
		ogImage:"Image",
		noIndex:"Boolean",
		noFollow:"Boolean"
	},
	SeoMeta:{
		id:"FieldMeta",
		description:"FieldMeta",
		ogTitle:"FieldMeta",
		ogDescription:"FieldMeta",
		title:"FieldMeta",
		ogImage:"FieldMeta",
		noIndex:"FieldMeta",
		noFollow:"FieldMeta"
	},
	Image:{
		_meta:"ImageMeta",
		id:"UUID",
		url:"String",
		width:"Int",
		height:"Int",
		size:"Int",
		type:"String",
		alt:"String"
	},
	ImageMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		alt:"FieldMeta"
	},
	Show:{
		_meta:"ShowMeta",
		id:"UUID",
		title:"String",
		description:"String",
		posterType:"ShowPosterType",
		poster:"Image",
		showItem:"ShowItem",
		posterSizeType:"ShowPosterSizeType",
		categoryYear:"ShowYear",
		production:"String",
		directors:"String",
		starrings:"String",
		gallery:"MediumGallery",
		seo:"Seo",
		link:"Linkable",
		synopsis:"String",
		paginateShowItem:"ShowItemConnection"
	},
	ShowMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		description:"FieldMeta",
		posterType:"FieldMeta",
		poster:"FieldMeta",
		showItem:"FieldMeta",
		posterSizeType:"FieldMeta",
		categoryYear:"FieldMeta",
		production:"FieldMeta",
		directors:"FieldMeta",
		starrings:"FieldMeta",
		gallery:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		synopsis:"FieldMeta"
	},
	ShowItem:{
		_meta:"ShowItemMeta",
		id:"UUID",
		order:"Int",
		list:"ShowList",
		show:"Show"
	},
	ShowItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		show:"FieldMeta"
	},
	ShowList:{
		_meta:"ShowListMeta",
		id:"UUID",
		items:"ShowItem",
		paginateItems:"ShowItemConnection"
	},
	ShowListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	ShowItemConnection:{
		pageInfo:"PageInfo",
		edges:"ShowItemEdge"
	},
	PageInfo:{
		totalCount:"Int"
	},
	ShowItemEdge:{
		node:"ShowItem"
	},
	ShowYear:{
		_meta:"ShowYearMeta",
		id:"UUID",
		order:"Int",
		name:"String",
		showList:"Show",
		showListByShowItem:"Show",
		showListByGallery:"Show",
		showListBySeo:"Show",
		showListByLink:"Show",
		paginateShowList:"ShowConnection"
	},
	ShowYearMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		name:"FieldMeta",
		showList:"FieldMeta"
	},
	ShowConnection:{
		pageInfo:"PageInfo",
		edges:"ShowEdge"
	},
	ShowEdge:{
		node:"Show"
	},
	MediumGallery:{
		_meta:"MediumGalleryMeta",
		id:"UUID",
		items:"MediumGalleryItem",
		paginateItems:"MediumGalleryItemConnection"
	},
	MediumGalleryMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	MediumGalleryItem:{
		_meta:"MediumGalleryItemMeta",
		id:"UUID",
		order:"Int",
		type:"MediumType",
		gallery:"MediumGallery",
		image:"Image",
		video:"Video"
	},
	MediumGalleryItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		type:"FieldMeta",
		gallery:"FieldMeta",
		image:"FieldMeta",
		video:"FieldMeta"
	},
	Video:{
		_meta:"VideoMeta",
		id:"UUID",
		src:"String",
		width:"Int",
		height:"Int",
		size:"Int",
		type:"String",
		duration:"Float",
		poster:"Image"
	},
	VideoMeta:{
		id:"FieldMeta",
		src:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		duration:"FieldMeta",
		poster:"FieldMeta"
	},
	MediumGalleryItemConnection:{
		pageInfo:"PageInfo",
		edges:"MediumGalleryItemEdge"
	},
	MediumGalleryItemEdge:{
		node:"MediumGalleryItem"
	},
	Redirect:{
		_meta:"RedirectMeta",
		id:"UUID",
		link:"Linkable",
		target:"Linkable"
	},
	RedirectMeta:{
		id:"FieldMeta",
		link:"FieldMeta",
		target:"FieldMeta"
	},
	ContentBlockConnection:{
		pageInfo:"PageInfo",
		edges:"ContentBlockEdge"
	},
	ContentBlockEdge:{
		node:"ContentBlock"
	},
	Link:{
		_meta:"LinkMeta",
		id:"UUID",
		type:"LinkType",
		title:"String",
		externalLink:"String",
		internalLink:"Linkable"
	},
	LinkMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		title:"FieldMeta",
		externalLink:"FieldMeta",
		internalLink:"FieldMeta"
	},
	MemberList:{
		_meta:"MemberListMeta",
		id:"UUID",
		items:"MemberItem",
		paginateItems:"MemberItemConnection"
	},
	MemberListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	MemberItem:{
		_meta:"MemberItemMeta",
		id:"UUID",
		order:"Int",
		list:"MemberList",
		member:"Member"
	},
	MemberItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		member:"FieldMeta"
	},
	Member:{
		_meta:"MemberMeta",
		id:"UUID",
		firstName:"String",
		lastName:"String",
		position:"String",
		email:"String",
		telephone:"String",
		image:"Image"
	},
	MemberMeta:{
		id:"FieldMeta",
		firstName:"FieldMeta",
		lastName:"FieldMeta",
		position:"FieldMeta",
		email:"FieldMeta",
		telephone:"FieldMeta",
		image:"FieldMeta"
	},
	MemberItemConnection:{
		pageInfo:"PageInfo",
		edges:"MemberItemEdge"
	},
	MemberItemEdge:{
		node:"MemberItem"
	},
	ShowYearList:{
		_meta:"ShowYearListMeta",
		id:"UUID",
		items:"ShowYearItem",
		paginateItems:"ShowYearItemConnection"
	},
	ShowYearListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	ShowYearItem:{
		_meta:"ShowYearItemMeta",
		id:"UUID",
		order:"Int",
		list:"ShowYearList",
		showYear:"ShowYear"
	},
	ShowYearItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		showYear:"FieldMeta"
	},
	ShowYearItemConnection:{
		pageInfo:"PageInfo",
		edges:"ShowYearItemEdge"
	},
	ShowYearItemEdge:{
		node:"ShowYearItem"
	},
	_ValidationResult:{
		valid:"Boolean",
		errors:"_ValidationError"
	},
	_ValidationError:{
		path:"_PathFragment",
		message:"_ValidationMessage"
	},
	_PathFragment:{
		"...on _FieldPathFragment":"_FieldPathFragment",
		"...on _IndexPathFragment":"_IndexPathFragment"
	},
	_FieldPathFragment:{
		field:"String"
	},
	_IndexPathFragment:{
		index:"Int",
		alias:"String"
	},
	_ValidationMessage:{
		text:"String"
	},
	ImageConnection:{
		pageInfo:"PageInfo",
		edges:"ImageEdge"
	},
	ImageEdge:{
		node:"Image"
	},
	LinkConnection:{
		pageInfo:"PageInfo",
		edges:"LinkEdge"
	},
	LinkEdge:{
		node:"Link"
	},
	SeoConnection:{
		pageInfo:"PageInfo",
		edges:"SeoEdge"
	},
	SeoEdge:{
		node:"Seo"
	},
	HomePageConnection:{
		pageInfo:"PageInfo",
		edges:"HomePageEdge"
	},
	HomePageEdge:{
		node:"HomePage"
	},
	LinkableConnection:{
		pageInfo:"PageInfo",
		edges:"LinkableEdge"
	},
	LinkableEdge:{
		node:"Linkable"
	},
	MediumGalleryConnection:{
		pageInfo:"PageInfo",
		edges:"MediumGalleryEdge"
	},
	MediumGalleryEdge:{
		node:"MediumGallery"
	},
	MemberConnection:{
		pageInfo:"PageInfo",
		edges:"MemberEdge"
	},
	MemberEdge:{
		node:"Member"
	},
	MemberListConnection:{
		pageInfo:"PageInfo",
		edges:"MemberListEdge"
	},
	MemberListEdge:{
		node:"MemberList"
	},
	ShowListConnection:{
		pageInfo:"PageInfo",
		edges:"ShowListEdge"
	},
	ShowListEdge:{
		node:"ShowList"
	},
	ShowYearConnection:{
		pageInfo:"PageInfo",
		edges:"ShowYearEdge"
	},
	ShowYearEdge:{
		node:"ShowYear"
	},
	ShowYearListConnection:{
		pageInfo:"PageInfo",
		edges:"ShowYearListEdge"
	},
	ShowYearListEdge:{
		node:"ShowYearList"
	},
	SocialLink:{
		_meta:"SocialLinkMeta",
		id:"UUID",
		name:"String",
		icon:"Image",
		link:"Link"
	},
	SocialLinkMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		icon:"FieldMeta",
		link:"FieldMeta"
	},
	SocialLinkConnection:{
		pageInfo:"PageInfo",
		edges:"SocialLinkEdge"
	},
	SocialLinkEdge:{
		node:"SocialLink"
	},
	SocialLinkItem:{
		_meta:"SocialLinkItemMeta",
		id:"UUID",
		order:"Int",
		list:"SocialLinkList",
		socialLink:"SocialLink"
	},
	SocialLinkItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		socialLink:"FieldMeta"
	},
	SocialLinkList:{
		_meta:"SocialLinkListMeta",
		id:"UUID",
		items:"SocialLinkItem",
		paginateItems:"SocialLinkItemConnection"
	},
	SocialLinkListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	SocialLinkItemConnection:{
		pageInfo:"PageInfo",
		edges:"SocialLinkItemEdge"
	},
	SocialLinkItemEdge:{
		node:"SocialLinkItem"
	},
	SocialLinkListConnection:{
		pageInfo:"PageInfo",
		edges:"SocialLinkListEdge"
	},
	SocialLinkListEdge:{
		node:"SocialLinkList"
	},
	VideoConnection:{
		pageInfo:"PageInfo",
		edges:"VideoEdge"
	},
	VideoEdge:{
		node:"Video"
	},
	YoutubeVideo:{
		_meta:"YoutubeVideoMeta",
		id:"UUID",
		videoId:"String"
	},
	YoutubeVideoMeta:{
		id:"FieldMeta",
		videoId:"FieldMeta"
	},
	YoutubeVideoConnection:{
		pageInfo:"PageInfo",
		edges:"YoutubeVideoEdge"
	},
	YoutubeVideoEdge:{
		node:"YoutubeVideo"
	},
	Header:{
		_meta:"HeaderMeta",
		id:"UUID",
		logo:"Image",
		socialLinks:"SocialLinkList",
		unique:"One"
	},
	HeaderMeta:{
		id:"FieldMeta",
		logo:"FieldMeta",
		socialLinks:"FieldMeta",
		unique:"FieldMeta"
	},
	HeaderConnection:{
		pageInfo:"PageInfo",
		edges:"HeaderEdge"
	},
	HeaderEdge:{
		node:"Header"
	},
	Footer:{
		_meta:"FooterMeta",
		id:"UUID",
		title:"String",
		info:"String",
		address:"FooterAddress",
		members:"MemberList",
		logo:"Image",
		socialLinks:"SocialLinkList",
		unique:"One",
		generalContact:"FooterGeneralContact"
	},
	FooterMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		info:"FieldMeta",
		address:"FieldMeta",
		members:"FieldMeta",
		logo:"FieldMeta",
		socialLinks:"FieldMeta",
		unique:"FieldMeta",
		generalContact:"FieldMeta"
	},
	FooterAddress:{
		_meta:"FooterAddressMeta",
		id:"UUID",
		label:"String",
		address:"String",
		addressLink:"Link"
	},
	FooterAddressMeta:{
		id:"FieldMeta",
		label:"FieldMeta",
		address:"FieldMeta",
		addressLink:"FieldMeta"
	},
	FooterGeneralContact:{
		_meta:"FooterGeneralContactMeta",
		id:"UUID",
		label:"String",
		email:"String",
		info:"String"
	},
	FooterGeneralContactMeta:{
		id:"FieldMeta",
		label:"FieldMeta",
		email:"FieldMeta",
		info:"FieldMeta"
	},
	FooterConnection:{
		pageInfo:"PageInfo",
		edges:"FooterEdge"
	},
	FooterEdge:{
		node:"Footer"
	},
	FooterAddressConnection:{
		pageInfo:"PageInfo",
		edges:"FooterAddressEdge"
	},
	FooterAddressEdge:{
		node:"FooterAddress"
	},
	PortfolioPageConnection:{
		pageInfo:"PageInfo",
		edges:"PortfolioPageEdge"
	},
	PortfolioPageEdge:{
		node:"PortfolioPage"
	},
	Settings:{
		_meta:"SettingsMeta",
		id:"UUID",
		unique:"One",
		seo:"Seo"
	},
	SettingsMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		seo:"FieldMeta"
	},
	SettingsConnection:{
		pageInfo:"PageInfo",
		edges:"SettingsEdge"
	},
	SettingsEdge:{
		node:"Settings"
	},
	FooterGeneralContactConnection:{
		pageInfo:"PageInfo",
		edges:"FooterGeneralContactEdge"
	},
	FooterGeneralContactEdge:{
		node:"FooterGeneralContact"
	},
	RedirectConnection:{
		pageInfo:"PageInfo",
		edges:"RedirectEdge"
	},
	RedirectEdge:{
		node:"Redirect"
	},
	QueryTransaction:{
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getHomePage:"HomePage",
		listHomePage:"HomePage",
		paginateHomePage:"HomePageConnection",
		validateCreateHomePage:"_ValidationResult",
		validateUpdateHomePage:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getMediumGallery:"MediumGallery",
		listMediumGallery:"MediumGallery",
		paginateMediumGallery:"MediumGalleryConnection",
		validateCreateMediumGallery:"_ValidationResult",
		validateUpdateMediumGallery:"_ValidationResult",
		getMediumGalleryItem:"MediumGalleryItem",
		listMediumGalleryItem:"MediumGalleryItem",
		paginateMediumGalleryItem:"MediumGalleryItemConnection",
		validateCreateMediumGalleryItem:"_ValidationResult",
		validateUpdateMediumGalleryItem:"_ValidationResult",
		getMember:"Member",
		listMember:"Member",
		paginateMember:"MemberConnection",
		validateCreateMember:"_ValidationResult",
		validateUpdateMember:"_ValidationResult",
		getMemberItem:"MemberItem",
		listMemberItem:"MemberItem",
		paginateMemberItem:"MemberItemConnection",
		validateCreateMemberItem:"_ValidationResult",
		validateUpdateMemberItem:"_ValidationResult",
		getMemberList:"MemberList",
		listMemberList:"MemberList",
		paginateMemberList:"MemberListConnection",
		validateCreateMemberList:"_ValidationResult",
		validateUpdateMemberList:"_ValidationResult",
		getShow:"Show",
		listShow:"Show",
		paginateShow:"ShowConnection",
		validateCreateShow:"_ValidationResult",
		validateUpdateShow:"_ValidationResult",
		getShowList:"ShowList",
		listShowList:"ShowList",
		paginateShowList:"ShowListConnection",
		validateCreateShowList:"_ValidationResult",
		validateUpdateShowList:"_ValidationResult",
		getShowYear:"ShowYear",
		listShowYear:"ShowYear",
		paginateShowYear:"ShowYearConnection",
		validateCreateShowYear:"_ValidationResult",
		validateUpdateShowYear:"_ValidationResult",
		getShowYearItem:"ShowYearItem",
		listShowYearItem:"ShowYearItem",
		paginateShowYearItem:"ShowYearItemConnection",
		validateCreateShowYearItem:"_ValidationResult",
		validateUpdateShowYearItem:"_ValidationResult",
		getShowYearList:"ShowYearList",
		listShowYearList:"ShowYearList",
		paginateShowYearList:"ShowYearListConnection",
		validateCreateShowYearList:"_ValidationResult",
		validateUpdateShowYearList:"_ValidationResult",
		getSocialLink:"SocialLink",
		listSocialLink:"SocialLink",
		paginateSocialLink:"SocialLinkConnection",
		validateCreateSocialLink:"_ValidationResult",
		validateUpdateSocialLink:"_ValidationResult",
		getSocialLinkItem:"SocialLinkItem",
		listSocialLinkItem:"SocialLinkItem",
		paginateSocialLinkItem:"SocialLinkItemConnection",
		validateCreateSocialLinkItem:"_ValidationResult",
		validateUpdateSocialLinkItem:"_ValidationResult",
		getSocialLinkList:"SocialLinkList",
		listSocialLinkList:"SocialLinkList",
		paginateSocialLinkList:"SocialLinkListConnection",
		validateCreateSocialLinkList:"_ValidationResult",
		validateUpdateSocialLinkList:"_ValidationResult",
		getVideo:"Video",
		listVideo:"Video",
		paginateVideo:"VideoConnection",
		validateCreateVideo:"_ValidationResult",
		validateUpdateVideo:"_ValidationResult",
		getYoutubeVideo:"YoutubeVideo",
		listYoutubeVideo:"YoutubeVideo",
		paginateYoutubeVideo:"YoutubeVideoConnection",
		validateCreateYoutubeVideo:"_ValidationResult",
		validateUpdateYoutubeVideo:"_ValidationResult",
		getHeader:"Header",
		listHeader:"Header",
		paginateHeader:"HeaderConnection",
		validateCreateHeader:"_ValidationResult",
		validateUpdateHeader:"_ValidationResult",
		getFooter:"Footer",
		listFooter:"Footer",
		paginateFooter:"FooterConnection",
		validateCreateFooter:"_ValidationResult",
		validateUpdateFooter:"_ValidationResult",
		getFooterAddress:"FooterAddress",
		listFooterAddress:"FooterAddress",
		paginateFooterAddress:"FooterAddressConnection",
		validateCreateFooterAddress:"_ValidationResult",
		validateUpdateFooterAddress:"_ValidationResult",
		getPortfolioPage:"PortfolioPage",
		listPortfolioPage:"PortfolioPage",
		paginatePortfolioPage:"PortfolioPageConnection",
		validateCreatePortfolioPage:"_ValidationResult",
		validateUpdatePortfolioPage:"_ValidationResult",
		getShowItem:"ShowItem",
		listShowItem:"ShowItem",
		paginateShowItem:"ShowItemConnection",
		validateCreateShowItem:"_ValidationResult",
		validateUpdateShowItem:"_ValidationResult",
		getSettings:"Settings",
		listSettings:"Settings",
		paginateSettings:"SettingsConnection",
		validateCreateSettings:"_ValidationResult",
		validateUpdateSettings:"_ValidationResult",
		getFooterGeneralContact:"FooterGeneralContact",
		listFooterGeneralContact:"FooterGeneralContact",
		paginateFooterGeneralContact:"FooterGeneralContactConnection",
		validateCreateFooterGeneralContact:"_ValidationResult",
		validateUpdateFooterGeneralContact:"_ValidationResult",
		getRedirect:"Redirect",
		listRedirect:"Redirect",
		paginateRedirect:"RedirectConnection",
		validateCreateRedirect:"_ValidationResult",
		validateUpdateRedirect:"_ValidationResult"
	},
	Info:{
		description:"String"
	},
	Mutation:{
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createHomePage:"HomePageCreateResult",
		deleteHomePage:"HomePageDeleteResult",
		updateHomePage:"HomePageUpdateResult",
		upsertHomePage:"HomePageUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createMediumGallery:"MediumGalleryCreateResult",
		deleteMediumGallery:"MediumGalleryDeleteResult",
		updateMediumGallery:"MediumGalleryUpdateResult",
		upsertMediumGallery:"MediumGalleryUpsertResult",
		createMediumGalleryItem:"MediumGalleryItemCreateResult",
		deleteMediumGalleryItem:"MediumGalleryItemDeleteResult",
		updateMediumGalleryItem:"MediumGalleryItemUpdateResult",
		upsertMediumGalleryItem:"MediumGalleryItemUpsertResult",
		createMember:"MemberCreateResult",
		deleteMember:"MemberDeleteResult",
		updateMember:"MemberUpdateResult",
		upsertMember:"MemberUpsertResult",
		createMemberItem:"MemberItemCreateResult",
		deleteMemberItem:"MemberItemDeleteResult",
		updateMemberItem:"MemberItemUpdateResult",
		upsertMemberItem:"MemberItemUpsertResult",
		createMemberList:"MemberListCreateResult",
		deleteMemberList:"MemberListDeleteResult",
		updateMemberList:"MemberListUpdateResult",
		upsertMemberList:"MemberListUpsertResult",
		createShow:"ShowCreateResult",
		deleteShow:"ShowDeleteResult",
		updateShow:"ShowUpdateResult",
		upsertShow:"ShowUpsertResult",
		createShowList:"ShowListCreateResult",
		deleteShowList:"ShowListDeleteResult",
		updateShowList:"ShowListUpdateResult",
		upsertShowList:"ShowListUpsertResult",
		createShowYear:"ShowYearCreateResult",
		deleteShowYear:"ShowYearDeleteResult",
		updateShowYear:"ShowYearUpdateResult",
		upsertShowYear:"ShowYearUpsertResult",
		createShowYearItem:"ShowYearItemCreateResult",
		deleteShowYearItem:"ShowYearItemDeleteResult",
		updateShowYearItem:"ShowYearItemUpdateResult",
		upsertShowYearItem:"ShowYearItemUpsertResult",
		createShowYearList:"ShowYearListCreateResult",
		deleteShowYearList:"ShowYearListDeleteResult",
		updateShowYearList:"ShowYearListUpdateResult",
		upsertShowYearList:"ShowYearListUpsertResult",
		createSocialLink:"SocialLinkCreateResult",
		deleteSocialLink:"SocialLinkDeleteResult",
		updateSocialLink:"SocialLinkUpdateResult",
		upsertSocialLink:"SocialLinkUpsertResult",
		createSocialLinkItem:"SocialLinkItemCreateResult",
		deleteSocialLinkItem:"SocialLinkItemDeleteResult",
		updateSocialLinkItem:"SocialLinkItemUpdateResult",
		upsertSocialLinkItem:"SocialLinkItemUpsertResult",
		createSocialLinkList:"SocialLinkListCreateResult",
		deleteSocialLinkList:"SocialLinkListDeleteResult",
		updateSocialLinkList:"SocialLinkListUpdateResult",
		upsertSocialLinkList:"SocialLinkListUpsertResult",
		createVideo:"VideoCreateResult",
		deleteVideo:"VideoDeleteResult",
		updateVideo:"VideoUpdateResult",
		upsertVideo:"VideoUpsertResult",
		createYoutubeVideo:"YoutubeVideoCreateResult",
		deleteYoutubeVideo:"YoutubeVideoDeleteResult",
		updateYoutubeVideo:"YoutubeVideoUpdateResult",
		upsertYoutubeVideo:"YoutubeVideoUpsertResult",
		createHeader:"HeaderCreateResult",
		deleteHeader:"HeaderDeleteResult",
		updateHeader:"HeaderUpdateResult",
		upsertHeader:"HeaderUpsertResult",
		createFooter:"FooterCreateResult",
		deleteFooter:"FooterDeleteResult",
		updateFooter:"FooterUpdateResult",
		upsertFooter:"FooterUpsertResult",
		createFooterAddress:"FooterAddressCreateResult",
		deleteFooterAddress:"FooterAddressDeleteResult",
		updateFooterAddress:"FooterAddressUpdateResult",
		upsertFooterAddress:"FooterAddressUpsertResult",
		createPortfolioPage:"PortfolioPageCreateResult",
		deletePortfolioPage:"PortfolioPageDeleteResult",
		updatePortfolioPage:"PortfolioPageUpdateResult",
		upsertPortfolioPage:"PortfolioPageUpsertResult",
		createShowItem:"ShowItemCreateResult",
		deleteShowItem:"ShowItemDeleteResult",
		updateShowItem:"ShowItemUpdateResult",
		upsertShowItem:"ShowItemUpsertResult",
		createSettings:"SettingsCreateResult",
		deleteSettings:"SettingsDeleteResult",
		updateSettings:"SettingsUpdateResult",
		upsertSettings:"SettingsUpsertResult",
		createFooterGeneralContact:"FooterGeneralContactCreateResult",
		deleteFooterGeneralContact:"FooterGeneralContactDeleteResult",
		updateFooterGeneralContact:"FooterGeneralContactUpdateResult",
		upsertFooterGeneralContact:"FooterGeneralContactUpsertResult",
		createRedirect:"RedirectCreateResult",
		deleteRedirect:"RedirectDeleteResult",
		updateRedirect:"RedirectUpdateResult",
		upsertRedirect:"RedirectUpsertResult",
		transaction:"MutationTransaction",
		query:"Query",
		generateUploadUrl:"S3SignedUpload",
		generateReadUrl:"S3SignedRead"
	},
	ContentBlockCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	MutationResult:{
		"...on ContentBlockCreateResult": "ContentBlockCreateResult",
		"...on ContentBlockDeleteResult": "ContentBlockDeleteResult",
		"...on ContentBlockUpdateResult": "ContentBlockUpdateResult",
		"...on ContentBlockUpsertResult": "ContentBlockUpsertResult",
		"...on ImageCreateResult": "ImageCreateResult",
		"...on ImageDeleteResult": "ImageDeleteResult",
		"...on ImageUpdateResult": "ImageUpdateResult",
		"...on ImageUpsertResult": "ImageUpsertResult",
		"...on LinkCreateResult": "LinkCreateResult",
		"...on LinkDeleteResult": "LinkDeleteResult",
		"...on LinkUpdateResult": "LinkUpdateResult",
		"...on LinkUpsertResult": "LinkUpsertResult",
		"...on SeoCreateResult": "SeoCreateResult",
		"...on SeoDeleteResult": "SeoDeleteResult",
		"...on SeoUpdateResult": "SeoUpdateResult",
		"...on SeoUpsertResult": "SeoUpsertResult",
		"...on HomePageCreateResult": "HomePageCreateResult",
		"...on HomePageDeleteResult": "HomePageDeleteResult",
		"...on HomePageUpdateResult": "HomePageUpdateResult",
		"...on HomePageUpsertResult": "HomePageUpsertResult",
		"...on LinkableCreateResult": "LinkableCreateResult",
		"...on LinkableDeleteResult": "LinkableDeleteResult",
		"...on LinkableUpdateResult": "LinkableUpdateResult",
		"...on LinkableUpsertResult": "LinkableUpsertResult",
		"...on MediumGalleryCreateResult": "MediumGalleryCreateResult",
		"...on MediumGalleryDeleteResult": "MediumGalleryDeleteResult",
		"...on MediumGalleryUpdateResult": "MediumGalleryUpdateResult",
		"...on MediumGalleryUpsertResult": "MediumGalleryUpsertResult",
		"...on MediumGalleryItemCreateResult": "MediumGalleryItemCreateResult",
		"...on MediumGalleryItemDeleteResult": "MediumGalleryItemDeleteResult",
		"...on MediumGalleryItemUpdateResult": "MediumGalleryItemUpdateResult",
		"...on MediumGalleryItemUpsertResult": "MediumGalleryItemUpsertResult",
		"...on MemberCreateResult": "MemberCreateResult",
		"...on MemberDeleteResult": "MemberDeleteResult",
		"...on MemberUpdateResult": "MemberUpdateResult",
		"...on MemberUpsertResult": "MemberUpsertResult",
		"...on MemberItemCreateResult": "MemberItemCreateResult",
		"...on MemberItemDeleteResult": "MemberItemDeleteResult",
		"...on MemberItemUpdateResult": "MemberItemUpdateResult",
		"...on MemberItemUpsertResult": "MemberItemUpsertResult",
		"...on MemberListCreateResult": "MemberListCreateResult",
		"...on MemberListDeleteResult": "MemberListDeleteResult",
		"...on MemberListUpdateResult": "MemberListUpdateResult",
		"...on MemberListUpsertResult": "MemberListUpsertResult",
		"...on ShowCreateResult": "ShowCreateResult",
		"...on ShowDeleteResult": "ShowDeleteResult",
		"...on ShowUpdateResult": "ShowUpdateResult",
		"...on ShowUpsertResult": "ShowUpsertResult",
		"...on ShowListCreateResult": "ShowListCreateResult",
		"...on ShowListDeleteResult": "ShowListDeleteResult",
		"...on ShowListUpdateResult": "ShowListUpdateResult",
		"...on ShowListUpsertResult": "ShowListUpsertResult",
		"...on ShowYearCreateResult": "ShowYearCreateResult",
		"...on ShowYearDeleteResult": "ShowYearDeleteResult",
		"...on ShowYearUpdateResult": "ShowYearUpdateResult",
		"...on ShowYearUpsertResult": "ShowYearUpsertResult",
		"...on ShowYearItemCreateResult": "ShowYearItemCreateResult",
		"...on ShowYearItemDeleteResult": "ShowYearItemDeleteResult",
		"...on ShowYearItemUpdateResult": "ShowYearItemUpdateResult",
		"...on ShowYearItemUpsertResult": "ShowYearItemUpsertResult",
		"...on ShowYearListCreateResult": "ShowYearListCreateResult",
		"...on ShowYearListDeleteResult": "ShowYearListDeleteResult",
		"...on ShowYearListUpdateResult": "ShowYearListUpdateResult",
		"...on ShowYearListUpsertResult": "ShowYearListUpsertResult",
		"...on SocialLinkCreateResult": "SocialLinkCreateResult",
		"...on SocialLinkDeleteResult": "SocialLinkDeleteResult",
		"...on SocialLinkUpdateResult": "SocialLinkUpdateResult",
		"...on SocialLinkUpsertResult": "SocialLinkUpsertResult",
		"...on SocialLinkItemCreateResult": "SocialLinkItemCreateResult",
		"...on SocialLinkItemDeleteResult": "SocialLinkItemDeleteResult",
		"...on SocialLinkItemUpdateResult": "SocialLinkItemUpdateResult",
		"...on SocialLinkItemUpsertResult": "SocialLinkItemUpsertResult",
		"...on SocialLinkListCreateResult": "SocialLinkListCreateResult",
		"...on SocialLinkListDeleteResult": "SocialLinkListDeleteResult",
		"...on SocialLinkListUpdateResult": "SocialLinkListUpdateResult",
		"...on SocialLinkListUpsertResult": "SocialLinkListUpsertResult",
		"...on VideoCreateResult": "VideoCreateResult",
		"...on VideoDeleteResult": "VideoDeleteResult",
		"...on VideoUpdateResult": "VideoUpdateResult",
		"...on VideoUpsertResult": "VideoUpsertResult",
		"...on YoutubeVideoCreateResult": "YoutubeVideoCreateResult",
		"...on YoutubeVideoDeleteResult": "YoutubeVideoDeleteResult",
		"...on YoutubeVideoUpdateResult": "YoutubeVideoUpdateResult",
		"...on YoutubeVideoUpsertResult": "YoutubeVideoUpsertResult",
		"...on HeaderCreateResult": "HeaderCreateResult",
		"...on HeaderDeleteResult": "HeaderDeleteResult",
		"...on HeaderUpdateResult": "HeaderUpdateResult",
		"...on HeaderUpsertResult": "HeaderUpsertResult",
		"...on FooterCreateResult": "FooterCreateResult",
		"...on FooterDeleteResult": "FooterDeleteResult",
		"...on FooterUpdateResult": "FooterUpdateResult",
		"...on FooterUpsertResult": "FooterUpsertResult",
		"...on FooterAddressCreateResult": "FooterAddressCreateResult",
		"...on FooterAddressDeleteResult": "FooterAddressDeleteResult",
		"...on FooterAddressUpdateResult": "FooterAddressUpdateResult",
		"...on FooterAddressUpsertResult": "FooterAddressUpsertResult",
		"...on PortfolioPageCreateResult": "PortfolioPageCreateResult",
		"...on PortfolioPageDeleteResult": "PortfolioPageDeleteResult",
		"...on PortfolioPageUpdateResult": "PortfolioPageUpdateResult",
		"...on PortfolioPageUpsertResult": "PortfolioPageUpsertResult",
		"...on ShowItemCreateResult": "ShowItemCreateResult",
		"...on ShowItemDeleteResult": "ShowItemDeleteResult",
		"...on ShowItemUpdateResult": "ShowItemUpdateResult",
		"...on ShowItemUpsertResult": "ShowItemUpsertResult",
		"...on SettingsCreateResult": "SettingsCreateResult",
		"...on SettingsDeleteResult": "SettingsDeleteResult",
		"...on SettingsUpdateResult": "SettingsUpdateResult",
		"...on SettingsUpsertResult": "SettingsUpsertResult",
		"...on FooterGeneralContactCreateResult": "FooterGeneralContactCreateResult",
		"...on FooterGeneralContactDeleteResult": "FooterGeneralContactDeleteResult",
		"...on FooterGeneralContactUpdateResult": "FooterGeneralContactUpdateResult",
		"...on FooterGeneralContactUpsertResult": "FooterGeneralContactUpsertResult",
		"...on RedirectCreateResult": "RedirectCreateResult",
		"...on RedirectDeleteResult": "RedirectDeleteResult",
		"...on RedirectUpdateResult": "RedirectUpdateResult",
		"...on RedirectUpsertResult": "RedirectUpsertResult",
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError"
	},
	_MutationError:{
		path:"_PathFragment",
		paths:"_PathFragment",
		type:"_MutationErrorType",
		message:"String"
	},
	ContentBlockDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock"
	},
	ContentBlockUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ImageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image"
	},
	ImageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	LinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link"
	},
	LinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	SeoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo"
	},
	SeoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	HomePageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage",
		validation:"_ValidationResult"
	},
	HomePageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage"
	},
	HomePageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage",
		validation:"_ValidationResult"
	},
	HomePageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage",
		validation:"_ValidationResult"
	},
	LinkableCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable"
	},
	LinkableUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	MediumGalleryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumGallery",
		validation:"_ValidationResult"
	},
	MediumGalleryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumGallery"
	},
	MediumGalleryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumGallery",
		validation:"_ValidationResult"
	},
	MediumGalleryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumGallery",
		validation:"_ValidationResult"
	},
	MediumGalleryItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumGalleryItem",
		validation:"_ValidationResult"
	},
	MediumGalleryItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumGalleryItem"
	},
	MediumGalleryItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumGalleryItem",
		validation:"_ValidationResult"
	},
	MediumGalleryItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumGalleryItem",
		validation:"_ValidationResult"
	},
	MemberCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Member",
		validation:"_ValidationResult"
	},
	MemberDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Member"
	},
	MemberUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Member",
		validation:"_ValidationResult"
	},
	MemberUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Member",
		validation:"_ValidationResult"
	},
	MemberItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MemberItem",
		validation:"_ValidationResult"
	},
	MemberItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MemberItem"
	},
	MemberItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MemberItem",
		validation:"_ValidationResult"
	},
	MemberItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MemberItem",
		validation:"_ValidationResult"
	},
	MemberListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MemberList",
		validation:"_ValidationResult"
	},
	MemberListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MemberList"
	},
	MemberListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MemberList",
		validation:"_ValidationResult"
	},
	MemberListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MemberList",
		validation:"_ValidationResult"
	},
	ShowCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Show",
		validation:"_ValidationResult"
	},
	ShowDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Show"
	},
	ShowUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Show",
		validation:"_ValidationResult"
	},
	ShowUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Show",
		validation:"_ValidationResult"
	},
	ShowListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowList",
		validation:"_ValidationResult"
	},
	ShowListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowList"
	},
	ShowListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowList",
		validation:"_ValidationResult"
	},
	ShowListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowList",
		validation:"_ValidationResult"
	},
	ShowYearCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowYear",
		validation:"_ValidationResult"
	},
	ShowYearDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowYear"
	},
	ShowYearUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowYear",
		validation:"_ValidationResult"
	},
	ShowYearUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowYear",
		validation:"_ValidationResult"
	},
	ShowYearItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowYearItem",
		validation:"_ValidationResult"
	},
	ShowYearItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowYearItem"
	},
	ShowYearItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowYearItem",
		validation:"_ValidationResult"
	},
	ShowYearItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowYearItem",
		validation:"_ValidationResult"
	},
	ShowYearListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowYearList",
		validation:"_ValidationResult"
	},
	ShowYearListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowYearList"
	},
	ShowYearListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowYearList",
		validation:"_ValidationResult"
	},
	ShowYearListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowYearList",
		validation:"_ValidationResult"
	},
	SocialLinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLink",
		validation:"_ValidationResult"
	},
	SocialLinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLink"
	},
	SocialLinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLink",
		validation:"_ValidationResult"
	},
	SocialLinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLink",
		validation:"_ValidationResult"
	},
	SocialLinkItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkItem",
		validation:"_ValidationResult"
	},
	SocialLinkItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkItem"
	},
	SocialLinkItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkItem",
		validation:"_ValidationResult"
	},
	SocialLinkItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkItem",
		validation:"_ValidationResult"
	},
	SocialLinkListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkList",
		validation:"_ValidationResult"
	},
	SocialLinkListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkList"
	},
	SocialLinkListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkList",
		validation:"_ValidationResult"
	},
	SocialLinkListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SocialLinkList",
		validation:"_ValidationResult"
	},
	VideoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	VideoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video"
	},
	VideoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	VideoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	YoutubeVideoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"YoutubeVideo",
		validation:"_ValidationResult"
	},
	YoutubeVideoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"YoutubeVideo"
	},
	YoutubeVideoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"YoutubeVideo",
		validation:"_ValidationResult"
	},
	YoutubeVideoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"YoutubeVideo",
		validation:"_ValidationResult"
	},
	HeaderCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header"
	},
	HeaderUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	FooterCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer"
	},
	FooterUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterAddressCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterAddress",
		validation:"_ValidationResult"
	},
	FooterAddressDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterAddress"
	},
	FooterAddressUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterAddress",
		validation:"_ValidationResult"
	},
	FooterAddressUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterAddress",
		validation:"_ValidationResult"
	},
	PortfolioPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PortfolioPage",
		validation:"_ValidationResult"
	},
	PortfolioPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PortfolioPage"
	},
	PortfolioPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PortfolioPage",
		validation:"_ValidationResult"
	},
	PortfolioPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PortfolioPage",
		validation:"_ValidationResult"
	},
	ShowItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowItem",
		validation:"_ValidationResult"
	},
	ShowItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowItem"
	},
	ShowItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowItem",
		validation:"_ValidationResult"
	},
	ShowItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ShowItem",
		validation:"_ValidationResult"
	},
	SettingsCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Settings",
		validation:"_ValidationResult"
	},
	SettingsDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Settings"
	},
	SettingsUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Settings",
		validation:"_ValidationResult"
	},
	SettingsUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Settings",
		validation:"_ValidationResult"
	},
	FooterGeneralContactCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterGeneralContact",
		validation:"_ValidationResult"
	},
	FooterGeneralContactDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterGeneralContact"
	},
	FooterGeneralContactUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterGeneralContact",
		validation:"_ValidationResult"
	},
	FooterGeneralContactUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterGeneralContact",
		validation:"_ValidationResult"
	},
	RedirectCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	RedirectDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect"
	},
	RedirectUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	RedirectUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	MutationTransaction:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		validation:"_ValidationResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createHomePage:"HomePageCreateResult",
		deleteHomePage:"HomePageDeleteResult",
		updateHomePage:"HomePageUpdateResult",
		upsertHomePage:"HomePageUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createMediumGallery:"MediumGalleryCreateResult",
		deleteMediumGallery:"MediumGalleryDeleteResult",
		updateMediumGallery:"MediumGalleryUpdateResult",
		upsertMediumGallery:"MediumGalleryUpsertResult",
		createMediumGalleryItem:"MediumGalleryItemCreateResult",
		deleteMediumGalleryItem:"MediumGalleryItemDeleteResult",
		updateMediumGalleryItem:"MediumGalleryItemUpdateResult",
		upsertMediumGalleryItem:"MediumGalleryItemUpsertResult",
		createMember:"MemberCreateResult",
		deleteMember:"MemberDeleteResult",
		updateMember:"MemberUpdateResult",
		upsertMember:"MemberUpsertResult",
		createMemberItem:"MemberItemCreateResult",
		deleteMemberItem:"MemberItemDeleteResult",
		updateMemberItem:"MemberItemUpdateResult",
		upsertMemberItem:"MemberItemUpsertResult",
		createMemberList:"MemberListCreateResult",
		deleteMemberList:"MemberListDeleteResult",
		updateMemberList:"MemberListUpdateResult",
		upsertMemberList:"MemberListUpsertResult",
		createShow:"ShowCreateResult",
		deleteShow:"ShowDeleteResult",
		updateShow:"ShowUpdateResult",
		upsertShow:"ShowUpsertResult",
		createShowList:"ShowListCreateResult",
		deleteShowList:"ShowListDeleteResult",
		updateShowList:"ShowListUpdateResult",
		upsertShowList:"ShowListUpsertResult",
		createShowYear:"ShowYearCreateResult",
		deleteShowYear:"ShowYearDeleteResult",
		updateShowYear:"ShowYearUpdateResult",
		upsertShowYear:"ShowYearUpsertResult",
		createShowYearItem:"ShowYearItemCreateResult",
		deleteShowYearItem:"ShowYearItemDeleteResult",
		updateShowYearItem:"ShowYearItemUpdateResult",
		upsertShowYearItem:"ShowYearItemUpsertResult",
		createShowYearList:"ShowYearListCreateResult",
		deleteShowYearList:"ShowYearListDeleteResult",
		updateShowYearList:"ShowYearListUpdateResult",
		upsertShowYearList:"ShowYearListUpsertResult",
		createSocialLink:"SocialLinkCreateResult",
		deleteSocialLink:"SocialLinkDeleteResult",
		updateSocialLink:"SocialLinkUpdateResult",
		upsertSocialLink:"SocialLinkUpsertResult",
		createSocialLinkItem:"SocialLinkItemCreateResult",
		deleteSocialLinkItem:"SocialLinkItemDeleteResult",
		updateSocialLinkItem:"SocialLinkItemUpdateResult",
		upsertSocialLinkItem:"SocialLinkItemUpsertResult",
		createSocialLinkList:"SocialLinkListCreateResult",
		deleteSocialLinkList:"SocialLinkListDeleteResult",
		updateSocialLinkList:"SocialLinkListUpdateResult",
		upsertSocialLinkList:"SocialLinkListUpsertResult",
		createVideo:"VideoCreateResult",
		deleteVideo:"VideoDeleteResult",
		updateVideo:"VideoUpdateResult",
		upsertVideo:"VideoUpsertResult",
		createYoutubeVideo:"YoutubeVideoCreateResult",
		deleteYoutubeVideo:"YoutubeVideoDeleteResult",
		updateYoutubeVideo:"YoutubeVideoUpdateResult",
		upsertYoutubeVideo:"YoutubeVideoUpsertResult",
		createHeader:"HeaderCreateResult",
		deleteHeader:"HeaderDeleteResult",
		updateHeader:"HeaderUpdateResult",
		upsertHeader:"HeaderUpsertResult",
		createFooter:"FooterCreateResult",
		deleteFooter:"FooterDeleteResult",
		updateFooter:"FooterUpdateResult",
		upsertFooter:"FooterUpsertResult",
		createFooterAddress:"FooterAddressCreateResult",
		deleteFooterAddress:"FooterAddressDeleteResult",
		updateFooterAddress:"FooterAddressUpdateResult",
		upsertFooterAddress:"FooterAddressUpsertResult",
		createPortfolioPage:"PortfolioPageCreateResult",
		deletePortfolioPage:"PortfolioPageDeleteResult",
		updatePortfolioPage:"PortfolioPageUpdateResult",
		upsertPortfolioPage:"PortfolioPageUpsertResult",
		createShowItem:"ShowItemCreateResult",
		deleteShowItem:"ShowItemDeleteResult",
		updateShowItem:"ShowItemUpdateResult",
		upsertShowItem:"ShowItemUpsertResult",
		createSettings:"SettingsCreateResult",
		deleteSettings:"SettingsDeleteResult",
		updateSettings:"SettingsUpdateResult",
		upsertSettings:"SettingsUpsertResult",
		createFooterGeneralContact:"FooterGeneralContactCreateResult",
		deleteFooterGeneralContact:"FooterGeneralContactDeleteResult",
		updateFooterGeneralContact:"FooterGeneralContactUpdateResult",
		upsertFooterGeneralContact:"FooterGeneralContactUpsertResult",
		createRedirect:"RedirectCreateResult",
		deleteRedirect:"RedirectDeleteResult",
		updateRedirect:"RedirectUpdateResult",
		upsertRedirect:"RedirectUpsertResult",
		query:"Query"
	},
	_Schema:{
		enums:"_Enum",
		entities:"_Entity"
	},
	_Entity:{
		name:"String",
		customPrimaryAllowed:"Boolean",
		fields:"_Field",
		unique:"_UniqueConstraint"
	},
	_UniqueConstraint:{
		fields:"String"
	},
	_Field:{
		"...on _Column": "_Column",
		"...on _Relation": "_Relation",
		name:"String",
		type:"String",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Column:{
		name:"String",
		type:"String",
		enumName:"String",
		defaultValue:"Json",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_OrderBy:{
		path:"String",
		direction:"_OrderByDirection"
	},
	_Relation:{
		name:"String",
		type:"String",
		side:"_RelationSide",
		targetEntity:"String",
		ownedBy:"String",
		inversedBy:"String",
		nullable:"Boolean",
		onDelete:"_OnDeleteBehaviour",
		orphanRemoval:"Boolean",
		orderBy:"_OrderBy",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Rule:{
		message:"_RuleMessage",
		validator:"Int"
	},
	_Validator:{
		operation:"String",
		arguments:"_Argument"
	},
	_Argument:{
		"...on _ValidatorArgument":"_ValidatorArgument",
		"...on _PathArgument":"_PathArgument",
		"...on _LiteralArgument":"_LiteralArgument"
	},
	_ValidatorArgument:{
		validator:"Int"
	},
	_PathArgument:{
		path:"String"
	},
	_LiteralArgument:{
		value:"Json"
	},
	_RuleMessage:{
		text:"String"
	},
	_Enum:{
		name:"String",
		values:"String"
	},
	S3SignedUpload:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String",
		publicUrl:"String"
	},
	S3Header:{
		key:"String",
		value:"String"
	},
	S3SignedRead:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String"
	}
}
type ZEUS_INTERFACES = GraphQLTypes["MutationResult"] | GraphQLTypes["_Field"]
type ZEUS_UNIONS = GraphQLTypes["_PathFragment"] | GraphQLTypes["_Argument"]

export type ValueTypes = {
    ["Query"]: AliasType<{
getContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePage"]],
listHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomePage"]],
paginateHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomePageConnection"]],
validateCreateHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getMediumGallery?: [{	by:ValueTypes["MediumGalleryUniqueWhere"],	filter?:ValueTypes["MediumGalleryWhere"] | null},ValueTypes["MediumGallery"]],
listMediumGallery?: [{	filter?:ValueTypes["MediumGalleryWhere"] | null,	orderBy?:ValueTypes["MediumGalleryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MediumGallery"]],
paginateMediumGallery?: [{	filter?:ValueTypes["MediumGalleryWhere"] | null,	orderBy?:ValueTypes["MediumGalleryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediumGalleryConnection"]],
validateCreateMediumGallery?: [{	data:ValueTypes["MediumGalleryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMediumGallery?: [{	by:ValueTypes["MediumGalleryUniqueWhere"],	data:ValueTypes["MediumGalleryUpdateInput"]},ValueTypes["_ValidationResult"]],
getMediumGalleryItem?: [{	by:ValueTypes["MediumGalleryItemUniqueWhere"],	filter?:ValueTypes["MediumGalleryItemWhere"] | null},ValueTypes["MediumGalleryItem"]],
listMediumGalleryItem?: [{	filter?:ValueTypes["MediumGalleryItemWhere"] | null,	orderBy?:ValueTypes["MediumGalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MediumGalleryItem"]],
paginateMediumGalleryItem?: [{	filter?:ValueTypes["MediumGalleryItemWhere"] | null,	orderBy?:ValueTypes["MediumGalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediumGalleryItemConnection"]],
validateCreateMediumGalleryItem?: [{	data:ValueTypes["MediumGalleryItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMediumGalleryItem?: [{	by:ValueTypes["MediumGalleryItemUniqueWhere"],	data:ValueTypes["MediumGalleryItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getMember?: [{	by:ValueTypes["MemberUniqueWhere"],	filter?:ValueTypes["MemberWhere"] | null},ValueTypes["Member"]],
listMember?: [{	filter?:ValueTypes["MemberWhere"] | null,	orderBy?:ValueTypes["MemberOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Member"]],
paginateMember?: [{	filter?:ValueTypes["MemberWhere"] | null,	orderBy?:ValueTypes["MemberOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MemberConnection"]],
validateCreateMember?: [{	data:ValueTypes["MemberCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMember?: [{	by:ValueTypes["MemberUniqueWhere"],	data:ValueTypes["MemberUpdateInput"]},ValueTypes["_ValidationResult"]],
getMemberItem?: [{	by:ValueTypes["MemberItemUniqueWhere"],	filter?:ValueTypes["MemberItemWhere"] | null},ValueTypes["MemberItem"]],
listMemberItem?: [{	filter?:ValueTypes["MemberItemWhere"] | null,	orderBy?:ValueTypes["MemberItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MemberItem"]],
paginateMemberItem?: [{	filter?:ValueTypes["MemberItemWhere"] | null,	orderBy?:ValueTypes["MemberItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MemberItemConnection"]],
validateCreateMemberItem?: [{	data:ValueTypes["MemberItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMemberItem?: [{	by:ValueTypes["MemberItemUniqueWhere"],	data:ValueTypes["MemberItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getMemberList?: [{	by:ValueTypes["MemberListUniqueWhere"],	filter?:ValueTypes["MemberListWhere"] | null},ValueTypes["MemberList"]],
listMemberList?: [{	filter?:ValueTypes["MemberListWhere"] | null,	orderBy?:ValueTypes["MemberListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MemberList"]],
paginateMemberList?: [{	filter?:ValueTypes["MemberListWhere"] | null,	orderBy?:ValueTypes["MemberListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MemberListConnection"]],
validateCreateMemberList?: [{	data:ValueTypes["MemberListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMemberList?: [{	by:ValueTypes["MemberListUniqueWhere"],	data:ValueTypes["MemberListUpdateInput"]},ValueTypes["_ValidationResult"]],
getShow?: [{	by:ValueTypes["ShowUniqueWhere"],	filter?:ValueTypes["ShowWhere"] | null},ValueTypes["Show"]],
listShow?: [{	filter?:ValueTypes["ShowWhere"] | null,	orderBy?:ValueTypes["ShowOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Show"]],
paginateShow?: [{	filter?:ValueTypes["ShowWhere"] | null,	orderBy?:ValueTypes["ShowOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShowConnection"]],
validateCreateShow?: [{	data:ValueTypes["ShowCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShow?: [{	by:ValueTypes["ShowUniqueWhere"],	data:ValueTypes["ShowUpdateInput"]},ValueTypes["_ValidationResult"]],
getShowList?: [{	by:ValueTypes["ShowListUniqueWhere"],	filter?:ValueTypes["ShowListWhere"] | null},ValueTypes["ShowList"]],
listShowList?: [{	filter?:ValueTypes["ShowListWhere"] | null,	orderBy?:ValueTypes["ShowListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShowList"]],
paginateShowList?: [{	filter?:ValueTypes["ShowListWhere"] | null,	orderBy?:ValueTypes["ShowListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShowListConnection"]],
validateCreateShowList?: [{	data:ValueTypes["ShowListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShowList?: [{	by:ValueTypes["ShowListUniqueWhere"],	data:ValueTypes["ShowListUpdateInput"]},ValueTypes["_ValidationResult"]],
getShowYear?: [{	by:ValueTypes["ShowYearUniqueWhere"],	filter?:ValueTypes["ShowYearWhere"] | null},ValueTypes["ShowYear"]],
listShowYear?: [{	filter?:ValueTypes["ShowYearWhere"] | null,	orderBy?:ValueTypes["ShowYearOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShowYear"]],
paginateShowYear?: [{	filter?:ValueTypes["ShowYearWhere"] | null,	orderBy?:ValueTypes["ShowYearOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShowYearConnection"]],
validateCreateShowYear?: [{	data:ValueTypes["ShowYearCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShowYear?: [{	by:ValueTypes["ShowYearUniqueWhere"],	data:ValueTypes["ShowYearUpdateInput"]},ValueTypes["_ValidationResult"]],
getShowYearItem?: [{	by:ValueTypes["ShowYearItemUniqueWhere"],	filter?:ValueTypes["ShowYearItemWhere"] | null},ValueTypes["ShowYearItem"]],
listShowYearItem?: [{	filter?:ValueTypes["ShowYearItemWhere"] | null,	orderBy?:ValueTypes["ShowYearItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShowYearItem"]],
paginateShowYearItem?: [{	filter?:ValueTypes["ShowYearItemWhere"] | null,	orderBy?:ValueTypes["ShowYearItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShowYearItemConnection"]],
validateCreateShowYearItem?: [{	data:ValueTypes["ShowYearItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShowYearItem?: [{	by:ValueTypes["ShowYearItemUniqueWhere"],	data:ValueTypes["ShowYearItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getShowYearList?: [{	by:ValueTypes["ShowYearListUniqueWhere"],	filter?:ValueTypes["ShowYearListWhere"] | null},ValueTypes["ShowYearList"]],
listShowYearList?: [{	filter?:ValueTypes["ShowYearListWhere"] | null,	orderBy?:ValueTypes["ShowYearListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShowYearList"]],
paginateShowYearList?: [{	filter?:ValueTypes["ShowYearListWhere"] | null,	orderBy?:ValueTypes["ShowYearListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShowYearListConnection"]],
validateCreateShowYearList?: [{	data:ValueTypes["ShowYearListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShowYearList?: [{	by:ValueTypes["ShowYearListUniqueWhere"],	data:ValueTypes["ShowYearListUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLink"]],
listSocialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLink"]],
paginateSocialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkConnection"]],
validateCreateSocialLink?: [{	data:ValueTypes["SocialLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	data:ValueTypes["SocialLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null},ValueTypes["SocialLinkItem"]],
listSocialLinkItem?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLinkItem"]],
paginateSocialLinkItem?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkItemConnection"]],
validateCreateSocialLinkItem?: [{	data:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	data:ValueTypes["SocialLinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkList"]],
listSocialLinkList?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null,	orderBy?:ValueTypes["SocialLinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLinkList"]],
paginateSocialLinkList?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null,	orderBy?:ValueTypes["SocialLinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkListConnection"]],
validateCreateSocialLinkList?: [{	data:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	data:ValueTypes["SocialLinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["Video"]],
listVideo?: [{	filter?:ValueTypes["VideoWhere"] | null,	orderBy?:ValueTypes["VideoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Video"]],
paginateVideo?: [{	filter?:ValueTypes["VideoWhere"] | null,	orderBy?:ValueTypes["VideoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["VideoConnection"]],
validateCreateVideo?: [{	data:ValueTypes["VideoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	data:ValueTypes["VideoUpdateInput"]},ValueTypes["_ValidationResult"]],
getYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	filter?:ValueTypes["YoutubeVideoWhere"] | null},ValueTypes["YoutubeVideo"]],
listYoutubeVideo?: [{	filter?:ValueTypes["YoutubeVideoWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["YoutubeVideo"]],
paginateYoutubeVideo?: [{	filter?:ValueTypes["YoutubeVideoWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["YoutubeVideoConnection"]],
validateCreateYoutubeVideo?: [{	data:ValueTypes["YoutubeVideoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	data:ValueTypes["YoutubeVideoUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["Header"]],
listHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Header"]],
paginateHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderConnection"]],
validateCreateHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["Footer"]],
listFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Footer"]],
paginateFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	data:ValueTypes["FooterUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterAddress?: [{	by:ValueTypes["FooterAddressUniqueWhere"],	filter?:ValueTypes["FooterAddressWhere"] | null},ValueTypes["FooterAddress"]],
listFooterAddress?: [{	filter?:ValueTypes["FooterAddressWhere"] | null,	orderBy?:ValueTypes["FooterAddressOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterAddress"]],
paginateFooterAddress?: [{	filter?:ValueTypes["FooterAddressWhere"] | null,	orderBy?:ValueTypes["FooterAddressOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterAddressConnection"]],
validateCreateFooterAddress?: [{	data:ValueTypes["FooterAddressCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterAddress?: [{	by:ValueTypes["FooterAddressUniqueWhere"],	data:ValueTypes["FooterAddressUpdateInput"]},ValueTypes["_ValidationResult"]],
getPortfolioPage?: [{	by:ValueTypes["PortfolioPageUniqueWhere"],	filter?:ValueTypes["PortfolioPageWhere"] | null},ValueTypes["PortfolioPage"]],
listPortfolioPage?: [{	filter?:ValueTypes["PortfolioPageWhere"] | null,	orderBy?:ValueTypes["PortfolioPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PortfolioPage"]],
paginatePortfolioPage?: [{	filter?:ValueTypes["PortfolioPageWhere"] | null,	orderBy?:ValueTypes["PortfolioPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PortfolioPageConnection"]],
validateCreatePortfolioPage?: [{	data:ValueTypes["PortfolioPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePortfolioPage?: [{	by:ValueTypes["PortfolioPageUniqueWhere"],	data:ValueTypes["PortfolioPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getShowItem?: [{	by:ValueTypes["ShowItemUniqueWhere"],	filter?:ValueTypes["ShowItemWhere"] | null},ValueTypes["ShowItem"]],
listShowItem?: [{	filter?:ValueTypes["ShowItemWhere"] | null,	orderBy?:ValueTypes["ShowItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShowItem"]],
paginateShowItem?: [{	filter?:ValueTypes["ShowItemWhere"] | null,	orderBy?:ValueTypes["ShowItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShowItemConnection"]],
validateCreateShowItem?: [{	data:ValueTypes["ShowItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShowItem?: [{	by:ValueTypes["ShowItemUniqueWhere"],	data:ValueTypes["ShowItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSettings?: [{	by:ValueTypes["SettingsUniqueWhere"],	filter?:ValueTypes["SettingsWhere"] | null},ValueTypes["Settings"]],
listSettings?: [{	filter?:ValueTypes["SettingsWhere"] | null,	orderBy?:ValueTypes["SettingsOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Settings"]],
paginateSettings?: [{	filter?:ValueTypes["SettingsWhere"] | null,	orderBy?:ValueTypes["SettingsOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SettingsConnection"]],
validateCreateSettings?: [{	data:ValueTypes["SettingsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSettings?: [{	by:ValueTypes["SettingsUniqueWhere"],	data:ValueTypes["SettingsUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterGeneralContact?: [{	by:ValueTypes["FooterGeneralContactUniqueWhere"],	filter?:ValueTypes["FooterGeneralContactWhere"] | null},ValueTypes["FooterGeneralContact"]],
listFooterGeneralContact?: [{	filter?:ValueTypes["FooterGeneralContactWhere"] | null,	orderBy?:ValueTypes["FooterGeneralContactOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterGeneralContact"]],
paginateFooterGeneralContact?: [{	filter?:ValueTypes["FooterGeneralContactWhere"] | null,	orderBy?:ValueTypes["FooterGeneralContactOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterGeneralContactConnection"]],
validateCreateFooterGeneralContact?: [{	data:ValueTypes["FooterGeneralContactCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterGeneralContact?: [{	by:ValueTypes["FooterGeneralContactUniqueWhere"],	data:ValueTypes["FooterGeneralContactUpdateInput"]},ValueTypes["_ValidationResult"]],
getRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
listRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
paginateRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["_ValidationResult"]],
	transaction?:ValueTypes["QueryTransaction"],
	_info?:ValueTypes["Info"],
	schema?:ValueTypes["_Schema"],
	s3DummyQuery?:true,
		__typename?: true
}>;
	["ContentBlock"]: AliasType<{
	_meta?:ValueTypes["ContentBlockMeta"],
	id?:true,
	order?:true,
	type?:true,
	primaryText?:true,
	secondaryText?:true,
homePage?: [{	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePage"]],
gallery?: [{	filter?:ValueTypes["MediumGalleryWhere"] | null},ValueTypes["MediumGallery"]],
video?: [{	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["Video"]],
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
members?: [{	filter?:ValueTypes["MemberListWhere"] | null},ValueTypes["MemberList"]],
portfolio?: [{	filter?:ValueTypes["ShowYearListWhere"] | null},ValueTypes["ShowYearList"]],
		__typename?: true
}>;
	["ContentBlockMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	primaryText?:ValueTypes["FieldMeta"],
	secondaryText?:ValueTypes["FieldMeta"],
	homePage?:ValueTypes["FieldMeta"],
	gallery?:ValueTypes["FieldMeta"],
	video?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	members?:ValueTypes["FieldMeta"],
	portfolio?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FieldMeta"]: AliasType<{
	readable?:true,
	updatable?:true,
		__typename?: true
}>;
	["UUID"]:string;
	["ContentBlockType"]:ContentBlockType;
	["HomePage"]: AliasType<{
	_meta?:ValueTypes["HomePageMeta"],
	id?:true,
	name?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
	unique?:true,
blocks?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
blocksByGallery?: [{	by:ValueTypes["HomePageBlocksByGalleryUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
blocksByLink?: [{	by:ValueTypes["HomePageBlocksByLinkUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
blocksByMembers?: [{	by:ValueTypes["HomePageBlocksByMembersUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
paginateBlocks?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
		__typename?: true
}>;
	["HomePageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	blocks?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Linkable"]: AliasType<{
	_meta?:ValueTypes["LinkableMeta"],
	id?:true,
	url?:true,
homePage?: [{	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePage"]],
portfolioPage?: [{	filter?:ValueTypes["PortfolioPageWhere"] | null},ValueTypes["PortfolioPage"]],
showPage?: [{	filter?:ValueTypes["ShowWhere"] | null},ValueTypes["Show"]],
redirect?: [{	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
		__typename?: true
}>;
	["LinkableMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	homePage?:ValueTypes["FieldMeta"],
	portfolioPage?:ValueTypes["FieldMeta"],
	showPage?:ValueTypes["FieldMeta"],
	redirect?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["HomePageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	blocks?:ValueTypes["ContentBlockWhere"] | null,
	and?:(ValueTypes["HomePageWhere"] | undefined | null)[],
	or?:(ValueTypes["HomePageWhere"] | undefined | null)[],
	not?:ValueTypes["HomePageWhere"] | null
};
	["UUIDCondition"]: {
	and?:ValueTypes["UUIDCondition"][],
	or?:ValueTypes["UUIDCondition"][],
	not?:ValueTypes["UUIDCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["UUID"] | null,
	notEq?:ValueTypes["UUID"] | null,
	in?:ValueTypes["UUID"][],
	notIn?:ValueTypes["UUID"][],
	lt?:ValueTypes["UUID"] | null,
	lte?:ValueTypes["UUID"] | null,
	gt?:ValueTypes["UUID"] | null,
	gte?:ValueTypes["UUID"] | null
};
	["StringCondition"]: {
	and?:ValueTypes["StringCondition"][],
	or?:ValueTypes["StringCondition"][],
	not?:ValueTypes["StringCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:string | null,
	notEq?:string | null,
	in?:string[],
	notIn?:string[],
	lt?:string | null,
	lte?:string | null,
	gt?:string | null,
	gte?:string | null,
	contains?:string | null,
	startsWith?:string | null,
	endsWith?:string | null,
	containsCI?:string | null,
	startsWithCI?:string | null,
	endsWithCI?:string | null
};
	["LinkableWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	homePage?:ValueTypes["HomePageWhere"] | null,
	portfolioPage?:ValueTypes["PortfolioPageWhere"] | null,
	showPage?:ValueTypes["ShowWhere"] | null,
	redirect?:ValueTypes["RedirectWhere"] | null,
	and?:(ValueTypes["LinkableWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkableWhere"] | undefined | null)[],
	not?:ValueTypes["LinkableWhere"] | null
};
	["PortfolioPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["PortfolioPageWhere"] | undefined | null)[],
	or?:(ValueTypes["PortfolioPageWhere"] | undefined | null)[],
	not?:ValueTypes["PortfolioPageWhere"] | null
};
	["SeoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	description?:ValueTypes["StringCondition"] | null,
	ogTitle?:ValueTypes["StringCondition"] | null,
	ogDescription?:ValueTypes["StringCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	ogImage?:ValueTypes["ImageWhere"] | null,
	noIndex?:ValueTypes["BooleanCondition"] | null,
	noFollow?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["SeoWhere"] | undefined | null)[],
	or?:(ValueTypes["SeoWhere"] | undefined | null)[],
	not?:ValueTypes["SeoWhere"] | null
};
	["ImageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	width?:ValueTypes["IntCondition"] | null,
	height?:ValueTypes["IntCondition"] | null,
	size?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["StringCondition"] | null,
	alt?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ImageWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageWhere"] | undefined | null)[],
	not?:ValueTypes["ImageWhere"] | null
};
	["IntCondition"]: {
	and?:ValueTypes["IntCondition"][],
	or?:ValueTypes["IntCondition"][],
	not?:ValueTypes["IntCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:number | null,
	notEq?:number | null,
	in?:number[],
	notIn?:number[],
	lt?:number | null,
	lte?:number | null,
	gt?:number | null,
	gte?:number | null
};
	["BooleanCondition"]: {
	and?:ValueTypes["BooleanCondition"][],
	or?:ValueTypes["BooleanCondition"][],
	not?:ValueTypes["BooleanCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:boolean | null,
	notEq?:boolean | null,
	in?:boolean[],
	notIn?:boolean[],
	lt?:boolean | null,
	lte?:boolean | null,
	gt?:boolean | null,
	gte?:boolean | null
};
	["OneCondition"]: {
	and?:ValueTypes["OneCondition"][],
	or?:ValueTypes["OneCondition"][],
	not?:ValueTypes["OneCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["One"] | null,
	notEq?:ValueTypes["One"] | null,
	in?:ValueTypes["One"][],
	notIn?:ValueTypes["One"][],
	lt?:ValueTypes["One"] | null,
	lte?:ValueTypes["One"] | null,
	gt?:ValueTypes["One"] | null,
	gte?:ValueTypes["One"] | null
};
	["One"]:One;
	["ShowWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	description?:ValueTypes["StringCondition"] | null,
	posterType?:ValueTypes["ShowPosterTypeCondition"] | null,
	poster?:ValueTypes["ImageWhere"] | null,
	showItem?:ValueTypes["ShowItemWhere"] | null,
	posterSizeType?:ValueTypes["ShowPosterSizeTypeCondition"] | null,
	categoryYear?:ValueTypes["ShowYearWhere"] | null,
	production?:ValueTypes["StringCondition"] | null,
	directors?:ValueTypes["StringCondition"] | null,
	starrings?:ValueTypes["StringCondition"] | null,
	gallery?:ValueTypes["MediumGalleryWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	synopsis?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ShowWhere"] | undefined | null)[],
	or?:(ValueTypes["ShowWhere"] | undefined | null)[],
	not?:ValueTypes["ShowWhere"] | null
};
	["ShowPosterTypeCondition"]: {
	and?:ValueTypes["ShowPosterTypeCondition"][],
	or?:ValueTypes["ShowPosterTypeCondition"][],
	not?:ValueTypes["ShowPosterTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ShowPosterType"] | null,
	notEq?:ValueTypes["ShowPosterType"] | null,
	in?:ValueTypes["ShowPosterType"][],
	notIn?:ValueTypes["ShowPosterType"][],
	lt?:ValueTypes["ShowPosterType"] | null,
	lte?:ValueTypes["ShowPosterType"] | null,
	gt?:ValueTypes["ShowPosterType"] | null,
	gte?:ValueTypes["ShowPosterType"] | null
};
	["ShowPosterType"]:ShowPosterType;
	["ShowItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["ShowListWhere"] | null,
	show?:ValueTypes["ShowWhere"] | null,
	and?:(ValueTypes["ShowItemWhere"] | undefined | null)[],
	or?:(ValueTypes["ShowItemWhere"] | undefined | null)[],
	not?:ValueTypes["ShowItemWhere"] | null
};
	["ShowListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["ShowItemWhere"] | null,
	and?:(ValueTypes["ShowListWhere"] | undefined | null)[],
	or?:(ValueTypes["ShowListWhere"] | undefined | null)[],
	not?:ValueTypes["ShowListWhere"] | null
};
	["ShowPosterSizeTypeCondition"]: {
	and?:ValueTypes["ShowPosterSizeTypeCondition"][],
	or?:ValueTypes["ShowPosterSizeTypeCondition"][],
	not?:ValueTypes["ShowPosterSizeTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ShowPosterSizeType"] | null,
	notEq?:ValueTypes["ShowPosterSizeType"] | null,
	in?:ValueTypes["ShowPosterSizeType"][],
	notIn?:ValueTypes["ShowPosterSizeType"][],
	lt?:ValueTypes["ShowPosterSizeType"] | null,
	lte?:ValueTypes["ShowPosterSizeType"] | null,
	gt?:ValueTypes["ShowPosterSizeType"] | null,
	gte?:ValueTypes["ShowPosterSizeType"] | null
};
	["ShowPosterSizeType"]:ShowPosterSizeType;
	["ShowYearWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	showList?:ValueTypes["ShowWhere"] | null,
	and?:(ValueTypes["ShowYearWhere"] | undefined | null)[],
	or?:(ValueTypes["ShowYearWhere"] | undefined | null)[],
	not?:ValueTypes["ShowYearWhere"] | null
};
	["MediumGalleryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["MediumGalleryItemWhere"] | null,
	and?:(ValueTypes["MediumGalleryWhere"] | undefined | null)[],
	or?:(ValueTypes["MediumGalleryWhere"] | undefined | null)[],
	not?:ValueTypes["MediumGalleryWhere"] | null
};
	["MediumGalleryItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["MediumTypeCondition"] | null,
	gallery?:ValueTypes["MediumGalleryWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	video?:ValueTypes["VideoWhere"] | null,
	and?:(ValueTypes["MediumGalleryItemWhere"] | undefined | null)[],
	or?:(ValueTypes["MediumGalleryItemWhere"] | undefined | null)[],
	not?:ValueTypes["MediumGalleryItemWhere"] | null
};
	["MediumTypeCondition"]: {
	and?:ValueTypes["MediumTypeCondition"][],
	or?:ValueTypes["MediumTypeCondition"][],
	not?:ValueTypes["MediumTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["MediumType"] | null,
	notEq?:ValueTypes["MediumType"] | null,
	in?:ValueTypes["MediumType"][],
	notIn?:ValueTypes["MediumType"][],
	lt?:ValueTypes["MediumType"] | null,
	lte?:ValueTypes["MediumType"] | null,
	gt?:ValueTypes["MediumType"] | null,
	gte?:ValueTypes["MediumType"] | null
};
	["MediumType"]:MediumType;
	["VideoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	src?:ValueTypes["StringCondition"] | null,
	width?:ValueTypes["IntCondition"] | null,
	height?:ValueTypes["IntCondition"] | null,
	size?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["StringCondition"] | null,
	duration?:ValueTypes["FloatCondition"] | null,
	poster?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["VideoWhere"] | undefined | null)[],
	or?:(ValueTypes["VideoWhere"] | undefined | null)[],
	not?:ValueTypes["VideoWhere"] | null
};
	["FloatCondition"]: {
	and?:ValueTypes["FloatCondition"][],
	or?:ValueTypes["FloatCondition"][],
	not?:ValueTypes["FloatCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:number | null,
	notEq?:number | null,
	in?:number[],
	notIn?:number[],
	lt?:number | null,
	lte?:number | null,
	gt?:number | null,
	gte?:number | null
};
	["RedirectWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	target?:ValueTypes["LinkableWhere"] | null,
	and?:(ValueTypes["RedirectWhere"] | undefined | null)[],
	or?:(ValueTypes["RedirectWhere"] | undefined | null)[],
	not?:ValueTypes["RedirectWhere"] | null
};
	["ContentBlockWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["ContentBlockTypeCondition"] | null,
	primaryText?:ValueTypes["StringCondition"] | null,
	secondaryText?:ValueTypes["StringCondition"] | null,
	homePage?:ValueTypes["HomePageWhere"] | null,
	gallery?:ValueTypes["MediumGalleryWhere"] | null,
	video?:ValueTypes["VideoWhere"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	members?:ValueTypes["MemberListWhere"] | null,
	portfolio?:ValueTypes["ShowYearListWhere"] | null,
	and?:(ValueTypes["ContentBlockWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentBlockWhere"] | undefined | null)[],
	not?:ValueTypes["ContentBlockWhere"] | null
};
	["ContentBlockTypeCondition"]: {
	and?:ValueTypes["ContentBlockTypeCondition"][],
	or?:ValueTypes["ContentBlockTypeCondition"][],
	not?:ValueTypes["ContentBlockTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ContentBlockType"] | null,
	notEq?:ValueTypes["ContentBlockType"] | null,
	in?:ValueTypes["ContentBlockType"][],
	notIn?:ValueTypes["ContentBlockType"][],
	lt?:ValueTypes["ContentBlockType"] | null,
	lte?:ValueTypes["ContentBlockType"] | null,
	gt?:ValueTypes["ContentBlockType"] | null,
	gte?:ValueTypes["ContentBlockType"] | null
};
	["LinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["LinkTypeCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	externalLink?:ValueTypes["StringCondition"] | null,
	internalLink?:ValueTypes["LinkableWhere"] | null,
	and?:(ValueTypes["LinkWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkWhere"] | undefined | null)[],
	not?:ValueTypes["LinkWhere"] | null
};
	["LinkTypeCondition"]: {
	and?:ValueTypes["LinkTypeCondition"][],
	or?:ValueTypes["LinkTypeCondition"][],
	not?:ValueTypes["LinkTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["LinkType"] | null,
	notEq?:ValueTypes["LinkType"] | null,
	in?:ValueTypes["LinkType"][],
	notIn?:ValueTypes["LinkType"][],
	lt?:ValueTypes["LinkType"] | null,
	lte?:ValueTypes["LinkType"] | null,
	gt?:ValueTypes["LinkType"] | null,
	gte?:ValueTypes["LinkType"] | null
};
	["LinkType"]:LinkType;
	["MemberListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["MemberItemWhere"] | null,
	and?:(ValueTypes["MemberListWhere"] | undefined | null)[],
	or?:(ValueTypes["MemberListWhere"] | undefined | null)[],
	not?:ValueTypes["MemberListWhere"] | null
};
	["MemberItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["MemberListWhere"] | null,
	member?:ValueTypes["MemberWhere"] | null,
	and?:(ValueTypes["MemberItemWhere"] | undefined | null)[],
	or?:(ValueTypes["MemberItemWhere"] | undefined | null)[],
	not?:ValueTypes["MemberItemWhere"] | null
};
	["MemberWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	firstName?:ValueTypes["StringCondition"] | null,
	lastName?:ValueTypes["StringCondition"] | null,
	position?:ValueTypes["StringCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	telephone?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["MemberWhere"] | undefined | null)[],
	or?:(ValueTypes["MemberWhere"] | undefined | null)[],
	not?:ValueTypes["MemberWhere"] | null
};
	["ShowYearListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["ShowYearItemWhere"] | null,
	and?:(ValueTypes["ShowYearListWhere"] | undefined | null)[],
	or?:(ValueTypes["ShowYearListWhere"] | undefined | null)[],
	not?:ValueTypes["ShowYearListWhere"] | null
};
	["ShowYearItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["ShowYearListWhere"] | null,
	showYear?:ValueTypes["ShowYearWhere"] | null,
	and?:(ValueTypes["ShowYearItemWhere"] | undefined | null)[],
	or?:(ValueTypes["ShowYearItemWhere"] | undefined | null)[],
	not?:ValueTypes["ShowYearItemWhere"] | null
};
	["PortfolioPage"]: AliasType<{
	_meta?:ValueTypes["PortfolioPageMeta"],
	id?:true,
	name?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
	unique?:true,
	title?:true,
	text?:true,
		__typename?: true
}>;
	["PortfolioPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Seo"]: AliasType<{
	_meta?:ValueTypes["SeoMeta"],
	id?:true,
	description?:true,
	ogTitle?:true,
	ogDescription?:true,
	title?:true,
ogImage?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
	noIndex?:true,
	noFollow?:true,
		__typename?: true
}>;
	["SeoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	ogTitle?:ValueTypes["FieldMeta"],
	ogDescription?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	ogImage?:ValueTypes["FieldMeta"],
	noIndex?:ValueTypes["FieldMeta"],
	noFollow?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Image"]: AliasType<{
	_meta?:ValueTypes["ImageMeta"],
	id?:true,
	url?:true,
	width?:true,
	height?:true,
	size?:true,
	type?:true,
	alt?:true,
		__typename?: true
}>;
	["ImageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	alt?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Show"]: AliasType<{
	_meta?:ValueTypes["ShowMeta"],
	id?:true,
	title?:true,
	description?:true,
	posterType?:true,
poster?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
showItem?: [{	filter?:ValueTypes["ShowItemWhere"] | null,	orderBy?:ValueTypes["ShowItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShowItem"]],
	posterSizeType?:true,
categoryYear?: [{	filter?:ValueTypes["ShowYearWhere"] | null},ValueTypes["ShowYear"]],
	production?:true,
	directors?:true,
	starrings?:true,
gallery?: [{	filter?:ValueTypes["MediumGalleryWhere"] | null},ValueTypes["MediumGallery"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
	synopsis?:true,
paginateShowItem?: [{	filter?:ValueTypes["ShowItemWhere"] | null,	orderBy?:ValueTypes["ShowItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShowItemConnection"]],
		__typename?: true
}>;
	["ShowMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	posterType?:ValueTypes["FieldMeta"],
	poster?:ValueTypes["FieldMeta"],
	showItem?:ValueTypes["FieldMeta"],
	posterSizeType?:ValueTypes["FieldMeta"],
	categoryYear?:ValueTypes["FieldMeta"],
	production?:ValueTypes["FieldMeta"],
	directors?:ValueTypes["FieldMeta"],
	starrings?:ValueTypes["FieldMeta"],
	gallery?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	synopsis?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ShowItem"]: AliasType<{
	_meta?:ValueTypes["ShowItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["ShowListWhere"] | null},ValueTypes["ShowList"]],
show?: [{	filter?:ValueTypes["ShowWhere"] | null},ValueTypes["Show"]],
		__typename?: true
}>;
	["ShowItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	show?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ShowList"]: AliasType<{
	_meta?:ValueTypes["ShowListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["ShowItemWhere"] | null,	orderBy?:ValueTypes["ShowItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShowItem"]],
paginateItems?: [{	filter?:ValueTypes["ShowItemWhere"] | null,	orderBy?:ValueTypes["ShowItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShowItemConnection"]],
		__typename?: true
}>;
	["ShowListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ShowItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["ShowListOrderBy"] | null,
	show?:ValueTypes["ShowOrderBy"] | null
};
	["OrderDirection"]:OrderDirection;
	["ShowListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["ShowOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	description?:ValueTypes["OrderDirection"] | null,
	posterType?:ValueTypes["OrderDirection"] | null,
	poster?:ValueTypes["ImageOrderBy"] | null,
	posterSizeType?:ValueTypes["OrderDirection"] | null,
	categoryYear?:ValueTypes["ShowYearOrderBy"] | null,
	production?:ValueTypes["OrderDirection"] | null,
	directors?:ValueTypes["OrderDirection"] | null,
	starrings?:ValueTypes["OrderDirection"] | null,
	gallery?:ValueTypes["MediumGalleryOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	synopsis?:ValueTypes["OrderDirection"] | null
};
	["ImageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	width?:ValueTypes["OrderDirection"] | null,
	height?:ValueTypes["OrderDirection"] | null,
	size?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	alt?:ValueTypes["OrderDirection"] | null
};
	["ShowYearOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null
};
	["MediumGalleryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["SeoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	description?:ValueTypes["OrderDirection"] | null,
	ogTitle?:ValueTypes["OrderDirection"] | null,
	ogDescription?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	ogImage?:ValueTypes["ImageOrderBy"] | null,
	noIndex?:ValueTypes["OrderDirection"] | null,
	noFollow?:ValueTypes["OrderDirection"] | null
};
	["LinkableOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	homePage?:ValueTypes["HomePageOrderBy"] | null,
	portfolioPage?:ValueTypes["PortfolioPageOrderBy"] | null,
	showPage?:ValueTypes["ShowOrderBy"] | null,
	redirect?:ValueTypes["RedirectOrderBy"] | null
};
	["HomePageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	unique?:ValueTypes["OrderDirection"] | null
};
	["PortfolioPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null
};
	["RedirectOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	target?:ValueTypes["LinkableOrderBy"] | null
};
	["ShowItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ShowItemEdge"],
		__typename?: true
}>;
	["PageInfo"]: AliasType<{
	totalCount?:true,
		__typename?: true
}>;
	["ShowItemEdge"]: AliasType<{
	node?:ValueTypes["ShowItem"],
		__typename?: true
}>;
	["ShowYear"]: AliasType<{
	_meta?:ValueTypes["ShowYearMeta"],
	id?:true,
	order?:true,
	name?:true,
showList?: [{	filter?:ValueTypes["ShowWhere"] | null,	orderBy?:ValueTypes["ShowOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Show"]],
showListByShowItem?: [{	by:ValueTypes["ShowYearShowListByShowItemUniqueWhere"],	filter?:ValueTypes["ShowWhere"] | null},ValueTypes["Show"]],
showListByGallery?: [{	by:ValueTypes["ShowYearShowListByGalleryUniqueWhere"],	filter?:ValueTypes["ShowWhere"] | null},ValueTypes["Show"]],
showListBySeo?: [{	by:ValueTypes["ShowYearShowListBySeoUniqueWhere"],	filter?:ValueTypes["ShowWhere"] | null},ValueTypes["Show"]],
showListByLink?: [{	by:ValueTypes["ShowYearShowListByLinkUniqueWhere"],	filter?:ValueTypes["ShowWhere"] | null},ValueTypes["Show"]],
paginateShowList?: [{	filter?:ValueTypes["ShowWhere"] | null,	orderBy?:ValueTypes["ShowOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShowConnection"]],
		__typename?: true
}>;
	["ShowYearMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	showList?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ShowYearShowListByShowItemUniqueWhere"]: {
	showItem?:ValueTypes["ShowItemUniqueWhere"] | null
};
	["ShowItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ShowYearShowListByGalleryUniqueWhere"]: {
	gallery?:ValueTypes["MediumGalleryUniqueWhere"] | null
};
	["MediumGalleryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["MediumGalleryItemUniqueWhere"] | null
};
	["MediumGalleryItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ShowYearShowListBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["SeoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	ogImage?:ValueTypes["ImageUniqueWhere"] | null
};
	["ImageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ShowYearShowListByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["LinkableUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["HomePageUniqueWhere"] | null,
	portfolioPage?:ValueTypes["PortfolioPageUniqueWhere"] | null,
	showPage?:ValueTypes["ShowUniqueWhere"] | null,
	redirect?:ValueTypes["RedirectUniqueWhere"] | null
};
	["HomePageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	blocks?:ValueTypes["ContentBlockUniqueWhere"] | null
};
	["ContentBlockUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	gallery?:ValueTypes["MediumGalleryUniqueWhere"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null,
	members?:ValueTypes["MemberListUniqueWhere"] | null
};
	["LinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["MemberListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["MemberItemUniqueWhere"] | null
};
	["MemberItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["PortfolioPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["ShowUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	showItem?:ValueTypes["ShowItemUniqueWhere"] | null,
	gallery?:ValueTypes["MediumGalleryUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["RedirectUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["ShowConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ShowEdge"],
		__typename?: true
}>;
	["ShowEdge"]: AliasType<{
	node?:ValueTypes["Show"],
		__typename?: true
}>;
	["MediumGallery"]: AliasType<{
	_meta?:ValueTypes["MediumGalleryMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["MediumGalleryItemWhere"] | null,	orderBy?:ValueTypes["MediumGalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MediumGalleryItem"]],
paginateItems?: [{	filter?:ValueTypes["MediumGalleryItemWhere"] | null,	orderBy?:ValueTypes["MediumGalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediumGalleryItemConnection"]],
		__typename?: true
}>;
	["MediumGalleryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["MediumGalleryItem"]: AliasType<{
	_meta?:ValueTypes["MediumGalleryItemMeta"],
	id?:true,
	order?:true,
	type?:true,
gallery?: [{	filter?:ValueTypes["MediumGalleryWhere"] | null},ValueTypes["MediumGallery"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
video?: [{	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["Video"]],
		__typename?: true
}>;
	["MediumGalleryItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	gallery?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	video?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Video"]: AliasType<{
	_meta?:ValueTypes["VideoMeta"],
	id?:true,
	src?:true,
	width?:true,
	height?:true,
	size?:true,
	type?:true,
	duration?:true,
poster?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["VideoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	src?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	duration?:ValueTypes["FieldMeta"],
	poster?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["MediumGalleryItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	gallery?:ValueTypes["MediumGalleryOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	video?:ValueTypes["VideoOrderBy"] | null
};
	["VideoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	src?:ValueTypes["OrderDirection"] | null,
	width?:ValueTypes["OrderDirection"] | null,
	height?:ValueTypes["OrderDirection"] | null,
	size?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	duration?:ValueTypes["OrderDirection"] | null,
	poster?:ValueTypes["ImageOrderBy"] | null
};
	["MediumGalleryItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MediumGalleryItemEdge"],
		__typename?: true
}>;
	["MediumGalleryItemEdge"]: AliasType<{
	node?:ValueTypes["MediumGalleryItem"],
		__typename?: true
}>;
	["Redirect"]: AliasType<{
	_meta?:ValueTypes["RedirectMeta"],
	id?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
target?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
		__typename?: true
}>;
	["RedirectMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	target?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContentBlockOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	primaryText?:ValueTypes["OrderDirection"] | null,
	secondaryText?:ValueTypes["OrderDirection"] | null,
	homePage?:ValueTypes["HomePageOrderBy"] | null,
	gallery?:ValueTypes["MediumGalleryOrderBy"] | null,
	video?:ValueTypes["VideoOrderBy"] | null,
	link?:ValueTypes["LinkOrderBy"] | null,
	members?:ValueTypes["MemberListOrderBy"] | null,
	portfolio?:ValueTypes["ShowYearListOrderBy"] | null
};
	["LinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	externalLink?:ValueTypes["OrderDirection"] | null,
	internalLink?:ValueTypes["LinkableOrderBy"] | null
};
	["MemberListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["ShowYearListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["HomePageBlocksByGalleryUniqueWhere"]: {
	gallery?:ValueTypes["MediumGalleryUniqueWhere"] | null
};
	["HomePageBlocksByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["HomePageBlocksByMembersUniqueWhere"]: {
	members?:ValueTypes["MemberListUniqueWhere"] | null
};
	["ContentBlockConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentBlockEdge"],
		__typename?: true
}>;
	["ContentBlockEdge"]: AliasType<{
	node?:ValueTypes["ContentBlock"],
		__typename?: true
}>;
	["Link"]: AliasType<{
	_meta?:ValueTypes["LinkMeta"],
	id?:true,
	type?:true,
	title?:true,
	externalLink?:true,
internalLink?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
		__typename?: true
}>;
	["LinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	externalLink?:ValueTypes["FieldMeta"],
	internalLink?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["MemberList"]: AliasType<{
	_meta?:ValueTypes["MemberListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["MemberItemWhere"] | null,	orderBy?:ValueTypes["MemberItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MemberItem"]],
paginateItems?: [{	filter?:ValueTypes["MemberItemWhere"] | null,	orderBy?:ValueTypes["MemberItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MemberItemConnection"]],
		__typename?: true
}>;
	["MemberListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["MemberItem"]: AliasType<{
	_meta?:ValueTypes["MemberItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["MemberListWhere"] | null},ValueTypes["MemberList"]],
member?: [{	filter?:ValueTypes["MemberWhere"] | null},ValueTypes["Member"]],
		__typename?: true
}>;
	["MemberItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	member?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Member"]: AliasType<{
	_meta?:ValueTypes["MemberMeta"],
	id?:true,
	firstName?:true,
	lastName?:true,
	position?:true,
	email?:true,
	telephone?:true,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["MemberMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	firstName?:ValueTypes["FieldMeta"],
	lastName?:ValueTypes["FieldMeta"],
	position?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	telephone?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["MemberItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["MemberListOrderBy"] | null,
	member?:ValueTypes["MemberOrderBy"] | null
};
	["MemberOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	firstName?:ValueTypes["OrderDirection"] | null,
	lastName?:ValueTypes["OrderDirection"] | null,
	position?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	telephone?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null
};
	["MemberItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MemberItemEdge"],
		__typename?: true
}>;
	["MemberItemEdge"]: AliasType<{
	node?:ValueTypes["MemberItem"],
		__typename?: true
}>;
	["ShowYearList"]: AliasType<{
	_meta?:ValueTypes["ShowYearListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["ShowYearItemWhere"] | null,	orderBy?:ValueTypes["ShowYearItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShowYearItem"]],
paginateItems?: [{	filter?:ValueTypes["ShowYearItemWhere"] | null,	orderBy?:ValueTypes["ShowYearItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShowYearItemConnection"]],
		__typename?: true
}>;
	["ShowYearListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ShowYearItem"]: AliasType<{
	_meta?:ValueTypes["ShowYearItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["ShowYearListWhere"] | null},ValueTypes["ShowYearList"]],
showYear?: [{	filter?:ValueTypes["ShowYearWhere"] | null},ValueTypes["ShowYear"]],
		__typename?: true
}>;
	["ShowYearItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	showYear?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ShowYearItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["ShowYearListOrderBy"] | null,
	showYear?:ValueTypes["ShowYearOrderBy"] | null
};
	["ShowYearItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ShowYearItemEdge"],
		__typename?: true
}>;
	["ShowYearItemEdge"]: AliasType<{
	node?:ValueTypes["ShowYearItem"],
		__typename?: true
}>;
	["_ValidationResult"]: AliasType<{
	valid?:true,
	errors?:ValueTypes["_ValidationError"],
		__typename?: true
}>;
	["_ValidationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	message?:ValueTypes["_ValidationMessage"],
		__typename?: true
}>;
	["_PathFragment"]: AliasType<{		["...on _FieldPathFragment"] : ValueTypes["_FieldPathFragment"],
		["...on _IndexPathFragment"] : ValueTypes["_IndexPathFragment"]
		__typename?: true
}>;
	["_FieldPathFragment"]: AliasType<{
	field?:true,
		__typename?: true
}>;
	["_IndexPathFragment"]: AliasType<{
	index?:true,
	alias?:true,
		__typename?: true
}>;
	["_ValidationMessage"]: AliasType<{
	text?:true,
		__typename?: true
}>;
	["ContentBlockCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	type?:ValueTypes["ContentBlockType"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	homePage?:ValueTypes["ContentBlockCreateHomePageEntityRelationInput"] | null,
	gallery?:ValueTypes["ContentBlockCreateGalleryEntityRelationInput"] | null,
	video?:ValueTypes["ContentBlockCreateVideoEntityRelationInput"] | null,
	link?:ValueTypes["ContentBlockCreateLinkEntityRelationInput"] | null,
	members?:ValueTypes["ContentBlockCreateMembersEntityRelationInput"] | null,
	portfolio?:ValueTypes["ContentBlockCreatePortfolioEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockCreateHomePageEntityRelationInput"]: {
	connect?:ValueTypes["HomePageUniqueWhere"] | null,
	create?:ValueTypes["HomePageWithoutBlocksCreateInput"] | null
};
	["HomePageWithoutBlocksCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	link?:ValueTypes["HomePageCreateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageCreateSeoEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutHomePageCreateInput"] | null
};
	["LinkableWithoutHomePageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	portfolioPage?:ValueTypes["LinkableCreatePortfolioPageEntityRelationInput"] | null,
	showPage?:ValueTypes["LinkableCreateShowPageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreatePortfolioPageEntityRelationInput"]: {
	connect?:ValueTypes["PortfolioPageUniqueWhere"] | null,
	create?:ValueTypes["PortfolioPageWithoutLinkCreateInput"] | null
};
	["PortfolioPageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	seo?:ValueTypes["PortfolioPageCreateSeoEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	text?:string | null,
	_dummy_field_?:boolean | null
};
	["PortfolioPageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["SeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	title?:string | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	noIndex?:boolean | null,
	noFollow?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SeoCreateOgImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ImageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	alt?:string | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreateShowPageEntityRelationInput"]: {
	connect?:ValueTypes["ShowUniqueWhere"] | null,
	create?:ValueTypes["ShowWithoutLinkCreateInput"] | null
};
	["ShowWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	posterType?:ValueTypes["ShowPosterType"] | null,
	poster?:ValueTypes["ShowCreatePosterEntityRelationInput"] | null,
	showItem?:ValueTypes["ShowCreateShowItemEntityRelationInput"][],
	posterSizeType?:ValueTypes["ShowPosterSizeType"] | null,
	categoryYear?:ValueTypes["ShowCreateCategoryYearEntityRelationInput"] | null,
	production?:string | null,
	directors?:string | null,
	starrings?:string | null,
	gallery?:ValueTypes["ShowCreateGalleryEntityRelationInput"] | null,
	seo?:ValueTypes["ShowCreateSeoEntityRelationInput"] | null,
	synopsis?:string | null,
	_dummy_field_?:boolean | null
};
	["ShowCreatePosterEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ShowCreateShowItemEntityRelationInput"]: {
	connect?:ValueTypes["ShowItemUniqueWhere"] | null,
	create?:ValueTypes["ShowItemWithoutShowCreateInput"] | null,
	alias?:string | null
};
	["ShowItemWithoutShowCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["ShowItemCreateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ShowItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["ShowListUniqueWhere"] | null,
	create?:ValueTypes["ShowListWithoutItemsCreateInput"] | null
};
	["ShowListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ShowItemUniqueWhere"] | null
};
	["ShowListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ShowCreateCategoryYearEntityRelationInput"]: {
	connect?:ValueTypes["ShowYearUniqueWhere"] | null,
	create?:ValueTypes["ShowYearWithoutShowListCreateInput"] | null
};
	["ShowYearUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	showList?:ValueTypes["ShowUniqueWhere"] | null
};
	["ShowYearWithoutShowListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	name?:string | null,
	_dummy_field_?:boolean | null
};
	["ShowCreateGalleryEntityRelationInput"]: {
	connect?:ValueTypes["MediumGalleryUniqueWhere"] | null,
	create?:ValueTypes["MediumGalleryCreateInput"] | null
};
	["MediumGalleryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["MediumGalleryCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["MediumGalleryCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["MediumGalleryItemUniqueWhere"] | null,
	create?:ValueTypes["MediumGalleryItemWithoutGalleryCreateInput"] | null,
	alias?:string | null
};
	["MediumGalleryItemWithoutGalleryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	type?:ValueTypes["MediumType"] | null,
	image?:ValueTypes["MediumGalleryItemCreateImageEntityRelationInput"] | null,
	video?:ValueTypes["MediumGalleryItemCreateVideoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MediumGalleryItemCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["MediumGalleryItemCreateVideoEntityRelationInput"]: {
	connect?:ValueTypes["VideoUniqueWhere"] | null,
	create?:ValueTypes["VideoCreateInput"] | null
};
	["VideoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["VideoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	src?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	duration?:number | null,
	poster?:ValueTypes["VideoCreatePosterEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["VideoCreatePosterEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ShowCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableCreateRedirectEntityRelationInput"]: {
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	create?:ValueTypes["RedirectWithoutLinkCreateInput"] | null
};
	["RedirectWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	target?:ValueTypes["RedirectCreateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectCreateTargetEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["LinkableCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	portfolioPage?:ValueTypes["LinkableCreatePortfolioPageEntityRelationInput"] | null,
	showPage?:ValueTypes["LinkableCreateShowPageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreateHomePageEntityRelationInput"]: {
	connect?:ValueTypes["HomePageUniqueWhere"] | null,
	create?:ValueTypes["HomePageWithoutLinkCreateInput"] | null
};
	["HomePageWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	seo?:ValueTypes["HomePageCreateSeoEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	blocks?:ValueTypes["HomePageCreateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["HomePageCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["HomePageCreateBlocksEntityRelationInput"]: {
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentBlockWithoutHomePageCreateInput"] | null,
	alias?:string | null
};
	["ContentBlockWithoutHomePageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	type?:ValueTypes["ContentBlockType"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	gallery?:ValueTypes["ContentBlockCreateGalleryEntityRelationInput"] | null,
	video?:ValueTypes["ContentBlockCreateVideoEntityRelationInput"] | null,
	link?:ValueTypes["ContentBlockCreateLinkEntityRelationInput"] | null,
	members?:ValueTypes["ContentBlockCreateMembersEntityRelationInput"] | null,
	portfolio?:ValueTypes["ContentBlockCreatePortfolioEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockCreateGalleryEntityRelationInput"]: {
	connect?:ValueTypes["MediumGalleryUniqueWhere"] | null,
	create?:ValueTypes["MediumGalleryCreateInput"] | null
};
	["ContentBlockCreateVideoEntityRelationInput"]: {
	connect?:ValueTypes["VideoUniqueWhere"] | null,
	create?:ValueTypes["VideoCreateInput"] | null
};
	["ContentBlockCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["LinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["LinkType"] | null,
	title?:string | null,
	externalLink?:string | null,
	internalLink?:ValueTypes["LinkCreateInternalLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["ContentBlockCreateMembersEntityRelationInput"]: {
	connect?:ValueTypes["MemberListUniqueWhere"] | null,
	create?:ValueTypes["MemberListCreateInput"] | null
};
	["MemberListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["MemberListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["MemberListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["MemberItemUniqueWhere"] | null,
	create?:ValueTypes["MemberItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["MemberItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	member?:ValueTypes["MemberItemCreateMemberEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MemberItemCreateMemberEntityRelationInput"]: {
	connect?:ValueTypes["MemberUniqueWhere"] | null,
	create?:ValueTypes["MemberCreateInput"] | null
};
	["MemberUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["MemberCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	firstName?:string | null,
	lastName?:string | null,
	position?:string | null,
	email?:string | null,
	telephone?:string | null,
	image?:ValueTypes["MemberCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MemberCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentBlockCreatePortfolioEntityRelationInput"]: {
	connect?:ValueTypes["ShowYearListUniqueWhere"] | null,
	create?:ValueTypes["ShowYearListCreateInput"] | null
};
	["ShowYearListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ShowYearItemUniqueWhere"] | null
};
	["ShowYearItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ShowYearListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ShowYearListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ShowYearListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ShowYearItemUniqueWhere"] | null,
	create?:ValueTypes["ShowYearItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["ShowYearItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	showYear?:ValueTypes["ShowYearItemCreateShowYearEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ShowYearItemCreateShowYearEntityRelationInput"]: {
	connect?:ValueTypes["ShowYearUniqueWhere"] | null,
	create?:ValueTypes["ShowYearCreateInput"] | null
};
	["ShowYearCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	name?:string | null,
	showList?:ValueTypes["ShowYearCreateShowListEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ShowYearCreateShowListEntityRelationInput"]: {
	connect?:ValueTypes["ShowUniqueWhere"] | null,
	create?:ValueTypes["ShowWithoutCategoryYearCreateInput"] | null,
	alias?:string | null
};
	["ShowWithoutCategoryYearCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	posterType?:ValueTypes["ShowPosterType"] | null,
	poster?:ValueTypes["ShowCreatePosterEntityRelationInput"] | null,
	showItem?:ValueTypes["ShowCreateShowItemEntityRelationInput"][],
	posterSizeType?:ValueTypes["ShowPosterSizeType"] | null,
	production?:string | null,
	directors?:string | null,
	starrings?:string | null,
	gallery?:ValueTypes["ShowCreateGalleryEntityRelationInput"] | null,
	seo?:ValueTypes["ShowCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ShowCreateLinkEntityRelationInput"] | null,
	synopsis?:string | null,
	_dummy_field_?:boolean | null
};
	["ShowCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutShowPageCreateInput"] | null
};
	["LinkableWithoutShowPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	portfolioPage?:ValueTypes["LinkableCreatePortfolioPageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateInput"]: {
	order?:number | null,
	type?:ValueTypes["ContentBlockType"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	homePage?:ValueTypes["ContentBlockUpdateHomePageEntityRelationInput"] | null,
	gallery?:ValueTypes["ContentBlockUpdateGalleryEntityRelationInput"] | null,
	video?:ValueTypes["ContentBlockUpdateVideoEntityRelationInput"] | null,
	link?:ValueTypes["ContentBlockUpdateLinkEntityRelationInput"] | null,
	members?:ValueTypes["ContentBlockUpdateMembersEntityRelationInput"] | null,
	portfolio?:ValueTypes["ContentBlockUpdatePortfolioEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateHomePageEntityRelationInput"]: {
	create?:ValueTypes["HomePageWithoutBlocksCreateInput"] | null,
	update?:ValueTypes["HomePageWithoutBlocksUpdateInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertHomePageRelationInput"] | null,
	connect?:ValueTypes["HomePageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HomePageWithoutBlocksUpdateInput"]: {
	name?:string | null,
	link?:ValueTypes["HomePageUpdateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageUpdateSeoEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutHomePageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutHomePageUpdateInput"] | null,
	upsert?:ValueTypes["HomePageUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutHomePageUpdateInput"]: {
	url?:string | null,
	portfolioPage?:ValueTypes["LinkableUpdatePortfolioPageEntityRelationInput"] | null,
	showPage?:ValueTypes["LinkableUpdateShowPageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableUpdatePortfolioPageEntityRelationInput"]: {
	create?:ValueTypes["PortfolioPageWithoutLinkCreateInput"] | null,
	update?:ValueTypes["PortfolioPageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertPortfolioPageRelationInput"] | null,
	connect?:ValueTypes["PortfolioPageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PortfolioPageWithoutLinkUpdateInput"]: {
	name?:string | null,
	seo?:ValueTypes["PortfolioPageUpdateSeoEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	text?:string | null,
	_dummy_field_?:boolean | null
};
	["PortfolioPageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["PortfolioPageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoUpdateInput"]: {
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	title?:string | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	noIndex?:boolean | null,
	noFollow?:boolean | null,
	_dummy_field_?:boolean | null
};
	["SeoUpdateOgImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertOgImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ImageUpdateInput"]: {
	url?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	alt?:string | null,
	_dummy_field_?:boolean | null
};
	["SeoUpsertOgImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["PortfolioPageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableUpsertPortfolioPageRelationInput"]: {
	update?:ValueTypes["PortfolioPageWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["PortfolioPageWithoutLinkCreateInput"] | null
};
	["LinkableUpdateShowPageEntityRelationInput"]: {
	create?:ValueTypes["ShowWithoutLinkCreateInput"] | null,
	update?:ValueTypes["ShowWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertShowPageRelationInput"] | null,
	connect?:ValueTypes["ShowUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ShowWithoutLinkUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	posterType?:ValueTypes["ShowPosterType"] | null,
	poster?:ValueTypes["ShowUpdatePosterEntityRelationInput"] | null,
	showItem?:ValueTypes["ShowUpdateShowItemEntityRelationInput"][],
	posterSizeType?:ValueTypes["ShowPosterSizeType"] | null,
	categoryYear?:ValueTypes["ShowUpdateCategoryYearEntityRelationInput"] | null,
	production?:string | null,
	directors?:string | null,
	starrings?:string | null,
	gallery?:ValueTypes["ShowUpdateGalleryEntityRelationInput"] | null,
	seo?:ValueTypes["ShowUpdateSeoEntityRelationInput"] | null,
	synopsis?:string | null,
	_dummy_field_?:boolean | null
};
	["ShowUpdatePosterEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ShowUpsertPosterRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ShowUpsertPosterRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ShowUpdateShowItemEntityRelationInput"]: {
	create?:ValueTypes["ShowItemWithoutShowCreateInput"] | null,
	update?:ValueTypes["ShowUpdateShowItemRelationInput"] | null,
	upsert?:ValueTypes["ShowUpsertShowItemRelationInput"] | null,
	connect?:ValueTypes["ShowItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ShowItemUniqueWhere"] | null,
	delete?:ValueTypes["ShowItemUniqueWhere"] | null,
	alias?:string | null
};
	["ShowUpdateShowItemRelationInput"]: {
	by?:ValueTypes["ShowItemUniqueWhere"] | null,
	data?:ValueTypes["ShowItemWithoutShowUpdateInput"] | null
};
	["ShowItemWithoutShowUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["ShowItemUpdateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ShowItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["ShowListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["ShowListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ShowItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["ShowListUniqueWhere"] | null,
	delete?:boolean | null
};
	["ShowListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ShowItemUpsertListRelationInput"]: {
	update?:ValueTypes["ShowListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["ShowListWithoutItemsCreateInput"] | null
};
	["ShowUpsertShowItemRelationInput"]: {
	by?:ValueTypes["ShowItemUniqueWhere"] | null,
	update?:ValueTypes["ShowItemWithoutShowUpdateInput"] | null,
	create?:ValueTypes["ShowItemWithoutShowCreateInput"] | null
};
	["ShowUpdateCategoryYearEntityRelationInput"]: {
	create?:ValueTypes["ShowYearWithoutShowListCreateInput"] | null,
	update?:ValueTypes["ShowYearWithoutShowListUpdateInput"] | null,
	upsert?:ValueTypes["ShowUpsertCategoryYearRelationInput"] | null,
	connect?:ValueTypes["ShowYearUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ShowYearWithoutShowListUpdateInput"]: {
	order?:number | null,
	name?:string | null,
	_dummy_field_?:boolean | null
};
	["ShowUpsertCategoryYearRelationInput"]: {
	update?:ValueTypes["ShowYearWithoutShowListUpdateInput"] | null,
	create?:ValueTypes["ShowYearWithoutShowListCreateInput"] | null
};
	["ShowUpdateGalleryEntityRelationInput"]: {
	create?:ValueTypes["MediumGalleryCreateInput"] | null,
	update?:ValueTypes["MediumGalleryUpdateInput"] | null,
	upsert?:ValueTypes["ShowUpsertGalleryRelationInput"] | null,
	connect?:ValueTypes["MediumGalleryUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["MediumGalleryUpdateInput"]: {
	items?:ValueTypes["MediumGalleryUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["MediumGalleryUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["MediumGalleryItemWithoutGalleryCreateInput"] | null,
	update?:ValueTypes["MediumGalleryUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["MediumGalleryUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["MediumGalleryItemUniqueWhere"] | null,
	disconnect?:ValueTypes["MediumGalleryItemUniqueWhere"] | null,
	delete?:ValueTypes["MediumGalleryItemUniqueWhere"] | null,
	alias?:string | null
};
	["MediumGalleryUpdateItemsRelationInput"]: {
	by?:ValueTypes["MediumGalleryItemUniqueWhere"] | null,
	data?:ValueTypes["MediumGalleryItemWithoutGalleryUpdateInput"] | null
};
	["MediumGalleryItemWithoutGalleryUpdateInput"]: {
	order?:number | null,
	type?:ValueTypes["MediumType"] | null,
	image?:ValueTypes["MediumGalleryItemUpdateImageEntityRelationInput"] | null,
	video?:ValueTypes["MediumGalleryItemUpdateVideoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MediumGalleryItemUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["MediumGalleryItemUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["MediumGalleryItemUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["MediumGalleryItemUpdateVideoEntityRelationInput"]: {
	create?:ValueTypes["VideoCreateInput"] | null,
	update?:ValueTypes["VideoUpdateInput"] | null,
	upsert?:ValueTypes["MediumGalleryItemUpsertVideoRelationInput"] | null,
	connect?:ValueTypes["VideoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["VideoUpdateInput"]: {
	src?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	duration?:number | null,
	poster?:ValueTypes["VideoUpdatePosterEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["VideoUpdatePosterEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["VideoUpsertPosterRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["VideoUpsertPosterRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["MediumGalleryItemUpsertVideoRelationInput"]: {
	update?:ValueTypes["VideoUpdateInput"] | null,
	create?:ValueTypes["VideoCreateInput"] | null
};
	["MediumGalleryUpsertItemsRelationInput"]: {
	by?:ValueTypes["MediumGalleryItemUniqueWhere"] | null,
	update?:ValueTypes["MediumGalleryItemWithoutGalleryUpdateInput"] | null,
	create?:ValueTypes["MediumGalleryItemWithoutGalleryCreateInput"] | null
};
	["ShowUpsertGalleryRelationInput"]: {
	update?:ValueTypes["MediumGalleryUpdateInput"] | null,
	create?:ValueTypes["MediumGalleryCreateInput"] | null
};
	["ShowUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["ShowUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ShowUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LinkableUpsertShowPageRelationInput"]: {
	update?:ValueTypes["ShowWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["ShowWithoutLinkCreateInput"] | null
};
	["LinkableUpdateRedirectEntityRelationInput"]: {
	create?:ValueTypes["RedirectWithoutLinkCreateInput"] | null,
	update?:ValueTypes["RedirectWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertRedirectRelationInput"] | null,
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["RedirectWithoutLinkUpdateInput"]: {
	target?:ValueTypes["RedirectUpdateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateTargetEntityRelationInput"]: {
	create?:ValueTypes["LinkableCreateInput"] | null,
	update?:ValueTypes["LinkableUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertTargetRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	delete?:boolean | null
};
	["LinkableUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	portfolioPage?:ValueTypes["LinkableUpdatePortfolioPageEntityRelationInput"] | null,
	showPage?:ValueTypes["LinkableUpdateShowPageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableUpdateHomePageEntityRelationInput"]: {
	create?:ValueTypes["HomePageWithoutLinkCreateInput"] | null,
	update?:ValueTypes["HomePageWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertHomePageRelationInput"] | null,
	connect?:ValueTypes["HomePageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HomePageWithoutLinkUpdateInput"]: {
	name?:string | null,
	seo?:ValueTypes["HomePageUpdateSeoEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	blocks?:ValueTypes["HomePageUpdateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["HomePageUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["HomePageUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HomePageUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["HomePageUpdateBlocksEntityRelationInput"]: {
	create?:ValueTypes["ContentBlockWithoutHomePageCreateInput"] | null,
	update?:ValueTypes["HomePageUpdateBlocksRelationInput"] | null,
	upsert?:ValueTypes["HomePageUpsertBlocksRelationInput"] | null,
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	delete?:ValueTypes["ContentBlockUniqueWhere"] | null,
	alias?:string | null
};
	["HomePageUpdateBlocksRelationInput"]: {
	by?:ValueTypes["ContentBlockUniqueWhere"] | null,
	data?:ValueTypes["ContentBlockWithoutHomePageUpdateInput"] | null
};
	["ContentBlockWithoutHomePageUpdateInput"]: {
	order?:number | null,
	type?:ValueTypes["ContentBlockType"] | null,
	primaryText?:string | null,
	secondaryText?:string | null,
	gallery?:ValueTypes["ContentBlockUpdateGalleryEntityRelationInput"] | null,
	video?:ValueTypes["ContentBlockUpdateVideoEntityRelationInput"] | null,
	link?:ValueTypes["ContentBlockUpdateLinkEntityRelationInput"] | null,
	members?:ValueTypes["ContentBlockUpdateMembersEntityRelationInput"] | null,
	portfolio?:ValueTypes["ContentBlockUpdatePortfolioEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateGalleryEntityRelationInput"]: {
	create?:ValueTypes["MediumGalleryCreateInput"] | null,
	update?:ValueTypes["MediumGalleryUpdateInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertGalleryRelationInput"] | null,
	connect?:ValueTypes["MediumGalleryUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentBlockUpsertGalleryRelationInput"]: {
	update?:ValueTypes["MediumGalleryUpdateInput"] | null,
	create?:ValueTypes["MediumGalleryCreateInput"] | null
};
	["ContentBlockUpdateVideoEntityRelationInput"]: {
	create?:ValueTypes["VideoCreateInput"] | null,
	update?:ValueTypes["VideoUpdateInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertVideoRelationInput"] | null,
	connect?:ValueTypes["VideoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentBlockUpsertVideoRelationInput"]: {
	update?:ValueTypes["VideoUpdateInput"] | null,
	create?:ValueTypes["VideoCreateInput"] | null
};
	["ContentBlockUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkUpdateInput"]: {
	type?:ValueTypes["LinkType"] | null,
	title?:string | null,
	externalLink?:string | null,
	internalLink?:ValueTypes["LinkUpdateInternalLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableCreateInput"] | null,
	update?:ValueTypes["LinkableUpdateInput"] | null,
	upsert?:ValueTypes["LinkUpsertInternalLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkUpsertInternalLinkRelationInput"]: {
	update?:ValueTypes["LinkableUpdateInput"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["ContentBlockUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentBlockUpdateMembersEntityRelationInput"]: {
	create?:ValueTypes["MemberListCreateInput"] | null,
	update?:ValueTypes["MemberListUpdateInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertMembersRelationInput"] | null,
	connect?:ValueTypes["MemberListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["MemberListUpdateInput"]: {
	items?:ValueTypes["MemberListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["MemberListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["MemberItemWithoutListCreateInput"] | null,
	update?:ValueTypes["MemberListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["MemberListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["MemberItemUniqueWhere"] | null,
	disconnect?:ValueTypes["MemberItemUniqueWhere"] | null,
	delete?:ValueTypes["MemberItemUniqueWhere"] | null,
	alias?:string | null
};
	["MemberListUpdateItemsRelationInput"]: {
	by?:ValueTypes["MemberItemUniqueWhere"] | null,
	data?:ValueTypes["MemberItemWithoutListUpdateInput"] | null
};
	["MemberItemWithoutListUpdateInput"]: {
	order?:number | null,
	member?:ValueTypes["MemberItemUpdateMemberEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MemberItemUpdateMemberEntityRelationInput"]: {
	create?:ValueTypes["MemberCreateInput"] | null,
	update?:ValueTypes["MemberUpdateInput"] | null,
	upsert?:ValueTypes["MemberItemUpsertMemberRelationInput"] | null,
	connect?:ValueTypes["MemberUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["MemberUpdateInput"]: {
	firstName?:string | null,
	lastName?:string | null,
	position?:string | null,
	email?:string | null,
	telephone?:string | null,
	image?:ValueTypes["MemberUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MemberUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["MemberUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["MemberUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["MemberItemUpsertMemberRelationInput"]: {
	update?:ValueTypes["MemberUpdateInput"] | null,
	create?:ValueTypes["MemberCreateInput"] | null
};
	["MemberListUpsertItemsRelationInput"]: {
	by?:ValueTypes["MemberItemUniqueWhere"] | null,
	update?:ValueTypes["MemberItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["MemberItemWithoutListCreateInput"] | null
};
	["ContentBlockUpsertMembersRelationInput"]: {
	update?:ValueTypes["MemberListUpdateInput"] | null,
	create?:ValueTypes["MemberListCreateInput"] | null
};
	["ContentBlockUpdatePortfolioEntityRelationInput"]: {
	create?:ValueTypes["ShowYearListCreateInput"] | null,
	update?:ValueTypes["ShowYearListUpdateInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertPortfolioRelationInput"] | null,
	connect?:ValueTypes["ShowYearListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ShowYearListUpdateInput"]: {
	items?:ValueTypes["ShowYearListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ShowYearListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ShowYearItemWithoutListCreateInput"] | null,
	update?:ValueTypes["ShowYearListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ShowYearListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ShowYearItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ShowYearItemUniqueWhere"] | null,
	delete?:ValueTypes["ShowYearItemUniqueWhere"] | null,
	alias?:string | null
};
	["ShowYearListUpdateItemsRelationInput"]: {
	by?:ValueTypes["ShowYearItemUniqueWhere"] | null,
	data?:ValueTypes["ShowYearItemWithoutListUpdateInput"] | null
};
	["ShowYearItemWithoutListUpdateInput"]: {
	order?:number | null,
	showYear?:ValueTypes["ShowYearItemUpdateShowYearEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ShowYearItemUpdateShowYearEntityRelationInput"]: {
	create?:ValueTypes["ShowYearCreateInput"] | null,
	update?:ValueTypes["ShowYearUpdateInput"] | null,
	upsert?:ValueTypes["ShowYearItemUpsertShowYearRelationInput"] | null,
	connect?:ValueTypes["ShowYearUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ShowYearUpdateInput"]: {
	order?:number | null,
	name?:string | null,
	showList?:ValueTypes["ShowYearUpdateShowListEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ShowYearUpdateShowListEntityRelationInput"]: {
	create?:ValueTypes["ShowWithoutCategoryYearCreateInput"] | null,
	update?:ValueTypes["ShowYearUpdateShowListRelationInput"] | null,
	upsert?:ValueTypes["ShowYearUpsertShowListRelationInput"] | null,
	connect?:ValueTypes["ShowUniqueWhere"] | null,
	disconnect?:ValueTypes["ShowUniqueWhere"] | null,
	delete?:ValueTypes["ShowUniqueWhere"] | null,
	alias?:string | null
};
	["ShowYearUpdateShowListRelationInput"]: {
	by?:ValueTypes["ShowUniqueWhere"] | null,
	data?:ValueTypes["ShowWithoutCategoryYearUpdateInput"] | null
};
	["ShowWithoutCategoryYearUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	posterType?:ValueTypes["ShowPosterType"] | null,
	poster?:ValueTypes["ShowUpdatePosterEntityRelationInput"] | null,
	showItem?:ValueTypes["ShowUpdateShowItemEntityRelationInput"][],
	posterSizeType?:ValueTypes["ShowPosterSizeType"] | null,
	production?:string | null,
	directors?:string | null,
	starrings?:string | null,
	gallery?:ValueTypes["ShowUpdateGalleryEntityRelationInput"] | null,
	seo?:ValueTypes["ShowUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ShowUpdateLinkEntityRelationInput"] | null,
	synopsis?:string | null,
	_dummy_field_?:boolean | null
};
	["ShowUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutShowPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutShowPageUpdateInput"] | null,
	upsert?:ValueTypes["ShowUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutShowPageUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	portfolioPage?:ValueTypes["LinkableUpdatePortfolioPageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ShowUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutShowPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutShowPageCreateInput"] | null
};
	["ShowYearUpsertShowListRelationInput"]: {
	by?:ValueTypes["ShowUniqueWhere"] | null,
	update?:ValueTypes["ShowWithoutCategoryYearUpdateInput"] | null,
	create?:ValueTypes["ShowWithoutCategoryYearCreateInput"] | null
};
	["ShowYearItemUpsertShowYearRelationInput"]: {
	update?:ValueTypes["ShowYearUpdateInput"] | null,
	create?:ValueTypes["ShowYearCreateInput"] | null
};
	["ShowYearListUpsertItemsRelationInput"]: {
	by?:ValueTypes["ShowYearItemUniqueWhere"] | null,
	update?:ValueTypes["ShowYearItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["ShowYearItemWithoutListCreateInput"] | null
};
	["ContentBlockUpsertPortfolioRelationInput"]: {
	update?:ValueTypes["ShowYearListUpdateInput"] | null,
	create?:ValueTypes["ShowYearListCreateInput"] | null
};
	["HomePageUpsertBlocksRelationInput"]: {
	by?:ValueTypes["ContentBlockUniqueWhere"] | null,
	update?:ValueTypes["ContentBlockWithoutHomePageUpdateInput"] | null,
	create?:ValueTypes["ContentBlockWithoutHomePageCreateInput"] | null
};
	["LinkableUpsertHomePageRelationInput"]: {
	update?:ValueTypes["HomePageWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["HomePageWithoutLinkCreateInput"] | null
};
	["RedirectUpsertTargetRelationInput"]: {
	update?:ValueTypes["LinkableUpdateInput"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["LinkableUpsertRedirectRelationInput"]: {
	update?:ValueTypes["RedirectWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["RedirectWithoutLinkCreateInput"] | null
};
	["HomePageUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutHomePageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutHomePageCreateInput"] | null
};
	["ContentBlockUpsertHomePageRelationInput"]: {
	update?:ValueTypes["HomePageWithoutBlocksUpdateInput"] | null,
	create?:ValueTypes["HomePageWithoutBlocksCreateInput"] | null
};
	["ImageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageEdge"],
		__typename?: true
}>;
	["ImageEdge"]: AliasType<{
	node?:ValueTypes["Image"],
		__typename?: true
}>;
	["LinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkEdge"],
		__typename?: true
}>;
	["LinkEdge"]: AliasType<{
	node?:ValueTypes["Link"],
		__typename?: true
}>;
	["SeoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoEdge"],
		__typename?: true
}>;
	["SeoEdge"]: AliasType<{
	node?:ValueTypes["Seo"],
		__typename?: true
}>;
	["HomePageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HomePageEdge"],
		__typename?: true
}>;
	["HomePageEdge"]: AliasType<{
	node?:ValueTypes["HomePage"],
		__typename?: true
}>;
	["HomePageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	link?:ValueTypes["HomePageCreateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageCreateSeoEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	blocks?:ValueTypes["HomePageCreateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["HomePageUpdateInput"]: {
	name?:string | null,
	link?:ValueTypes["HomePageUpdateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageUpdateSeoEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	blocks?:ValueTypes["HomePageUpdateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LinkableConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkableEdge"],
		__typename?: true
}>;
	["LinkableEdge"]: AliasType<{
	node?:ValueTypes["Linkable"],
		__typename?: true
}>;
	["MediumGalleryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MediumGalleryEdge"],
		__typename?: true
}>;
	["MediumGalleryEdge"]: AliasType<{
	node?:ValueTypes["MediumGallery"],
		__typename?: true
}>;
	["MediumGalleryItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	type?:ValueTypes["MediumType"] | null,
	gallery?:ValueTypes["MediumGalleryItemCreateGalleryEntityRelationInput"] | null,
	image?:ValueTypes["MediumGalleryItemCreateImageEntityRelationInput"] | null,
	video?:ValueTypes["MediumGalleryItemCreateVideoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MediumGalleryItemCreateGalleryEntityRelationInput"]: {
	connect?:ValueTypes["MediumGalleryUniqueWhere"] | null,
	create?:ValueTypes["MediumGalleryWithoutItemsCreateInput"] | null
};
	["MediumGalleryWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["MediumGalleryItemUpdateInput"]: {
	order?:number | null,
	type?:ValueTypes["MediumType"] | null,
	gallery?:ValueTypes["MediumGalleryItemUpdateGalleryEntityRelationInput"] | null,
	image?:ValueTypes["MediumGalleryItemUpdateImageEntityRelationInput"] | null,
	video?:ValueTypes["MediumGalleryItemUpdateVideoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MediumGalleryItemUpdateGalleryEntityRelationInput"]: {
	create?:ValueTypes["MediumGalleryWithoutItemsCreateInput"] | null,
	update?:ValueTypes["MediumGalleryWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["MediumGalleryItemUpsertGalleryRelationInput"] | null,
	connect?:ValueTypes["MediumGalleryUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["MediumGalleryWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["MediumGalleryItemUpsertGalleryRelationInput"]: {
	update?:ValueTypes["MediumGalleryWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["MediumGalleryWithoutItemsCreateInput"] | null
};
	["MemberConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MemberEdge"],
		__typename?: true
}>;
	["MemberEdge"]: AliasType<{
	node?:ValueTypes["Member"],
		__typename?: true
}>;
	["MemberItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["MemberItemCreateListEntityRelationInput"] | null,
	member?:ValueTypes["MemberItemCreateMemberEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MemberItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["MemberListUniqueWhere"] | null,
	create?:ValueTypes["MemberListWithoutItemsCreateInput"] | null
};
	["MemberListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["MemberItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["MemberItemUpdateListEntityRelationInput"] | null,
	member?:ValueTypes["MemberItemUpdateMemberEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MemberItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["MemberListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["MemberListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["MemberItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["MemberListUniqueWhere"] | null,
	delete?:boolean | null
};
	["MemberListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["MemberItemUpsertListRelationInput"]: {
	update?:ValueTypes["MemberListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["MemberListWithoutItemsCreateInput"] | null
};
	["MemberListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MemberListEdge"],
		__typename?: true
}>;
	["MemberListEdge"]: AliasType<{
	node?:ValueTypes["MemberList"],
		__typename?: true
}>;
	["ShowCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	posterType?:ValueTypes["ShowPosterType"] | null,
	poster?:ValueTypes["ShowCreatePosterEntityRelationInput"] | null,
	showItem?:ValueTypes["ShowCreateShowItemEntityRelationInput"][],
	posterSizeType?:ValueTypes["ShowPosterSizeType"] | null,
	categoryYear?:ValueTypes["ShowCreateCategoryYearEntityRelationInput"] | null,
	production?:string | null,
	directors?:string | null,
	starrings?:string | null,
	gallery?:ValueTypes["ShowCreateGalleryEntityRelationInput"] | null,
	seo?:ValueTypes["ShowCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ShowCreateLinkEntityRelationInput"] | null,
	synopsis?:string | null,
	_dummy_field_?:boolean | null
};
	["ShowUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	posterType?:ValueTypes["ShowPosterType"] | null,
	poster?:ValueTypes["ShowUpdatePosterEntityRelationInput"] | null,
	showItem?:ValueTypes["ShowUpdateShowItemEntityRelationInput"][],
	posterSizeType?:ValueTypes["ShowPosterSizeType"] | null,
	categoryYear?:ValueTypes["ShowUpdateCategoryYearEntityRelationInput"] | null,
	production?:string | null,
	directors?:string | null,
	starrings?:string | null,
	gallery?:ValueTypes["ShowUpdateGalleryEntityRelationInput"] | null,
	seo?:ValueTypes["ShowUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ShowUpdateLinkEntityRelationInput"] | null,
	synopsis?:string | null,
	_dummy_field_?:boolean | null
};
	["ShowListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ShowListEdge"],
		__typename?: true
}>;
	["ShowListEdge"]: AliasType<{
	node?:ValueTypes["ShowList"],
		__typename?: true
}>;
	["ShowListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ShowListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ShowListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ShowItemUniqueWhere"] | null,
	create?:ValueTypes["ShowItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["ShowItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	show?:ValueTypes["ShowItemCreateShowEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ShowItemCreateShowEntityRelationInput"]: {
	connect?:ValueTypes["ShowUniqueWhere"] | null,
	create?:ValueTypes["ShowWithoutShowItemCreateInput"] | null
};
	["ShowWithoutShowItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	posterType?:ValueTypes["ShowPosterType"] | null,
	poster?:ValueTypes["ShowCreatePosterEntityRelationInput"] | null,
	posterSizeType?:ValueTypes["ShowPosterSizeType"] | null,
	categoryYear?:ValueTypes["ShowCreateCategoryYearEntityRelationInput"] | null,
	production?:string | null,
	directors?:string | null,
	starrings?:string | null,
	gallery?:ValueTypes["ShowCreateGalleryEntityRelationInput"] | null,
	seo?:ValueTypes["ShowCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ShowCreateLinkEntityRelationInput"] | null,
	synopsis?:string | null,
	_dummy_field_?:boolean | null
};
	["ShowListUpdateInput"]: {
	items?:ValueTypes["ShowListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ShowListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ShowItemWithoutListCreateInput"] | null,
	update?:ValueTypes["ShowListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ShowListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ShowItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ShowItemUniqueWhere"] | null,
	delete?:ValueTypes["ShowItemUniqueWhere"] | null,
	alias?:string | null
};
	["ShowListUpdateItemsRelationInput"]: {
	by?:ValueTypes["ShowItemUniqueWhere"] | null,
	data?:ValueTypes["ShowItemWithoutListUpdateInput"] | null
};
	["ShowItemWithoutListUpdateInput"]: {
	order?:number | null,
	show?:ValueTypes["ShowItemUpdateShowEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ShowItemUpdateShowEntityRelationInput"]: {
	create?:ValueTypes["ShowWithoutShowItemCreateInput"] | null,
	update?:ValueTypes["ShowWithoutShowItemUpdateInput"] | null,
	upsert?:ValueTypes["ShowItemUpsertShowRelationInput"] | null,
	connect?:ValueTypes["ShowUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ShowWithoutShowItemUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	posterType?:ValueTypes["ShowPosterType"] | null,
	poster?:ValueTypes["ShowUpdatePosterEntityRelationInput"] | null,
	posterSizeType?:ValueTypes["ShowPosterSizeType"] | null,
	categoryYear?:ValueTypes["ShowUpdateCategoryYearEntityRelationInput"] | null,
	production?:string | null,
	directors?:string | null,
	starrings?:string | null,
	gallery?:ValueTypes["ShowUpdateGalleryEntityRelationInput"] | null,
	seo?:ValueTypes["ShowUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ShowUpdateLinkEntityRelationInput"] | null,
	synopsis?:string | null,
	_dummy_field_?:boolean | null
};
	["ShowItemUpsertShowRelationInput"]: {
	update?:ValueTypes["ShowWithoutShowItemUpdateInput"] | null,
	create?:ValueTypes["ShowWithoutShowItemCreateInput"] | null
};
	["ShowListUpsertItemsRelationInput"]: {
	by?:ValueTypes["ShowItemUniqueWhere"] | null,
	update?:ValueTypes["ShowItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["ShowItemWithoutListCreateInput"] | null
};
	["ShowYearConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ShowYearEdge"],
		__typename?: true
}>;
	["ShowYearEdge"]: AliasType<{
	node?:ValueTypes["ShowYear"],
		__typename?: true
}>;
	["ShowYearItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["ShowYearItemCreateListEntityRelationInput"] | null,
	showYear?:ValueTypes["ShowYearItemCreateShowYearEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ShowYearItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["ShowYearListUniqueWhere"] | null,
	create?:ValueTypes["ShowYearListWithoutItemsCreateInput"] | null
};
	["ShowYearListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ShowYearItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["ShowYearItemUpdateListEntityRelationInput"] | null,
	showYear?:ValueTypes["ShowYearItemUpdateShowYearEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ShowYearItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["ShowYearListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["ShowYearListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ShowYearItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["ShowYearListUniqueWhere"] | null,
	delete?:boolean | null
};
	["ShowYearListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ShowYearItemUpsertListRelationInput"]: {
	update?:ValueTypes["ShowYearListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["ShowYearListWithoutItemsCreateInput"] | null
};
	["ShowYearListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ShowYearListEdge"],
		__typename?: true
}>;
	["ShowYearListEdge"]: AliasType<{
	node?:ValueTypes["ShowYearList"],
		__typename?: true
}>;
	["SocialLink"]: AliasType<{
	_meta?:ValueTypes["SocialLinkMeta"],
	id?:true,
	name?:true,
icon?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: true
}>;
	["SocialLinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	icon?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["SocialLinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["SocialLinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	icon?:ValueTypes["ImageWhere"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["SocialLinkWhere"] | undefined | null)[],
	or?:(ValueTypes["SocialLinkWhere"] | undefined | null)[],
	not?:ValueTypes["SocialLinkWhere"] | null
};
	["SocialLinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	icon?:ValueTypes["ImageOrderBy"] | null,
	link?:ValueTypes["LinkOrderBy"] | null
};
	["SocialLinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SocialLinkEdge"],
		__typename?: true
}>;
	["SocialLinkEdge"]: AliasType<{
	node?:ValueTypes["SocialLink"],
		__typename?: true
}>;
	["SocialLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	icon?:ValueTypes["SocialLinkCreateIconEntityRelationInput"] | null,
	link?:ValueTypes["SocialLinkCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkCreateIconEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["SocialLinkCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["SocialLinkUpdateInput"]: {
	name?:string | null,
	icon?:ValueTypes["SocialLinkUpdateIconEntityRelationInput"] | null,
	link?:ValueTypes["SocialLinkUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkUpdateIconEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["SocialLinkUpsertIconRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SocialLinkUpsertIconRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["SocialLinkUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["SocialLinkUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SocialLinkUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["SocialLinkItem"]: AliasType<{
	_meta?:ValueTypes["SocialLinkItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkList"]],
socialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLink"]],
		__typename?: true
}>;
	["SocialLinkItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	socialLink?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["SocialLinkList"]: AliasType<{
	_meta?:ValueTypes["SocialLinkListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLinkItem"]],
paginateItems?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkItemConnection"]],
		__typename?: true
}>;
	["SocialLinkListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["SocialLinkItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["SocialLinkListWhere"] | null,
	socialLink?:ValueTypes["SocialLinkWhere"] | null,
	and?:(ValueTypes["SocialLinkItemWhere"] | undefined | null)[],
	or?:(ValueTypes["SocialLinkItemWhere"] | undefined | null)[],
	not?:ValueTypes["SocialLinkItemWhere"] | null
};
	["SocialLinkListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["SocialLinkItemWhere"] | null,
	and?:(ValueTypes["SocialLinkListWhere"] | undefined | null)[],
	or?:(ValueTypes["SocialLinkListWhere"] | undefined | null)[],
	not?:ValueTypes["SocialLinkListWhere"] | null
};
	["SocialLinkItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["SocialLinkListOrderBy"] | null,
	socialLink?:ValueTypes["SocialLinkOrderBy"] | null
};
	["SocialLinkListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["SocialLinkItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SocialLinkItemEdge"],
		__typename?: true
}>;
	["SocialLinkItemEdge"]: AliasType<{
	node?:ValueTypes["SocialLinkItem"],
		__typename?: true
}>;
	["SocialLinkItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["SocialLinkItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["SocialLinkItemCreateListEntityRelationInput"] | null,
	socialLink?:ValueTypes["SocialLinkItemCreateSocialLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["SocialLinkListUniqueWhere"] | null,
	create?:ValueTypes["SocialLinkListWithoutItemsCreateInput"] | null
};
	["SocialLinkListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["SocialLinkItemUniqueWhere"] | null
};
	["SocialLinkListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkItemCreateSocialLinkEntityRelationInput"]: {
	connect?:ValueTypes["SocialLinkUniqueWhere"] | null,
	create?:ValueTypes["SocialLinkCreateInput"] | null
};
	["SocialLinkItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["SocialLinkItemUpdateListEntityRelationInput"] | null,
	socialLink?:ValueTypes["SocialLinkItemUpdateSocialLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["SocialLinkListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["SocialLinkListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["SocialLinkItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["SocialLinkListUniqueWhere"] | null,
	delete?:boolean | null
};
	["SocialLinkListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["SocialLinkItemUpsertListRelationInput"]: {
	update?:ValueTypes["SocialLinkListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["SocialLinkListWithoutItemsCreateInput"] | null
};
	["SocialLinkItemUpdateSocialLinkEntityRelationInput"]: {
	create?:ValueTypes["SocialLinkCreateInput"] | null,
	update?:ValueTypes["SocialLinkUpdateInput"] | null,
	upsert?:ValueTypes["SocialLinkItemUpsertSocialLinkRelationInput"] | null,
	connect?:ValueTypes["SocialLinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SocialLinkItemUpsertSocialLinkRelationInput"]: {
	update?:ValueTypes["SocialLinkUpdateInput"] | null,
	create?:ValueTypes["SocialLinkCreateInput"] | null
};
	["SocialLinkListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SocialLinkListEdge"],
		__typename?: true
}>;
	["SocialLinkListEdge"]: AliasType<{
	node?:ValueTypes["SocialLinkList"],
		__typename?: true
}>;
	["SocialLinkListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["SocialLinkListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SocialLinkListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	create?:ValueTypes["SocialLinkItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["SocialLinkItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	socialLink?:ValueTypes["SocialLinkItemCreateSocialLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkListUpdateInput"]: {
	items?:ValueTypes["SocialLinkListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SocialLinkListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["SocialLinkItemWithoutListCreateInput"] | null,
	update?:ValueTypes["SocialLinkListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["SocialLinkListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	disconnect?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	delete?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	alias?:string | null
};
	["SocialLinkListUpdateItemsRelationInput"]: {
	by?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	data?:ValueTypes["SocialLinkItemWithoutListUpdateInput"] | null
};
	["SocialLinkItemWithoutListUpdateInput"]: {
	order?:number | null,
	socialLink?:ValueTypes["SocialLinkItemUpdateSocialLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SocialLinkListUpsertItemsRelationInput"]: {
	by?:ValueTypes["SocialLinkItemUniqueWhere"] | null,
	update?:ValueTypes["SocialLinkItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["SocialLinkItemWithoutListCreateInput"] | null
};
	["VideoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["VideoEdge"],
		__typename?: true
}>;
	["VideoEdge"]: AliasType<{
	node?:ValueTypes["Video"],
		__typename?: true
}>;
	["YoutubeVideo"]: AliasType<{
	_meta?:ValueTypes["YoutubeVideoMeta"],
	id?:true,
	videoId?:true,
		__typename?: true
}>;
	["YoutubeVideoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	videoId?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["YoutubeVideoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["YoutubeVideoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	videoId?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["YoutubeVideoWhere"] | undefined | null)[],
	or?:(ValueTypes["YoutubeVideoWhere"] | undefined | null)[],
	not?:ValueTypes["YoutubeVideoWhere"] | null
};
	["YoutubeVideoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	videoId?:ValueTypes["OrderDirection"] | null
};
	["YoutubeVideoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["YoutubeVideoEdge"],
		__typename?: true
}>;
	["YoutubeVideoEdge"]: AliasType<{
	node?:ValueTypes["YoutubeVideo"],
		__typename?: true
}>;
	["YoutubeVideoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	videoId?:string | null,
	_dummy_field_?:boolean | null
};
	["YoutubeVideoUpdateInput"]: {
	videoId?:string | null,
	_dummy_field_?:boolean | null
};
	["Header"]: AliasType<{
	_meta?:ValueTypes["HeaderMeta"],
	id?:true,
logo?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
socialLinks?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkList"]],
	unique?:true,
		__typename?: true
}>;
	["HeaderMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	socialLinks?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["HeaderUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	socialLinks?:ValueTypes["SocialLinkListUniqueWhere"] | null
};
	["HeaderWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	logo?:ValueTypes["ImageWhere"] | null,
	socialLinks?:ValueTypes["SocialLinkListWhere"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	and?:(ValueTypes["HeaderWhere"] | undefined | null)[],
	or?:(ValueTypes["HeaderWhere"] | undefined | null)[],
	not?:ValueTypes["HeaderWhere"] | null
};
	["HeaderOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	logo?:ValueTypes["ImageOrderBy"] | null,
	socialLinks?:ValueTypes["SocialLinkListOrderBy"] | null,
	unique?:ValueTypes["OrderDirection"] | null
};
	["HeaderConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeaderEdge"],
		__typename?: true
}>;
	["HeaderEdge"]: AliasType<{
	node?:ValueTypes["Header"],
		__typename?: true
}>;
	["HeaderCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	logo?:ValueTypes["HeaderCreateLogoEntityRelationInput"] | null,
	socialLinks?:ValueTypes["HeaderCreateSocialLinksEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderCreateLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HeaderCreateSocialLinksEntityRelationInput"]: {
	connect?:ValueTypes["SocialLinkListUniqueWhere"] | null,
	create?:ValueTypes["SocialLinkListCreateInput"] | null
};
	["HeaderUpdateInput"]: {
	logo?:ValueTypes["HeaderUpdateLogoEntityRelationInput"] | null,
	socialLinks?:ValueTypes["HeaderUpdateSocialLinksEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderUpdateLogoEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["HeaderUpsertLogoRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HeaderUpsertLogoRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HeaderUpdateSocialLinksEntityRelationInput"]: {
	create?:ValueTypes["SocialLinkListCreateInput"] | null,
	update?:ValueTypes["SocialLinkListUpdateInput"] | null,
	upsert?:ValueTypes["HeaderUpsertSocialLinksRelationInput"] | null,
	connect?:ValueTypes["SocialLinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HeaderUpsertSocialLinksRelationInput"]: {
	update?:ValueTypes["SocialLinkListUpdateInput"] | null,
	create?:ValueTypes["SocialLinkListCreateInput"] | null
};
	["Footer"]: AliasType<{
	_meta?:ValueTypes["FooterMeta"],
	id?:true,
	title?:true,
	info?:true,
address?: [{	filter?:ValueTypes["FooterAddressWhere"] | null},ValueTypes["FooterAddress"]],
members?: [{	filter?:ValueTypes["MemberListWhere"] | null},ValueTypes["MemberList"]],
logo?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
socialLinks?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkList"]],
	unique?:true,
generalContact?: [{	filter?:ValueTypes["FooterGeneralContactWhere"] | null},ValueTypes["FooterGeneralContact"]],
		__typename?: true
}>;
	["FooterMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	info?:ValueTypes["FieldMeta"],
	address?:ValueTypes["FieldMeta"],
	members?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	socialLinks?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	generalContact?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FooterAddress"]: AliasType<{
	_meta?:ValueTypes["FooterAddressMeta"],
	id?:true,
	label?:true,
	address?:true,
addressLink?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: true
}>;
	["FooterAddressMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	address?:ValueTypes["FieldMeta"],
	addressLink?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FooterAddressWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	label?:ValueTypes["StringCondition"] | null,
	address?:ValueTypes["StringCondition"] | null,
	addressLink?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["FooterAddressWhere"] | undefined | null)[],
	or?:(ValueTypes["FooterAddressWhere"] | undefined | null)[],
	not?:ValueTypes["FooterAddressWhere"] | null
};
	["FooterGeneralContact"]: AliasType<{
	_meta?:ValueTypes["FooterGeneralContactMeta"],
	id?:true,
	label?:true,
	email?:true,
	info?:true,
		__typename?: true
}>;
	["FooterGeneralContactMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	info?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FooterGeneralContactWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	label?:ValueTypes["StringCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	info?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["FooterGeneralContactWhere"] | undefined | null)[],
	or?:(ValueTypes["FooterGeneralContactWhere"] | undefined | null)[],
	not?:ValueTypes["FooterGeneralContactWhere"] | null
};
	["FooterUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	members?:ValueTypes["MemberListUniqueWhere"] | null,
	socialLinks?:ValueTypes["SocialLinkListUniqueWhere"] | null
};
	["FooterWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	info?:ValueTypes["StringCondition"] | null,
	address?:ValueTypes["FooterAddressWhere"] | null,
	members?:ValueTypes["MemberListWhere"] | null,
	logo?:ValueTypes["ImageWhere"] | null,
	socialLinks?:ValueTypes["SocialLinkListWhere"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	generalContact?:ValueTypes["FooterGeneralContactWhere"] | null,
	and?:(ValueTypes["FooterWhere"] | undefined | null)[],
	or?:(ValueTypes["FooterWhere"] | undefined | null)[],
	not?:ValueTypes["FooterWhere"] | null
};
	["FooterOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	info?:ValueTypes["OrderDirection"] | null,
	address?:ValueTypes["FooterAddressOrderBy"] | null,
	members?:ValueTypes["MemberListOrderBy"] | null,
	logo?:ValueTypes["ImageOrderBy"] | null,
	socialLinks?:ValueTypes["SocialLinkListOrderBy"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	generalContact?:ValueTypes["FooterGeneralContactOrderBy"] | null
};
	["FooterAddressOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	label?:ValueTypes["OrderDirection"] | null,
	address?:ValueTypes["OrderDirection"] | null,
	addressLink?:ValueTypes["LinkOrderBy"] | null
};
	["FooterGeneralContactOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	label?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	info?:ValueTypes["OrderDirection"] | null
};
	["FooterConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterEdge"],
		__typename?: true
}>;
	["FooterEdge"]: AliasType<{
	node?:ValueTypes["Footer"],
		__typename?: true
}>;
	["FooterCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	info?:string | null,
	address?:ValueTypes["FooterCreateAddressEntityRelationInput"] | null,
	members?:ValueTypes["FooterCreateMembersEntityRelationInput"] | null,
	logo?:ValueTypes["FooterCreateLogoEntityRelationInput"] | null,
	socialLinks?:ValueTypes["FooterCreateSocialLinksEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	generalContact?:ValueTypes["FooterCreateGeneralContactEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterCreateAddressEntityRelationInput"]: {
	connect?:ValueTypes["FooterAddressUniqueWhere"] | null,
	create?:ValueTypes["FooterAddressCreateInput"] | null
};
	["FooterAddressUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	addressLink?:ValueTypes["LinkUniqueWhere"] | null
};
	["FooterAddressCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	label?:string | null,
	address?:string | null,
	addressLink?:ValueTypes["FooterAddressCreateAddressLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterAddressCreateAddressLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FooterCreateMembersEntityRelationInput"]: {
	connect?:ValueTypes["MemberListUniqueWhere"] | null,
	create?:ValueTypes["MemberListCreateInput"] | null
};
	["FooterCreateLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FooterCreateSocialLinksEntityRelationInput"]: {
	connect?:ValueTypes["SocialLinkListUniqueWhere"] | null,
	create?:ValueTypes["SocialLinkListCreateInput"] | null
};
	["FooterCreateGeneralContactEntityRelationInput"]: {
	connect?:ValueTypes["FooterGeneralContactUniqueWhere"] | null,
	create?:ValueTypes["FooterGeneralContactCreateInput"] | null
};
	["FooterGeneralContactUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["FooterGeneralContactCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	label?:string | null,
	email?:string | null,
	info?:string | null,
	_dummy_field_?:boolean | null
};
	["FooterUpdateInput"]: {
	title?:string | null,
	info?:string | null,
	address?:ValueTypes["FooterUpdateAddressEntityRelationInput"] | null,
	members?:ValueTypes["FooterUpdateMembersEntityRelationInput"] | null,
	logo?:ValueTypes["FooterUpdateLogoEntityRelationInput"] | null,
	socialLinks?:ValueTypes["FooterUpdateSocialLinksEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	generalContact?:ValueTypes["FooterUpdateGeneralContactEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterUpdateAddressEntityRelationInput"]: {
	create?:ValueTypes["FooterAddressCreateInput"] | null,
	update?:ValueTypes["FooterAddressUpdateInput"] | null,
	upsert?:ValueTypes["FooterUpsertAddressRelationInput"] | null,
	connect?:ValueTypes["FooterAddressUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterAddressUpdateInput"]: {
	label?:string | null,
	address?:string | null,
	addressLink?:ValueTypes["FooterAddressUpdateAddressLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterAddressUpdateAddressLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["FooterAddressUpsertAddressLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterAddressUpsertAddressLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FooterUpsertAddressRelationInput"]: {
	update?:ValueTypes["FooterAddressUpdateInput"] | null,
	create?:ValueTypes["FooterAddressCreateInput"] | null
};
	["FooterUpdateMembersEntityRelationInput"]: {
	create?:ValueTypes["MemberListCreateInput"] | null,
	update?:ValueTypes["MemberListUpdateInput"] | null,
	upsert?:ValueTypes["FooterUpsertMembersRelationInput"] | null,
	connect?:ValueTypes["MemberListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterUpsertMembersRelationInput"]: {
	update?:ValueTypes["MemberListUpdateInput"] | null,
	create?:ValueTypes["MemberListCreateInput"] | null
};
	["FooterUpdateLogoEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["FooterUpsertLogoRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterUpsertLogoRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FooterUpdateSocialLinksEntityRelationInput"]: {
	create?:ValueTypes["SocialLinkListCreateInput"] | null,
	update?:ValueTypes["SocialLinkListUpdateInput"] | null,
	upsert?:ValueTypes["FooterUpsertSocialLinksRelationInput"] | null,
	connect?:ValueTypes["SocialLinkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterUpsertSocialLinksRelationInput"]: {
	update?:ValueTypes["SocialLinkListUpdateInput"] | null,
	create?:ValueTypes["SocialLinkListCreateInput"] | null
};
	["FooterUpdateGeneralContactEntityRelationInput"]: {
	create?:ValueTypes["FooterGeneralContactCreateInput"] | null,
	update?:ValueTypes["FooterGeneralContactUpdateInput"] | null,
	upsert?:ValueTypes["FooterUpsertGeneralContactRelationInput"] | null,
	connect?:ValueTypes["FooterGeneralContactUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterGeneralContactUpdateInput"]: {
	label?:string | null,
	email?:string | null,
	info?:string | null,
	_dummy_field_?:boolean | null
};
	["FooterUpsertGeneralContactRelationInput"]: {
	update?:ValueTypes["FooterGeneralContactUpdateInput"] | null,
	create?:ValueTypes["FooterGeneralContactCreateInput"] | null
};
	["FooterAddressConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterAddressEdge"],
		__typename?: true
}>;
	["FooterAddressEdge"]: AliasType<{
	node?:ValueTypes["FooterAddress"],
		__typename?: true
}>;
	["PortfolioPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PortfolioPageEdge"],
		__typename?: true
}>;
	["PortfolioPageEdge"]: AliasType<{
	node?:ValueTypes["PortfolioPage"],
		__typename?: true
}>;
	["PortfolioPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	link?:ValueTypes["PortfolioPageCreateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["PortfolioPageCreateSeoEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	text?:string | null,
	_dummy_field_?:boolean | null
};
	["PortfolioPageCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutPortfolioPageCreateInput"] | null
};
	["LinkableWithoutPortfolioPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	showPage?:ValueTypes["LinkableCreateShowPageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PortfolioPageUpdateInput"]: {
	name?:string | null,
	link?:ValueTypes["PortfolioPageUpdateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["PortfolioPageUpdateSeoEntityRelationInput"] | null,
	unique?:ValueTypes["One"] | null,
	title?:string | null,
	text?:string | null,
	_dummy_field_?:boolean | null
};
	["PortfolioPageUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutPortfolioPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutPortfolioPageUpdateInput"] | null,
	upsert?:ValueTypes["PortfolioPageUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutPortfolioPageUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	showPage?:ValueTypes["LinkableUpdateShowPageEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PortfolioPageUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutPortfolioPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutPortfolioPageCreateInput"] | null
};
	["ShowItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["ShowItemCreateListEntityRelationInput"] | null,
	show?:ValueTypes["ShowItemCreateShowEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ShowItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["ShowItemUpdateListEntityRelationInput"] | null,
	show?:ValueTypes["ShowItemUpdateShowEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["Settings"]: AliasType<{
	_meta?:ValueTypes["SettingsMeta"],
	id?:true,
	unique?:true,
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
		__typename?: true
}>;
	["SettingsMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["SettingsUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["SettingsWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["SettingsWhere"] | undefined | null)[],
	or?:(ValueTypes["SettingsWhere"] | undefined | null)[],
	not?:ValueTypes["SettingsWhere"] | null
};
	["SettingsOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["SettingsConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SettingsEdge"],
		__typename?: true
}>;
	["SettingsEdge"]: AliasType<{
	node?:ValueTypes["Settings"],
		__typename?: true
}>;
	["SettingsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["SettingsCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SettingsCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["SettingsUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	seo?:ValueTypes["SettingsUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SettingsUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["SettingsUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SettingsUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["FooterGeneralContactConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterGeneralContactEdge"],
		__typename?: true
}>;
	["FooterGeneralContactEdge"]: AliasType<{
	node?:ValueTypes["FooterGeneralContact"],
		__typename?: true
}>;
	["RedirectConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RedirectEdge"],
		__typename?: true
}>;
	["RedirectEdge"]: AliasType<{
	node?:ValueTypes["Redirect"],
		__typename?: true
}>;
	["RedirectCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["RedirectCreateLinkEntityRelationInput"] | null,
	target?:ValueTypes["RedirectCreateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutRedirectCreateInput"] | null
};
	["LinkableWithoutRedirectCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	portfolioPage?:ValueTypes["LinkableCreatePortfolioPageEntityRelationInput"] | null,
	showPage?:ValueTypes["LinkableCreateShowPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateInput"]: {
	link?:ValueTypes["RedirectUpdateLinkEntityRelationInput"] | null,
	target?:ValueTypes["RedirectUpdateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutRedirectCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutRedirectUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutRedirectUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	portfolioPage?:ValueTypes["LinkableUpdatePortfolioPageEntityRelationInput"] | null,
	showPage?:ValueTypes["LinkableUpdateShowPageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutRedirectUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutRedirectCreateInput"] | null
};
	["QueryTransaction"]: AliasType<{
getContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePage"]],
listHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomePage"]],
paginateHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomePageConnection"]],
validateCreateHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getMediumGallery?: [{	by:ValueTypes["MediumGalleryUniqueWhere"],	filter?:ValueTypes["MediumGalleryWhere"] | null},ValueTypes["MediumGallery"]],
listMediumGallery?: [{	filter?:ValueTypes["MediumGalleryWhere"] | null,	orderBy?:ValueTypes["MediumGalleryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MediumGallery"]],
paginateMediumGallery?: [{	filter?:ValueTypes["MediumGalleryWhere"] | null,	orderBy?:ValueTypes["MediumGalleryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediumGalleryConnection"]],
validateCreateMediumGallery?: [{	data:ValueTypes["MediumGalleryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMediumGallery?: [{	by:ValueTypes["MediumGalleryUniqueWhere"],	data:ValueTypes["MediumGalleryUpdateInput"]},ValueTypes["_ValidationResult"]],
getMediumGalleryItem?: [{	by:ValueTypes["MediumGalleryItemUniqueWhere"],	filter?:ValueTypes["MediumGalleryItemWhere"] | null},ValueTypes["MediumGalleryItem"]],
listMediumGalleryItem?: [{	filter?:ValueTypes["MediumGalleryItemWhere"] | null,	orderBy?:ValueTypes["MediumGalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MediumGalleryItem"]],
paginateMediumGalleryItem?: [{	filter?:ValueTypes["MediumGalleryItemWhere"] | null,	orderBy?:ValueTypes["MediumGalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediumGalleryItemConnection"]],
validateCreateMediumGalleryItem?: [{	data:ValueTypes["MediumGalleryItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMediumGalleryItem?: [{	by:ValueTypes["MediumGalleryItemUniqueWhere"],	data:ValueTypes["MediumGalleryItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getMember?: [{	by:ValueTypes["MemberUniqueWhere"],	filter?:ValueTypes["MemberWhere"] | null},ValueTypes["Member"]],
listMember?: [{	filter?:ValueTypes["MemberWhere"] | null,	orderBy?:ValueTypes["MemberOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Member"]],
paginateMember?: [{	filter?:ValueTypes["MemberWhere"] | null,	orderBy?:ValueTypes["MemberOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MemberConnection"]],
validateCreateMember?: [{	data:ValueTypes["MemberCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMember?: [{	by:ValueTypes["MemberUniqueWhere"],	data:ValueTypes["MemberUpdateInput"]},ValueTypes["_ValidationResult"]],
getMemberItem?: [{	by:ValueTypes["MemberItemUniqueWhere"],	filter?:ValueTypes["MemberItemWhere"] | null},ValueTypes["MemberItem"]],
listMemberItem?: [{	filter?:ValueTypes["MemberItemWhere"] | null,	orderBy?:ValueTypes["MemberItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MemberItem"]],
paginateMemberItem?: [{	filter?:ValueTypes["MemberItemWhere"] | null,	orderBy?:ValueTypes["MemberItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MemberItemConnection"]],
validateCreateMemberItem?: [{	data:ValueTypes["MemberItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMemberItem?: [{	by:ValueTypes["MemberItemUniqueWhere"],	data:ValueTypes["MemberItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getMemberList?: [{	by:ValueTypes["MemberListUniqueWhere"],	filter?:ValueTypes["MemberListWhere"] | null},ValueTypes["MemberList"]],
listMemberList?: [{	filter?:ValueTypes["MemberListWhere"] | null,	orderBy?:ValueTypes["MemberListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MemberList"]],
paginateMemberList?: [{	filter?:ValueTypes["MemberListWhere"] | null,	orderBy?:ValueTypes["MemberListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MemberListConnection"]],
validateCreateMemberList?: [{	data:ValueTypes["MemberListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMemberList?: [{	by:ValueTypes["MemberListUniqueWhere"],	data:ValueTypes["MemberListUpdateInput"]},ValueTypes["_ValidationResult"]],
getShow?: [{	by:ValueTypes["ShowUniqueWhere"],	filter?:ValueTypes["ShowWhere"] | null},ValueTypes["Show"]],
listShow?: [{	filter?:ValueTypes["ShowWhere"] | null,	orderBy?:ValueTypes["ShowOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Show"]],
paginateShow?: [{	filter?:ValueTypes["ShowWhere"] | null,	orderBy?:ValueTypes["ShowOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShowConnection"]],
validateCreateShow?: [{	data:ValueTypes["ShowCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShow?: [{	by:ValueTypes["ShowUniqueWhere"],	data:ValueTypes["ShowUpdateInput"]},ValueTypes["_ValidationResult"]],
getShowList?: [{	by:ValueTypes["ShowListUniqueWhere"],	filter?:ValueTypes["ShowListWhere"] | null},ValueTypes["ShowList"]],
listShowList?: [{	filter?:ValueTypes["ShowListWhere"] | null,	orderBy?:ValueTypes["ShowListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShowList"]],
paginateShowList?: [{	filter?:ValueTypes["ShowListWhere"] | null,	orderBy?:ValueTypes["ShowListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShowListConnection"]],
validateCreateShowList?: [{	data:ValueTypes["ShowListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShowList?: [{	by:ValueTypes["ShowListUniqueWhere"],	data:ValueTypes["ShowListUpdateInput"]},ValueTypes["_ValidationResult"]],
getShowYear?: [{	by:ValueTypes["ShowYearUniqueWhere"],	filter?:ValueTypes["ShowYearWhere"] | null},ValueTypes["ShowYear"]],
listShowYear?: [{	filter?:ValueTypes["ShowYearWhere"] | null,	orderBy?:ValueTypes["ShowYearOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShowYear"]],
paginateShowYear?: [{	filter?:ValueTypes["ShowYearWhere"] | null,	orderBy?:ValueTypes["ShowYearOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShowYearConnection"]],
validateCreateShowYear?: [{	data:ValueTypes["ShowYearCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShowYear?: [{	by:ValueTypes["ShowYearUniqueWhere"],	data:ValueTypes["ShowYearUpdateInput"]},ValueTypes["_ValidationResult"]],
getShowYearItem?: [{	by:ValueTypes["ShowYearItemUniqueWhere"],	filter?:ValueTypes["ShowYearItemWhere"] | null},ValueTypes["ShowYearItem"]],
listShowYearItem?: [{	filter?:ValueTypes["ShowYearItemWhere"] | null,	orderBy?:ValueTypes["ShowYearItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShowYearItem"]],
paginateShowYearItem?: [{	filter?:ValueTypes["ShowYearItemWhere"] | null,	orderBy?:ValueTypes["ShowYearItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShowYearItemConnection"]],
validateCreateShowYearItem?: [{	data:ValueTypes["ShowYearItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShowYearItem?: [{	by:ValueTypes["ShowYearItemUniqueWhere"],	data:ValueTypes["ShowYearItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getShowYearList?: [{	by:ValueTypes["ShowYearListUniqueWhere"],	filter?:ValueTypes["ShowYearListWhere"] | null},ValueTypes["ShowYearList"]],
listShowYearList?: [{	filter?:ValueTypes["ShowYearListWhere"] | null,	orderBy?:ValueTypes["ShowYearListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShowYearList"]],
paginateShowYearList?: [{	filter?:ValueTypes["ShowYearListWhere"] | null,	orderBy?:ValueTypes["ShowYearListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShowYearListConnection"]],
validateCreateShowYearList?: [{	data:ValueTypes["ShowYearListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShowYearList?: [{	by:ValueTypes["ShowYearListUniqueWhere"],	data:ValueTypes["ShowYearListUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLink"]],
listSocialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLink"]],
paginateSocialLink?: [{	filter?:ValueTypes["SocialLinkWhere"] | null,	orderBy?:ValueTypes["SocialLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkConnection"]],
validateCreateSocialLink?: [{	data:ValueTypes["SocialLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	data:ValueTypes["SocialLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null},ValueTypes["SocialLinkItem"]],
listSocialLinkItem?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLinkItem"]],
paginateSocialLinkItem?: [{	filter?:ValueTypes["SocialLinkItemWhere"] | null,	orderBy?:ValueTypes["SocialLinkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkItemConnection"]],
validateCreateSocialLinkItem?: [{	data:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	data:ValueTypes["SocialLinkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkList"]],
listSocialLinkList?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null,	orderBy?:ValueTypes["SocialLinkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SocialLinkList"]],
paginateSocialLinkList?: [{	filter?:ValueTypes["SocialLinkListWhere"] | null,	orderBy?:ValueTypes["SocialLinkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SocialLinkListConnection"]],
validateCreateSocialLinkList?: [{	data:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	data:ValueTypes["SocialLinkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["Video"]],
listVideo?: [{	filter?:ValueTypes["VideoWhere"] | null,	orderBy?:ValueTypes["VideoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Video"]],
paginateVideo?: [{	filter?:ValueTypes["VideoWhere"] | null,	orderBy?:ValueTypes["VideoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["VideoConnection"]],
validateCreateVideo?: [{	data:ValueTypes["VideoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	data:ValueTypes["VideoUpdateInput"]},ValueTypes["_ValidationResult"]],
getYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	filter?:ValueTypes["YoutubeVideoWhere"] | null},ValueTypes["YoutubeVideo"]],
listYoutubeVideo?: [{	filter?:ValueTypes["YoutubeVideoWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["YoutubeVideo"]],
paginateYoutubeVideo?: [{	filter?:ValueTypes["YoutubeVideoWhere"] | null,	orderBy?:ValueTypes["YoutubeVideoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["YoutubeVideoConnection"]],
validateCreateYoutubeVideo?: [{	data:ValueTypes["YoutubeVideoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	data:ValueTypes["YoutubeVideoUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["Header"]],
listHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Header"]],
paginateHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderConnection"]],
validateCreateHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["Footer"]],
listFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Footer"]],
paginateFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	data:ValueTypes["FooterUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterAddress?: [{	by:ValueTypes["FooterAddressUniqueWhere"],	filter?:ValueTypes["FooterAddressWhere"] | null},ValueTypes["FooterAddress"]],
listFooterAddress?: [{	filter?:ValueTypes["FooterAddressWhere"] | null,	orderBy?:ValueTypes["FooterAddressOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterAddress"]],
paginateFooterAddress?: [{	filter?:ValueTypes["FooterAddressWhere"] | null,	orderBy?:ValueTypes["FooterAddressOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterAddressConnection"]],
validateCreateFooterAddress?: [{	data:ValueTypes["FooterAddressCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterAddress?: [{	by:ValueTypes["FooterAddressUniqueWhere"],	data:ValueTypes["FooterAddressUpdateInput"]},ValueTypes["_ValidationResult"]],
getPortfolioPage?: [{	by:ValueTypes["PortfolioPageUniqueWhere"],	filter?:ValueTypes["PortfolioPageWhere"] | null},ValueTypes["PortfolioPage"]],
listPortfolioPage?: [{	filter?:ValueTypes["PortfolioPageWhere"] | null,	orderBy?:ValueTypes["PortfolioPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PortfolioPage"]],
paginatePortfolioPage?: [{	filter?:ValueTypes["PortfolioPageWhere"] | null,	orderBy?:ValueTypes["PortfolioPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PortfolioPageConnection"]],
validateCreatePortfolioPage?: [{	data:ValueTypes["PortfolioPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePortfolioPage?: [{	by:ValueTypes["PortfolioPageUniqueWhere"],	data:ValueTypes["PortfolioPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getShowItem?: [{	by:ValueTypes["ShowItemUniqueWhere"],	filter?:ValueTypes["ShowItemWhere"] | null},ValueTypes["ShowItem"]],
listShowItem?: [{	filter?:ValueTypes["ShowItemWhere"] | null,	orderBy?:ValueTypes["ShowItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ShowItem"]],
paginateShowItem?: [{	filter?:ValueTypes["ShowItemWhere"] | null,	orderBy?:ValueTypes["ShowItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ShowItemConnection"]],
validateCreateShowItem?: [{	data:ValueTypes["ShowItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateShowItem?: [{	by:ValueTypes["ShowItemUniqueWhere"],	data:ValueTypes["ShowItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getSettings?: [{	by:ValueTypes["SettingsUniqueWhere"],	filter?:ValueTypes["SettingsWhere"] | null},ValueTypes["Settings"]],
listSettings?: [{	filter?:ValueTypes["SettingsWhere"] | null,	orderBy?:ValueTypes["SettingsOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Settings"]],
paginateSettings?: [{	filter?:ValueTypes["SettingsWhere"] | null,	orderBy?:ValueTypes["SettingsOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SettingsConnection"]],
validateCreateSettings?: [{	data:ValueTypes["SettingsCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSettings?: [{	by:ValueTypes["SettingsUniqueWhere"],	data:ValueTypes["SettingsUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterGeneralContact?: [{	by:ValueTypes["FooterGeneralContactUniqueWhere"],	filter?:ValueTypes["FooterGeneralContactWhere"] | null},ValueTypes["FooterGeneralContact"]],
listFooterGeneralContact?: [{	filter?:ValueTypes["FooterGeneralContactWhere"] | null,	orderBy?:ValueTypes["FooterGeneralContactOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterGeneralContact"]],
paginateFooterGeneralContact?: [{	filter?:ValueTypes["FooterGeneralContactWhere"] | null,	orderBy?:ValueTypes["FooterGeneralContactOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterGeneralContactConnection"]],
validateCreateFooterGeneralContact?: [{	data:ValueTypes["FooterGeneralContactCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterGeneralContact?: [{	by:ValueTypes["FooterGeneralContactUniqueWhere"],	data:ValueTypes["FooterGeneralContactUpdateInput"]},ValueTypes["_ValidationResult"]],
getRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
listRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
paginateRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["_ValidationResult"]],
		__typename?: true
}>;
	["Info"]: AliasType<{
	description?:true,
		__typename?: true
}>;
	["Mutation"]: AliasType<{
createContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	update:ValueTypes["ContentBlockUpdateInput"],	create:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageCreateResult"]],
deleteHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePageDeleteResult"]],
updateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["HomePageUpdateResult"]],
upsertHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	update:ValueTypes["HomePageUpdateInput"],	create:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageUpsertResult"]],
createLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	update:ValueTypes["LinkableUpdateInput"],	create:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createMediumGallery?: [{	data:ValueTypes["MediumGalleryCreateInput"]},ValueTypes["MediumGalleryCreateResult"]],
deleteMediumGallery?: [{	by:ValueTypes["MediumGalleryUniqueWhere"],	filter?:ValueTypes["MediumGalleryWhere"] | null},ValueTypes["MediumGalleryDeleteResult"]],
updateMediumGallery?: [{	by:ValueTypes["MediumGalleryUniqueWhere"],	filter?:ValueTypes["MediumGalleryWhere"] | null,	data:ValueTypes["MediumGalleryUpdateInput"]},ValueTypes["MediumGalleryUpdateResult"]],
upsertMediumGallery?: [{	by:ValueTypes["MediumGalleryUniqueWhere"],	filter?:ValueTypes["MediumGalleryWhere"] | null,	update:ValueTypes["MediumGalleryUpdateInput"],	create:ValueTypes["MediumGalleryCreateInput"]},ValueTypes["MediumGalleryUpsertResult"]],
createMediumGalleryItem?: [{	data:ValueTypes["MediumGalleryItemCreateInput"]},ValueTypes["MediumGalleryItemCreateResult"]],
deleteMediumGalleryItem?: [{	by:ValueTypes["MediumGalleryItemUniqueWhere"],	filter?:ValueTypes["MediumGalleryItemWhere"] | null},ValueTypes["MediumGalleryItemDeleteResult"]],
updateMediumGalleryItem?: [{	by:ValueTypes["MediumGalleryItemUniqueWhere"],	filter?:ValueTypes["MediumGalleryItemWhere"] | null,	data:ValueTypes["MediumGalleryItemUpdateInput"]},ValueTypes["MediumGalleryItemUpdateResult"]],
upsertMediumGalleryItem?: [{	by:ValueTypes["MediumGalleryItemUniqueWhere"],	filter?:ValueTypes["MediumGalleryItemWhere"] | null,	update:ValueTypes["MediumGalleryItemUpdateInput"],	create:ValueTypes["MediumGalleryItemCreateInput"]},ValueTypes["MediumGalleryItemUpsertResult"]],
createMember?: [{	data:ValueTypes["MemberCreateInput"]},ValueTypes["MemberCreateResult"]],
deleteMember?: [{	by:ValueTypes["MemberUniqueWhere"],	filter?:ValueTypes["MemberWhere"] | null},ValueTypes["MemberDeleteResult"]],
updateMember?: [{	by:ValueTypes["MemberUniqueWhere"],	filter?:ValueTypes["MemberWhere"] | null,	data:ValueTypes["MemberUpdateInput"]},ValueTypes["MemberUpdateResult"]],
upsertMember?: [{	by:ValueTypes["MemberUniqueWhere"],	filter?:ValueTypes["MemberWhere"] | null,	update:ValueTypes["MemberUpdateInput"],	create:ValueTypes["MemberCreateInput"]},ValueTypes["MemberUpsertResult"]],
createMemberItem?: [{	data:ValueTypes["MemberItemCreateInput"]},ValueTypes["MemberItemCreateResult"]],
deleteMemberItem?: [{	by:ValueTypes["MemberItemUniqueWhere"],	filter?:ValueTypes["MemberItemWhere"] | null},ValueTypes["MemberItemDeleteResult"]],
updateMemberItem?: [{	by:ValueTypes["MemberItemUniqueWhere"],	filter?:ValueTypes["MemberItemWhere"] | null,	data:ValueTypes["MemberItemUpdateInput"]},ValueTypes["MemberItemUpdateResult"]],
upsertMemberItem?: [{	by:ValueTypes["MemberItemUniqueWhere"],	filter?:ValueTypes["MemberItemWhere"] | null,	update:ValueTypes["MemberItemUpdateInput"],	create:ValueTypes["MemberItemCreateInput"]},ValueTypes["MemberItemUpsertResult"]],
createMemberList?: [{	data:ValueTypes["MemberListCreateInput"]},ValueTypes["MemberListCreateResult"]],
deleteMemberList?: [{	by:ValueTypes["MemberListUniqueWhere"],	filter?:ValueTypes["MemberListWhere"] | null},ValueTypes["MemberListDeleteResult"]],
updateMemberList?: [{	by:ValueTypes["MemberListUniqueWhere"],	filter?:ValueTypes["MemberListWhere"] | null,	data:ValueTypes["MemberListUpdateInput"]},ValueTypes["MemberListUpdateResult"]],
upsertMemberList?: [{	by:ValueTypes["MemberListUniqueWhere"],	filter?:ValueTypes["MemberListWhere"] | null,	update:ValueTypes["MemberListUpdateInput"],	create:ValueTypes["MemberListCreateInput"]},ValueTypes["MemberListUpsertResult"]],
createShow?: [{	data:ValueTypes["ShowCreateInput"]},ValueTypes["ShowCreateResult"]],
deleteShow?: [{	by:ValueTypes["ShowUniqueWhere"],	filter?:ValueTypes["ShowWhere"] | null},ValueTypes["ShowDeleteResult"]],
updateShow?: [{	by:ValueTypes["ShowUniqueWhere"],	filter?:ValueTypes["ShowWhere"] | null,	data:ValueTypes["ShowUpdateInput"]},ValueTypes["ShowUpdateResult"]],
upsertShow?: [{	by:ValueTypes["ShowUniqueWhere"],	filter?:ValueTypes["ShowWhere"] | null,	update:ValueTypes["ShowUpdateInput"],	create:ValueTypes["ShowCreateInput"]},ValueTypes["ShowUpsertResult"]],
createShowList?: [{	data:ValueTypes["ShowListCreateInput"]},ValueTypes["ShowListCreateResult"]],
deleteShowList?: [{	by:ValueTypes["ShowListUniqueWhere"],	filter?:ValueTypes["ShowListWhere"] | null},ValueTypes["ShowListDeleteResult"]],
updateShowList?: [{	by:ValueTypes["ShowListUniqueWhere"],	filter?:ValueTypes["ShowListWhere"] | null,	data:ValueTypes["ShowListUpdateInput"]},ValueTypes["ShowListUpdateResult"]],
upsertShowList?: [{	by:ValueTypes["ShowListUniqueWhere"],	filter?:ValueTypes["ShowListWhere"] | null,	update:ValueTypes["ShowListUpdateInput"],	create:ValueTypes["ShowListCreateInput"]},ValueTypes["ShowListUpsertResult"]],
createShowYear?: [{	data:ValueTypes["ShowYearCreateInput"]},ValueTypes["ShowYearCreateResult"]],
deleteShowYear?: [{	by:ValueTypes["ShowYearUniqueWhere"],	filter?:ValueTypes["ShowYearWhere"] | null},ValueTypes["ShowYearDeleteResult"]],
updateShowYear?: [{	by:ValueTypes["ShowYearUniqueWhere"],	filter?:ValueTypes["ShowYearWhere"] | null,	data:ValueTypes["ShowYearUpdateInput"]},ValueTypes["ShowYearUpdateResult"]],
upsertShowYear?: [{	by:ValueTypes["ShowYearUniqueWhere"],	filter?:ValueTypes["ShowYearWhere"] | null,	update:ValueTypes["ShowYearUpdateInput"],	create:ValueTypes["ShowYearCreateInput"]},ValueTypes["ShowYearUpsertResult"]],
createShowYearItem?: [{	data:ValueTypes["ShowYearItemCreateInput"]},ValueTypes["ShowYearItemCreateResult"]],
deleteShowYearItem?: [{	by:ValueTypes["ShowYearItemUniqueWhere"],	filter?:ValueTypes["ShowYearItemWhere"] | null},ValueTypes["ShowYearItemDeleteResult"]],
updateShowYearItem?: [{	by:ValueTypes["ShowYearItemUniqueWhere"],	filter?:ValueTypes["ShowYearItemWhere"] | null,	data:ValueTypes["ShowYearItemUpdateInput"]},ValueTypes["ShowYearItemUpdateResult"]],
upsertShowYearItem?: [{	by:ValueTypes["ShowYearItemUniqueWhere"],	filter?:ValueTypes["ShowYearItemWhere"] | null,	update:ValueTypes["ShowYearItemUpdateInput"],	create:ValueTypes["ShowYearItemCreateInput"]},ValueTypes["ShowYearItemUpsertResult"]],
createShowYearList?: [{	data:ValueTypes["ShowYearListCreateInput"]},ValueTypes["ShowYearListCreateResult"]],
deleteShowYearList?: [{	by:ValueTypes["ShowYearListUniqueWhere"],	filter?:ValueTypes["ShowYearListWhere"] | null},ValueTypes["ShowYearListDeleteResult"]],
updateShowYearList?: [{	by:ValueTypes["ShowYearListUniqueWhere"],	filter?:ValueTypes["ShowYearListWhere"] | null,	data:ValueTypes["ShowYearListUpdateInput"]},ValueTypes["ShowYearListUpdateResult"]],
upsertShowYearList?: [{	by:ValueTypes["ShowYearListUniqueWhere"],	filter?:ValueTypes["ShowYearListWhere"] | null,	update:ValueTypes["ShowYearListUpdateInput"],	create:ValueTypes["ShowYearListCreateInput"]},ValueTypes["ShowYearListUpsertResult"]],
createSocialLink?: [{	data:ValueTypes["SocialLinkCreateInput"]},ValueTypes["SocialLinkCreateResult"]],
deleteSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLinkDeleteResult"]],
updateSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null,	data:ValueTypes["SocialLinkUpdateInput"]},ValueTypes["SocialLinkUpdateResult"]],
upsertSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null,	update:ValueTypes["SocialLinkUpdateInput"],	create:ValueTypes["SocialLinkCreateInput"]},ValueTypes["SocialLinkUpsertResult"]],
createSocialLinkItem?: [{	data:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["SocialLinkItemCreateResult"]],
deleteSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null},ValueTypes["SocialLinkItemDeleteResult"]],
updateSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null,	data:ValueTypes["SocialLinkItemUpdateInput"]},ValueTypes["SocialLinkItemUpdateResult"]],
upsertSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null,	update:ValueTypes["SocialLinkItemUpdateInput"],	create:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["SocialLinkItemUpsertResult"]],
createSocialLinkList?: [{	data:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["SocialLinkListCreateResult"]],
deleteSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkListDeleteResult"]],
updateSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null,	data:ValueTypes["SocialLinkListUpdateInput"]},ValueTypes["SocialLinkListUpdateResult"]],
upsertSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null,	update:ValueTypes["SocialLinkListUpdateInput"],	create:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["SocialLinkListUpsertResult"]],
createVideo?: [{	data:ValueTypes["VideoCreateInput"]},ValueTypes["VideoCreateResult"]],
deleteVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["VideoDeleteResult"]],
updateVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null,	data:ValueTypes["VideoUpdateInput"]},ValueTypes["VideoUpdateResult"]],
upsertVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null,	update:ValueTypes["VideoUpdateInput"],	create:ValueTypes["VideoCreateInput"]},ValueTypes["VideoUpsertResult"]],
createYoutubeVideo?: [{	data:ValueTypes["YoutubeVideoCreateInput"]},ValueTypes["YoutubeVideoCreateResult"]],
deleteYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	filter?:ValueTypes["YoutubeVideoWhere"] | null},ValueTypes["YoutubeVideoDeleteResult"]],
updateYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	filter?:ValueTypes["YoutubeVideoWhere"] | null,	data:ValueTypes["YoutubeVideoUpdateInput"]},ValueTypes["YoutubeVideoUpdateResult"]],
upsertYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	filter?:ValueTypes["YoutubeVideoWhere"] | null,	update:ValueTypes["YoutubeVideoUpdateInput"],	create:ValueTypes["YoutubeVideoCreateInput"]},ValueTypes["YoutubeVideoUpsertResult"]],
createHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderCreateResult"]],
deleteHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["HeaderDeleteResult"]],
updateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	update:ValueTypes["HeaderUpdateInput"],	create:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderUpsertResult"]],
createFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	data:ValueTypes["FooterUpdateInput"]},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	update:ValueTypes["FooterUpdateInput"],	create:ValueTypes["FooterCreateInput"]},ValueTypes["FooterUpsertResult"]],
createFooterAddress?: [{	data:ValueTypes["FooterAddressCreateInput"]},ValueTypes["FooterAddressCreateResult"]],
deleteFooterAddress?: [{	by:ValueTypes["FooterAddressUniqueWhere"],	filter?:ValueTypes["FooterAddressWhere"] | null},ValueTypes["FooterAddressDeleteResult"]],
updateFooterAddress?: [{	by:ValueTypes["FooterAddressUniqueWhere"],	filter?:ValueTypes["FooterAddressWhere"] | null,	data:ValueTypes["FooterAddressUpdateInput"]},ValueTypes["FooterAddressUpdateResult"]],
upsertFooterAddress?: [{	by:ValueTypes["FooterAddressUniqueWhere"],	filter?:ValueTypes["FooterAddressWhere"] | null,	update:ValueTypes["FooterAddressUpdateInput"],	create:ValueTypes["FooterAddressCreateInput"]},ValueTypes["FooterAddressUpsertResult"]],
createPortfolioPage?: [{	data:ValueTypes["PortfolioPageCreateInput"]},ValueTypes["PortfolioPageCreateResult"]],
deletePortfolioPage?: [{	by:ValueTypes["PortfolioPageUniqueWhere"],	filter?:ValueTypes["PortfolioPageWhere"] | null},ValueTypes["PortfolioPageDeleteResult"]],
updatePortfolioPage?: [{	by:ValueTypes["PortfolioPageUniqueWhere"],	filter?:ValueTypes["PortfolioPageWhere"] | null,	data:ValueTypes["PortfolioPageUpdateInput"]},ValueTypes["PortfolioPageUpdateResult"]],
upsertPortfolioPage?: [{	by:ValueTypes["PortfolioPageUniqueWhere"],	filter?:ValueTypes["PortfolioPageWhere"] | null,	update:ValueTypes["PortfolioPageUpdateInput"],	create:ValueTypes["PortfolioPageCreateInput"]},ValueTypes["PortfolioPageUpsertResult"]],
createShowItem?: [{	data:ValueTypes["ShowItemCreateInput"]},ValueTypes["ShowItemCreateResult"]],
deleteShowItem?: [{	by:ValueTypes["ShowItemUniqueWhere"],	filter?:ValueTypes["ShowItemWhere"] | null},ValueTypes["ShowItemDeleteResult"]],
updateShowItem?: [{	by:ValueTypes["ShowItemUniqueWhere"],	filter?:ValueTypes["ShowItemWhere"] | null,	data:ValueTypes["ShowItemUpdateInput"]},ValueTypes["ShowItemUpdateResult"]],
upsertShowItem?: [{	by:ValueTypes["ShowItemUniqueWhere"],	filter?:ValueTypes["ShowItemWhere"] | null,	update:ValueTypes["ShowItemUpdateInput"],	create:ValueTypes["ShowItemCreateInput"]},ValueTypes["ShowItemUpsertResult"]],
createSettings?: [{	data:ValueTypes["SettingsCreateInput"]},ValueTypes["SettingsCreateResult"]],
deleteSettings?: [{	by:ValueTypes["SettingsUniqueWhere"],	filter?:ValueTypes["SettingsWhere"] | null},ValueTypes["SettingsDeleteResult"]],
updateSettings?: [{	by:ValueTypes["SettingsUniqueWhere"],	filter?:ValueTypes["SettingsWhere"] | null,	data:ValueTypes["SettingsUpdateInput"]},ValueTypes["SettingsUpdateResult"]],
upsertSettings?: [{	by:ValueTypes["SettingsUniqueWhere"],	filter?:ValueTypes["SettingsWhere"] | null,	update:ValueTypes["SettingsUpdateInput"],	create:ValueTypes["SettingsCreateInput"]},ValueTypes["SettingsUpsertResult"]],
createFooterGeneralContact?: [{	data:ValueTypes["FooterGeneralContactCreateInput"]},ValueTypes["FooterGeneralContactCreateResult"]],
deleteFooterGeneralContact?: [{	by:ValueTypes["FooterGeneralContactUniqueWhere"],	filter?:ValueTypes["FooterGeneralContactWhere"] | null},ValueTypes["FooterGeneralContactDeleteResult"]],
updateFooterGeneralContact?: [{	by:ValueTypes["FooterGeneralContactUniqueWhere"],	filter?:ValueTypes["FooterGeneralContactWhere"] | null,	data:ValueTypes["FooterGeneralContactUpdateInput"]},ValueTypes["FooterGeneralContactUpdateResult"]],
upsertFooterGeneralContact?: [{	by:ValueTypes["FooterGeneralContactUniqueWhere"],	filter?:ValueTypes["FooterGeneralContactWhere"] | null,	update:ValueTypes["FooterGeneralContactUpdateInput"],	create:ValueTypes["FooterGeneralContactCreateInput"]},ValueTypes["FooterGeneralContactUpsertResult"]],
createRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	update:ValueTypes["RedirectUpdateInput"],	create:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectUpsertResult"]],
transaction?: [{	options?:ValueTypes["MutationTransactionOptions"] | null},ValueTypes["MutationTransaction"]],
	query?:ValueTypes["Query"],
generateUploadUrl?: [{	contentType:string,	expiration?:number | null,	prefix?:string | null},ValueTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey:string,	expiration?:number | null},ValueTypes["S3SignedRead"]],
		__typename?: true
}>;
	["ContentBlockCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MutationResult"]:AliasType<{
		ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"];
		['...on ContentBlockCreateResult']?: Omit<ValueTypes["ContentBlockCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockDeleteResult']?: Omit<ValueTypes["ContentBlockDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpdateResult']?: Omit<ValueTypes["ContentBlockUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpsertResult']?: Omit<ValueTypes["ContentBlockUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageCreateResult']?: Omit<ValueTypes["ImageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageDeleteResult']?: Omit<ValueTypes["ImageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpdateResult']?: Omit<ValueTypes["ImageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpsertResult']?: Omit<ValueTypes["ImageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkCreateResult']?: Omit<ValueTypes["LinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkDeleteResult']?: Omit<ValueTypes["LinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpdateResult']?: Omit<ValueTypes["LinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpsertResult']?: Omit<ValueTypes["LinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoCreateResult']?: Omit<ValueTypes["SeoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDeleteResult']?: Omit<ValueTypes["SeoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpdateResult']?: Omit<ValueTypes["SeoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpsertResult']?: Omit<ValueTypes["SeoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageCreateResult']?: Omit<ValueTypes["HomePageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageDeleteResult']?: Omit<ValueTypes["HomePageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageUpdateResult']?: Omit<ValueTypes["HomePageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageUpsertResult']?: Omit<ValueTypes["HomePageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableCreateResult']?: Omit<ValueTypes["LinkableCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableDeleteResult']?: Omit<ValueTypes["LinkableDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpdateResult']?: Omit<ValueTypes["LinkableUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpsertResult']?: Omit<ValueTypes["LinkableUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumGalleryCreateResult']?: Omit<ValueTypes["MediumGalleryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumGalleryDeleteResult']?: Omit<ValueTypes["MediumGalleryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumGalleryUpdateResult']?: Omit<ValueTypes["MediumGalleryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumGalleryUpsertResult']?: Omit<ValueTypes["MediumGalleryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumGalleryItemCreateResult']?: Omit<ValueTypes["MediumGalleryItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumGalleryItemDeleteResult']?: Omit<ValueTypes["MediumGalleryItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumGalleryItemUpdateResult']?: Omit<ValueTypes["MediumGalleryItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumGalleryItemUpsertResult']?: Omit<ValueTypes["MediumGalleryItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberCreateResult']?: Omit<ValueTypes["MemberCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberDeleteResult']?: Omit<ValueTypes["MemberDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberUpdateResult']?: Omit<ValueTypes["MemberUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberUpsertResult']?: Omit<ValueTypes["MemberUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberItemCreateResult']?: Omit<ValueTypes["MemberItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberItemDeleteResult']?: Omit<ValueTypes["MemberItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberItemUpdateResult']?: Omit<ValueTypes["MemberItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberItemUpsertResult']?: Omit<ValueTypes["MemberItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberListCreateResult']?: Omit<ValueTypes["MemberListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberListDeleteResult']?: Omit<ValueTypes["MemberListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberListUpdateResult']?: Omit<ValueTypes["MemberListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MemberListUpsertResult']?: Omit<ValueTypes["MemberListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowCreateResult']?: Omit<ValueTypes["ShowCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowDeleteResult']?: Omit<ValueTypes["ShowDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowUpdateResult']?: Omit<ValueTypes["ShowUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowUpsertResult']?: Omit<ValueTypes["ShowUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowListCreateResult']?: Omit<ValueTypes["ShowListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowListDeleteResult']?: Omit<ValueTypes["ShowListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowListUpdateResult']?: Omit<ValueTypes["ShowListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowListUpsertResult']?: Omit<ValueTypes["ShowListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowYearCreateResult']?: Omit<ValueTypes["ShowYearCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowYearDeleteResult']?: Omit<ValueTypes["ShowYearDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowYearUpdateResult']?: Omit<ValueTypes["ShowYearUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowYearUpsertResult']?: Omit<ValueTypes["ShowYearUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowYearItemCreateResult']?: Omit<ValueTypes["ShowYearItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowYearItemDeleteResult']?: Omit<ValueTypes["ShowYearItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowYearItemUpdateResult']?: Omit<ValueTypes["ShowYearItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowYearItemUpsertResult']?: Omit<ValueTypes["ShowYearItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowYearListCreateResult']?: Omit<ValueTypes["ShowYearListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowYearListDeleteResult']?: Omit<ValueTypes["ShowYearListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowYearListUpdateResult']?: Omit<ValueTypes["ShowYearListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowYearListUpsertResult']?: Omit<ValueTypes["ShowYearListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkCreateResult']?: Omit<ValueTypes["SocialLinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkDeleteResult']?: Omit<ValueTypes["SocialLinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkUpdateResult']?: Omit<ValueTypes["SocialLinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkUpsertResult']?: Omit<ValueTypes["SocialLinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkItemCreateResult']?: Omit<ValueTypes["SocialLinkItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkItemDeleteResult']?: Omit<ValueTypes["SocialLinkItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkItemUpdateResult']?: Omit<ValueTypes["SocialLinkItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkItemUpsertResult']?: Omit<ValueTypes["SocialLinkItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkListCreateResult']?: Omit<ValueTypes["SocialLinkListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkListDeleteResult']?: Omit<ValueTypes["SocialLinkListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkListUpdateResult']?: Omit<ValueTypes["SocialLinkListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SocialLinkListUpsertResult']?: Omit<ValueTypes["SocialLinkListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoCreateResult']?: Omit<ValueTypes["VideoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoDeleteResult']?: Omit<ValueTypes["VideoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoUpdateResult']?: Omit<ValueTypes["VideoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoUpsertResult']?: Omit<ValueTypes["VideoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on YoutubeVideoCreateResult']?: Omit<ValueTypes["YoutubeVideoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on YoutubeVideoDeleteResult']?: Omit<ValueTypes["YoutubeVideoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on YoutubeVideoUpdateResult']?: Omit<ValueTypes["YoutubeVideoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on YoutubeVideoUpsertResult']?: Omit<ValueTypes["YoutubeVideoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderCreateResult']?: Omit<ValueTypes["HeaderCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderDeleteResult']?: Omit<ValueTypes["HeaderDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderUpdateResult']?: Omit<ValueTypes["HeaderUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderUpsertResult']?: Omit<ValueTypes["HeaderUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterCreateResult']?: Omit<ValueTypes["FooterCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterDeleteResult']?: Omit<ValueTypes["FooterDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpdateResult']?: Omit<ValueTypes["FooterUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpsertResult']?: Omit<ValueTypes["FooterUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterAddressCreateResult']?: Omit<ValueTypes["FooterAddressCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterAddressDeleteResult']?: Omit<ValueTypes["FooterAddressDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterAddressUpdateResult']?: Omit<ValueTypes["FooterAddressUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterAddressUpsertResult']?: Omit<ValueTypes["FooterAddressUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PortfolioPageCreateResult']?: Omit<ValueTypes["PortfolioPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PortfolioPageDeleteResult']?: Omit<ValueTypes["PortfolioPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PortfolioPageUpdateResult']?: Omit<ValueTypes["PortfolioPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PortfolioPageUpsertResult']?: Omit<ValueTypes["PortfolioPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowItemCreateResult']?: Omit<ValueTypes["ShowItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowItemDeleteResult']?: Omit<ValueTypes["ShowItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowItemUpdateResult']?: Omit<ValueTypes["ShowItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ShowItemUpsertResult']?: Omit<ValueTypes["ShowItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SettingsCreateResult']?: Omit<ValueTypes["SettingsCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SettingsDeleteResult']?: Omit<ValueTypes["SettingsDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SettingsUpdateResult']?: Omit<ValueTypes["SettingsUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SettingsUpsertResult']?: Omit<ValueTypes["SettingsUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterGeneralContactCreateResult']?: Omit<ValueTypes["FooterGeneralContactCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterGeneralContactDeleteResult']?: Omit<ValueTypes["FooterGeneralContactDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterGeneralContactUpdateResult']?: Omit<ValueTypes["FooterGeneralContactUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterGeneralContactUpsertResult']?: Omit<ValueTypes["FooterGeneralContactUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectCreateResult']?: Omit<ValueTypes["RedirectCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectDeleteResult']?: Omit<ValueTypes["RedirectDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectUpdateResult']?: Omit<ValueTypes["RedirectUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectUpsertResult']?: Omit<ValueTypes["RedirectUpsertResult"],keyof ValueTypes["MutationResult"]>;
		__typename?: true
}>;
	["_MutationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	paths?:ValueTypes["_PathFragment"],
	type?:true,
	message?:true,
		__typename?: true
}>;
	["_MutationErrorType"]:_MutationErrorType;
	["ContentBlockDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
		__typename?: true
}>;
	["ContentBlockUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentBlockUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
		__typename?: true
}>;
	["ImageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
		__typename?: true
}>;
	["LinkUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
		__typename?: true
}>;
	["SeoUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
		__typename?: true
}>;
	["HomePageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
		__typename?: true
}>;
	["LinkableUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumGalleryCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumGallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumGalleryDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumGallery"],
		__typename?: true
}>;
	["MediumGalleryUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumGallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumGalleryUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumGallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumGalleryItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumGalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumGalleryItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumGalleryItem"],
		__typename?: true
}>;
	["MediumGalleryItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumGalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumGalleryItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumGalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MemberCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Member"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MemberDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Member"],
		__typename?: true
}>;
	["MemberUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Member"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MemberUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Member"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MemberItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MemberItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MemberItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MemberItem"],
		__typename?: true
}>;
	["MemberItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MemberItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MemberItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MemberItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MemberListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MemberList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MemberListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MemberList"],
		__typename?: true
}>;
	["MemberListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MemberList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MemberListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MemberList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Show"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Show"],
		__typename?: true
}>;
	["ShowUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Show"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Show"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowList"],
		__typename?: true
}>;
	["ShowListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowYearCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowYear"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowYearDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowYear"],
		__typename?: true
}>;
	["ShowYearUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowYear"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowYearUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowYear"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowYearItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowYearItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowYearItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowYearItem"],
		__typename?: true
}>;
	["ShowYearItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowYearItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowYearItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowYearItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowYearListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowYearList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowYearListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowYearList"],
		__typename?: true
}>;
	["ShowYearListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowYearList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowYearListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowYearList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SocialLinkCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SocialLinkDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLink"],
		__typename?: true
}>;
	["SocialLinkUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SocialLinkUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SocialLinkItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SocialLinkItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkItem"],
		__typename?: true
}>;
	["SocialLinkItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SocialLinkItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SocialLinkListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SocialLinkListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkList"],
		__typename?: true
}>;
	["SocialLinkListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SocialLinkListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SocialLinkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["VideoCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["VideoDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
		__typename?: true
}>;
	["VideoUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["VideoUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["YoutubeVideoCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["YoutubeVideo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["YoutubeVideoDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["YoutubeVideo"],
		__typename?: true
}>;
	["YoutubeVideoUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["YoutubeVideo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["YoutubeVideoUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["YoutubeVideo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
		__typename?: true
}>;
	["HeaderUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
		__typename?: true
}>;
	["FooterUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterAddressCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterAddress"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterAddressDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterAddress"],
		__typename?: true
}>;
	["FooterAddressUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterAddress"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterAddressUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterAddress"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PortfolioPageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PortfolioPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PortfolioPageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PortfolioPage"],
		__typename?: true
}>;
	["PortfolioPageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PortfolioPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PortfolioPageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PortfolioPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowItem"],
		__typename?: true
}>;
	["ShowItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ShowItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ShowItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SettingsCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Settings"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SettingsDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Settings"],
		__typename?: true
}>;
	["SettingsUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Settings"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SettingsUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Settings"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterGeneralContactCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterGeneralContact"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterGeneralContactDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterGeneralContact"],
		__typename?: true
}>;
	["FooterGeneralContactUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterGeneralContact"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterGeneralContactUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterGeneralContact"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["RedirectCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["RedirectDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
		__typename?: true
}>;
	["RedirectUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["RedirectUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MutationTransaction"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	validation?:ValueTypes["_ValidationResult"],
createContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	update:ValueTypes["ContentBlockUpdateInput"],	create:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageCreateResult"]],
deleteHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePageDeleteResult"]],
updateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["HomePageUpdateResult"]],
upsertHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	update:ValueTypes["HomePageUpdateInput"],	create:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageUpsertResult"]],
createLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	update:ValueTypes["LinkableUpdateInput"],	create:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createMediumGallery?: [{	data:ValueTypes["MediumGalleryCreateInput"]},ValueTypes["MediumGalleryCreateResult"]],
deleteMediumGallery?: [{	by:ValueTypes["MediumGalleryUniqueWhere"],	filter?:ValueTypes["MediumGalleryWhere"] | null},ValueTypes["MediumGalleryDeleteResult"]],
updateMediumGallery?: [{	by:ValueTypes["MediumGalleryUniqueWhere"],	filter?:ValueTypes["MediumGalleryWhere"] | null,	data:ValueTypes["MediumGalleryUpdateInput"]},ValueTypes["MediumGalleryUpdateResult"]],
upsertMediumGallery?: [{	by:ValueTypes["MediumGalleryUniqueWhere"],	filter?:ValueTypes["MediumGalleryWhere"] | null,	update:ValueTypes["MediumGalleryUpdateInput"],	create:ValueTypes["MediumGalleryCreateInput"]},ValueTypes["MediumGalleryUpsertResult"]],
createMediumGalleryItem?: [{	data:ValueTypes["MediumGalleryItemCreateInput"]},ValueTypes["MediumGalleryItemCreateResult"]],
deleteMediumGalleryItem?: [{	by:ValueTypes["MediumGalleryItemUniqueWhere"],	filter?:ValueTypes["MediumGalleryItemWhere"] | null},ValueTypes["MediumGalleryItemDeleteResult"]],
updateMediumGalleryItem?: [{	by:ValueTypes["MediumGalleryItemUniqueWhere"],	filter?:ValueTypes["MediumGalleryItemWhere"] | null,	data:ValueTypes["MediumGalleryItemUpdateInput"]},ValueTypes["MediumGalleryItemUpdateResult"]],
upsertMediumGalleryItem?: [{	by:ValueTypes["MediumGalleryItemUniqueWhere"],	filter?:ValueTypes["MediumGalleryItemWhere"] | null,	update:ValueTypes["MediumGalleryItemUpdateInput"],	create:ValueTypes["MediumGalleryItemCreateInput"]},ValueTypes["MediumGalleryItemUpsertResult"]],
createMember?: [{	data:ValueTypes["MemberCreateInput"]},ValueTypes["MemberCreateResult"]],
deleteMember?: [{	by:ValueTypes["MemberUniqueWhere"],	filter?:ValueTypes["MemberWhere"] | null},ValueTypes["MemberDeleteResult"]],
updateMember?: [{	by:ValueTypes["MemberUniqueWhere"],	filter?:ValueTypes["MemberWhere"] | null,	data:ValueTypes["MemberUpdateInput"]},ValueTypes["MemberUpdateResult"]],
upsertMember?: [{	by:ValueTypes["MemberUniqueWhere"],	filter?:ValueTypes["MemberWhere"] | null,	update:ValueTypes["MemberUpdateInput"],	create:ValueTypes["MemberCreateInput"]},ValueTypes["MemberUpsertResult"]],
createMemberItem?: [{	data:ValueTypes["MemberItemCreateInput"]},ValueTypes["MemberItemCreateResult"]],
deleteMemberItem?: [{	by:ValueTypes["MemberItemUniqueWhere"],	filter?:ValueTypes["MemberItemWhere"] | null},ValueTypes["MemberItemDeleteResult"]],
updateMemberItem?: [{	by:ValueTypes["MemberItemUniqueWhere"],	filter?:ValueTypes["MemberItemWhere"] | null,	data:ValueTypes["MemberItemUpdateInput"]},ValueTypes["MemberItemUpdateResult"]],
upsertMemberItem?: [{	by:ValueTypes["MemberItemUniqueWhere"],	filter?:ValueTypes["MemberItemWhere"] | null,	update:ValueTypes["MemberItemUpdateInput"],	create:ValueTypes["MemberItemCreateInput"]},ValueTypes["MemberItemUpsertResult"]],
createMemberList?: [{	data:ValueTypes["MemberListCreateInput"]},ValueTypes["MemberListCreateResult"]],
deleteMemberList?: [{	by:ValueTypes["MemberListUniqueWhere"],	filter?:ValueTypes["MemberListWhere"] | null},ValueTypes["MemberListDeleteResult"]],
updateMemberList?: [{	by:ValueTypes["MemberListUniqueWhere"],	filter?:ValueTypes["MemberListWhere"] | null,	data:ValueTypes["MemberListUpdateInput"]},ValueTypes["MemberListUpdateResult"]],
upsertMemberList?: [{	by:ValueTypes["MemberListUniqueWhere"],	filter?:ValueTypes["MemberListWhere"] | null,	update:ValueTypes["MemberListUpdateInput"],	create:ValueTypes["MemberListCreateInput"]},ValueTypes["MemberListUpsertResult"]],
createShow?: [{	data:ValueTypes["ShowCreateInput"]},ValueTypes["ShowCreateResult"]],
deleteShow?: [{	by:ValueTypes["ShowUniqueWhere"],	filter?:ValueTypes["ShowWhere"] | null},ValueTypes["ShowDeleteResult"]],
updateShow?: [{	by:ValueTypes["ShowUniqueWhere"],	filter?:ValueTypes["ShowWhere"] | null,	data:ValueTypes["ShowUpdateInput"]},ValueTypes["ShowUpdateResult"]],
upsertShow?: [{	by:ValueTypes["ShowUniqueWhere"],	filter?:ValueTypes["ShowWhere"] | null,	update:ValueTypes["ShowUpdateInput"],	create:ValueTypes["ShowCreateInput"]},ValueTypes["ShowUpsertResult"]],
createShowList?: [{	data:ValueTypes["ShowListCreateInput"]},ValueTypes["ShowListCreateResult"]],
deleteShowList?: [{	by:ValueTypes["ShowListUniqueWhere"],	filter?:ValueTypes["ShowListWhere"] | null},ValueTypes["ShowListDeleteResult"]],
updateShowList?: [{	by:ValueTypes["ShowListUniqueWhere"],	filter?:ValueTypes["ShowListWhere"] | null,	data:ValueTypes["ShowListUpdateInput"]},ValueTypes["ShowListUpdateResult"]],
upsertShowList?: [{	by:ValueTypes["ShowListUniqueWhere"],	filter?:ValueTypes["ShowListWhere"] | null,	update:ValueTypes["ShowListUpdateInput"],	create:ValueTypes["ShowListCreateInput"]},ValueTypes["ShowListUpsertResult"]],
createShowYear?: [{	data:ValueTypes["ShowYearCreateInput"]},ValueTypes["ShowYearCreateResult"]],
deleteShowYear?: [{	by:ValueTypes["ShowYearUniqueWhere"],	filter?:ValueTypes["ShowYearWhere"] | null},ValueTypes["ShowYearDeleteResult"]],
updateShowYear?: [{	by:ValueTypes["ShowYearUniqueWhere"],	filter?:ValueTypes["ShowYearWhere"] | null,	data:ValueTypes["ShowYearUpdateInput"]},ValueTypes["ShowYearUpdateResult"]],
upsertShowYear?: [{	by:ValueTypes["ShowYearUniqueWhere"],	filter?:ValueTypes["ShowYearWhere"] | null,	update:ValueTypes["ShowYearUpdateInput"],	create:ValueTypes["ShowYearCreateInput"]},ValueTypes["ShowYearUpsertResult"]],
createShowYearItem?: [{	data:ValueTypes["ShowYearItemCreateInput"]},ValueTypes["ShowYearItemCreateResult"]],
deleteShowYearItem?: [{	by:ValueTypes["ShowYearItemUniqueWhere"],	filter?:ValueTypes["ShowYearItemWhere"] | null},ValueTypes["ShowYearItemDeleteResult"]],
updateShowYearItem?: [{	by:ValueTypes["ShowYearItemUniqueWhere"],	filter?:ValueTypes["ShowYearItemWhere"] | null,	data:ValueTypes["ShowYearItemUpdateInput"]},ValueTypes["ShowYearItemUpdateResult"]],
upsertShowYearItem?: [{	by:ValueTypes["ShowYearItemUniqueWhere"],	filter?:ValueTypes["ShowYearItemWhere"] | null,	update:ValueTypes["ShowYearItemUpdateInput"],	create:ValueTypes["ShowYearItemCreateInput"]},ValueTypes["ShowYearItemUpsertResult"]],
createShowYearList?: [{	data:ValueTypes["ShowYearListCreateInput"]},ValueTypes["ShowYearListCreateResult"]],
deleteShowYearList?: [{	by:ValueTypes["ShowYearListUniqueWhere"],	filter?:ValueTypes["ShowYearListWhere"] | null},ValueTypes["ShowYearListDeleteResult"]],
updateShowYearList?: [{	by:ValueTypes["ShowYearListUniqueWhere"],	filter?:ValueTypes["ShowYearListWhere"] | null,	data:ValueTypes["ShowYearListUpdateInput"]},ValueTypes["ShowYearListUpdateResult"]],
upsertShowYearList?: [{	by:ValueTypes["ShowYearListUniqueWhere"],	filter?:ValueTypes["ShowYearListWhere"] | null,	update:ValueTypes["ShowYearListUpdateInput"],	create:ValueTypes["ShowYearListCreateInput"]},ValueTypes["ShowYearListUpsertResult"]],
createSocialLink?: [{	data:ValueTypes["SocialLinkCreateInput"]},ValueTypes["SocialLinkCreateResult"]],
deleteSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null},ValueTypes["SocialLinkDeleteResult"]],
updateSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null,	data:ValueTypes["SocialLinkUpdateInput"]},ValueTypes["SocialLinkUpdateResult"]],
upsertSocialLink?: [{	by:ValueTypes["SocialLinkUniqueWhere"],	filter?:ValueTypes["SocialLinkWhere"] | null,	update:ValueTypes["SocialLinkUpdateInput"],	create:ValueTypes["SocialLinkCreateInput"]},ValueTypes["SocialLinkUpsertResult"]],
createSocialLinkItem?: [{	data:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["SocialLinkItemCreateResult"]],
deleteSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null},ValueTypes["SocialLinkItemDeleteResult"]],
updateSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null,	data:ValueTypes["SocialLinkItemUpdateInput"]},ValueTypes["SocialLinkItemUpdateResult"]],
upsertSocialLinkItem?: [{	by:ValueTypes["SocialLinkItemUniqueWhere"],	filter?:ValueTypes["SocialLinkItemWhere"] | null,	update:ValueTypes["SocialLinkItemUpdateInput"],	create:ValueTypes["SocialLinkItemCreateInput"]},ValueTypes["SocialLinkItemUpsertResult"]],
createSocialLinkList?: [{	data:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["SocialLinkListCreateResult"]],
deleteSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null},ValueTypes["SocialLinkListDeleteResult"]],
updateSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null,	data:ValueTypes["SocialLinkListUpdateInput"]},ValueTypes["SocialLinkListUpdateResult"]],
upsertSocialLinkList?: [{	by:ValueTypes["SocialLinkListUniqueWhere"],	filter?:ValueTypes["SocialLinkListWhere"] | null,	update:ValueTypes["SocialLinkListUpdateInput"],	create:ValueTypes["SocialLinkListCreateInput"]},ValueTypes["SocialLinkListUpsertResult"]],
createVideo?: [{	data:ValueTypes["VideoCreateInput"]},ValueTypes["VideoCreateResult"]],
deleteVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["VideoDeleteResult"]],
updateVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null,	data:ValueTypes["VideoUpdateInput"]},ValueTypes["VideoUpdateResult"]],
upsertVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null,	update:ValueTypes["VideoUpdateInput"],	create:ValueTypes["VideoCreateInput"]},ValueTypes["VideoUpsertResult"]],
createYoutubeVideo?: [{	data:ValueTypes["YoutubeVideoCreateInput"]},ValueTypes["YoutubeVideoCreateResult"]],
deleteYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	filter?:ValueTypes["YoutubeVideoWhere"] | null},ValueTypes["YoutubeVideoDeleteResult"]],
updateYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	filter?:ValueTypes["YoutubeVideoWhere"] | null,	data:ValueTypes["YoutubeVideoUpdateInput"]},ValueTypes["YoutubeVideoUpdateResult"]],
upsertYoutubeVideo?: [{	by:ValueTypes["YoutubeVideoUniqueWhere"],	filter?:ValueTypes["YoutubeVideoWhere"] | null,	update:ValueTypes["YoutubeVideoUpdateInput"],	create:ValueTypes["YoutubeVideoCreateInput"]},ValueTypes["YoutubeVideoUpsertResult"]],
createHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderCreateResult"]],
deleteHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["HeaderDeleteResult"]],
updateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	update:ValueTypes["HeaderUpdateInput"],	create:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderUpsertResult"]],
createFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	data:ValueTypes["FooterUpdateInput"]},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	update:ValueTypes["FooterUpdateInput"],	create:ValueTypes["FooterCreateInput"]},ValueTypes["FooterUpsertResult"]],
createFooterAddress?: [{	data:ValueTypes["FooterAddressCreateInput"]},ValueTypes["FooterAddressCreateResult"]],
deleteFooterAddress?: [{	by:ValueTypes["FooterAddressUniqueWhere"],	filter?:ValueTypes["FooterAddressWhere"] | null},ValueTypes["FooterAddressDeleteResult"]],
updateFooterAddress?: [{	by:ValueTypes["FooterAddressUniqueWhere"],	filter?:ValueTypes["FooterAddressWhere"] | null,	data:ValueTypes["FooterAddressUpdateInput"]},ValueTypes["FooterAddressUpdateResult"]],
upsertFooterAddress?: [{	by:ValueTypes["FooterAddressUniqueWhere"],	filter?:ValueTypes["FooterAddressWhere"] | null,	update:ValueTypes["FooterAddressUpdateInput"],	create:ValueTypes["FooterAddressCreateInput"]},ValueTypes["FooterAddressUpsertResult"]],
createPortfolioPage?: [{	data:ValueTypes["PortfolioPageCreateInput"]},ValueTypes["PortfolioPageCreateResult"]],
deletePortfolioPage?: [{	by:ValueTypes["PortfolioPageUniqueWhere"],	filter?:ValueTypes["PortfolioPageWhere"] | null},ValueTypes["PortfolioPageDeleteResult"]],
updatePortfolioPage?: [{	by:ValueTypes["PortfolioPageUniqueWhere"],	filter?:ValueTypes["PortfolioPageWhere"] | null,	data:ValueTypes["PortfolioPageUpdateInput"]},ValueTypes["PortfolioPageUpdateResult"]],
upsertPortfolioPage?: [{	by:ValueTypes["PortfolioPageUniqueWhere"],	filter?:ValueTypes["PortfolioPageWhere"] | null,	update:ValueTypes["PortfolioPageUpdateInput"],	create:ValueTypes["PortfolioPageCreateInput"]},ValueTypes["PortfolioPageUpsertResult"]],
createShowItem?: [{	data:ValueTypes["ShowItemCreateInput"]},ValueTypes["ShowItemCreateResult"]],
deleteShowItem?: [{	by:ValueTypes["ShowItemUniqueWhere"],	filter?:ValueTypes["ShowItemWhere"] | null},ValueTypes["ShowItemDeleteResult"]],
updateShowItem?: [{	by:ValueTypes["ShowItemUniqueWhere"],	filter?:ValueTypes["ShowItemWhere"] | null,	data:ValueTypes["ShowItemUpdateInput"]},ValueTypes["ShowItemUpdateResult"]],
upsertShowItem?: [{	by:ValueTypes["ShowItemUniqueWhere"],	filter?:ValueTypes["ShowItemWhere"] | null,	update:ValueTypes["ShowItemUpdateInput"],	create:ValueTypes["ShowItemCreateInput"]},ValueTypes["ShowItemUpsertResult"]],
createSettings?: [{	data:ValueTypes["SettingsCreateInput"]},ValueTypes["SettingsCreateResult"]],
deleteSettings?: [{	by:ValueTypes["SettingsUniqueWhere"],	filter?:ValueTypes["SettingsWhere"] | null},ValueTypes["SettingsDeleteResult"]],
updateSettings?: [{	by:ValueTypes["SettingsUniqueWhere"],	filter?:ValueTypes["SettingsWhere"] | null,	data:ValueTypes["SettingsUpdateInput"]},ValueTypes["SettingsUpdateResult"]],
upsertSettings?: [{	by:ValueTypes["SettingsUniqueWhere"],	filter?:ValueTypes["SettingsWhere"] | null,	update:ValueTypes["SettingsUpdateInput"],	create:ValueTypes["SettingsCreateInput"]},ValueTypes["SettingsUpsertResult"]],
createFooterGeneralContact?: [{	data:ValueTypes["FooterGeneralContactCreateInput"]},ValueTypes["FooterGeneralContactCreateResult"]],
deleteFooterGeneralContact?: [{	by:ValueTypes["FooterGeneralContactUniqueWhere"],	filter?:ValueTypes["FooterGeneralContactWhere"] | null},ValueTypes["FooterGeneralContactDeleteResult"]],
updateFooterGeneralContact?: [{	by:ValueTypes["FooterGeneralContactUniqueWhere"],	filter?:ValueTypes["FooterGeneralContactWhere"] | null,	data:ValueTypes["FooterGeneralContactUpdateInput"]},ValueTypes["FooterGeneralContactUpdateResult"]],
upsertFooterGeneralContact?: [{	by:ValueTypes["FooterGeneralContactUniqueWhere"],	filter?:ValueTypes["FooterGeneralContactWhere"] | null,	update:ValueTypes["FooterGeneralContactUpdateInput"],	create:ValueTypes["FooterGeneralContactCreateInput"]},ValueTypes["FooterGeneralContactUpsertResult"]],
createRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	update:ValueTypes["RedirectUpdateInput"],	create:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectUpsertResult"]],
	query?:ValueTypes["Query"],
		__typename?: true
}>;
	["MutationTransactionOptions"]: {
	deferForeignKeyConstraints?:boolean | null
};
	["Json"]:unknown;
	["_Schema"]: AliasType<{
	enums?:ValueTypes["_Enum"],
	entities?:ValueTypes["_Entity"],
		__typename?: true
}>;
	["_Entity"]: AliasType<{
	name?:true,
	customPrimaryAllowed?:true,
	fields?:ValueTypes["_Field"],
	unique?:ValueTypes["_UniqueConstraint"],
		__typename?: true
}>;
	["_UniqueConstraint"]: AliasType<{
	fields?:true,
		__typename?: true
}>;
	["_Field"]:AliasType<{
		name?:true,
	type?:true,
	nullable?:true,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"];
		['...on _Column']?: Omit<ValueTypes["_Column"],keyof ValueTypes["_Field"]>;
		['...on _Relation']?: Omit<ValueTypes["_Relation"],keyof ValueTypes["_Field"]>;
		__typename?: true
}>;
	["_Column"]: AliasType<{
	name?:true,
	type?:true,
	enumName?:true,
	defaultValue?:true,
	nullable?:true,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: true
}>;
	["_OnDeleteBehaviour"]:_OnDeleteBehaviour;
	["_RelationSide"]:_RelationSide;
	["_OrderByDirection"]:_OrderByDirection;
	["_OrderBy"]: AliasType<{
	path?:true,
	direction?:true,
		__typename?: true
}>;
	["_Relation"]: AliasType<{
	name?:true,
	type?:true,
	side?:true,
	targetEntity?:true,
	ownedBy?:true,
	inversedBy?:true,
	nullable?:true,
	onDelete?:true,
	orphanRemoval?:true,
	orderBy?:ValueTypes["_OrderBy"],
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: true
}>;
	["_Rule"]: AliasType<{
	message?:ValueTypes["_RuleMessage"],
	validator?:true,
		__typename?: true
}>;
	["_Validator"]: AliasType<{
	operation?:true,
	arguments?:ValueTypes["_Argument"],
		__typename?: true
}>;
	["_Argument"]: AliasType<{		["...on _ValidatorArgument"] : ValueTypes["_ValidatorArgument"],
		["...on _PathArgument"] : ValueTypes["_PathArgument"],
		["...on _LiteralArgument"] : ValueTypes["_LiteralArgument"]
		__typename?: true
}>;
	["_ValidatorArgument"]: AliasType<{
	validator?:true,
		__typename?: true
}>;
	["_PathArgument"]: AliasType<{
	path?:true,
		__typename?: true
}>;
	["_LiteralArgument"]: AliasType<{
	value?:true,
		__typename?: true
}>;
	["_RuleMessage"]: AliasType<{
	text?:true,
		__typename?: true
}>;
	["_Enum"]: AliasType<{
	name?:true,
	values?:true,
		__typename?: true
}>;
	["S3SignedUpload"]: AliasType<{
	url?:true,
	headers?:ValueTypes["S3Header"],
	method?:true,
	/** Allowed patterns:
** */
	objectKey?:true,
	bucket?:true,
	publicUrl?:true,
		__typename?: true
}>;
	["S3Header"]: AliasType<{
	key?:true,
	value?:true,
		__typename?: true
}>;
	["S3SignedRead"]: AliasType<{
	url?:true,
	headers?:ValueTypes["S3Header"],
	method?:true,
	/** Allowed patterns:
** */
	objectKey?:true,
	bucket?:true,
		__typename?: true
}>
  }

export type ModelTypes = {
    ["Query"]: {
		getContentBlock?:ModelTypes["ContentBlock"],
	listContentBlock:ModelTypes["ContentBlock"][],
	paginateContentBlock:ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentBlock:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getHomePage?:ModelTypes["HomePage"],
	listHomePage:ModelTypes["HomePage"][],
	paginateHomePage:ModelTypes["HomePageConnection"],
	validateCreateHomePage:ModelTypes["_ValidationResult"],
	validateUpdateHomePage:ModelTypes["_ValidationResult"],
	getLinkable?:ModelTypes["Linkable"],
	listLinkable:ModelTypes["Linkable"][],
	paginateLinkable:ModelTypes["LinkableConnection"],
	validateCreateLinkable:ModelTypes["_ValidationResult"],
	validateUpdateLinkable:ModelTypes["_ValidationResult"],
	getMediumGallery?:ModelTypes["MediumGallery"],
	listMediumGallery:ModelTypes["MediumGallery"][],
	paginateMediumGallery:ModelTypes["MediumGalleryConnection"],
	validateCreateMediumGallery:ModelTypes["_ValidationResult"],
	validateUpdateMediumGallery:ModelTypes["_ValidationResult"],
	getMediumGalleryItem?:ModelTypes["MediumGalleryItem"],
	listMediumGalleryItem:ModelTypes["MediumGalleryItem"][],
	paginateMediumGalleryItem:ModelTypes["MediumGalleryItemConnection"],
	validateCreateMediumGalleryItem:ModelTypes["_ValidationResult"],
	validateUpdateMediumGalleryItem:ModelTypes["_ValidationResult"],
	getMember?:ModelTypes["Member"],
	listMember:ModelTypes["Member"][],
	paginateMember:ModelTypes["MemberConnection"],
	validateCreateMember:ModelTypes["_ValidationResult"],
	validateUpdateMember:ModelTypes["_ValidationResult"],
	getMemberItem?:ModelTypes["MemberItem"],
	listMemberItem:ModelTypes["MemberItem"][],
	paginateMemberItem:ModelTypes["MemberItemConnection"],
	validateCreateMemberItem:ModelTypes["_ValidationResult"],
	validateUpdateMemberItem:ModelTypes["_ValidationResult"],
	getMemberList?:ModelTypes["MemberList"],
	listMemberList:ModelTypes["MemberList"][],
	paginateMemberList:ModelTypes["MemberListConnection"],
	validateCreateMemberList:ModelTypes["_ValidationResult"],
	validateUpdateMemberList:ModelTypes["_ValidationResult"],
	getShow?:ModelTypes["Show"],
	listShow:ModelTypes["Show"][],
	paginateShow:ModelTypes["ShowConnection"],
	validateCreateShow:ModelTypes["_ValidationResult"],
	validateUpdateShow:ModelTypes["_ValidationResult"],
	getShowList?:ModelTypes["ShowList"],
	listShowList:ModelTypes["ShowList"][],
	paginateShowList:ModelTypes["ShowListConnection"],
	validateCreateShowList:ModelTypes["_ValidationResult"],
	validateUpdateShowList:ModelTypes["_ValidationResult"],
	getShowYear?:ModelTypes["ShowYear"],
	listShowYear:ModelTypes["ShowYear"][],
	paginateShowYear:ModelTypes["ShowYearConnection"],
	validateCreateShowYear:ModelTypes["_ValidationResult"],
	validateUpdateShowYear:ModelTypes["_ValidationResult"],
	getShowYearItem?:ModelTypes["ShowYearItem"],
	listShowYearItem:ModelTypes["ShowYearItem"][],
	paginateShowYearItem:ModelTypes["ShowYearItemConnection"],
	validateCreateShowYearItem:ModelTypes["_ValidationResult"],
	validateUpdateShowYearItem:ModelTypes["_ValidationResult"],
	getShowYearList?:ModelTypes["ShowYearList"],
	listShowYearList:ModelTypes["ShowYearList"][],
	paginateShowYearList:ModelTypes["ShowYearListConnection"],
	validateCreateShowYearList:ModelTypes["_ValidationResult"],
	validateUpdateShowYearList:ModelTypes["_ValidationResult"],
	getSocialLink?:ModelTypes["SocialLink"],
	listSocialLink:ModelTypes["SocialLink"][],
	paginateSocialLink:ModelTypes["SocialLinkConnection"],
	validateCreateSocialLink:ModelTypes["_ValidationResult"],
	validateUpdateSocialLink:ModelTypes["_ValidationResult"],
	getSocialLinkItem?:ModelTypes["SocialLinkItem"],
	listSocialLinkItem:ModelTypes["SocialLinkItem"][],
	paginateSocialLinkItem:ModelTypes["SocialLinkItemConnection"],
	validateCreateSocialLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateSocialLinkItem:ModelTypes["_ValidationResult"],
	getSocialLinkList?:ModelTypes["SocialLinkList"],
	listSocialLinkList:ModelTypes["SocialLinkList"][],
	paginateSocialLinkList:ModelTypes["SocialLinkListConnection"],
	validateCreateSocialLinkList:ModelTypes["_ValidationResult"],
	validateUpdateSocialLinkList:ModelTypes["_ValidationResult"],
	getVideo?:ModelTypes["Video"],
	listVideo:ModelTypes["Video"][],
	paginateVideo:ModelTypes["VideoConnection"],
	validateCreateVideo:ModelTypes["_ValidationResult"],
	validateUpdateVideo:ModelTypes["_ValidationResult"],
	getYoutubeVideo?:ModelTypes["YoutubeVideo"],
	listYoutubeVideo:ModelTypes["YoutubeVideo"][],
	paginateYoutubeVideo:ModelTypes["YoutubeVideoConnection"],
	validateCreateYoutubeVideo:ModelTypes["_ValidationResult"],
	validateUpdateYoutubeVideo:ModelTypes["_ValidationResult"],
	getHeader?:ModelTypes["Header"],
	listHeader:ModelTypes["Header"][],
	paginateHeader:ModelTypes["HeaderConnection"],
	validateCreateHeader:ModelTypes["_ValidationResult"],
	validateUpdateHeader:ModelTypes["_ValidationResult"],
	getFooter?:ModelTypes["Footer"],
	listFooter:ModelTypes["Footer"][],
	paginateFooter:ModelTypes["FooterConnection"],
	validateCreateFooter:ModelTypes["_ValidationResult"],
	validateUpdateFooter:ModelTypes["_ValidationResult"],
	getFooterAddress?:ModelTypes["FooterAddress"],
	listFooterAddress:ModelTypes["FooterAddress"][],
	paginateFooterAddress:ModelTypes["FooterAddressConnection"],
	validateCreateFooterAddress:ModelTypes["_ValidationResult"],
	validateUpdateFooterAddress:ModelTypes["_ValidationResult"],
	getPortfolioPage?:ModelTypes["PortfolioPage"],
	listPortfolioPage:ModelTypes["PortfolioPage"][],
	paginatePortfolioPage:ModelTypes["PortfolioPageConnection"],
	validateCreatePortfolioPage:ModelTypes["_ValidationResult"],
	validateUpdatePortfolioPage:ModelTypes["_ValidationResult"],
	getShowItem?:ModelTypes["ShowItem"],
	listShowItem:ModelTypes["ShowItem"][],
	paginateShowItem:ModelTypes["ShowItemConnection"],
	validateCreateShowItem:ModelTypes["_ValidationResult"],
	validateUpdateShowItem:ModelTypes["_ValidationResult"],
	getSettings?:ModelTypes["Settings"],
	listSettings:ModelTypes["Settings"][],
	paginateSettings:ModelTypes["SettingsConnection"],
	validateCreateSettings:ModelTypes["_ValidationResult"],
	validateUpdateSettings:ModelTypes["_ValidationResult"],
	getFooterGeneralContact?:ModelTypes["FooterGeneralContact"],
	listFooterGeneralContact:ModelTypes["FooterGeneralContact"][],
	paginateFooterGeneralContact:ModelTypes["FooterGeneralContactConnection"],
	validateCreateFooterGeneralContact:ModelTypes["_ValidationResult"],
	validateUpdateFooterGeneralContact:ModelTypes["_ValidationResult"],
	getRedirect?:ModelTypes["Redirect"],
	listRedirect:ModelTypes["Redirect"][],
	paginateRedirect:ModelTypes["RedirectConnection"],
	validateCreateRedirect:ModelTypes["_ValidationResult"],
	validateUpdateRedirect:ModelTypes["_ValidationResult"],
	transaction?:ModelTypes["QueryTransaction"],
	_info?:ModelTypes["Info"],
	schema?:ModelTypes["_Schema"],
	s3DummyQuery?:string
};
	["ContentBlock"]: {
		_meta?:ModelTypes["ContentBlockMeta"],
	id:ModelTypes["UUID"],
	order:number,
	type:ModelTypes["ContentBlockType"],
	primaryText?:string,
	secondaryText?:string,
	homePage?:ModelTypes["HomePage"],
	gallery?:ModelTypes["MediumGallery"],
	video?:ModelTypes["Video"],
	link?:ModelTypes["Link"],
	members?:ModelTypes["MemberList"],
	portfolio?:ModelTypes["ShowYearList"]
};
	["ContentBlockMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	primaryText?:ModelTypes["FieldMeta"],
	secondaryText?:ModelTypes["FieldMeta"],
	homePage?:ModelTypes["FieldMeta"],
	gallery?:ModelTypes["FieldMeta"],
	video?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	members?:ModelTypes["FieldMeta"],
	portfolio?:ModelTypes["FieldMeta"]
};
	["FieldMeta"]: {
		readable?:boolean,
	updatable?:boolean
};
	["UUID"]:string;
	["ContentBlockType"]: GraphQLTypes["ContentBlockType"];
	["HomePage"]: {
		_meta?:ModelTypes["HomePageMeta"],
	id:ModelTypes["UUID"],
	name:string,
	link?:ModelTypes["Linkable"],
	seo?:ModelTypes["Seo"],
	unique:ModelTypes["One"],
	blocks:ModelTypes["ContentBlock"][],
	blocksByGallery?:ModelTypes["ContentBlock"],
	blocksByLink?:ModelTypes["ContentBlock"],
	blocksByMembers?:ModelTypes["ContentBlock"],
	paginateBlocks:ModelTypes["ContentBlockConnection"]
};
	["HomePageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	blocks?:ModelTypes["FieldMeta"]
};
	["Linkable"]: {
		_meta?:ModelTypes["LinkableMeta"],
	id:ModelTypes["UUID"],
	url:string,
	homePage?:ModelTypes["HomePage"],
	portfolioPage?:ModelTypes["PortfolioPage"],
	showPage?:ModelTypes["Show"],
	redirect?:ModelTypes["Redirect"]
};
	["LinkableMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	homePage?:ModelTypes["FieldMeta"],
	portfolioPage?:ModelTypes["FieldMeta"],
	showPage?:ModelTypes["FieldMeta"],
	redirect?:ModelTypes["FieldMeta"]
};
	["HomePageWhere"]: GraphQLTypes["HomePageWhere"];
	["UUIDCondition"]: GraphQLTypes["UUIDCondition"];
	["StringCondition"]: GraphQLTypes["StringCondition"];
	["LinkableWhere"]: GraphQLTypes["LinkableWhere"];
	["PortfolioPageWhere"]: GraphQLTypes["PortfolioPageWhere"];
	["SeoWhere"]: GraphQLTypes["SeoWhere"];
	["ImageWhere"]: GraphQLTypes["ImageWhere"];
	["IntCondition"]: GraphQLTypes["IntCondition"];
	["BooleanCondition"]: GraphQLTypes["BooleanCondition"];
	["OneCondition"]: GraphQLTypes["OneCondition"];
	["One"]: GraphQLTypes["One"];
	["ShowWhere"]: GraphQLTypes["ShowWhere"];
	["ShowPosterTypeCondition"]: GraphQLTypes["ShowPosterTypeCondition"];
	["ShowPosterType"]: GraphQLTypes["ShowPosterType"];
	["ShowItemWhere"]: GraphQLTypes["ShowItemWhere"];
	["ShowListWhere"]: GraphQLTypes["ShowListWhere"];
	["ShowPosterSizeTypeCondition"]: GraphQLTypes["ShowPosterSizeTypeCondition"];
	["ShowPosterSizeType"]: GraphQLTypes["ShowPosterSizeType"];
	["ShowYearWhere"]: GraphQLTypes["ShowYearWhere"];
	["MediumGalleryWhere"]: GraphQLTypes["MediumGalleryWhere"];
	["MediumGalleryItemWhere"]: GraphQLTypes["MediumGalleryItemWhere"];
	["MediumTypeCondition"]: GraphQLTypes["MediumTypeCondition"];
	["MediumType"]: GraphQLTypes["MediumType"];
	["VideoWhere"]: GraphQLTypes["VideoWhere"];
	["FloatCondition"]: GraphQLTypes["FloatCondition"];
	["RedirectWhere"]: GraphQLTypes["RedirectWhere"];
	["ContentBlockWhere"]: GraphQLTypes["ContentBlockWhere"];
	["ContentBlockTypeCondition"]: GraphQLTypes["ContentBlockTypeCondition"];
	["LinkWhere"]: GraphQLTypes["LinkWhere"];
	["LinkTypeCondition"]: GraphQLTypes["LinkTypeCondition"];
	["LinkType"]: GraphQLTypes["LinkType"];
	["MemberListWhere"]: GraphQLTypes["MemberListWhere"];
	["MemberItemWhere"]: GraphQLTypes["MemberItemWhere"];
	["MemberWhere"]: GraphQLTypes["MemberWhere"];
	["ShowYearListWhere"]: GraphQLTypes["ShowYearListWhere"];
	["ShowYearItemWhere"]: GraphQLTypes["ShowYearItemWhere"];
	["PortfolioPage"]: {
		_meta?:ModelTypes["PortfolioPageMeta"],
	id:ModelTypes["UUID"],
	name:string,
	link?:ModelTypes["Linkable"],
	seo?:ModelTypes["Seo"],
	unique:ModelTypes["One"],
	title?:string,
	text?:string
};
	["PortfolioPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"]
};
	["Seo"]: {
		_meta?:ModelTypes["SeoMeta"],
	id:ModelTypes["UUID"],
	description?:string,
	ogTitle?:string,
	ogDescription?:string,
	title?:string,
	ogImage?:ModelTypes["Image"],
	noIndex?:boolean,
	noFollow?:boolean
};
	["SeoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	description?:ModelTypes["FieldMeta"],
	ogTitle?:ModelTypes["FieldMeta"],
	ogDescription?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	ogImage?:ModelTypes["FieldMeta"],
	noIndex?:ModelTypes["FieldMeta"],
	noFollow?:ModelTypes["FieldMeta"]
};
	["Image"]: {
		_meta?:ModelTypes["ImageMeta"],
	id:ModelTypes["UUID"],
	url:string,
	width?:number,
	height?:number,
	size?:number,
	type?:string,
	alt?:string
};
	["ImageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	width?:ModelTypes["FieldMeta"],
	height?:ModelTypes["FieldMeta"],
	size?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	alt?:ModelTypes["FieldMeta"]
};
	["Show"]: {
		_meta?:ModelTypes["ShowMeta"],
	id:ModelTypes["UUID"],
	title:string,
	description?:string,
	posterType:ModelTypes["ShowPosterType"],
	poster?:ModelTypes["Image"],
	showItem:ModelTypes["ShowItem"][],
	posterSizeType:ModelTypes["ShowPosterSizeType"],
	categoryYear?:ModelTypes["ShowYear"],
	production?:string,
	directors?:string,
	starrings?:string,
	gallery?:ModelTypes["MediumGallery"],
	seo?:ModelTypes["Seo"],
	link?:ModelTypes["Linkable"],
	synopsis?:string,
	paginateShowItem:ModelTypes["ShowItemConnection"]
};
	["ShowMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	description?:ModelTypes["FieldMeta"],
	posterType?:ModelTypes["FieldMeta"],
	poster?:ModelTypes["FieldMeta"],
	showItem?:ModelTypes["FieldMeta"],
	posterSizeType?:ModelTypes["FieldMeta"],
	categoryYear?:ModelTypes["FieldMeta"],
	production?:ModelTypes["FieldMeta"],
	directors?:ModelTypes["FieldMeta"],
	starrings?:ModelTypes["FieldMeta"],
	gallery?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	synopsis?:ModelTypes["FieldMeta"]
};
	["ShowItem"]: {
		_meta?:ModelTypes["ShowItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["ShowList"],
	show?:ModelTypes["Show"]
};
	["ShowItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	show?:ModelTypes["FieldMeta"]
};
	["ShowList"]: {
		_meta?:ModelTypes["ShowListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["ShowItem"][],
	paginateItems:ModelTypes["ShowItemConnection"]
};
	["ShowListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["ShowItemOrderBy"]: GraphQLTypes["ShowItemOrderBy"];
	["OrderDirection"]: GraphQLTypes["OrderDirection"];
	["ShowListOrderBy"]: GraphQLTypes["ShowListOrderBy"];
	["ShowOrderBy"]: GraphQLTypes["ShowOrderBy"];
	["ImageOrderBy"]: GraphQLTypes["ImageOrderBy"];
	["ShowYearOrderBy"]: GraphQLTypes["ShowYearOrderBy"];
	["MediumGalleryOrderBy"]: GraphQLTypes["MediumGalleryOrderBy"];
	["SeoOrderBy"]: GraphQLTypes["SeoOrderBy"];
	["LinkableOrderBy"]: GraphQLTypes["LinkableOrderBy"];
	["HomePageOrderBy"]: GraphQLTypes["HomePageOrderBy"];
	["PortfolioPageOrderBy"]: GraphQLTypes["PortfolioPageOrderBy"];
	["RedirectOrderBy"]: GraphQLTypes["RedirectOrderBy"];
	["ShowItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ShowItemEdge"][]
};
	["PageInfo"]: {
		totalCount:number
};
	["ShowItemEdge"]: {
		node:ModelTypes["ShowItem"]
};
	["ShowYear"]: {
		_meta?:ModelTypes["ShowYearMeta"],
	id:ModelTypes["UUID"],
	order:number,
	name:string,
	showList:ModelTypes["Show"][],
	showListByShowItem?:ModelTypes["Show"],
	showListByGallery?:ModelTypes["Show"],
	showListBySeo?:ModelTypes["Show"],
	showListByLink?:ModelTypes["Show"],
	paginateShowList:ModelTypes["ShowConnection"]
};
	["ShowYearMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	showList?:ModelTypes["FieldMeta"]
};
	["ShowYearShowListByShowItemUniqueWhere"]: GraphQLTypes["ShowYearShowListByShowItemUniqueWhere"];
	["ShowItemUniqueWhere"]: GraphQLTypes["ShowItemUniqueWhere"];
	["ShowYearShowListByGalleryUniqueWhere"]: GraphQLTypes["ShowYearShowListByGalleryUniqueWhere"];
	["MediumGalleryUniqueWhere"]: GraphQLTypes["MediumGalleryUniqueWhere"];
	["MediumGalleryItemUniqueWhere"]: GraphQLTypes["MediumGalleryItemUniqueWhere"];
	["ShowYearShowListBySeoUniqueWhere"]: GraphQLTypes["ShowYearShowListBySeoUniqueWhere"];
	["SeoUniqueWhere"]: GraphQLTypes["SeoUniqueWhere"];
	["ImageUniqueWhere"]: GraphQLTypes["ImageUniqueWhere"];
	["ShowYearShowListByLinkUniqueWhere"]: GraphQLTypes["ShowYearShowListByLinkUniqueWhere"];
	["LinkableUniqueWhere"]: GraphQLTypes["LinkableUniqueWhere"];
	["HomePageUniqueWhere"]: GraphQLTypes["HomePageUniqueWhere"];
	["ContentBlockUniqueWhere"]: GraphQLTypes["ContentBlockUniqueWhere"];
	["LinkUniqueWhere"]: GraphQLTypes["LinkUniqueWhere"];
	["MemberListUniqueWhere"]: GraphQLTypes["MemberListUniqueWhere"];
	["MemberItemUniqueWhere"]: GraphQLTypes["MemberItemUniqueWhere"];
	["PortfolioPageUniqueWhere"]: GraphQLTypes["PortfolioPageUniqueWhere"];
	["ShowUniqueWhere"]: GraphQLTypes["ShowUniqueWhere"];
	["RedirectUniqueWhere"]: GraphQLTypes["RedirectUniqueWhere"];
	["ShowConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ShowEdge"][]
};
	["ShowEdge"]: {
		node:ModelTypes["Show"]
};
	["MediumGallery"]: {
		_meta?:ModelTypes["MediumGalleryMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["MediumGalleryItem"][],
	paginateItems:ModelTypes["MediumGalleryItemConnection"]
};
	["MediumGalleryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["MediumGalleryItem"]: {
		_meta?:ModelTypes["MediumGalleryItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	type?:ModelTypes["MediumType"],
	gallery?:ModelTypes["MediumGallery"],
	image?:ModelTypes["Image"],
	video?:ModelTypes["Video"]
};
	["MediumGalleryItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	gallery?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	video?:ModelTypes["FieldMeta"]
};
	["Video"]: {
		_meta?:ModelTypes["VideoMeta"],
	id:ModelTypes["UUID"],
	src?:string,
	width?:number,
	height?:number,
	size?:number,
	type?:string,
	duration?:number,
	poster?:ModelTypes["Image"]
};
	["VideoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	src?:ModelTypes["FieldMeta"],
	width?:ModelTypes["FieldMeta"],
	height?:ModelTypes["FieldMeta"],
	size?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	duration?:ModelTypes["FieldMeta"],
	poster?:ModelTypes["FieldMeta"]
};
	["MediumGalleryItemOrderBy"]: GraphQLTypes["MediumGalleryItemOrderBy"];
	["VideoOrderBy"]: GraphQLTypes["VideoOrderBy"];
	["MediumGalleryItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["MediumGalleryItemEdge"][]
};
	["MediumGalleryItemEdge"]: {
		node:ModelTypes["MediumGalleryItem"]
};
	["Redirect"]: {
		_meta?:ModelTypes["RedirectMeta"],
	id:ModelTypes["UUID"],
	link?:ModelTypes["Linkable"],
	target?:ModelTypes["Linkable"]
};
	["RedirectMeta"]: {
		id?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	target?:ModelTypes["FieldMeta"]
};
	["ContentBlockOrderBy"]: GraphQLTypes["ContentBlockOrderBy"];
	["LinkOrderBy"]: GraphQLTypes["LinkOrderBy"];
	["MemberListOrderBy"]: GraphQLTypes["MemberListOrderBy"];
	["ShowYearListOrderBy"]: GraphQLTypes["ShowYearListOrderBy"];
	["HomePageBlocksByGalleryUniqueWhere"]: GraphQLTypes["HomePageBlocksByGalleryUniqueWhere"];
	["HomePageBlocksByLinkUniqueWhere"]: GraphQLTypes["HomePageBlocksByLinkUniqueWhere"];
	["HomePageBlocksByMembersUniqueWhere"]: GraphQLTypes["HomePageBlocksByMembersUniqueWhere"];
	["ContentBlockConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentBlockEdge"][]
};
	["ContentBlockEdge"]: {
		node:ModelTypes["ContentBlock"]
};
	["Link"]: {
		_meta?:ModelTypes["LinkMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["LinkType"],
	title?:string,
	externalLink?:string,
	internalLink?:ModelTypes["Linkable"]
};
	["LinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	externalLink?:ModelTypes["FieldMeta"],
	internalLink?:ModelTypes["FieldMeta"]
};
	["MemberList"]: {
		_meta?:ModelTypes["MemberListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["MemberItem"][],
	paginateItems:ModelTypes["MemberItemConnection"]
};
	["MemberListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["MemberItem"]: {
		_meta?:ModelTypes["MemberItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["MemberList"],
	member?:ModelTypes["Member"]
};
	["MemberItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	member?:ModelTypes["FieldMeta"]
};
	["Member"]: {
		_meta?:ModelTypes["MemberMeta"],
	id:ModelTypes["UUID"],
	firstName?:string,
	lastName:string,
	position?:string,
	email?:string,
	telephone?:string,
	image?:ModelTypes["Image"]
};
	["MemberMeta"]: {
		id?:ModelTypes["FieldMeta"],
	firstName?:ModelTypes["FieldMeta"],
	lastName?:ModelTypes["FieldMeta"],
	position?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	telephone?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"]
};
	["MemberItemOrderBy"]: GraphQLTypes["MemberItemOrderBy"];
	["MemberOrderBy"]: GraphQLTypes["MemberOrderBy"];
	["MemberItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["MemberItemEdge"][]
};
	["MemberItemEdge"]: {
		node:ModelTypes["MemberItem"]
};
	["ShowYearList"]: {
		_meta?:ModelTypes["ShowYearListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["ShowYearItem"][],
	paginateItems:ModelTypes["ShowYearItemConnection"]
};
	["ShowYearListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["ShowYearItem"]: {
		_meta?:ModelTypes["ShowYearItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["ShowYearList"],
	showYear?:ModelTypes["ShowYear"]
};
	["ShowYearItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	showYear?:ModelTypes["FieldMeta"]
};
	["ShowYearItemOrderBy"]: GraphQLTypes["ShowYearItemOrderBy"];
	["ShowYearItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ShowYearItemEdge"][]
};
	["ShowYearItemEdge"]: {
		node:ModelTypes["ShowYearItem"]
};
	["_ValidationResult"]: {
		valid:boolean,
	errors:ModelTypes["_ValidationError"][]
};
	["_ValidationError"]: {
		path:ModelTypes["_PathFragment"][],
	message:ModelTypes["_ValidationMessage"]
};
	["_PathFragment"]:ModelTypes["_FieldPathFragment"] | ModelTypes["_IndexPathFragment"];
	["_FieldPathFragment"]: {
		field:string
};
	["_IndexPathFragment"]: {
		index:number,
	alias?:string
};
	["_ValidationMessage"]: {
		text:string
};
	["ContentBlockCreateInput"]: GraphQLTypes["ContentBlockCreateInput"];
	["ContentBlockCreateHomePageEntityRelationInput"]: GraphQLTypes["ContentBlockCreateHomePageEntityRelationInput"];
	["HomePageWithoutBlocksCreateInput"]: GraphQLTypes["HomePageWithoutBlocksCreateInput"];
	["HomePageCreateLinkEntityRelationInput"]: GraphQLTypes["HomePageCreateLinkEntityRelationInput"];
	["LinkableWithoutHomePageCreateInput"]: GraphQLTypes["LinkableWithoutHomePageCreateInput"];
	["LinkableCreatePortfolioPageEntityRelationInput"]: GraphQLTypes["LinkableCreatePortfolioPageEntityRelationInput"];
	["PortfolioPageWithoutLinkCreateInput"]: GraphQLTypes["PortfolioPageWithoutLinkCreateInput"];
	["PortfolioPageCreateSeoEntityRelationInput"]: GraphQLTypes["PortfolioPageCreateSeoEntityRelationInput"];
	["SeoCreateInput"]: GraphQLTypes["SeoCreateInput"];
	["SeoCreateOgImageEntityRelationInput"]: GraphQLTypes["SeoCreateOgImageEntityRelationInput"];
	["ImageCreateInput"]: GraphQLTypes["ImageCreateInput"];
	["LinkableCreateShowPageEntityRelationInput"]: GraphQLTypes["LinkableCreateShowPageEntityRelationInput"];
	["ShowWithoutLinkCreateInput"]: GraphQLTypes["ShowWithoutLinkCreateInput"];
	["ShowCreatePosterEntityRelationInput"]: GraphQLTypes["ShowCreatePosterEntityRelationInput"];
	["ShowCreateShowItemEntityRelationInput"]: GraphQLTypes["ShowCreateShowItemEntityRelationInput"];
	["ShowItemWithoutShowCreateInput"]: GraphQLTypes["ShowItemWithoutShowCreateInput"];
	["ShowItemCreateListEntityRelationInput"]: GraphQLTypes["ShowItemCreateListEntityRelationInput"];
	["ShowListUniqueWhere"]: GraphQLTypes["ShowListUniqueWhere"];
	["ShowListWithoutItemsCreateInput"]: GraphQLTypes["ShowListWithoutItemsCreateInput"];
	["ShowCreateCategoryYearEntityRelationInput"]: GraphQLTypes["ShowCreateCategoryYearEntityRelationInput"];
	["ShowYearUniqueWhere"]: GraphQLTypes["ShowYearUniqueWhere"];
	["ShowYearWithoutShowListCreateInput"]: GraphQLTypes["ShowYearWithoutShowListCreateInput"];
	["ShowCreateGalleryEntityRelationInput"]: GraphQLTypes["ShowCreateGalleryEntityRelationInput"];
	["MediumGalleryCreateInput"]: GraphQLTypes["MediumGalleryCreateInput"];
	["MediumGalleryCreateItemsEntityRelationInput"]: GraphQLTypes["MediumGalleryCreateItemsEntityRelationInput"];
	["MediumGalleryItemWithoutGalleryCreateInput"]: GraphQLTypes["MediumGalleryItemWithoutGalleryCreateInput"];
	["MediumGalleryItemCreateImageEntityRelationInput"]: GraphQLTypes["MediumGalleryItemCreateImageEntityRelationInput"];
	["MediumGalleryItemCreateVideoEntityRelationInput"]: GraphQLTypes["MediumGalleryItemCreateVideoEntityRelationInput"];
	["VideoUniqueWhere"]: GraphQLTypes["VideoUniqueWhere"];
	["VideoCreateInput"]: GraphQLTypes["VideoCreateInput"];
	["VideoCreatePosterEntityRelationInput"]: GraphQLTypes["VideoCreatePosterEntityRelationInput"];
	["ShowCreateSeoEntityRelationInput"]: GraphQLTypes["ShowCreateSeoEntityRelationInput"];
	["LinkableCreateRedirectEntityRelationInput"]: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"];
	["RedirectWithoutLinkCreateInput"]: GraphQLTypes["RedirectWithoutLinkCreateInput"];
	["RedirectCreateTargetEntityRelationInput"]: GraphQLTypes["RedirectCreateTargetEntityRelationInput"];
	["LinkableCreateInput"]: GraphQLTypes["LinkableCreateInput"];
	["LinkableCreateHomePageEntityRelationInput"]: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"];
	["HomePageWithoutLinkCreateInput"]: GraphQLTypes["HomePageWithoutLinkCreateInput"];
	["HomePageCreateSeoEntityRelationInput"]: GraphQLTypes["HomePageCreateSeoEntityRelationInput"];
	["HomePageCreateBlocksEntityRelationInput"]: GraphQLTypes["HomePageCreateBlocksEntityRelationInput"];
	["ContentBlockWithoutHomePageCreateInput"]: GraphQLTypes["ContentBlockWithoutHomePageCreateInput"];
	["ContentBlockCreateGalleryEntityRelationInput"]: GraphQLTypes["ContentBlockCreateGalleryEntityRelationInput"];
	["ContentBlockCreateVideoEntityRelationInput"]: GraphQLTypes["ContentBlockCreateVideoEntityRelationInput"];
	["ContentBlockCreateLinkEntityRelationInput"]: GraphQLTypes["ContentBlockCreateLinkEntityRelationInput"];
	["LinkCreateInput"]: GraphQLTypes["LinkCreateInput"];
	["LinkCreateInternalLinkEntityRelationInput"]: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"];
	["ContentBlockCreateMembersEntityRelationInput"]: GraphQLTypes["ContentBlockCreateMembersEntityRelationInput"];
	["MemberListCreateInput"]: GraphQLTypes["MemberListCreateInput"];
	["MemberListCreateItemsEntityRelationInput"]: GraphQLTypes["MemberListCreateItemsEntityRelationInput"];
	["MemberItemWithoutListCreateInput"]: GraphQLTypes["MemberItemWithoutListCreateInput"];
	["MemberItemCreateMemberEntityRelationInput"]: GraphQLTypes["MemberItemCreateMemberEntityRelationInput"];
	["MemberUniqueWhere"]: GraphQLTypes["MemberUniqueWhere"];
	["MemberCreateInput"]: GraphQLTypes["MemberCreateInput"];
	["MemberCreateImageEntityRelationInput"]: GraphQLTypes["MemberCreateImageEntityRelationInput"];
	["ContentBlockCreatePortfolioEntityRelationInput"]: GraphQLTypes["ContentBlockCreatePortfolioEntityRelationInput"];
	["ShowYearListUniqueWhere"]: GraphQLTypes["ShowYearListUniqueWhere"];
	["ShowYearItemUniqueWhere"]: GraphQLTypes["ShowYearItemUniqueWhere"];
	["ShowYearListCreateInput"]: GraphQLTypes["ShowYearListCreateInput"];
	["ShowYearListCreateItemsEntityRelationInput"]: GraphQLTypes["ShowYearListCreateItemsEntityRelationInput"];
	["ShowYearItemWithoutListCreateInput"]: GraphQLTypes["ShowYearItemWithoutListCreateInput"];
	["ShowYearItemCreateShowYearEntityRelationInput"]: GraphQLTypes["ShowYearItemCreateShowYearEntityRelationInput"];
	["ShowYearCreateInput"]: GraphQLTypes["ShowYearCreateInput"];
	["ShowYearCreateShowListEntityRelationInput"]: GraphQLTypes["ShowYearCreateShowListEntityRelationInput"];
	["ShowWithoutCategoryYearCreateInput"]: GraphQLTypes["ShowWithoutCategoryYearCreateInput"];
	["ShowCreateLinkEntityRelationInput"]: GraphQLTypes["ShowCreateLinkEntityRelationInput"];
	["LinkableWithoutShowPageCreateInput"]: GraphQLTypes["LinkableWithoutShowPageCreateInput"];
	["ContentBlockUpdateInput"]: GraphQLTypes["ContentBlockUpdateInput"];
	["ContentBlockUpdateHomePageEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateHomePageEntityRelationInput"];
	["HomePageWithoutBlocksUpdateInput"]: GraphQLTypes["HomePageWithoutBlocksUpdateInput"];
	["HomePageUpdateLinkEntityRelationInput"]: GraphQLTypes["HomePageUpdateLinkEntityRelationInput"];
	["LinkableWithoutHomePageUpdateInput"]: GraphQLTypes["LinkableWithoutHomePageUpdateInput"];
	["LinkableUpdatePortfolioPageEntityRelationInput"]: GraphQLTypes["LinkableUpdatePortfolioPageEntityRelationInput"];
	["PortfolioPageWithoutLinkUpdateInput"]: GraphQLTypes["PortfolioPageWithoutLinkUpdateInput"];
	["PortfolioPageUpdateSeoEntityRelationInput"]: GraphQLTypes["PortfolioPageUpdateSeoEntityRelationInput"];
	["SeoUpdateInput"]: GraphQLTypes["SeoUpdateInput"];
	["SeoUpdateOgImageEntityRelationInput"]: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"];
	["ImageUpdateInput"]: GraphQLTypes["ImageUpdateInput"];
	["SeoUpsertOgImageRelationInput"]: GraphQLTypes["SeoUpsertOgImageRelationInput"];
	["PortfolioPageUpsertSeoRelationInput"]: GraphQLTypes["PortfolioPageUpsertSeoRelationInput"];
	["LinkableUpsertPortfolioPageRelationInput"]: GraphQLTypes["LinkableUpsertPortfolioPageRelationInput"];
	["LinkableUpdateShowPageEntityRelationInput"]: GraphQLTypes["LinkableUpdateShowPageEntityRelationInput"];
	["ShowWithoutLinkUpdateInput"]: GraphQLTypes["ShowWithoutLinkUpdateInput"];
	["ShowUpdatePosterEntityRelationInput"]: GraphQLTypes["ShowUpdatePosterEntityRelationInput"];
	["ShowUpsertPosterRelationInput"]: GraphQLTypes["ShowUpsertPosterRelationInput"];
	["ShowUpdateShowItemEntityRelationInput"]: GraphQLTypes["ShowUpdateShowItemEntityRelationInput"];
	["ShowUpdateShowItemRelationInput"]: GraphQLTypes["ShowUpdateShowItemRelationInput"];
	["ShowItemWithoutShowUpdateInput"]: GraphQLTypes["ShowItemWithoutShowUpdateInput"];
	["ShowItemUpdateListEntityRelationInput"]: GraphQLTypes["ShowItemUpdateListEntityRelationInput"];
	["ShowListWithoutItemsUpdateInput"]: GraphQLTypes["ShowListWithoutItemsUpdateInput"];
	["ShowItemUpsertListRelationInput"]: GraphQLTypes["ShowItemUpsertListRelationInput"];
	["ShowUpsertShowItemRelationInput"]: GraphQLTypes["ShowUpsertShowItemRelationInput"];
	["ShowUpdateCategoryYearEntityRelationInput"]: GraphQLTypes["ShowUpdateCategoryYearEntityRelationInput"];
	["ShowYearWithoutShowListUpdateInput"]: GraphQLTypes["ShowYearWithoutShowListUpdateInput"];
	["ShowUpsertCategoryYearRelationInput"]: GraphQLTypes["ShowUpsertCategoryYearRelationInput"];
	["ShowUpdateGalleryEntityRelationInput"]: GraphQLTypes["ShowUpdateGalleryEntityRelationInput"];
	["MediumGalleryUpdateInput"]: GraphQLTypes["MediumGalleryUpdateInput"];
	["MediumGalleryUpdateItemsEntityRelationInput"]: GraphQLTypes["MediumGalleryUpdateItemsEntityRelationInput"];
	["MediumGalleryUpdateItemsRelationInput"]: GraphQLTypes["MediumGalleryUpdateItemsRelationInput"];
	["MediumGalleryItemWithoutGalleryUpdateInput"]: GraphQLTypes["MediumGalleryItemWithoutGalleryUpdateInput"];
	["MediumGalleryItemUpdateImageEntityRelationInput"]: GraphQLTypes["MediumGalleryItemUpdateImageEntityRelationInput"];
	["MediumGalleryItemUpsertImageRelationInput"]: GraphQLTypes["MediumGalleryItemUpsertImageRelationInput"];
	["MediumGalleryItemUpdateVideoEntityRelationInput"]: GraphQLTypes["MediumGalleryItemUpdateVideoEntityRelationInput"];
	["VideoUpdateInput"]: GraphQLTypes["VideoUpdateInput"];
	["VideoUpdatePosterEntityRelationInput"]: GraphQLTypes["VideoUpdatePosterEntityRelationInput"];
	["VideoUpsertPosterRelationInput"]: GraphQLTypes["VideoUpsertPosterRelationInput"];
	["MediumGalleryItemUpsertVideoRelationInput"]: GraphQLTypes["MediumGalleryItemUpsertVideoRelationInput"];
	["MediumGalleryUpsertItemsRelationInput"]: GraphQLTypes["MediumGalleryUpsertItemsRelationInput"];
	["ShowUpsertGalleryRelationInput"]: GraphQLTypes["ShowUpsertGalleryRelationInput"];
	["ShowUpdateSeoEntityRelationInput"]: GraphQLTypes["ShowUpdateSeoEntityRelationInput"];
	["ShowUpsertSeoRelationInput"]: GraphQLTypes["ShowUpsertSeoRelationInput"];
	["LinkableUpsertShowPageRelationInput"]: GraphQLTypes["LinkableUpsertShowPageRelationInput"];
	["LinkableUpdateRedirectEntityRelationInput"]: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"];
	["RedirectWithoutLinkUpdateInput"]: GraphQLTypes["RedirectWithoutLinkUpdateInput"];
	["RedirectUpdateTargetEntityRelationInput"]: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"];
	["LinkableUpdateInput"]: GraphQLTypes["LinkableUpdateInput"];
	["LinkableUpdateHomePageEntityRelationInput"]: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"];
	["HomePageWithoutLinkUpdateInput"]: GraphQLTypes["HomePageWithoutLinkUpdateInput"];
	["HomePageUpdateSeoEntityRelationInput"]: GraphQLTypes["HomePageUpdateSeoEntityRelationInput"];
	["HomePageUpsertSeoRelationInput"]: GraphQLTypes["HomePageUpsertSeoRelationInput"];
	["HomePageUpdateBlocksEntityRelationInput"]: GraphQLTypes["HomePageUpdateBlocksEntityRelationInput"];
	["HomePageUpdateBlocksRelationInput"]: GraphQLTypes["HomePageUpdateBlocksRelationInput"];
	["ContentBlockWithoutHomePageUpdateInput"]: GraphQLTypes["ContentBlockWithoutHomePageUpdateInput"];
	["ContentBlockUpdateGalleryEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateGalleryEntityRelationInput"];
	["ContentBlockUpsertGalleryRelationInput"]: GraphQLTypes["ContentBlockUpsertGalleryRelationInput"];
	["ContentBlockUpdateVideoEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateVideoEntityRelationInput"];
	["ContentBlockUpsertVideoRelationInput"]: GraphQLTypes["ContentBlockUpsertVideoRelationInput"];
	["ContentBlockUpdateLinkEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateLinkEntityRelationInput"];
	["LinkUpdateInput"]: GraphQLTypes["LinkUpdateInput"];
	["LinkUpdateInternalLinkEntityRelationInput"]: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"];
	["LinkUpsertInternalLinkRelationInput"]: GraphQLTypes["LinkUpsertInternalLinkRelationInput"];
	["ContentBlockUpsertLinkRelationInput"]: GraphQLTypes["ContentBlockUpsertLinkRelationInput"];
	["ContentBlockUpdateMembersEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateMembersEntityRelationInput"];
	["MemberListUpdateInput"]: GraphQLTypes["MemberListUpdateInput"];
	["MemberListUpdateItemsEntityRelationInput"]: GraphQLTypes["MemberListUpdateItemsEntityRelationInput"];
	["MemberListUpdateItemsRelationInput"]: GraphQLTypes["MemberListUpdateItemsRelationInput"];
	["MemberItemWithoutListUpdateInput"]: GraphQLTypes["MemberItemWithoutListUpdateInput"];
	["MemberItemUpdateMemberEntityRelationInput"]: GraphQLTypes["MemberItemUpdateMemberEntityRelationInput"];
	["MemberUpdateInput"]: GraphQLTypes["MemberUpdateInput"];
	["MemberUpdateImageEntityRelationInput"]: GraphQLTypes["MemberUpdateImageEntityRelationInput"];
	["MemberUpsertImageRelationInput"]: GraphQLTypes["MemberUpsertImageRelationInput"];
	["MemberItemUpsertMemberRelationInput"]: GraphQLTypes["MemberItemUpsertMemberRelationInput"];
	["MemberListUpsertItemsRelationInput"]: GraphQLTypes["MemberListUpsertItemsRelationInput"];
	["ContentBlockUpsertMembersRelationInput"]: GraphQLTypes["ContentBlockUpsertMembersRelationInput"];
	["ContentBlockUpdatePortfolioEntityRelationInput"]: GraphQLTypes["ContentBlockUpdatePortfolioEntityRelationInput"];
	["ShowYearListUpdateInput"]: GraphQLTypes["ShowYearListUpdateInput"];
	["ShowYearListUpdateItemsEntityRelationInput"]: GraphQLTypes["ShowYearListUpdateItemsEntityRelationInput"];
	["ShowYearListUpdateItemsRelationInput"]: GraphQLTypes["ShowYearListUpdateItemsRelationInput"];
	["ShowYearItemWithoutListUpdateInput"]: GraphQLTypes["ShowYearItemWithoutListUpdateInput"];
	["ShowYearItemUpdateShowYearEntityRelationInput"]: GraphQLTypes["ShowYearItemUpdateShowYearEntityRelationInput"];
	["ShowYearUpdateInput"]: GraphQLTypes["ShowYearUpdateInput"];
	["ShowYearUpdateShowListEntityRelationInput"]: GraphQLTypes["ShowYearUpdateShowListEntityRelationInput"];
	["ShowYearUpdateShowListRelationInput"]: GraphQLTypes["ShowYearUpdateShowListRelationInput"];
	["ShowWithoutCategoryYearUpdateInput"]: GraphQLTypes["ShowWithoutCategoryYearUpdateInput"];
	["ShowUpdateLinkEntityRelationInput"]: GraphQLTypes["ShowUpdateLinkEntityRelationInput"];
	["LinkableWithoutShowPageUpdateInput"]: GraphQLTypes["LinkableWithoutShowPageUpdateInput"];
	["ShowUpsertLinkRelationInput"]: GraphQLTypes["ShowUpsertLinkRelationInput"];
	["ShowYearUpsertShowListRelationInput"]: GraphQLTypes["ShowYearUpsertShowListRelationInput"];
	["ShowYearItemUpsertShowYearRelationInput"]: GraphQLTypes["ShowYearItemUpsertShowYearRelationInput"];
	["ShowYearListUpsertItemsRelationInput"]: GraphQLTypes["ShowYearListUpsertItemsRelationInput"];
	["ContentBlockUpsertPortfolioRelationInput"]: GraphQLTypes["ContentBlockUpsertPortfolioRelationInput"];
	["HomePageUpsertBlocksRelationInput"]: GraphQLTypes["HomePageUpsertBlocksRelationInput"];
	["LinkableUpsertHomePageRelationInput"]: GraphQLTypes["LinkableUpsertHomePageRelationInput"];
	["RedirectUpsertTargetRelationInput"]: GraphQLTypes["RedirectUpsertTargetRelationInput"];
	["LinkableUpsertRedirectRelationInput"]: GraphQLTypes["LinkableUpsertRedirectRelationInput"];
	["HomePageUpsertLinkRelationInput"]: GraphQLTypes["HomePageUpsertLinkRelationInput"];
	["ContentBlockUpsertHomePageRelationInput"]: GraphQLTypes["ContentBlockUpsertHomePageRelationInput"];
	["ImageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageEdge"][]
};
	["ImageEdge"]: {
		node:ModelTypes["Image"]
};
	["LinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkEdge"][]
};
	["LinkEdge"]: {
		node:ModelTypes["Link"]
};
	["SeoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SeoEdge"][]
};
	["SeoEdge"]: {
		node:ModelTypes["Seo"]
};
	["HomePageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HomePageEdge"][]
};
	["HomePageEdge"]: {
		node:ModelTypes["HomePage"]
};
	["HomePageCreateInput"]: GraphQLTypes["HomePageCreateInput"];
	["HomePageUpdateInput"]: GraphQLTypes["HomePageUpdateInput"];
	["LinkableConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkableEdge"][]
};
	["LinkableEdge"]: {
		node:ModelTypes["Linkable"]
};
	["MediumGalleryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["MediumGalleryEdge"][]
};
	["MediumGalleryEdge"]: {
		node:ModelTypes["MediumGallery"]
};
	["MediumGalleryItemCreateInput"]: GraphQLTypes["MediumGalleryItemCreateInput"];
	["MediumGalleryItemCreateGalleryEntityRelationInput"]: GraphQLTypes["MediumGalleryItemCreateGalleryEntityRelationInput"];
	["MediumGalleryWithoutItemsCreateInput"]: GraphQLTypes["MediumGalleryWithoutItemsCreateInput"];
	["MediumGalleryItemUpdateInput"]: GraphQLTypes["MediumGalleryItemUpdateInput"];
	["MediumGalleryItemUpdateGalleryEntityRelationInput"]: GraphQLTypes["MediumGalleryItemUpdateGalleryEntityRelationInput"];
	["MediumGalleryWithoutItemsUpdateInput"]: GraphQLTypes["MediumGalleryWithoutItemsUpdateInput"];
	["MediumGalleryItemUpsertGalleryRelationInput"]: GraphQLTypes["MediumGalleryItemUpsertGalleryRelationInput"];
	["MemberConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["MemberEdge"][]
};
	["MemberEdge"]: {
		node:ModelTypes["Member"]
};
	["MemberItemCreateInput"]: GraphQLTypes["MemberItemCreateInput"];
	["MemberItemCreateListEntityRelationInput"]: GraphQLTypes["MemberItemCreateListEntityRelationInput"];
	["MemberListWithoutItemsCreateInput"]: GraphQLTypes["MemberListWithoutItemsCreateInput"];
	["MemberItemUpdateInput"]: GraphQLTypes["MemberItemUpdateInput"];
	["MemberItemUpdateListEntityRelationInput"]: GraphQLTypes["MemberItemUpdateListEntityRelationInput"];
	["MemberListWithoutItemsUpdateInput"]: GraphQLTypes["MemberListWithoutItemsUpdateInput"];
	["MemberItemUpsertListRelationInput"]: GraphQLTypes["MemberItemUpsertListRelationInput"];
	["MemberListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["MemberListEdge"][]
};
	["MemberListEdge"]: {
		node:ModelTypes["MemberList"]
};
	["ShowCreateInput"]: GraphQLTypes["ShowCreateInput"];
	["ShowUpdateInput"]: GraphQLTypes["ShowUpdateInput"];
	["ShowListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ShowListEdge"][]
};
	["ShowListEdge"]: {
		node:ModelTypes["ShowList"]
};
	["ShowListCreateInput"]: GraphQLTypes["ShowListCreateInput"];
	["ShowListCreateItemsEntityRelationInput"]: GraphQLTypes["ShowListCreateItemsEntityRelationInput"];
	["ShowItemWithoutListCreateInput"]: GraphQLTypes["ShowItemWithoutListCreateInput"];
	["ShowItemCreateShowEntityRelationInput"]: GraphQLTypes["ShowItemCreateShowEntityRelationInput"];
	["ShowWithoutShowItemCreateInput"]: GraphQLTypes["ShowWithoutShowItemCreateInput"];
	["ShowListUpdateInput"]: GraphQLTypes["ShowListUpdateInput"];
	["ShowListUpdateItemsEntityRelationInput"]: GraphQLTypes["ShowListUpdateItemsEntityRelationInput"];
	["ShowListUpdateItemsRelationInput"]: GraphQLTypes["ShowListUpdateItemsRelationInput"];
	["ShowItemWithoutListUpdateInput"]: GraphQLTypes["ShowItemWithoutListUpdateInput"];
	["ShowItemUpdateShowEntityRelationInput"]: GraphQLTypes["ShowItemUpdateShowEntityRelationInput"];
	["ShowWithoutShowItemUpdateInput"]: GraphQLTypes["ShowWithoutShowItemUpdateInput"];
	["ShowItemUpsertShowRelationInput"]: GraphQLTypes["ShowItemUpsertShowRelationInput"];
	["ShowListUpsertItemsRelationInput"]: GraphQLTypes["ShowListUpsertItemsRelationInput"];
	["ShowYearConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ShowYearEdge"][]
};
	["ShowYearEdge"]: {
		node:ModelTypes["ShowYear"]
};
	["ShowYearItemCreateInput"]: GraphQLTypes["ShowYearItemCreateInput"];
	["ShowYearItemCreateListEntityRelationInput"]: GraphQLTypes["ShowYearItemCreateListEntityRelationInput"];
	["ShowYearListWithoutItemsCreateInput"]: GraphQLTypes["ShowYearListWithoutItemsCreateInput"];
	["ShowYearItemUpdateInput"]: GraphQLTypes["ShowYearItemUpdateInput"];
	["ShowYearItemUpdateListEntityRelationInput"]: GraphQLTypes["ShowYearItemUpdateListEntityRelationInput"];
	["ShowYearListWithoutItemsUpdateInput"]: GraphQLTypes["ShowYearListWithoutItemsUpdateInput"];
	["ShowYearItemUpsertListRelationInput"]: GraphQLTypes["ShowYearItemUpsertListRelationInput"];
	["ShowYearListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ShowYearListEdge"][]
};
	["ShowYearListEdge"]: {
		node:ModelTypes["ShowYearList"]
};
	["SocialLink"]: {
		_meta?:ModelTypes["SocialLinkMeta"],
	id:ModelTypes["UUID"],
	name:string,
	icon?:ModelTypes["Image"],
	link?:ModelTypes["Link"]
};
	["SocialLinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	icon?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["SocialLinkUniqueWhere"]: GraphQLTypes["SocialLinkUniqueWhere"];
	["SocialLinkWhere"]: GraphQLTypes["SocialLinkWhere"];
	["SocialLinkOrderBy"]: GraphQLTypes["SocialLinkOrderBy"];
	["SocialLinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SocialLinkEdge"][]
};
	["SocialLinkEdge"]: {
		node:ModelTypes["SocialLink"]
};
	["SocialLinkCreateInput"]: GraphQLTypes["SocialLinkCreateInput"];
	["SocialLinkCreateIconEntityRelationInput"]: GraphQLTypes["SocialLinkCreateIconEntityRelationInput"];
	["SocialLinkCreateLinkEntityRelationInput"]: GraphQLTypes["SocialLinkCreateLinkEntityRelationInput"];
	["SocialLinkUpdateInput"]: GraphQLTypes["SocialLinkUpdateInput"];
	["SocialLinkUpdateIconEntityRelationInput"]: GraphQLTypes["SocialLinkUpdateIconEntityRelationInput"];
	["SocialLinkUpsertIconRelationInput"]: GraphQLTypes["SocialLinkUpsertIconRelationInput"];
	["SocialLinkUpdateLinkEntityRelationInput"]: GraphQLTypes["SocialLinkUpdateLinkEntityRelationInput"];
	["SocialLinkUpsertLinkRelationInput"]: GraphQLTypes["SocialLinkUpsertLinkRelationInput"];
	["SocialLinkItem"]: {
		_meta?:ModelTypes["SocialLinkItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["SocialLinkList"],
	socialLink?:ModelTypes["SocialLink"]
};
	["SocialLinkItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	socialLink?:ModelTypes["FieldMeta"]
};
	["SocialLinkList"]: {
		_meta?:ModelTypes["SocialLinkListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["SocialLinkItem"][],
	paginateItems:ModelTypes["SocialLinkItemConnection"]
};
	["SocialLinkListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["SocialLinkItemWhere"]: GraphQLTypes["SocialLinkItemWhere"];
	["SocialLinkListWhere"]: GraphQLTypes["SocialLinkListWhere"];
	["SocialLinkItemOrderBy"]: GraphQLTypes["SocialLinkItemOrderBy"];
	["SocialLinkListOrderBy"]: GraphQLTypes["SocialLinkListOrderBy"];
	["SocialLinkItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SocialLinkItemEdge"][]
};
	["SocialLinkItemEdge"]: {
		node:ModelTypes["SocialLinkItem"]
};
	["SocialLinkItemUniqueWhere"]: GraphQLTypes["SocialLinkItemUniqueWhere"];
	["SocialLinkItemCreateInput"]: GraphQLTypes["SocialLinkItemCreateInput"];
	["SocialLinkItemCreateListEntityRelationInput"]: GraphQLTypes["SocialLinkItemCreateListEntityRelationInput"];
	["SocialLinkListUniqueWhere"]: GraphQLTypes["SocialLinkListUniqueWhere"];
	["SocialLinkListWithoutItemsCreateInput"]: GraphQLTypes["SocialLinkListWithoutItemsCreateInput"];
	["SocialLinkItemCreateSocialLinkEntityRelationInput"]: GraphQLTypes["SocialLinkItemCreateSocialLinkEntityRelationInput"];
	["SocialLinkItemUpdateInput"]: GraphQLTypes["SocialLinkItemUpdateInput"];
	["SocialLinkItemUpdateListEntityRelationInput"]: GraphQLTypes["SocialLinkItemUpdateListEntityRelationInput"];
	["SocialLinkListWithoutItemsUpdateInput"]: GraphQLTypes["SocialLinkListWithoutItemsUpdateInput"];
	["SocialLinkItemUpsertListRelationInput"]: GraphQLTypes["SocialLinkItemUpsertListRelationInput"];
	["SocialLinkItemUpdateSocialLinkEntityRelationInput"]: GraphQLTypes["SocialLinkItemUpdateSocialLinkEntityRelationInput"];
	["SocialLinkItemUpsertSocialLinkRelationInput"]: GraphQLTypes["SocialLinkItemUpsertSocialLinkRelationInput"];
	["SocialLinkListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SocialLinkListEdge"][]
};
	["SocialLinkListEdge"]: {
		node:ModelTypes["SocialLinkList"]
};
	["SocialLinkListCreateInput"]: GraphQLTypes["SocialLinkListCreateInput"];
	["SocialLinkListCreateItemsEntityRelationInput"]: GraphQLTypes["SocialLinkListCreateItemsEntityRelationInput"];
	["SocialLinkItemWithoutListCreateInput"]: GraphQLTypes["SocialLinkItemWithoutListCreateInput"];
	["SocialLinkListUpdateInput"]: GraphQLTypes["SocialLinkListUpdateInput"];
	["SocialLinkListUpdateItemsEntityRelationInput"]: GraphQLTypes["SocialLinkListUpdateItemsEntityRelationInput"];
	["SocialLinkListUpdateItemsRelationInput"]: GraphQLTypes["SocialLinkListUpdateItemsRelationInput"];
	["SocialLinkItemWithoutListUpdateInput"]: GraphQLTypes["SocialLinkItemWithoutListUpdateInput"];
	["SocialLinkListUpsertItemsRelationInput"]: GraphQLTypes["SocialLinkListUpsertItemsRelationInput"];
	["VideoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["VideoEdge"][]
};
	["VideoEdge"]: {
		node:ModelTypes["Video"]
};
	["YoutubeVideo"]: {
		_meta?:ModelTypes["YoutubeVideoMeta"],
	id:ModelTypes["UUID"],
	videoId:string
};
	["YoutubeVideoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	videoId?:ModelTypes["FieldMeta"]
};
	["YoutubeVideoUniqueWhere"]: GraphQLTypes["YoutubeVideoUniqueWhere"];
	["YoutubeVideoWhere"]: GraphQLTypes["YoutubeVideoWhere"];
	["YoutubeVideoOrderBy"]: GraphQLTypes["YoutubeVideoOrderBy"];
	["YoutubeVideoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["YoutubeVideoEdge"][]
};
	["YoutubeVideoEdge"]: {
		node:ModelTypes["YoutubeVideo"]
};
	["YoutubeVideoCreateInput"]: GraphQLTypes["YoutubeVideoCreateInput"];
	["YoutubeVideoUpdateInput"]: GraphQLTypes["YoutubeVideoUpdateInput"];
	["Header"]: {
		_meta?:ModelTypes["HeaderMeta"],
	id:ModelTypes["UUID"],
	logo?:ModelTypes["Image"],
	socialLinks?:ModelTypes["SocialLinkList"],
	unique:ModelTypes["One"]
};
	["HeaderMeta"]: {
		id?:ModelTypes["FieldMeta"],
	logo?:ModelTypes["FieldMeta"],
	socialLinks?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"]
};
	["HeaderUniqueWhere"]: GraphQLTypes["HeaderUniqueWhere"];
	["HeaderWhere"]: GraphQLTypes["HeaderWhere"];
	["HeaderOrderBy"]: GraphQLTypes["HeaderOrderBy"];
	["HeaderConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HeaderEdge"][]
};
	["HeaderEdge"]: {
		node:ModelTypes["Header"]
};
	["HeaderCreateInput"]: GraphQLTypes["HeaderCreateInput"];
	["HeaderCreateLogoEntityRelationInput"]: GraphQLTypes["HeaderCreateLogoEntityRelationInput"];
	["HeaderCreateSocialLinksEntityRelationInput"]: GraphQLTypes["HeaderCreateSocialLinksEntityRelationInput"];
	["HeaderUpdateInput"]: GraphQLTypes["HeaderUpdateInput"];
	["HeaderUpdateLogoEntityRelationInput"]: GraphQLTypes["HeaderUpdateLogoEntityRelationInput"];
	["HeaderUpsertLogoRelationInput"]: GraphQLTypes["HeaderUpsertLogoRelationInput"];
	["HeaderUpdateSocialLinksEntityRelationInput"]: GraphQLTypes["HeaderUpdateSocialLinksEntityRelationInput"];
	["HeaderUpsertSocialLinksRelationInput"]: GraphQLTypes["HeaderUpsertSocialLinksRelationInput"];
	["Footer"]: {
		_meta?:ModelTypes["FooterMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	info?:string,
	address?:ModelTypes["FooterAddress"],
	members?:ModelTypes["MemberList"],
	logo?:ModelTypes["Image"],
	socialLinks?:ModelTypes["SocialLinkList"],
	unique:ModelTypes["One"],
	generalContact?:ModelTypes["FooterGeneralContact"]
};
	["FooterMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	info?:ModelTypes["FieldMeta"],
	address?:ModelTypes["FieldMeta"],
	members?:ModelTypes["FieldMeta"],
	logo?:ModelTypes["FieldMeta"],
	socialLinks?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	generalContact?:ModelTypes["FieldMeta"]
};
	["FooterAddress"]: {
		_meta?:ModelTypes["FooterAddressMeta"],
	id:ModelTypes["UUID"],
	label?:string,
	address?:string,
	addressLink?:ModelTypes["Link"]
};
	["FooterAddressMeta"]: {
		id?:ModelTypes["FieldMeta"],
	label?:ModelTypes["FieldMeta"],
	address?:ModelTypes["FieldMeta"],
	addressLink?:ModelTypes["FieldMeta"]
};
	["FooterAddressWhere"]: GraphQLTypes["FooterAddressWhere"];
	["FooterGeneralContact"]: {
		_meta?:ModelTypes["FooterGeneralContactMeta"],
	id:ModelTypes["UUID"],
	label?:string,
	email?:string,
	info?:string
};
	["FooterGeneralContactMeta"]: {
		id?:ModelTypes["FieldMeta"],
	label?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	info?:ModelTypes["FieldMeta"]
};
	["FooterGeneralContactWhere"]: GraphQLTypes["FooterGeneralContactWhere"];
	["FooterUniqueWhere"]: GraphQLTypes["FooterUniqueWhere"];
	["FooterWhere"]: GraphQLTypes["FooterWhere"];
	["FooterOrderBy"]: GraphQLTypes["FooterOrderBy"];
	["FooterAddressOrderBy"]: GraphQLTypes["FooterAddressOrderBy"];
	["FooterGeneralContactOrderBy"]: GraphQLTypes["FooterGeneralContactOrderBy"];
	["FooterConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FooterEdge"][]
};
	["FooterEdge"]: {
		node:ModelTypes["Footer"]
};
	["FooterCreateInput"]: GraphQLTypes["FooterCreateInput"];
	["FooterCreateAddressEntityRelationInput"]: GraphQLTypes["FooterCreateAddressEntityRelationInput"];
	["FooterAddressUniqueWhere"]: GraphQLTypes["FooterAddressUniqueWhere"];
	["FooterAddressCreateInput"]: GraphQLTypes["FooterAddressCreateInput"];
	["FooterAddressCreateAddressLinkEntityRelationInput"]: GraphQLTypes["FooterAddressCreateAddressLinkEntityRelationInput"];
	["FooterCreateMembersEntityRelationInput"]: GraphQLTypes["FooterCreateMembersEntityRelationInput"];
	["FooterCreateLogoEntityRelationInput"]: GraphQLTypes["FooterCreateLogoEntityRelationInput"];
	["FooterCreateSocialLinksEntityRelationInput"]: GraphQLTypes["FooterCreateSocialLinksEntityRelationInput"];
	["FooterCreateGeneralContactEntityRelationInput"]: GraphQLTypes["FooterCreateGeneralContactEntityRelationInput"];
	["FooterGeneralContactUniqueWhere"]: GraphQLTypes["FooterGeneralContactUniqueWhere"];
	["FooterGeneralContactCreateInput"]: GraphQLTypes["FooterGeneralContactCreateInput"];
	["FooterUpdateInput"]: GraphQLTypes["FooterUpdateInput"];
	["FooterUpdateAddressEntityRelationInput"]: GraphQLTypes["FooterUpdateAddressEntityRelationInput"];
	["FooterAddressUpdateInput"]: GraphQLTypes["FooterAddressUpdateInput"];
	["FooterAddressUpdateAddressLinkEntityRelationInput"]: GraphQLTypes["FooterAddressUpdateAddressLinkEntityRelationInput"];
	["FooterAddressUpsertAddressLinkRelationInput"]: GraphQLTypes["FooterAddressUpsertAddressLinkRelationInput"];
	["FooterUpsertAddressRelationInput"]: GraphQLTypes["FooterUpsertAddressRelationInput"];
	["FooterUpdateMembersEntityRelationInput"]: GraphQLTypes["FooterUpdateMembersEntityRelationInput"];
	["FooterUpsertMembersRelationInput"]: GraphQLTypes["FooterUpsertMembersRelationInput"];
	["FooterUpdateLogoEntityRelationInput"]: GraphQLTypes["FooterUpdateLogoEntityRelationInput"];
	["FooterUpsertLogoRelationInput"]: GraphQLTypes["FooterUpsertLogoRelationInput"];
	["FooterUpdateSocialLinksEntityRelationInput"]: GraphQLTypes["FooterUpdateSocialLinksEntityRelationInput"];
	["FooterUpsertSocialLinksRelationInput"]: GraphQLTypes["FooterUpsertSocialLinksRelationInput"];
	["FooterUpdateGeneralContactEntityRelationInput"]: GraphQLTypes["FooterUpdateGeneralContactEntityRelationInput"];
	["FooterGeneralContactUpdateInput"]: GraphQLTypes["FooterGeneralContactUpdateInput"];
	["FooterUpsertGeneralContactRelationInput"]: GraphQLTypes["FooterUpsertGeneralContactRelationInput"];
	["FooterAddressConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FooterAddressEdge"][]
};
	["FooterAddressEdge"]: {
		node:ModelTypes["FooterAddress"]
};
	["PortfolioPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PortfolioPageEdge"][]
};
	["PortfolioPageEdge"]: {
		node:ModelTypes["PortfolioPage"]
};
	["PortfolioPageCreateInput"]: GraphQLTypes["PortfolioPageCreateInput"];
	["PortfolioPageCreateLinkEntityRelationInput"]: GraphQLTypes["PortfolioPageCreateLinkEntityRelationInput"];
	["LinkableWithoutPortfolioPageCreateInput"]: GraphQLTypes["LinkableWithoutPortfolioPageCreateInput"];
	["PortfolioPageUpdateInput"]: GraphQLTypes["PortfolioPageUpdateInput"];
	["PortfolioPageUpdateLinkEntityRelationInput"]: GraphQLTypes["PortfolioPageUpdateLinkEntityRelationInput"];
	["LinkableWithoutPortfolioPageUpdateInput"]: GraphQLTypes["LinkableWithoutPortfolioPageUpdateInput"];
	["PortfolioPageUpsertLinkRelationInput"]: GraphQLTypes["PortfolioPageUpsertLinkRelationInput"];
	["ShowItemCreateInput"]: GraphQLTypes["ShowItemCreateInput"];
	["ShowItemUpdateInput"]: GraphQLTypes["ShowItemUpdateInput"];
	["Settings"]: {
		_meta?:ModelTypes["SettingsMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	seo?:ModelTypes["Seo"]
};
	["SettingsMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["SettingsUniqueWhere"]: GraphQLTypes["SettingsUniqueWhere"];
	["SettingsWhere"]: GraphQLTypes["SettingsWhere"];
	["SettingsOrderBy"]: GraphQLTypes["SettingsOrderBy"];
	["SettingsConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SettingsEdge"][]
};
	["SettingsEdge"]: {
		node:ModelTypes["Settings"]
};
	["SettingsCreateInput"]: GraphQLTypes["SettingsCreateInput"];
	["SettingsCreateSeoEntityRelationInput"]: GraphQLTypes["SettingsCreateSeoEntityRelationInput"];
	["SettingsUpdateInput"]: GraphQLTypes["SettingsUpdateInput"];
	["SettingsUpdateSeoEntityRelationInput"]: GraphQLTypes["SettingsUpdateSeoEntityRelationInput"];
	["SettingsUpsertSeoRelationInput"]: GraphQLTypes["SettingsUpsertSeoRelationInput"];
	["FooterGeneralContactConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FooterGeneralContactEdge"][]
};
	["FooterGeneralContactEdge"]: {
		node:ModelTypes["FooterGeneralContact"]
};
	["RedirectConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["RedirectEdge"][]
};
	["RedirectEdge"]: {
		node:ModelTypes["Redirect"]
};
	["RedirectCreateInput"]: GraphQLTypes["RedirectCreateInput"];
	["RedirectCreateLinkEntityRelationInput"]: GraphQLTypes["RedirectCreateLinkEntityRelationInput"];
	["LinkableWithoutRedirectCreateInput"]: GraphQLTypes["LinkableWithoutRedirectCreateInput"];
	["RedirectUpdateInput"]: GraphQLTypes["RedirectUpdateInput"];
	["RedirectUpdateLinkEntityRelationInput"]: GraphQLTypes["RedirectUpdateLinkEntityRelationInput"];
	["LinkableWithoutRedirectUpdateInput"]: GraphQLTypes["LinkableWithoutRedirectUpdateInput"];
	["RedirectUpsertLinkRelationInput"]: GraphQLTypes["RedirectUpsertLinkRelationInput"];
	["QueryTransaction"]: {
		getContentBlock?:ModelTypes["ContentBlock"],
	listContentBlock:ModelTypes["ContentBlock"][],
	paginateContentBlock:ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentBlock:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getHomePage?:ModelTypes["HomePage"],
	listHomePage:ModelTypes["HomePage"][],
	paginateHomePage:ModelTypes["HomePageConnection"],
	validateCreateHomePage:ModelTypes["_ValidationResult"],
	validateUpdateHomePage:ModelTypes["_ValidationResult"],
	getLinkable?:ModelTypes["Linkable"],
	listLinkable:ModelTypes["Linkable"][],
	paginateLinkable:ModelTypes["LinkableConnection"],
	validateCreateLinkable:ModelTypes["_ValidationResult"],
	validateUpdateLinkable:ModelTypes["_ValidationResult"],
	getMediumGallery?:ModelTypes["MediumGallery"],
	listMediumGallery:ModelTypes["MediumGallery"][],
	paginateMediumGallery:ModelTypes["MediumGalleryConnection"],
	validateCreateMediumGallery:ModelTypes["_ValidationResult"],
	validateUpdateMediumGallery:ModelTypes["_ValidationResult"],
	getMediumGalleryItem?:ModelTypes["MediumGalleryItem"],
	listMediumGalleryItem:ModelTypes["MediumGalleryItem"][],
	paginateMediumGalleryItem:ModelTypes["MediumGalleryItemConnection"],
	validateCreateMediumGalleryItem:ModelTypes["_ValidationResult"],
	validateUpdateMediumGalleryItem:ModelTypes["_ValidationResult"],
	getMember?:ModelTypes["Member"],
	listMember:ModelTypes["Member"][],
	paginateMember:ModelTypes["MemberConnection"],
	validateCreateMember:ModelTypes["_ValidationResult"],
	validateUpdateMember:ModelTypes["_ValidationResult"],
	getMemberItem?:ModelTypes["MemberItem"],
	listMemberItem:ModelTypes["MemberItem"][],
	paginateMemberItem:ModelTypes["MemberItemConnection"],
	validateCreateMemberItem:ModelTypes["_ValidationResult"],
	validateUpdateMemberItem:ModelTypes["_ValidationResult"],
	getMemberList?:ModelTypes["MemberList"],
	listMemberList:ModelTypes["MemberList"][],
	paginateMemberList:ModelTypes["MemberListConnection"],
	validateCreateMemberList:ModelTypes["_ValidationResult"],
	validateUpdateMemberList:ModelTypes["_ValidationResult"],
	getShow?:ModelTypes["Show"],
	listShow:ModelTypes["Show"][],
	paginateShow:ModelTypes["ShowConnection"],
	validateCreateShow:ModelTypes["_ValidationResult"],
	validateUpdateShow:ModelTypes["_ValidationResult"],
	getShowList?:ModelTypes["ShowList"],
	listShowList:ModelTypes["ShowList"][],
	paginateShowList:ModelTypes["ShowListConnection"],
	validateCreateShowList:ModelTypes["_ValidationResult"],
	validateUpdateShowList:ModelTypes["_ValidationResult"],
	getShowYear?:ModelTypes["ShowYear"],
	listShowYear:ModelTypes["ShowYear"][],
	paginateShowYear:ModelTypes["ShowYearConnection"],
	validateCreateShowYear:ModelTypes["_ValidationResult"],
	validateUpdateShowYear:ModelTypes["_ValidationResult"],
	getShowYearItem?:ModelTypes["ShowYearItem"],
	listShowYearItem:ModelTypes["ShowYearItem"][],
	paginateShowYearItem:ModelTypes["ShowYearItemConnection"],
	validateCreateShowYearItem:ModelTypes["_ValidationResult"],
	validateUpdateShowYearItem:ModelTypes["_ValidationResult"],
	getShowYearList?:ModelTypes["ShowYearList"],
	listShowYearList:ModelTypes["ShowYearList"][],
	paginateShowYearList:ModelTypes["ShowYearListConnection"],
	validateCreateShowYearList:ModelTypes["_ValidationResult"],
	validateUpdateShowYearList:ModelTypes["_ValidationResult"],
	getSocialLink?:ModelTypes["SocialLink"],
	listSocialLink:ModelTypes["SocialLink"][],
	paginateSocialLink:ModelTypes["SocialLinkConnection"],
	validateCreateSocialLink:ModelTypes["_ValidationResult"],
	validateUpdateSocialLink:ModelTypes["_ValidationResult"],
	getSocialLinkItem?:ModelTypes["SocialLinkItem"],
	listSocialLinkItem:ModelTypes["SocialLinkItem"][],
	paginateSocialLinkItem:ModelTypes["SocialLinkItemConnection"],
	validateCreateSocialLinkItem:ModelTypes["_ValidationResult"],
	validateUpdateSocialLinkItem:ModelTypes["_ValidationResult"],
	getSocialLinkList?:ModelTypes["SocialLinkList"],
	listSocialLinkList:ModelTypes["SocialLinkList"][],
	paginateSocialLinkList:ModelTypes["SocialLinkListConnection"],
	validateCreateSocialLinkList:ModelTypes["_ValidationResult"],
	validateUpdateSocialLinkList:ModelTypes["_ValidationResult"],
	getVideo?:ModelTypes["Video"],
	listVideo:ModelTypes["Video"][],
	paginateVideo:ModelTypes["VideoConnection"],
	validateCreateVideo:ModelTypes["_ValidationResult"],
	validateUpdateVideo:ModelTypes["_ValidationResult"],
	getYoutubeVideo?:ModelTypes["YoutubeVideo"],
	listYoutubeVideo:ModelTypes["YoutubeVideo"][],
	paginateYoutubeVideo:ModelTypes["YoutubeVideoConnection"],
	validateCreateYoutubeVideo:ModelTypes["_ValidationResult"],
	validateUpdateYoutubeVideo:ModelTypes["_ValidationResult"],
	getHeader?:ModelTypes["Header"],
	listHeader:ModelTypes["Header"][],
	paginateHeader:ModelTypes["HeaderConnection"],
	validateCreateHeader:ModelTypes["_ValidationResult"],
	validateUpdateHeader:ModelTypes["_ValidationResult"],
	getFooter?:ModelTypes["Footer"],
	listFooter:ModelTypes["Footer"][],
	paginateFooter:ModelTypes["FooterConnection"],
	validateCreateFooter:ModelTypes["_ValidationResult"],
	validateUpdateFooter:ModelTypes["_ValidationResult"],
	getFooterAddress?:ModelTypes["FooterAddress"],
	listFooterAddress:ModelTypes["FooterAddress"][],
	paginateFooterAddress:ModelTypes["FooterAddressConnection"],
	validateCreateFooterAddress:ModelTypes["_ValidationResult"],
	validateUpdateFooterAddress:ModelTypes["_ValidationResult"],
	getPortfolioPage?:ModelTypes["PortfolioPage"],
	listPortfolioPage:ModelTypes["PortfolioPage"][],
	paginatePortfolioPage:ModelTypes["PortfolioPageConnection"],
	validateCreatePortfolioPage:ModelTypes["_ValidationResult"],
	validateUpdatePortfolioPage:ModelTypes["_ValidationResult"],
	getShowItem?:ModelTypes["ShowItem"],
	listShowItem:ModelTypes["ShowItem"][],
	paginateShowItem:ModelTypes["ShowItemConnection"],
	validateCreateShowItem:ModelTypes["_ValidationResult"],
	validateUpdateShowItem:ModelTypes["_ValidationResult"],
	getSettings?:ModelTypes["Settings"],
	listSettings:ModelTypes["Settings"][],
	paginateSettings:ModelTypes["SettingsConnection"],
	validateCreateSettings:ModelTypes["_ValidationResult"],
	validateUpdateSettings:ModelTypes["_ValidationResult"],
	getFooterGeneralContact?:ModelTypes["FooterGeneralContact"],
	listFooterGeneralContact:ModelTypes["FooterGeneralContact"][],
	paginateFooterGeneralContact:ModelTypes["FooterGeneralContactConnection"],
	validateCreateFooterGeneralContact:ModelTypes["_ValidationResult"],
	validateUpdateFooterGeneralContact:ModelTypes["_ValidationResult"],
	getRedirect?:ModelTypes["Redirect"],
	listRedirect:ModelTypes["Redirect"][],
	paginateRedirect:ModelTypes["RedirectConnection"],
	validateCreateRedirect:ModelTypes["_ValidationResult"],
	validateUpdateRedirect:ModelTypes["_ValidationResult"]
};
	["Info"]: {
		description?:string
};
	["Mutation"]: {
		createContentBlock:ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock:ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock:ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock:ModelTypes["ContentBlockUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createHomePage:ModelTypes["HomePageCreateResult"],
	deleteHomePage:ModelTypes["HomePageDeleteResult"],
	updateHomePage:ModelTypes["HomePageUpdateResult"],
	upsertHomePage:ModelTypes["HomePageUpsertResult"],
	createLinkable:ModelTypes["LinkableCreateResult"],
	deleteLinkable:ModelTypes["LinkableDeleteResult"],
	updateLinkable:ModelTypes["LinkableUpdateResult"],
	upsertLinkable:ModelTypes["LinkableUpsertResult"],
	createMediumGallery:ModelTypes["MediumGalleryCreateResult"],
	deleteMediumGallery:ModelTypes["MediumGalleryDeleteResult"],
	updateMediumGallery:ModelTypes["MediumGalleryUpdateResult"],
	upsertMediumGallery:ModelTypes["MediumGalleryUpsertResult"],
	createMediumGalleryItem:ModelTypes["MediumGalleryItemCreateResult"],
	deleteMediumGalleryItem:ModelTypes["MediumGalleryItemDeleteResult"],
	updateMediumGalleryItem:ModelTypes["MediumGalleryItemUpdateResult"],
	upsertMediumGalleryItem:ModelTypes["MediumGalleryItemUpsertResult"],
	createMember:ModelTypes["MemberCreateResult"],
	deleteMember:ModelTypes["MemberDeleteResult"],
	updateMember:ModelTypes["MemberUpdateResult"],
	upsertMember:ModelTypes["MemberUpsertResult"],
	createMemberItem:ModelTypes["MemberItemCreateResult"],
	deleteMemberItem:ModelTypes["MemberItemDeleteResult"],
	updateMemberItem:ModelTypes["MemberItemUpdateResult"],
	upsertMemberItem:ModelTypes["MemberItemUpsertResult"],
	createMemberList:ModelTypes["MemberListCreateResult"],
	deleteMemberList:ModelTypes["MemberListDeleteResult"],
	updateMemberList:ModelTypes["MemberListUpdateResult"],
	upsertMemberList:ModelTypes["MemberListUpsertResult"],
	createShow:ModelTypes["ShowCreateResult"],
	deleteShow:ModelTypes["ShowDeleteResult"],
	updateShow:ModelTypes["ShowUpdateResult"],
	upsertShow:ModelTypes["ShowUpsertResult"],
	createShowList:ModelTypes["ShowListCreateResult"],
	deleteShowList:ModelTypes["ShowListDeleteResult"],
	updateShowList:ModelTypes["ShowListUpdateResult"],
	upsertShowList:ModelTypes["ShowListUpsertResult"],
	createShowYear:ModelTypes["ShowYearCreateResult"],
	deleteShowYear:ModelTypes["ShowYearDeleteResult"],
	updateShowYear:ModelTypes["ShowYearUpdateResult"],
	upsertShowYear:ModelTypes["ShowYearUpsertResult"],
	createShowYearItem:ModelTypes["ShowYearItemCreateResult"],
	deleteShowYearItem:ModelTypes["ShowYearItemDeleteResult"],
	updateShowYearItem:ModelTypes["ShowYearItemUpdateResult"],
	upsertShowYearItem:ModelTypes["ShowYearItemUpsertResult"],
	createShowYearList:ModelTypes["ShowYearListCreateResult"],
	deleteShowYearList:ModelTypes["ShowYearListDeleteResult"],
	updateShowYearList:ModelTypes["ShowYearListUpdateResult"],
	upsertShowYearList:ModelTypes["ShowYearListUpsertResult"],
	createSocialLink:ModelTypes["SocialLinkCreateResult"],
	deleteSocialLink:ModelTypes["SocialLinkDeleteResult"],
	updateSocialLink:ModelTypes["SocialLinkUpdateResult"],
	upsertSocialLink:ModelTypes["SocialLinkUpsertResult"],
	createSocialLinkItem:ModelTypes["SocialLinkItemCreateResult"],
	deleteSocialLinkItem:ModelTypes["SocialLinkItemDeleteResult"],
	updateSocialLinkItem:ModelTypes["SocialLinkItemUpdateResult"],
	upsertSocialLinkItem:ModelTypes["SocialLinkItemUpsertResult"],
	createSocialLinkList:ModelTypes["SocialLinkListCreateResult"],
	deleteSocialLinkList:ModelTypes["SocialLinkListDeleteResult"],
	updateSocialLinkList:ModelTypes["SocialLinkListUpdateResult"],
	upsertSocialLinkList:ModelTypes["SocialLinkListUpsertResult"],
	createVideo:ModelTypes["VideoCreateResult"],
	deleteVideo:ModelTypes["VideoDeleteResult"],
	updateVideo:ModelTypes["VideoUpdateResult"],
	upsertVideo:ModelTypes["VideoUpsertResult"],
	createYoutubeVideo:ModelTypes["YoutubeVideoCreateResult"],
	deleteYoutubeVideo:ModelTypes["YoutubeVideoDeleteResult"],
	updateYoutubeVideo:ModelTypes["YoutubeVideoUpdateResult"],
	upsertYoutubeVideo:ModelTypes["YoutubeVideoUpsertResult"],
	createHeader:ModelTypes["HeaderCreateResult"],
	deleteHeader:ModelTypes["HeaderDeleteResult"],
	updateHeader:ModelTypes["HeaderUpdateResult"],
	upsertHeader:ModelTypes["HeaderUpsertResult"],
	createFooter:ModelTypes["FooterCreateResult"],
	deleteFooter:ModelTypes["FooterDeleteResult"],
	updateFooter:ModelTypes["FooterUpdateResult"],
	upsertFooter:ModelTypes["FooterUpsertResult"],
	createFooterAddress:ModelTypes["FooterAddressCreateResult"],
	deleteFooterAddress:ModelTypes["FooterAddressDeleteResult"],
	updateFooterAddress:ModelTypes["FooterAddressUpdateResult"],
	upsertFooterAddress:ModelTypes["FooterAddressUpsertResult"],
	createPortfolioPage:ModelTypes["PortfolioPageCreateResult"],
	deletePortfolioPage:ModelTypes["PortfolioPageDeleteResult"],
	updatePortfolioPage:ModelTypes["PortfolioPageUpdateResult"],
	upsertPortfolioPage:ModelTypes["PortfolioPageUpsertResult"],
	createShowItem:ModelTypes["ShowItemCreateResult"],
	deleteShowItem:ModelTypes["ShowItemDeleteResult"],
	updateShowItem:ModelTypes["ShowItemUpdateResult"],
	upsertShowItem:ModelTypes["ShowItemUpsertResult"],
	createSettings:ModelTypes["SettingsCreateResult"],
	deleteSettings:ModelTypes["SettingsDeleteResult"],
	updateSettings:ModelTypes["SettingsUpdateResult"],
	upsertSettings:ModelTypes["SettingsUpsertResult"],
	createFooterGeneralContact:ModelTypes["FooterGeneralContactCreateResult"],
	deleteFooterGeneralContact:ModelTypes["FooterGeneralContactDeleteResult"],
	updateFooterGeneralContact:ModelTypes["FooterGeneralContactUpdateResult"],
	upsertFooterGeneralContact:ModelTypes["FooterGeneralContactUpsertResult"],
	createRedirect:ModelTypes["RedirectCreateResult"],
	deleteRedirect:ModelTypes["RedirectDeleteResult"],
	updateRedirect:ModelTypes["RedirectUpdateResult"],
	upsertRedirect:ModelTypes["RedirectUpsertResult"],
	transaction:ModelTypes["MutationTransaction"],
	query:ModelTypes["Query"],
	generateUploadUrl:ModelTypes["S3SignedUpload"],
	generateReadUrl:ModelTypes["S3SignedRead"]
};
	["ContentBlockCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationResult"]: ModelTypes["ContentBlockCreateResult"] | ModelTypes["ContentBlockDeleteResult"] | ModelTypes["ContentBlockUpdateResult"] | ModelTypes["ContentBlockUpsertResult"] | ModelTypes["ImageCreateResult"] | ModelTypes["ImageDeleteResult"] | ModelTypes["ImageUpdateResult"] | ModelTypes["ImageUpsertResult"] | ModelTypes["LinkCreateResult"] | ModelTypes["LinkDeleteResult"] | ModelTypes["LinkUpdateResult"] | ModelTypes["LinkUpsertResult"] | ModelTypes["SeoCreateResult"] | ModelTypes["SeoDeleteResult"] | ModelTypes["SeoUpdateResult"] | ModelTypes["SeoUpsertResult"] | ModelTypes["HomePageCreateResult"] | ModelTypes["HomePageDeleteResult"] | ModelTypes["HomePageUpdateResult"] | ModelTypes["HomePageUpsertResult"] | ModelTypes["LinkableCreateResult"] | ModelTypes["LinkableDeleteResult"] | ModelTypes["LinkableUpdateResult"] | ModelTypes["LinkableUpsertResult"] | ModelTypes["MediumGalleryCreateResult"] | ModelTypes["MediumGalleryDeleteResult"] | ModelTypes["MediumGalleryUpdateResult"] | ModelTypes["MediumGalleryUpsertResult"] | ModelTypes["MediumGalleryItemCreateResult"] | ModelTypes["MediumGalleryItemDeleteResult"] | ModelTypes["MediumGalleryItemUpdateResult"] | ModelTypes["MediumGalleryItemUpsertResult"] | ModelTypes["MemberCreateResult"] | ModelTypes["MemberDeleteResult"] | ModelTypes["MemberUpdateResult"] | ModelTypes["MemberUpsertResult"] | ModelTypes["MemberItemCreateResult"] | ModelTypes["MemberItemDeleteResult"] | ModelTypes["MemberItemUpdateResult"] | ModelTypes["MemberItemUpsertResult"] | ModelTypes["MemberListCreateResult"] | ModelTypes["MemberListDeleteResult"] | ModelTypes["MemberListUpdateResult"] | ModelTypes["MemberListUpsertResult"] | ModelTypes["ShowCreateResult"] | ModelTypes["ShowDeleteResult"] | ModelTypes["ShowUpdateResult"] | ModelTypes["ShowUpsertResult"] | ModelTypes["ShowListCreateResult"] | ModelTypes["ShowListDeleteResult"] | ModelTypes["ShowListUpdateResult"] | ModelTypes["ShowListUpsertResult"] | ModelTypes["ShowYearCreateResult"] | ModelTypes["ShowYearDeleteResult"] | ModelTypes["ShowYearUpdateResult"] | ModelTypes["ShowYearUpsertResult"] | ModelTypes["ShowYearItemCreateResult"] | ModelTypes["ShowYearItemDeleteResult"] | ModelTypes["ShowYearItemUpdateResult"] | ModelTypes["ShowYearItemUpsertResult"] | ModelTypes["ShowYearListCreateResult"] | ModelTypes["ShowYearListDeleteResult"] | ModelTypes["ShowYearListUpdateResult"] | ModelTypes["ShowYearListUpsertResult"] | ModelTypes["SocialLinkCreateResult"] | ModelTypes["SocialLinkDeleteResult"] | ModelTypes["SocialLinkUpdateResult"] | ModelTypes["SocialLinkUpsertResult"] | ModelTypes["SocialLinkItemCreateResult"] | ModelTypes["SocialLinkItemDeleteResult"] | ModelTypes["SocialLinkItemUpdateResult"] | ModelTypes["SocialLinkItemUpsertResult"] | ModelTypes["SocialLinkListCreateResult"] | ModelTypes["SocialLinkListDeleteResult"] | ModelTypes["SocialLinkListUpdateResult"] | ModelTypes["SocialLinkListUpsertResult"] | ModelTypes["VideoCreateResult"] | ModelTypes["VideoDeleteResult"] | ModelTypes["VideoUpdateResult"] | ModelTypes["VideoUpsertResult"] | ModelTypes["YoutubeVideoCreateResult"] | ModelTypes["YoutubeVideoDeleteResult"] | ModelTypes["YoutubeVideoUpdateResult"] | ModelTypes["YoutubeVideoUpsertResult"] | ModelTypes["HeaderCreateResult"] | ModelTypes["HeaderDeleteResult"] | ModelTypes["HeaderUpdateResult"] | ModelTypes["HeaderUpsertResult"] | ModelTypes["FooterCreateResult"] | ModelTypes["FooterDeleteResult"] | ModelTypes["FooterUpdateResult"] | ModelTypes["FooterUpsertResult"] | ModelTypes["FooterAddressCreateResult"] | ModelTypes["FooterAddressDeleteResult"] | ModelTypes["FooterAddressUpdateResult"] | ModelTypes["FooterAddressUpsertResult"] | ModelTypes["PortfolioPageCreateResult"] | ModelTypes["PortfolioPageDeleteResult"] | ModelTypes["PortfolioPageUpdateResult"] | ModelTypes["PortfolioPageUpsertResult"] | ModelTypes["ShowItemCreateResult"] | ModelTypes["ShowItemDeleteResult"] | ModelTypes["ShowItemUpdateResult"] | ModelTypes["ShowItemUpsertResult"] | ModelTypes["SettingsCreateResult"] | ModelTypes["SettingsDeleteResult"] | ModelTypes["SettingsUpdateResult"] | ModelTypes["SettingsUpsertResult"] | ModelTypes["FooterGeneralContactCreateResult"] | ModelTypes["FooterGeneralContactDeleteResult"] | ModelTypes["FooterGeneralContactUpdateResult"] | ModelTypes["FooterGeneralContactUpsertResult"] | ModelTypes["RedirectCreateResult"] | ModelTypes["RedirectDeleteResult"] | ModelTypes["RedirectUpdateResult"] | ModelTypes["RedirectUpsertResult"];
	["_MutationError"]: {
		path:ModelTypes["_PathFragment"][],
	paths:ModelTypes["_PathFragment"][],
	type:ModelTypes["_MutationErrorType"],
	message?:string
};
	["_MutationErrorType"]: GraphQLTypes["_MutationErrorType"];
	["ContentBlockDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"]
};
	["ContentBlockUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"]
};
	["ImageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"]
};
	["LinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"]
};
	["SeoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"]
};
	["HomePageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"]
};
	["LinkableUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumGalleryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediumGallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumGalleryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediumGallery"]
};
	["MediumGalleryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediumGallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumGalleryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediumGallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumGalleryItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediumGalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumGalleryItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediumGalleryItem"]
};
	["MediumGalleryItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediumGalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumGalleryItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediumGalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["MemberCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Member"],
	validation:ModelTypes["_ValidationResult"]
};
	["MemberDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Member"]
};
	["MemberUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Member"],
	validation:ModelTypes["_ValidationResult"]
};
	["MemberUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Member"],
	validation:ModelTypes["_ValidationResult"]
};
	["MemberItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MemberItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["MemberItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MemberItem"]
};
	["MemberItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MemberItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["MemberItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MemberItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["MemberListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MemberList"],
	validation:ModelTypes["_ValidationResult"]
};
	["MemberListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MemberList"]
};
	["MemberListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MemberList"],
	validation:ModelTypes["_ValidationResult"]
};
	["MemberListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MemberList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Show"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Show"]
};
	["ShowUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Show"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Show"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowList"]
};
	["ShowListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowYearCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowYear"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowYearDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowYear"]
};
	["ShowYearUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowYear"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowYearUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowYear"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowYearItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowYearItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowYearItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowYearItem"]
};
	["ShowYearItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowYearItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowYearItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowYearItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowYearListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowYearList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowYearListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowYearList"]
};
	["ShowYearListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowYearList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowYearListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowYearList"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLink"]
};
	["SocialLinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkItem"]
};
	["SocialLinkItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkList"]
};
	["SocialLinkListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["SocialLinkListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SocialLinkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["VideoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Video"],
	validation:ModelTypes["_ValidationResult"]
};
	["VideoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Video"]
};
	["VideoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Video"],
	validation:ModelTypes["_ValidationResult"]
};
	["VideoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Video"],
	validation:ModelTypes["_ValidationResult"]
};
	["YoutubeVideoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["YoutubeVideo"],
	validation:ModelTypes["_ValidationResult"]
};
	["YoutubeVideoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["YoutubeVideo"]
};
	["YoutubeVideoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["YoutubeVideo"],
	validation:ModelTypes["_ValidationResult"]
};
	["YoutubeVideoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["YoutubeVideo"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"]
};
	["HeaderUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"]
};
	["FooterUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterAddressCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterAddress"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterAddressDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterAddress"]
};
	["FooterAddressUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterAddress"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterAddressUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterAddress"],
	validation:ModelTypes["_ValidationResult"]
};
	["PortfolioPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PortfolioPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["PortfolioPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PortfolioPage"]
};
	["PortfolioPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PortfolioPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["PortfolioPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PortfolioPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowItem"]
};
	["ShowItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ShowItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ShowItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["SettingsCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Settings"],
	validation:ModelTypes["_ValidationResult"]
};
	["SettingsDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Settings"]
};
	["SettingsUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Settings"],
	validation:ModelTypes["_ValidationResult"]
};
	["SettingsUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Settings"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterGeneralContactCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterGeneralContact"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterGeneralContactDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterGeneralContact"]
};
	["FooterGeneralContactUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterGeneralContact"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterGeneralContactUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterGeneralContact"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"]
};
	["RedirectUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	validation:ModelTypes["_ValidationResult"],
	createContentBlock:ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock:ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock:ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock:ModelTypes["ContentBlockUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createHomePage:ModelTypes["HomePageCreateResult"],
	deleteHomePage:ModelTypes["HomePageDeleteResult"],
	updateHomePage:ModelTypes["HomePageUpdateResult"],
	upsertHomePage:ModelTypes["HomePageUpsertResult"],
	createLinkable:ModelTypes["LinkableCreateResult"],
	deleteLinkable:ModelTypes["LinkableDeleteResult"],
	updateLinkable:ModelTypes["LinkableUpdateResult"],
	upsertLinkable:ModelTypes["LinkableUpsertResult"],
	createMediumGallery:ModelTypes["MediumGalleryCreateResult"],
	deleteMediumGallery:ModelTypes["MediumGalleryDeleteResult"],
	updateMediumGallery:ModelTypes["MediumGalleryUpdateResult"],
	upsertMediumGallery:ModelTypes["MediumGalleryUpsertResult"],
	createMediumGalleryItem:ModelTypes["MediumGalleryItemCreateResult"],
	deleteMediumGalleryItem:ModelTypes["MediumGalleryItemDeleteResult"],
	updateMediumGalleryItem:ModelTypes["MediumGalleryItemUpdateResult"],
	upsertMediumGalleryItem:ModelTypes["MediumGalleryItemUpsertResult"],
	createMember:ModelTypes["MemberCreateResult"],
	deleteMember:ModelTypes["MemberDeleteResult"],
	updateMember:ModelTypes["MemberUpdateResult"],
	upsertMember:ModelTypes["MemberUpsertResult"],
	createMemberItem:ModelTypes["MemberItemCreateResult"],
	deleteMemberItem:ModelTypes["MemberItemDeleteResult"],
	updateMemberItem:ModelTypes["MemberItemUpdateResult"],
	upsertMemberItem:ModelTypes["MemberItemUpsertResult"],
	createMemberList:ModelTypes["MemberListCreateResult"],
	deleteMemberList:ModelTypes["MemberListDeleteResult"],
	updateMemberList:ModelTypes["MemberListUpdateResult"],
	upsertMemberList:ModelTypes["MemberListUpsertResult"],
	createShow:ModelTypes["ShowCreateResult"],
	deleteShow:ModelTypes["ShowDeleteResult"],
	updateShow:ModelTypes["ShowUpdateResult"],
	upsertShow:ModelTypes["ShowUpsertResult"],
	createShowList:ModelTypes["ShowListCreateResult"],
	deleteShowList:ModelTypes["ShowListDeleteResult"],
	updateShowList:ModelTypes["ShowListUpdateResult"],
	upsertShowList:ModelTypes["ShowListUpsertResult"],
	createShowYear:ModelTypes["ShowYearCreateResult"],
	deleteShowYear:ModelTypes["ShowYearDeleteResult"],
	updateShowYear:ModelTypes["ShowYearUpdateResult"],
	upsertShowYear:ModelTypes["ShowYearUpsertResult"],
	createShowYearItem:ModelTypes["ShowYearItemCreateResult"],
	deleteShowYearItem:ModelTypes["ShowYearItemDeleteResult"],
	updateShowYearItem:ModelTypes["ShowYearItemUpdateResult"],
	upsertShowYearItem:ModelTypes["ShowYearItemUpsertResult"],
	createShowYearList:ModelTypes["ShowYearListCreateResult"],
	deleteShowYearList:ModelTypes["ShowYearListDeleteResult"],
	updateShowYearList:ModelTypes["ShowYearListUpdateResult"],
	upsertShowYearList:ModelTypes["ShowYearListUpsertResult"],
	createSocialLink:ModelTypes["SocialLinkCreateResult"],
	deleteSocialLink:ModelTypes["SocialLinkDeleteResult"],
	updateSocialLink:ModelTypes["SocialLinkUpdateResult"],
	upsertSocialLink:ModelTypes["SocialLinkUpsertResult"],
	createSocialLinkItem:ModelTypes["SocialLinkItemCreateResult"],
	deleteSocialLinkItem:ModelTypes["SocialLinkItemDeleteResult"],
	updateSocialLinkItem:ModelTypes["SocialLinkItemUpdateResult"],
	upsertSocialLinkItem:ModelTypes["SocialLinkItemUpsertResult"],
	createSocialLinkList:ModelTypes["SocialLinkListCreateResult"],
	deleteSocialLinkList:ModelTypes["SocialLinkListDeleteResult"],
	updateSocialLinkList:ModelTypes["SocialLinkListUpdateResult"],
	upsertSocialLinkList:ModelTypes["SocialLinkListUpsertResult"],
	createVideo:ModelTypes["VideoCreateResult"],
	deleteVideo:ModelTypes["VideoDeleteResult"],
	updateVideo:ModelTypes["VideoUpdateResult"],
	upsertVideo:ModelTypes["VideoUpsertResult"],
	createYoutubeVideo:ModelTypes["YoutubeVideoCreateResult"],
	deleteYoutubeVideo:ModelTypes["YoutubeVideoDeleteResult"],
	updateYoutubeVideo:ModelTypes["YoutubeVideoUpdateResult"],
	upsertYoutubeVideo:ModelTypes["YoutubeVideoUpsertResult"],
	createHeader:ModelTypes["HeaderCreateResult"],
	deleteHeader:ModelTypes["HeaderDeleteResult"],
	updateHeader:ModelTypes["HeaderUpdateResult"],
	upsertHeader:ModelTypes["HeaderUpsertResult"],
	createFooter:ModelTypes["FooterCreateResult"],
	deleteFooter:ModelTypes["FooterDeleteResult"],
	updateFooter:ModelTypes["FooterUpdateResult"],
	upsertFooter:ModelTypes["FooterUpsertResult"],
	createFooterAddress:ModelTypes["FooterAddressCreateResult"],
	deleteFooterAddress:ModelTypes["FooterAddressDeleteResult"],
	updateFooterAddress:ModelTypes["FooterAddressUpdateResult"],
	upsertFooterAddress:ModelTypes["FooterAddressUpsertResult"],
	createPortfolioPage:ModelTypes["PortfolioPageCreateResult"],
	deletePortfolioPage:ModelTypes["PortfolioPageDeleteResult"],
	updatePortfolioPage:ModelTypes["PortfolioPageUpdateResult"],
	upsertPortfolioPage:ModelTypes["PortfolioPageUpsertResult"],
	createShowItem:ModelTypes["ShowItemCreateResult"],
	deleteShowItem:ModelTypes["ShowItemDeleteResult"],
	updateShowItem:ModelTypes["ShowItemUpdateResult"],
	upsertShowItem:ModelTypes["ShowItemUpsertResult"],
	createSettings:ModelTypes["SettingsCreateResult"],
	deleteSettings:ModelTypes["SettingsDeleteResult"],
	updateSettings:ModelTypes["SettingsUpdateResult"],
	upsertSettings:ModelTypes["SettingsUpsertResult"],
	createFooterGeneralContact:ModelTypes["FooterGeneralContactCreateResult"],
	deleteFooterGeneralContact:ModelTypes["FooterGeneralContactDeleteResult"],
	updateFooterGeneralContact:ModelTypes["FooterGeneralContactUpdateResult"],
	upsertFooterGeneralContact:ModelTypes["FooterGeneralContactUpsertResult"],
	createRedirect:ModelTypes["RedirectCreateResult"],
	deleteRedirect:ModelTypes["RedirectDeleteResult"],
	updateRedirect:ModelTypes["RedirectUpdateResult"],
	upsertRedirect:ModelTypes["RedirectUpsertResult"],
	query?:ModelTypes["Query"]
};
	["MutationTransactionOptions"]: GraphQLTypes["MutationTransactionOptions"];
	["Json"]:any;
	["_Schema"]: {
		enums:ModelTypes["_Enum"][],
	entities:ModelTypes["_Entity"][]
};
	["_Entity"]: {
		name:string,
	customPrimaryAllowed:boolean,
	fields:ModelTypes["_Field"][],
	unique:ModelTypes["_UniqueConstraint"][]
};
	["_UniqueConstraint"]: {
		fields:string[]
};
	["_Field"]: ModelTypes["_Column"] | ModelTypes["_Relation"];
	["_Column"]: {
		name:string,
	type:string,
	enumName?:string,
	defaultValue?:ModelTypes["Json"],
	nullable:boolean,
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_OnDeleteBehaviour"]: GraphQLTypes["_OnDeleteBehaviour"];
	["_RelationSide"]: GraphQLTypes["_RelationSide"];
	["_OrderByDirection"]: GraphQLTypes["_OrderByDirection"];
	["_OrderBy"]: {
		path:string[],
	direction:ModelTypes["_OrderByDirection"]
};
	["_Relation"]: {
		name:string,
	type:string,
	side:ModelTypes["_RelationSide"],
	targetEntity:string,
	ownedBy?:string,
	inversedBy?:string,
	nullable?:boolean,
	onDelete?:ModelTypes["_OnDeleteBehaviour"],
	orphanRemoval?:boolean,
	orderBy?:ModelTypes["_OrderBy"][],
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_Rule"]: {
		message?:ModelTypes["_RuleMessage"],
	validator:number
};
	["_Validator"]: {
		operation:string,
	arguments:ModelTypes["_Argument"][]
};
	["_Argument"]:ModelTypes["_ValidatorArgument"] | ModelTypes["_PathArgument"] | ModelTypes["_LiteralArgument"];
	["_ValidatorArgument"]: {
		validator:number
};
	["_PathArgument"]: {
		path:string[]
};
	["_LiteralArgument"]: {
		value?:ModelTypes["Json"]
};
	["_RuleMessage"]: {
		text?:string
};
	["_Enum"]: {
		name:string,
	values:string[]
};
	["S3SignedUpload"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	/** Allowed patterns:
** */
	objectKey:string,
	bucket:string,
	publicUrl:string
};
	["S3Header"]: {
		key:string,
	value:string
};
	["S3SignedRead"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	/** Allowed patterns:
** */
	objectKey:string,
	bucket:string
}
    }

export type GraphQLTypes = {
    ["Query"]: {
	__typename: "Query",
	getContentBlock?: GraphQLTypes["ContentBlock"],
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getHomePage?: GraphQLTypes["HomePage"],
	listHomePage: Array<GraphQLTypes["HomePage"]>,
	paginateHomePage: GraphQLTypes["HomePageConnection"],
	validateCreateHomePage: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePage: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"],
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getMediumGallery?: GraphQLTypes["MediumGallery"],
	listMediumGallery: Array<GraphQLTypes["MediumGallery"]>,
	paginateMediumGallery: GraphQLTypes["MediumGalleryConnection"],
	validateCreateMediumGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateMediumGallery: GraphQLTypes["_ValidationResult"],
	getMediumGalleryItem?: GraphQLTypes["MediumGalleryItem"],
	listMediumGalleryItem: Array<GraphQLTypes["MediumGalleryItem"]>,
	paginateMediumGalleryItem: GraphQLTypes["MediumGalleryItemConnection"],
	validateCreateMediumGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMediumGalleryItem: GraphQLTypes["_ValidationResult"],
	getMember?: GraphQLTypes["Member"],
	listMember: Array<GraphQLTypes["Member"]>,
	paginateMember: GraphQLTypes["MemberConnection"],
	validateCreateMember: GraphQLTypes["_ValidationResult"],
	validateUpdateMember: GraphQLTypes["_ValidationResult"],
	getMemberItem?: GraphQLTypes["MemberItem"],
	listMemberItem: Array<GraphQLTypes["MemberItem"]>,
	paginateMemberItem: GraphQLTypes["MemberItemConnection"],
	validateCreateMemberItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMemberItem: GraphQLTypes["_ValidationResult"],
	getMemberList?: GraphQLTypes["MemberList"],
	listMemberList: Array<GraphQLTypes["MemberList"]>,
	paginateMemberList: GraphQLTypes["MemberListConnection"],
	validateCreateMemberList: GraphQLTypes["_ValidationResult"],
	validateUpdateMemberList: GraphQLTypes["_ValidationResult"],
	getShow?: GraphQLTypes["Show"],
	listShow: Array<GraphQLTypes["Show"]>,
	paginateShow: GraphQLTypes["ShowConnection"],
	validateCreateShow: GraphQLTypes["_ValidationResult"],
	validateUpdateShow: GraphQLTypes["_ValidationResult"],
	getShowList?: GraphQLTypes["ShowList"],
	listShowList: Array<GraphQLTypes["ShowList"]>,
	paginateShowList: GraphQLTypes["ShowListConnection"],
	validateCreateShowList: GraphQLTypes["_ValidationResult"],
	validateUpdateShowList: GraphQLTypes["_ValidationResult"],
	getShowYear?: GraphQLTypes["ShowYear"],
	listShowYear: Array<GraphQLTypes["ShowYear"]>,
	paginateShowYear: GraphQLTypes["ShowYearConnection"],
	validateCreateShowYear: GraphQLTypes["_ValidationResult"],
	validateUpdateShowYear: GraphQLTypes["_ValidationResult"],
	getShowYearItem?: GraphQLTypes["ShowYearItem"],
	listShowYearItem: Array<GraphQLTypes["ShowYearItem"]>,
	paginateShowYearItem: GraphQLTypes["ShowYearItemConnection"],
	validateCreateShowYearItem: GraphQLTypes["_ValidationResult"],
	validateUpdateShowYearItem: GraphQLTypes["_ValidationResult"],
	getShowYearList?: GraphQLTypes["ShowYearList"],
	listShowYearList: Array<GraphQLTypes["ShowYearList"]>,
	paginateShowYearList: GraphQLTypes["ShowYearListConnection"],
	validateCreateShowYearList: GraphQLTypes["_ValidationResult"],
	validateUpdateShowYearList: GraphQLTypes["_ValidationResult"],
	getSocialLink?: GraphQLTypes["SocialLink"],
	listSocialLink: Array<GraphQLTypes["SocialLink"]>,
	paginateSocialLink: GraphQLTypes["SocialLinkConnection"],
	validateCreateSocialLink: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLink: GraphQLTypes["_ValidationResult"],
	getSocialLinkItem?: GraphQLTypes["SocialLinkItem"],
	listSocialLinkItem: Array<GraphQLTypes["SocialLinkItem"]>,
	paginateSocialLinkItem: GraphQLTypes["SocialLinkItemConnection"],
	validateCreateSocialLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLinkItem: GraphQLTypes["_ValidationResult"],
	getSocialLinkList?: GraphQLTypes["SocialLinkList"],
	listSocialLinkList: Array<GraphQLTypes["SocialLinkList"]>,
	paginateSocialLinkList: GraphQLTypes["SocialLinkListConnection"],
	validateCreateSocialLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLinkList: GraphQLTypes["_ValidationResult"],
	getVideo?: GraphQLTypes["Video"],
	listVideo: Array<GraphQLTypes["Video"]>,
	paginateVideo: GraphQLTypes["VideoConnection"],
	validateCreateVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateVideo: GraphQLTypes["_ValidationResult"],
	getYoutubeVideo?: GraphQLTypes["YoutubeVideo"],
	listYoutubeVideo: Array<GraphQLTypes["YoutubeVideo"]>,
	paginateYoutubeVideo: GraphQLTypes["YoutubeVideoConnection"],
	validateCreateYoutubeVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateYoutubeVideo: GraphQLTypes["_ValidationResult"],
	getHeader?: GraphQLTypes["Header"],
	listHeader: Array<GraphQLTypes["Header"]>,
	paginateHeader: GraphQLTypes["HeaderConnection"],
	validateCreateHeader: GraphQLTypes["_ValidationResult"],
	validateUpdateHeader: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"],
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getFooterAddress?: GraphQLTypes["FooterAddress"],
	listFooterAddress: Array<GraphQLTypes["FooterAddress"]>,
	paginateFooterAddress: GraphQLTypes["FooterAddressConnection"],
	validateCreateFooterAddress: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterAddress: GraphQLTypes["_ValidationResult"],
	getPortfolioPage?: GraphQLTypes["PortfolioPage"],
	listPortfolioPage: Array<GraphQLTypes["PortfolioPage"]>,
	paginatePortfolioPage: GraphQLTypes["PortfolioPageConnection"],
	validateCreatePortfolioPage: GraphQLTypes["_ValidationResult"],
	validateUpdatePortfolioPage: GraphQLTypes["_ValidationResult"],
	getShowItem?: GraphQLTypes["ShowItem"],
	listShowItem: Array<GraphQLTypes["ShowItem"]>,
	paginateShowItem: GraphQLTypes["ShowItemConnection"],
	validateCreateShowItem: GraphQLTypes["_ValidationResult"],
	validateUpdateShowItem: GraphQLTypes["_ValidationResult"],
	getSettings?: GraphQLTypes["Settings"],
	listSettings: Array<GraphQLTypes["Settings"]>,
	paginateSettings: GraphQLTypes["SettingsConnection"],
	validateCreateSettings: GraphQLTypes["_ValidationResult"],
	validateUpdateSettings: GraphQLTypes["_ValidationResult"],
	getFooterGeneralContact?: GraphQLTypes["FooterGeneralContact"],
	listFooterGeneralContact: Array<GraphQLTypes["FooterGeneralContact"]>,
	paginateFooterGeneralContact: GraphQLTypes["FooterGeneralContactConnection"],
	validateCreateFooterGeneralContact: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterGeneralContact: GraphQLTypes["_ValidationResult"],
	getRedirect?: GraphQLTypes["Redirect"],
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"],
	transaction?: GraphQLTypes["QueryTransaction"],
	_info?: GraphQLTypes["Info"],
	schema?: GraphQLTypes["_Schema"],
	s3DummyQuery?: string
};
	["ContentBlock"]: {
	__typename: "ContentBlock",
	_meta?: GraphQLTypes["ContentBlockMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	type: GraphQLTypes["ContentBlockType"],
	primaryText?: string,
	secondaryText?: string,
	homePage?: GraphQLTypes["HomePage"],
	gallery?: GraphQLTypes["MediumGallery"],
	video?: GraphQLTypes["Video"],
	link?: GraphQLTypes["Link"],
	members?: GraphQLTypes["MemberList"],
	portfolio?: GraphQLTypes["ShowYearList"]
};
	["ContentBlockMeta"]: {
	__typename: "ContentBlockMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	primaryText?: GraphQLTypes["FieldMeta"],
	secondaryText?: GraphQLTypes["FieldMeta"],
	homePage?: GraphQLTypes["FieldMeta"],
	gallery?: GraphQLTypes["FieldMeta"],
	video?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	members?: GraphQLTypes["FieldMeta"],
	portfolio?: GraphQLTypes["FieldMeta"]
};
	["FieldMeta"]: {
	__typename: "FieldMeta",
	readable?: boolean,
	updatable?: boolean
};
	["UUID"]:string;
	["ContentBlockType"]: ContentBlockType;
	["HomePage"]: {
	__typename: "HomePage",
	_meta?: GraphQLTypes["HomePageMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	link?: GraphQLTypes["Linkable"],
	seo?: GraphQLTypes["Seo"],
	unique: GraphQLTypes["One"],
	blocks: Array<GraphQLTypes["ContentBlock"]>,
	blocksByGallery?: GraphQLTypes["ContentBlock"],
	blocksByLink?: GraphQLTypes["ContentBlock"],
	blocksByMembers?: GraphQLTypes["ContentBlock"],
	paginateBlocks: GraphQLTypes["ContentBlockConnection"]
};
	["HomePageMeta"]: {
	__typename: "HomePageMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	blocks?: GraphQLTypes["FieldMeta"]
};
	["Linkable"]: {
	__typename: "Linkable",
	_meta?: GraphQLTypes["LinkableMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	homePage?: GraphQLTypes["HomePage"],
	portfolioPage?: GraphQLTypes["PortfolioPage"],
	showPage?: GraphQLTypes["Show"],
	redirect?: GraphQLTypes["Redirect"]
};
	["LinkableMeta"]: {
	__typename: "LinkableMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	homePage?: GraphQLTypes["FieldMeta"],
	portfolioPage?: GraphQLTypes["FieldMeta"],
	showPage?: GraphQLTypes["FieldMeta"],
	redirect?: GraphQLTypes["FieldMeta"]
};
	["HomePageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	unique?: GraphQLTypes["OneCondition"],
	blocks?: GraphQLTypes["ContentBlockWhere"],
	and?: Array<GraphQLTypes["HomePageWhere"] | undefined>,
	or?: Array<GraphQLTypes["HomePageWhere"] | undefined>,
	not?: GraphQLTypes["HomePageWhere"]
};
	["UUIDCondition"]: {
		and?: Array<GraphQLTypes["UUIDCondition"]>,
	or?: Array<GraphQLTypes["UUIDCondition"]>,
	not?: GraphQLTypes["UUIDCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["UUID"],
	notEq?: GraphQLTypes["UUID"],
	in?: Array<GraphQLTypes["UUID"]>,
	notIn?: Array<GraphQLTypes["UUID"]>,
	lt?: GraphQLTypes["UUID"],
	lte?: GraphQLTypes["UUID"],
	gt?: GraphQLTypes["UUID"],
	gte?: GraphQLTypes["UUID"]
};
	["StringCondition"]: {
		and?: Array<GraphQLTypes["StringCondition"]>,
	or?: Array<GraphQLTypes["StringCondition"]>,
	not?: GraphQLTypes["StringCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: string,
	notEq?: string,
	in?: Array<string>,
	notIn?: Array<string>,
	lt?: string,
	lte?: string,
	gt?: string,
	gte?: string,
	contains?: string,
	startsWith?: string,
	endsWith?: string,
	containsCI?: string,
	startsWithCI?: string,
	endsWithCI?: string
};
	["LinkableWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	homePage?: GraphQLTypes["HomePageWhere"],
	portfolioPage?: GraphQLTypes["PortfolioPageWhere"],
	showPage?: GraphQLTypes["ShowWhere"],
	redirect?: GraphQLTypes["RedirectWhere"],
	and?: Array<GraphQLTypes["LinkableWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkableWhere"] | undefined>,
	not?: GraphQLTypes["LinkableWhere"]
};
	["PortfolioPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	unique?: GraphQLTypes["OneCondition"],
	title?: GraphQLTypes["StringCondition"],
	text?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["PortfolioPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["PortfolioPageWhere"] | undefined>,
	not?: GraphQLTypes["PortfolioPageWhere"]
};
	["SeoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	description?: GraphQLTypes["StringCondition"],
	ogTitle?: GraphQLTypes["StringCondition"],
	ogDescription?: GraphQLTypes["StringCondition"],
	title?: GraphQLTypes["StringCondition"],
	ogImage?: GraphQLTypes["ImageWhere"],
	noIndex?: GraphQLTypes["BooleanCondition"],
	noFollow?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	or?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	not?: GraphQLTypes["SeoWhere"]
};
	["ImageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	width?: GraphQLTypes["IntCondition"],
	height?: GraphQLTypes["IntCondition"],
	size?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["StringCondition"],
	alt?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	not?: GraphQLTypes["ImageWhere"]
};
	["IntCondition"]: {
		and?: Array<GraphQLTypes["IntCondition"]>,
	or?: Array<GraphQLTypes["IntCondition"]>,
	not?: GraphQLTypes["IntCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: number,
	notEq?: number,
	in?: Array<number>,
	notIn?: Array<number>,
	lt?: number,
	lte?: number,
	gt?: number,
	gte?: number
};
	["BooleanCondition"]: {
		and?: Array<GraphQLTypes["BooleanCondition"]>,
	or?: Array<GraphQLTypes["BooleanCondition"]>,
	not?: GraphQLTypes["BooleanCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: boolean,
	notEq?: boolean,
	in?: Array<boolean>,
	notIn?: Array<boolean>,
	lt?: boolean,
	lte?: boolean,
	gt?: boolean,
	gte?: boolean
};
	["OneCondition"]: {
		and?: Array<GraphQLTypes["OneCondition"]>,
	or?: Array<GraphQLTypes["OneCondition"]>,
	not?: GraphQLTypes["OneCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["One"],
	notEq?: GraphQLTypes["One"],
	in?: Array<GraphQLTypes["One"]>,
	notIn?: Array<GraphQLTypes["One"]>,
	lt?: GraphQLTypes["One"],
	lte?: GraphQLTypes["One"],
	gt?: GraphQLTypes["One"],
	gte?: GraphQLTypes["One"]
};
	["One"]: One;
	["ShowWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	description?: GraphQLTypes["StringCondition"],
	posterType?: GraphQLTypes["ShowPosterTypeCondition"],
	poster?: GraphQLTypes["ImageWhere"],
	showItem?: GraphQLTypes["ShowItemWhere"],
	posterSizeType?: GraphQLTypes["ShowPosterSizeTypeCondition"],
	categoryYear?: GraphQLTypes["ShowYearWhere"],
	production?: GraphQLTypes["StringCondition"],
	directors?: GraphQLTypes["StringCondition"],
	starrings?: GraphQLTypes["StringCondition"],
	gallery?: GraphQLTypes["MediumGalleryWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	link?: GraphQLTypes["LinkableWhere"],
	synopsis?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ShowWhere"] | undefined>,
	or?: Array<GraphQLTypes["ShowWhere"] | undefined>,
	not?: GraphQLTypes["ShowWhere"]
};
	["ShowPosterTypeCondition"]: {
		and?: Array<GraphQLTypes["ShowPosterTypeCondition"]>,
	or?: Array<GraphQLTypes["ShowPosterTypeCondition"]>,
	not?: GraphQLTypes["ShowPosterTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ShowPosterType"],
	notEq?: GraphQLTypes["ShowPosterType"],
	in?: Array<GraphQLTypes["ShowPosterType"]>,
	notIn?: Array<GraphQLTypes["ShowPosterType"]>,
	lt?: GraphQLTypes["ShowPosterType"],
	lte?: GraphQLTypes["ShowPosterType"],
	gt?: GraphQLTypes["ShowPosterType"],
	gte?: GraphQLTypes["ShowPosterType"]
};
	["ShowPosterType"]: ShowPosterType;
	["ShowItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["ShowListWhere"],
	show?: GraphQLTypes["ShowWhere"],
	and?: Array<GraphQLTypes["ShowItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["ShowItemWhere"] | undefined>,
	not?: GraphQLTypes["ShowItemWhere"]
};
	["ShowListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["ShowItemWhere"],
	and?: Array<GraphQLTypes["ShowListWhere"] | undefined>,
	or?: Array<GraphQLTypes["ShowListWhere"] | undefined>,
	not?: GraphQLTypes["ShowListWhere"]
};
	["ShowPosterSizeTypeCondition"]: {
		and?: Array<GraphQLTypes["ShowPosterSizeTypeCondition"]>,
	or?: Array<GraphQLTypes["ShowPosterSizeTypeCondition"]>,
	not?: GraphQLTypes["ShowPosterSizeTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ShowPosterSizeType"],
	notEq?: GraphQLTypes["ShowPosterSizeType"],
	in?: Array<GraphQLTypes["ShowPosterSizeType"]>,
	notIn?: Array<GraphQLTypes["ShowPosterSizeType"]>,
	lt?: GraphQLTypes["ShowPosterSizeType"],
	lte?: GraphQLTypes["ShowPosterSizeType"],
	gt?: GraphQLTypes["ShowPosterSizeType"],
	gte?: GraphQLTypes["ShowPosterSizeType"]
};
	["ShowPosterSizeType"]: ShowPosterSizeType;
	["ShowYearWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	name?: GraphQLTypes["StringCondition"],
	showList?: GraphQLTypes["ShowWhere"],
	and?: Array<GraphQLTypes["ShowYearWhere"] | undefined>,
	or?: Array<GraphQLTypes["ShowYearWhere"] | undefined>,
	not?: GraphQLTypes["ShowYearWhere"]
};
	["MediumGalleryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["MediumGalleryItemWhere"],
	and?: Array<GraphQLTypes["MediumGalleryWhere"] | undefined>,
	or?: Array<GraphQLTypes["MediumGalleryWhere"] | undefined>,
	not?: GraphQLTypes["MediumGalleryWhere"]
};
	["MediumGalleryItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["MediumTypeCondition"],
	gallery?: GraphQLTypes["MediumGalleryWhere"],
	image?: GraphQLTypes["ImageWhere"],
	video?: GraphQLTypes["VideoWhere"],
	and?: Array<GraphQLTypes["MediumGalleryItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["MediumGalleryItemWhere"] | undefined>,
	not?: GraphQLTypes["MediumGalleryItemWhere"]
};
	["MediumTypeCondition"]: {
		and?: Array<GraphQLTypes["MediumTypeCondition"]>,
	or?: Array<GraphQLTypes["MediumTypeCondition"]>,
	not?: GraphQLTypes["MediumTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["MediumType"],
	notEq?: GraphQLTypes["MediumType"],
	in?: Array<GraphQLTypes["MediumType"]>,
	notIn?: Array<GraphQLTypes["MediumType"]>,
	lt?: GraphQLTypes["MediumType"],
	lte?: GraphQLTypes["MediumType"],
	gt?: GraphQLTypes["MediumType"],
	gte?: GraphQLTypes["MediumType"]
};
	["MediumType"]: MediumType;
	["VideoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	src?: GraphQLTypes["StringCondition"],
	width?: GraphQLTypes["IntCondition"],
	height?: GraphQLTypes["IntCondition"],
	size?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["StringCondition"],
	duration?: GraphQLTypes["FloatCondition"],
	poster?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["VideoWhere"] | undefined>,
	or?: Array<GraphQLTypes["VideoWhere"] | undefined>,
	not?: GraphQLTypes["VideoWhere"]
};
	["FloatCondition"]: {
		and?: Array<GraphQLTypes["FloatCondition"]>,
	or?: Array<GraphQLTypes["FloatCondition"]>,
	not?: GraphQLTypes["FloatCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: number,
	notEq?: number,
	in?: Array<number>,
	notIn?: Array<number>,
	lt?: number,
	lte?: number,
	gt?: number,
	gte?: number
};
	["RedirectWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	target?: GraphQLTypes["LinkableWhere"],
	and?: Array<GraphQLTypes["RedirectWhere"] | undefined>,
	or?: Array<GraphQLTypes["RedirectWhere"] | undefined>,
	not?: GraphQLTypes["RedirectWhere"]
};
	["ContentBlockWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["ContentBlockTypeCondition"],
	primaryText?: GraphQLTypes["StringCondition"],
	secondaryText?: GraphQLTypes["StringCondition"],
	homePage?: GraphQLTypes["HomePageWhere"],
	gallery?: GraphQLTypes["MediumGalleryWhere"],
	video?: GraphQLTypes["VideoWhere"],
	link?: GraphQLTypes["LinkWhere"],
	members?: GraphQLTypes["MemberListWhere"],
	portfolio?: GraphQLTypes["ShowYearListWhere"],
	and?: Array<GraphQLTypes["ContentBlockWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentBlockWhere"] | undefined>,
	not?: GraphQLTypes["ContentBlockWhere"]
};
	["ContentBlockTypeCondition"]: {
		and?: Array<GraphQLTypes["ContentBlockTypeCondition"]>,
	or?: Array<GraphQLTypes["ContentBlockTypeCondition"]>,
	not?: GraphQLTypes["ContentBlockTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ContentBlockType"],
	notEq?: GraphQLTypes["ContentBlockType"],
	in?: Array<GraphQLTypes["ContentBlockType"]>,
	notIn?: Array<GraphQLTypes["ContentBlockType"]>,
	lt?: GraphQLTypes["ContentBlockType"],
	lte?: GraphQLTypes["ContentBlockType"],
	gt?: GraphQLTypes["ContentBlockType"],
	gte?: GraphQLTypes["ContentBlockType"]
};
	["LinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["LinkTypeCondition"],
	title?: GraphQLTypes["StringCondition"],
	externalLink?: GraphQLTypes["StringCondition"],
	internalLink?: GraphQLTypes["LinkableWhere"],
	and?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	not?: GraphQLTypes["LinkWhere"]
};
	["LinkTypeCondition"]: {
		and?: Array<GraphQLTypes["LinkTypeCondition"]>,
	or?: Array<GraphQLTypes["LinkTypeCondition"]>,
	not?: GraphQLTypes["LinkTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["LinkType"],
	notEq?: GraphQLTypes["LinkType"],
	in?: Array<GraphQLTypes["LinkType"]>,
	notIn?: Array<GraphQLTypes["LinkType"]>,
	lt?: GraphQLTypes["LinkType"],
	lte?: GraphQLTypes["LinkType"],
	gt?: GraphQLTypes["LinkType"],
	gte?: GraphQLTypes["LinkType"]
};
	["LinkType"]: LinkType;
	["MemberListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["MemberItemWhere"],
	and?: Array<GraphQLTypes["MemberListWhere"] | undefined>,
	or?: Array<GraphQLTypes["MemberListWhere"] | undefined>,
	not?: GraphQLTypes["MemberListWhere"]
};
	["MemberItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["MemberListWhere"],
	member?: GraphQLTypes["MemberWhere"],
	and?: Array<GraphQLTypes["MemberItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["MemberItemWhere"] | undefined>,
	not?: GraphQLTypes["MemberItemWhere"]
};
	["MemberWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	firstName?: GraphQLTypes["StringCondition"],
	lastName?: GraphQLTypes["StringCondition"],
	position?: GraphQLTypes["StringCondition"],
	email?: GraphQLTypes["StringCondition"],
	telephone?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["MemberWhere"] | undefined>,
	or?: Array<GraphQLTypes["MemberWhere"] | undefined>,
	not?: GraphQLTypes["MemberWhere"]
};
	["ShowYearListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["ShowYearItemWhere"],
	and?: Array<GraphQLTypes["ShowYearListWhere"] | undefined>,
	or?: Array<GraphQLTypes["ShowYearListWhere"] | undefined>,
	not?: GraphQLTypes["ShowYearListWhere"]
};
	["ShowYearItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["ShowYearListWhere"],
	showYear?: GraphQLTypes["ShowYearWhere"],
	and?: Array<GraphQLTypes["ShowYearItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["ShowYearItemWhere"] | undefined>,
	not?: GraphQLTypes["ShowYearItemWhere"]
};
	["PortfolioPage"]: {
	__typename: "PortfolioPage",
	_meta?: GraphQLTypes["PortfolioPageMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	link?: GraphQLTypes["Linkable"],
	seo?: GraphQLTypes["Seo"],
	unique: GraphQLTypes["One"],
	title?: string,
	text?: string
};
	["PortfolioPageMeta"]: {
	__typename: "PortfolioPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"]
};
	["Seo"]: {
	__typename: "Seo",
	_meta?: GraphQLTypes["SeoMeta"],
	id: GraphQLTypes["UUID"],
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	title?: string,
	ogImage?: GraphQLTypes["Image"],
	noIndex?: boolean,
	noFollow?: boolean
};
	["SeoMeta"]: {
	__typename: "SeoMeta",
	id?: GraphQLTypes["FieldMeta"],
	description?: GraphQLTypes["FieldMeta"],
	ogTitle?: GraphQLTypes["FieldMeta"],
	ogDescription?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	ogImage?: GraphQLTypes["FieldMeta"],
	noIndex?: GraphQLTypes["FieldMeta"],
	noFollow?: GraphQLTypes["FieldMeta"]
};
	["Image"]: {
	__typename: "Image",
	_meta?: GraphQLTypes["ImageMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string
};
	["ImageMeta"]: {
	__typename: "ImageMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	width?: GraphQLTypes["FieldMeta"],
	height?: GraphQLTypes["FieldMeta"],
	size?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	alt?: GraphQLTypes["FieldMeta"]
};
	["Show"]: {
	__typename: "Show",
	_meta?: GraphQLTypes["ShowMeta"],
	id: GraphQLTypes["UUID"],
	title: string,
	description?: string,
	posterType: GraphQLTypes["ShowPosterType"],
	poster?: GraphQLTypes["Image"],
	showItem: Array<GraphQLTypes["ShowItem"]>,
	posterSizeType: GraphQLTypes["ShowPosterSizeType"],
	categoryYear?: GraphQLTypes["ShowYear"],
	production?: string,
	directors?: string,
	starrings?: string,
	gallery?: GraphQLTypes["MediumGallery"],
	seo?: GraphQLTypes["Seo"],
	link?: GraphQLTypes["Linkable"],
	synopsis?: string,
	paginateShowItem: GraphQLTypes["ShowItemConnection"]
};
	["ShowMeta"]: {
	__typename: "ShowMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	description?: GraphQLTypes["FieldMeta"],
	posterType?: GraphQLTypes["FieldMeta"],
	poster?: GraphQLTypes["FieldMeta"],
	showItem?: GraphQLTypes["FieldMeta"],
	posterSizeType?: GraphQLTypes["FieldMeta"],
	categoryYear?: GraphQLTypes["FieldMeta"],
	production?: GraphQLTypes["FieldMeta"],
	directors?: GraphQLTypes["FieldMeta"],
	starrings?: GraphQLTypes["FieldMeta"],
	gallery?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	synopsis?: GraphQLTypes["FieldMeta"]
};
	["ShowItem"]: {
	__typename: "ShowItem",
	_meta?: GraphQLTypes["ShowItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ShowList"],
	show?: GraphQLTypes["Show"]
};
	["ShowItemMeta"]: {
	__typename: "ShowItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	show?: GraphQLTypes["FieldMeta"]
};
	["ShowList"]: {
	__typename: "ShowList",
	_meta?: GraphQLTypes["ShowListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ShowItem"]>,
	paginateItems: GraphQLTypes["ShowItemConnection"]
};
	["ShowListMeta"]: {
	__typename: "ShowListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["ShowItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["ShowListOrderBy"],
	show?: GraphQLTypes["ShowOrderBy"]
};
	["OrderDirection"]: OrderDirection;
	["ShowListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["ShowOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	description?: GraphQLTypes["OrderDirection"],
	posterType?: GraphQLTypes["OrderDirection"],
	poster?: GraphQLTypes["ImageOrderBy"],
	posterSizeType?: GraphQLTypes["OrderDirection"],
	categoryYear?: GraphQLTypes["ShowYearOrderBy"],
	production?: GraphQLTypes["OrderDirection"],
	directors?: GraphQLTypes["OrderDirection"],
	starrings?: GraphQLTypes["OrderDirection"],
	gallery?: GraphQLTypes["MediumGalleryOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	link?: GraphQLTypes["LinkableOrderBy"],
	synopsis?: GraphQLTypes["OrderDirection"]
};
	["ImageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	width?: GraphQLTypes["OrderDirection"],
	height?: GraphQLTypes["OrderDirection"],
	size?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	alt?: GraphQLTypes["OrderDirection"]
};
	["ShowYearOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"]
};
	["MediumGalleryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["SeoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	description?: GraphQLTypes["OrderDirection"],
	ogTitle?: GraphQLTypes["OrderDirection"],
	ogDescription?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	ogImage?: GraphQLTypes["ImageOrderBy"],
	noIndex?: GraphQLTypes["OrderDirection"],
	noFollow?: GraphQLTypes["OrderDirection"]
};
	["LinkableOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	homePage?: GraphQLTypes["HomePageOrderBy"],
	portfolioPage?: GraphQLTypes["PortfolioPageOrderBy"],
	showPage?: GraphQLTypes["ShowOrderBy"],
	redirect?: GraphQLTypes["RedirectOrderBy"]
};
	["HomePageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	unique?: GraphQLTypes["OrderDirection"]
};
	["PortfolioPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	unique?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"]
};
	["RedirectOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	target?: GraphQLTypes["LinkableOrderBy"]
};
	["ShowItemConnection"]: {
	__typename: "ShowItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ShowItemEdge"]>
};
	["PageInfo"]: {
	__typename: "PageInfo",
	totalCount: number
};
	["ShowItemEdge"]: {
	__typename: "ShowItemEdge",
	node: GraphQLTypes["ShowItem"]
};
	["ShowYear"]: {
	__typename: "ShowYear",
	_meta?: GraphQLTypes["ShowYearMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	name: string,
	showList: Array<GraphQLTypes["Show"]>,
	showListByShowItem?: GraphQLTypes["Show"],
	showListByGallery?: GraphQLTypes["Show"],
	showListBySeo?: GraphQLTypes["Show"],
	showListByLink?: GraphQLTypes["Show"],
	paginateShowList: GraphQLTypes["ShowConnection"]
};
	["ShowYearMeta"]: {
	__typename: "ShowYearMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	showList?: GraphQLTypes["FieldMeta"]
};
	["ShowYearShowListByShowItemUniqueWhere"]: {
		showItem?: GraphQLTypes["ShowItemUniqueWhere"]
};
	["ShowItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ShowYearShowListByGalleryUniqueWhere"]: {
		gallery?: GraphQLTypes["MediumGalleryUniqueWhere"]
};
	["MediumGalleryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["MediumGalleryItemUniqueWhere"]
};
	["MediumGalleryItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ShowYearShowListBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["SeoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	ogImage?: GraphQLTypes["ImageUniqueWhere"]
};
	["ImageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ShowYearShowListByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["LinkableUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["HomePageUniqueWhere"],
	portfolioPage?: GraphQLTypes["PortfolioPageUniqueWhere"],
	showPage?: GraphQLTypes["ShowUniqueWhere"],
	redirect?: GraphQLTypes["RedirectUniqueWhere"]
};
	["HomePageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	blocks?: GraphQLTypes["ContentBlockUniqueWhere"]
};
	["ContentBlockUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	gallery?: GraphQLTypes["MediumGalleryUniqueWhere"],
	link?: GraphQLTypes["LinkUniqueWhere"],
	members?: GraphQLTypes["MemberListUniqueWhere"]
};
	["LinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["MemberListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["MemberItemUniqueWhere"]
};
	["MemberItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["PortfolioPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["ShowUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	showItem?: GraphQLTypes["ShowItemUniqueWhere"],
	gallery?: GraphQLTypes["MediumGalleryUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["RedirectUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["ShowConnection"]: {
	__typename: "ShowConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ShowEdge"]>
};
	["ShowEdge"]: {
	__typename: "ShowEdge",
	node: GraphQLTypes["Show"]
};
	["MediumGallery"]: {
	__typename: "MediumGallery",
	_meta?: GraphQLTypes["MediumGalleryMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["MediumGalleryItem"]>,
	paginateItems: GraphQLTypes["MediumGalleryItemConnection"]
};
	["MediumGalleryMeta"]: {
	__typename: "MediumGalleryMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["MediumGalleryItem"]: {
	__typename: "MediumGalleryItem",
	_meta?: GraphQLTypes["MediumGalleryItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	type?: GraphQLTypes["MediumType"],
	gallery?: GraphQLTypes["MediumGallery"],
	image?: GraphQLTypes["Image"],
	video?: GraphQLTypes["Video"]
};
	["MediumGalleryItemMeta"]: {
	__typename: "MediumGalleryItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	gallery?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	video?: GraphQLTypes["FieldMeta"]
};
	["Video"]: {
	__typename: "Video",
	_meta?: GraphQLTypes["VideoMeta"],
	id: GraphQLTypes["UUID"],
	src?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	duration?: number,
	poster?: GraphQLTypes["Image"]
};
	["VideoMeta"]: {
	__typename: "VideoMeta",
	id?: GraphQLTypes["FieldMeta"],
	src?: GraphQLTypes["FieldMeta"],
	width?: GraphQLTypes["FieldMeta"],
	height?: GraphQLTypes["FieldMeta"],
	size?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	duration?: GraphQLTypes["FieldMeta"],
	poster?: GraphQLTypes["FieldMeta"]
};
	["MediumGalleryItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	gallery?: GraphQLTypes["MediumGalleryOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"],
	video?: GraphQLTypes["VideoOrderBy"]
};
	["VideoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	src?: GraphQLTypes["OrderDirection"],
	width?: GraphQLTypes["OrderDirection"],
	height?: GraphQLTypes["OrderDirection"],
	size?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	duration?: GraphQLTypes["OrderDirection"],
	poster?: GraphQLTypes["ImageOrderBy"]
};
	["MediumGalleryItemConnection"]: {
	__typename: "MediumGalleryItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MediumGalleryItemEdge"]>
};
	["MediumGalleryItemEdge"]: {
	__typename: "MediumGalleryItemEdge",
	node: GraphQLTypes["MediumGalleryItem"]
};
	["Redirect"]: {
	__typename: "Redirect",
	_meta?: GraphQLTypes["RedirectMeta"],
	id: GraphQLTypes["UUID"],
	link?: GraphQLTypes["Linkable"],
	target?: GraphQLTypes["Linkable"]
};
	["RedirectMeta"]: {
	__typename: "RedirectMeta",
	id?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	target?: GraphQLTypes["FieldMeta"]
};
	["ContentBlockOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	primaryText?: GraphQLTypes["OrderDirection"],
	secondaryText?: GraphQLTypes["OrderDirection"],
	homePage?: GraphQLTypes["HomePageOrderBy"],
	gallery?: GraphQLTypes["MediumGalleryOrderBy"],
	video?: GraphQLTypes["VideoOrderBy"],
	link?: GraphQLTypes["LinkOrderBy"],
	members?: GraphQLTypes["MemberListOrderBy"],
	portfolio?: GraphQLTypes["ShowYearListOrderBy"]
};
	["LinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	externalLink?: GraphQLTypes["OrderDirection"],
	internalLink?: GraphQLTypes["LinkableOrderBy"]
};
	["MemberListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["ShowYearListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["HomePageBlocksByGalleryUniqueWhere"]: {
		gallery?: GraphQLTypes["MediumGalleryUniqueWhere"]
};
	["HomePageBlocksByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"]
};
	["HomePageBlocksByMembersUniqueWhere"]: {
		members?: GraphQLTypes["MemberListUniqueWhere"]
};
	["ContentBlockConnection"]: {
	__typename: "ContentBlockConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentBlockEdge"]>
};
	["ContentBlockEdge"]: {
	__typename: "ContentBlockEdge",
	node: GraphQLTypes["ContentBlock"]
};
	["Link"]: {
	__typename: "Link",
	_meta?: GraphQLTypes["LinkMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["Linkable"]
};
	["LinkMeta"]: {
	__typename: "LinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	externalLink?: GraphQLTypes["FieldMeta"],
	internalLink?: GraphQLTypes["FieldMeta"]
};
	["MemberList"]: {
	__typename: "MemberList",
	_meta?: GraphQLTypes["MemberListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["MemberItem"]>,
	paginateItems: GraphQLTypes["MemberItemConnection"]
};
	["MemberListMeta"]: {
	__typename: "MemberListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["MemberItem"]: {
	__typename: "MemberItem",
	_meta?: GraphQLTypes["MemberItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["MemberList"],
	member?: GraphQLTypes["Member"]
};
	["MemberItemMeta"]: {
	__typename: "MemberItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	member?: GraphQLTypes["FieldMeta"]
};
	["Member"]: {
	__typename: "Member",
	_meta?: GraphQLTypes["MemberMeta"],
	id: GraphQLTypes["UUID"],
	firstName?: string,
	lastName: string,
	position?: string,
	email?: string,
	telephone?: string,
	image?: GraphQLTypes["Image"]
};
	["MemberMeta"]: {
	__typename: "MemberMeta",
	id?: GraphQLTypes["FieldMeta"],
	firstName?: GraphQLTypes["FieldMeta"],
	lastName?: GraphQLTypes["FieldMeta"],
	position?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	telephone?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"]
};
	["MemberItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["MemberListOrderBy"],
	member?: GraphQLTypes["MemberOrderBy"]
};
	["MemberOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	firstName?: GraphQLTypes["OrderDirection"],
	lastName?: GraphQLTypes["OrderDirection"],
	position?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"],
	telephone?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"]
};
	["MemberItemConnection"]: {
	__typename: "MemberItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MemberItemEdge"]>
};
	["MemberItemEdge"]: {
	__typename: "MemberItemEdge",
	node: GraphQLTypes["MemberItem"]
};
	["ShowYearList"]: {
	__typename: "ShowYearList",
	_meta?: GraphQLTypes["ShowYearListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ShowYearItem"]>,
	paginateItems: GraphQLTypes["ShowYearItemConnection"]
};
	["ShowYearListMeta"]: {
	__typename: "ShowYearListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["ShowYearItem"]: {
	__typename: "ShowYearItem",
	_meta?: GraphQLTypes["ShowYearItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ShowYearList"],
	showYear?: GraphQLTypes["ShowYear"]
};
	["ShowYearItemMeta"]: {
	__typename: "ShowYearItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	showYear?: GraphQLTypes["FieldMeta"]
};
	["ShowYearItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["ShowYearListOrderBy"],
	showYear?: GraphQLTypes["ShowYearOrderBy"]
};
	["ShowYearItemConnection"]: {
	__typename: "ShowYearItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ShowYearItemEdge"]>
};
	["ShowYearItemEdge"]: {
	__typename: "ShowYearItemEdge",
	node: GraphQLTypes["ShowYearItem"]
};
	["_ValidationResult"]: {
	__typename: "_ValidationResult",
	valid: boolean,
	errors: Array<GraphQLTypes["_ValidationError"]>
};
	["_ValidationError"]: {
	__typename: "_ValidationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	message: GraphQLTypes["_ValidationMessage"]
};
	["_PathFragment"]:{
	__typename:"_FieldPathFragment" | "_IndexPathFragment"
	['...on _FieldPathFragment']: '__union' & GraphQLTypes["_FieldPathFragment"];
	['...on _IndexPathFragment']: '__union' & GraphQLTypes["_IndexPathFragment"];
};
	["_FieldPathFragment"]: {
	__typename: "_FieldPathFragment",
	field: string
};
	["_IndexPathFragment"]: {
	__typename: "_IndexPathFragment",
	index: number,
	alias?: string
};
	["_ValidationMessage"]: {
	__typename: "_ValidationMessage",
	text: string
};
	["ContentBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	type?: GraphQLTypes["ContentBlockType"],
	primaryText?: string,
	secondaryText?: string,
	homePage?: GraphQLTypes["ContentBlockCreateHomePageEntityRelationInput"],
	gallery?: GraphQLTypes["ContentBlockCreateGalleryEntityRelationInput"],
	video?: GraphQLTypes["ContentBlockCreateVideoEntityRelationInput"],
	link?: GraphQLTypes["ContentBlockCreateLinkEntityRelationInput"],
	members?: GraphQLTypes["ContentBlockCreateMembersEntityRelationInput"],
	portfolio?: GraphQLTypes["ContentBlockCreatePortfolioEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentBlockCreateHomePageEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageUniqueWhere"],
	create?: GraphQLTypes["HomePageWithoutBlocksCreateInput"]
};
	["HomePageWithoutBlocksCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	link?: GraphQLTypes["HomePageCreateLinkEntityRelationInput"],
	seo?: GraphQLTypes["HomePageCreateSeoEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["HomePageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutHomePageCreateInput"]
};
	["LinkableWithoutHomePageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	portfolioPage?: GraphQLTypes["LinkableCreatePortfolioPageEntityRelationInput"],
	showPage?: GraphQLTypes["LinkableCreateShowPageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableCreatePortfolioPageEntityRelationInput"]: {
		connect?: GraphQLTypes["PortfolioPageUniqueWhere"],
	create?: GraphQLTypes["PortfolioPageWithoutLinkCreateInput"]
};
	["PortfolioPageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	seo?: GraphQLTypes["PortfolioPageCreateSeoEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	title?: string,
	text?: string,
	_dummy_field_?: boolean
};
	["PortfolioPageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["SeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	title?: string,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	noIndex?: boolean,
	noFollow?: boolean,
	_dummy_field_?: boolean
};
	["SeoCreateOgImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ImageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string,
	_dummy_field_?: boolean
};
	["LinkableCreateShowPageEntityRelationInput"]: {
		connect?: GraphQLTypes["ShowUniqueWhere"],
	create?: GraphQLTypes["ShowWithoutLinkCreateInput"]
};
	["ShowWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	posterType?: GraphQLTypes["ShowPosterType"],
	poster?: GraphQLTypes["ShowCreatePosterEntityRelationInput"],
	showItem?: Array<GraphQLTypes["ShowCreateShowItemEntityRelationInput"]>,
	posterSizeType?: GraphQLTypes["ShowPosterSizeType"],
	categoryYear?: GraphQLTypes["ShowCreateCategoryYearEntityRelationInput"],
	production?: string,
	directors?: string,
	starrings?: string,
	gallery?: GraphQLTypes["ShowCreateGalleryEntityRelationInput"],
	seo?: GraphQLTypes["ShowCreateSeoEntityRelationInput"],
	synopsis?: string,
	_dummy_field_?: boolean
};
	["ShowCreatePosterEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ShowCreateShowItemEntityRelationInput"]: {
		connect?: GraphQLTypes["ShowItemUniqueWhere"],
	create?: GraphQLTypes["ShowItemWithoutShowCreateInput"],
	alias?: string
};
	["ShowItemWithoutShowCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["ShowItemCreateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ShowItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ShowListUniqueWhere"],
	create?: GraphQLTypes["ShowListWithoutItemsCreateInput"]
};
	["ShowListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["ShowItemUniqueWhere"]
};
	["ShowListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ShowCreateCategoryYearEntityRelationInput"]: {
		connect?: GraphQLTypes["ShowYearUniqueWhere"],
	create?: GraphQLTypes["ShowYearWithoutShowListCreateInput"]
};
	["ShowYearUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	showList?: GraphQLTypes["ShowUniqueWhere"]
};
	["ShowYearWithoutShowListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	name?: string,
	_dummy_field_?: boolean
};
	["ShowCreateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumGalleryUniqueWhere"],
	create?: GraphQLTypes["MediumGalleryCreateInput"]
};
	["MediumGalleryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["MediumGalleryCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["MediumGalleryCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumGalleryItemUniqueWhere"],
	create?: GraphQLTypes["MediumGalleryItemWithoutGalleryCreateInput"],
	alias?: string
};
	["MediumGalleryItemWithoutGalleryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	type?: GraphQLTypes["MediumType"],
	image?: GraphQLTypes["MediumGalleryItemCreateImageEntityRelationInput"],
	video?: GraphQLTypes["MediumGalleryItemCreateVideoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MediumGalleryItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["MediumGalleryItemCreateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"],
	create?: GraphQLTypes["VideoCreateInput"]
};
	["VideoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["VideoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	src?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	duration?: number,
	poster?: GraphQLTypes["VideoCreatePosterEntityRelationInput"],
	_dummy_field_?: boolean
};
	["VideoCreatePosterEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ShowCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableCreateRedirectEntityRelationInput"]: {
		connect?: GraphQLTypes["RedirectUniqueWhere"],
	create?: GraphQLTypes["RedirectWithoutLinkCreateInput"]
};
	["RedirectWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	target?: GraphQLTypes["RedirectCreateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectCreateTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["LinkableCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	portfolioPage?: GraphQLTypes["LinkableCreatePortfolioPageEntityRelationInput"],
	showPage?: GraphQLTypes["LinkableCreateShowPageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableCreateHomePageEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageUniqueWhere"],
	create?: GraphQLTypes["HomePageWithoutLinkCreateInput"]
};
	["HomePageWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	seo?: GraphQLTypes["HomePageCreateSeoEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	blocks?: Array<GraphQLTypes["HomePageCreateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["HomePageCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["HomePageCreateBlocksEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	create?: GraphQLTypes["ContentBlockWithoutHomePageCreateInput"],
	alias?: string
};
	["ContentBlockWithoutHomePageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	type?: GraphQLTypes["ContentBlockType"],
	primaryText?: string,
	secondaryText?: string,
	gallery?: GraphQLTypes["ContentBlockCreateGalleryEntityRelationInput"],
	video?: GraphQLTypes["ContentBlockCreateVideoEntityRelationInput"],
	link?: GraphQLTypes["ContentBlockCreateLinkEntityRelationInput"],
	members?: GraphQLTypes["ContentBlockCreateMembersEntityRelationInput"],
	portfolio?: GraphQLTypes["ContentBlockCreatePortfolioEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentBlockCreateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumGalleryUniqueWhere"],
	create?: GraphQLTypes["MediumGalleryCreateInput"]
};
	["ContentBlockCreateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"],
	create?: GraphQLTypes["VideoCreateInput"]
};
	["ContentBlockCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["LinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["ContentBlockCreateMembersEntityRelationInput"]: {
		connect?: GraphQLTypes["MemberListUniqueWhere"],
	create?: GraphQLTypes["MemberListCreateInput"]
};
	["MemberListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["MemberListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["MemberListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["MemberItemUniqueWhere"],
	create?: GraphQLTypes["MemberItemWithoutListCreateInput"],
	alias?: string
};
	["MemberItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	member?: GraphQLTypes["MemberItemCreateMemberEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MemberItemCreateMemberEntityRelationInput"]: {
		connect?: GraphQLTypes["MemberUniqueWhere"],
	create?: GraphQLTypes["MemberCreateInput"]
};
	["MemberUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["MemberCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	firstName?: string,
	lastName?: string,
	position?: string,
	email?: string,
	telephone?: string,
	image?: GraphQLTypes["MemberCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MemberCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentBlockCreatePortfolioEntityRelationInput"]: {
		connect?: GraphQLTypes["ShowYearListUniqueWhere"],
	create?: GraphQLTypes["ShowYearListCreateInput"]
};
	["ShowYearListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["ShowYearItemUniqueWhere"]
};
	["ShowYearItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ShowYearListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["ShowYearListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ShowYearListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ShowYearItemUniqueWhere"],
	create?: GraphQLTypes["ShowYearItemWithoutListCreateInput"],
	alias?: string
};
	["ShowYearItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	showYear?: GraphQLTypes["ShowYearItemCreateShowYearEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ShowYearItemCreateShowYearEntityRelationInput"]: {
		connect?: GraphQLTypes["ShowYearUniqueWhere"],
	create?: GraphQLTypes["ShowYearCreateInput"]
};
	["ShowYearCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	name?: string,
	showList?: Array<GraphQLTypes["ShowYearCreateShowListEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ShowYearCreateShowListEntityRelationInput"]: {
		connect?: GraphQLTypes["ShowUniqueWhere"],
	create?: GraphQLTypes["ShowWithoutCategoryYearCreateInput"],
	alias?: string
};
	["ShowWithoutCategoryYearCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	posterType?: GraphQLTypes["ShowPosterType"],
	poster?: GraphQLTypes["ShowCreatePosterEntityRelationInput"],
	showItem?: Array<GraphQLTypes["ShowCreateShowItemEntityRelationInput"]>,
	posterSizeType?: GraphQLTypes["ShowPosterSizeType"],
	production?: string,
	directors?: string,
	starrings?: string,
	gallery?: GraphQLTypes["ShowCreateGalleryEntityRelationInput"],
	seo?: GraphQLTypes["ShowCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["ShowCreateLinkEntityRelationInput"],
	synopsis?: string,
	_dummy_field_?: boolean
};
	["ShowCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutShowPageCreateInput"]
};
	["LinkableWithoutShowPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	portfolioPage?: GraphQLTypes["LinkableCreatePortfolioPageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentBlockUpdateInput"]: {
		order?: number,
	type?: GraphQLTypes["ContentBlockType"],
	primaryText?: string,
	secondaryText?: string,
	homePage?: GraphQLTypes["ContentBlockUpdateHomePageEntityRelationInput"],
	gallery?: GraphQLTypes["ContentBlockUpdateGalleryEntityRelationInput"],
	video?: GraphQLTypes["ContentBlockUpdateVideoEntityRelationInput"],
	link?: GraphQLTypes["ContentBlockUpdateLinkEntityRelationInput"],
	members?: GraphQLTypes["ContentBlockUpdateMembersEntityRelationInput"],
	portfolio?: GraphQLTypes["ContentBlockUpdatePortfolioEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentBlockUpdateHomePageEntityRelationInput"]: {
		create?: GraphQLTypes["HomePageWithoutBlocksCreateInput"],
	update?: GraphQLTypes["HomePageWithoutBlocksUpdateInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertHomePageRelationInput"],
	connect?: GraphQLTypes["HomePageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HomePageWithoutBlocksUpdateInput"]: {
		name?: string,
	link?: GraphQLTypes["HomePageUpdateLinkEntityRelationInput"],
	seo?: GraphQLTypes["HomePageUpdateSeoEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["HomePageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutHomePageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutHomePageUpdateInput"],
	upsert?: GraphQLTypes["HomePageUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutHomePageUpdateInput"]: {
		url?: string,
	portfolioPage?: GraphQLTypes["LinkableUpdatePortfolioPageEntityRelationInput"],
	showPage?: GraphQLTypes["LinkableUpdateShowPageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableUpdatePortfolioPageEntityRelationInput"]: {
		create?: GraphQLTypes["PortfolioPageWithoutLinkCreateInput"],
	update?: GraphQLTypes["PortfolioPageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertPortfolioPageRelationInput"],
	connect?: GraphQLTypes["PortfolioPageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PortfolioPageWithoutLinkUpdateInput"]: {
		name?: string,
	seo?: GraphQLTypes["PortfolioPageUpdateSeoEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	title?: string,
	text?: string,
	_dummy_field_?: boolean
};
	["PortfolioPageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["PortfolioPageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoUpdateInput"]: {
		description?: string,
	ogTitle?: string,
	ogDescription?: string,
	title?: string,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	noIndex?: boolean,
	noFollow?: boolean,
	_dummy_field_?: boolean
};
	["SeoUpdateOgImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertOgImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ImageUpdateInput"]: {
		url?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string,
	_dummy_field_?: boolean
};
	["SeoUpsertOgImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["PortfolioPageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableUpsertPortfolioPageRelationInput"]: {
		update?: GraphQLTypes["PortfolioPageWithoutLinkUpdateInput"],
	create?: GraphQLTypes["PortfolioPageWithoutLinkCreateInput"]
};
	["LinkableUpdateShowPageEntityRelationInput"]: {
		create?: GraphQLTypes["ShowWithoutLinkCreateInput"],
	update?: GraphQLTypes["ShowWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertShowPageRelationInput"],
	connect?: GraphQLTypes["ShowUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ShowWithoutLinkUpdateInput"]: {
		title?: string,
	description?: string,
	posterType?: GraphQLTypes["ShowPosterType"],
	poster?: GraphQLTypes["ShowUpdatePosterEntityRelationInput"],
	showItem?: Array<GraphQLTypes["ShowUpdateShowItemEntityRelationInput"]>,
	posterSizeType?: GraphQLTypes["ShowPosterSizeType"],
	categoryYear?: GraphQLTypes["ShowUpdateCategoryYearEntityRelationInput"],
	production?: string,
	directors?: string,
	starrings?: string,
	gallery?: GraphQLTypes["ShowUpdateGalleryEntityRelationInput"],
	seo?: GraphQLTypes["ShowUpdateSeoEntityRelationInput"],
	synopsis?: string,
	_dummy_field_?: boolean
};
	["ShowUpdatePosterEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ShowUpsertPosterRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ShowUpsertPosterRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ShowUpdateShowItemEntityRelationInput"]: {
		create?: GraphQLTypes["ShowItemWithoutShowCreateInput"],
	update?: GraphQLTypes["ShowUpdateShowItemRelationInput"],
	upsert?: GraphQLTypes["ShowUpsertShowItemRelationInput"],
	connect?: GraphQLTypes["ShowItemUniqueWhere"],
	disconnect?: GraphQLTypes["ShowItemUniqueWhere"],
	delete?: GraphQLTypes["ShowItemUniqueWhere"],
	alias?: string
};
	["ShowUpdateShowItemRelationInput"]: {
		by?: GraphQLTypes["ShowItemUniqueWhere"],
	data?: GraphQLTypes["ShowItemWithoutShowUpdateInput"]
};
	["ShowItemWithoutShowUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["ShowItemUpdateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ShowItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ShowListWithoutItemsCreateInput"],
	update?: GraphQLTypes["ShowListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ShowItemUpsertListRelationInput"],
	connect?: GraphQLTypes["ShowListUniqueWhere"],
	delete?: boolean
};
	["ShowListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ShowItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["ShowListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["ShowListWithoutItemsCreateInput"]
};
	["ShowUpsertShowItemRelationInput"]: {
		by?: GraphQLTypes["ShowItemUniqueWhere"],
	update?: GraphQLTypes["ShowItemWithoutShowUpdateInput"],
	create?: GraphQLTypes["ShowItemWithoutShowCreateInput"]
};
	["ShowUpdateCategoryYearEntityRelationInput"]: {
		create?: GraphQLTypes["ShowYearWithoutShowListCreateInput"],
	update?: GraphQLTypes["ShowYearWithoutShowListUpdateInput"],
	upsert?: GraphQLTypes["ShowUpsertCategoryYearRelationInput"],
	connect?: GraphQLTypes["ShowYearUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ShowYearWithoutShowListUpdateInput"]: {
		order?: number,
	name?: string,
	_dummy_field_?: boolean
};
	["ShowUpsertCategoryYearRelationInput"]: {
		update?: GraphQLTypes["ShowYearWithoutShowListUpdateInput"],
	create?: GraphQLTypes["ShowYearWithoutShowListCreateInput"]
};
	["ShowUpdateGalleryEntityRelationInput"]: {
		create?: GraphQLTypes["MediumGalleryCreateInput"],
	update?: GraphQLTypes["MediumGalleryUpdateInput"],
	upsert?: GraphQLTypes["ShowUpsertGalleryRelationInput"],
	connect?: GraphQLTypes["MediumGalleryUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["MediumGalleryUpdateInput"]: {
		items?: Array<GraphQLTypes["MediumGalleryUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["MediumGalleryUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["MediumGalleryItemWithoutGalleryCreateInput"],
	update?: GraphQLTypes["MediumGalleryUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["MediumGalleryUpsertItemsRelationInput"],
	connect?: GraphQLTypes["MediumGalleryItemUniqueWhere"],
	disconnect?: GraphQLTypes["MediumGalleryItemUniqueWhere"],
	delete?: GraphQLTypes["MediumGalleryItemUniqueWhere"],
	alias?: string
};
	["MediumGalleryUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["MediumGalleryItemUniqueWhere"],
	data?: GraphQLTypes["MediumGalleryItemWithoutGalleryUpdateInput"]
};
	["MediumGalleryItemWithoutGalleryUpdateInput"]: {
		order?: number,
	type?: GraphQLTypes["MediumType"],
	image?: GraphQLTypes["MediumGalleryItemUpdateImageEntityRelationInput"],
	video?: GraphQLTypes["MediumGalleryItemUpdateVideoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MediumGalleryItemUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["MediumGalleryItemUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["MediumGalleryItemUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["MediumGalleryItemUpdateVideoEntityRelationInput"]: {
		create?: GraphQLTypes["VideoCreateInput"],
	update?: GraphQLTypes["VideoUpdateInput"],
	upsert?: GraphQLTypes["MediumGalleryItemUpsertVideoRelationInput"],
	connect?: GraphQLTypes["VideoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["VideoUpdateInput"]: {
		src?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	duration?: number,
	poster?: GraphQLTypes["VideoUpdatePosterEntityRelationInput"],
	_dummy_field_?: boolean
};
	["VideoUpdatePosterEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["VideoUpsertPosterRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["VideoUpsertPosterRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["MediumGalleryItemUpsertVideoRelationInput"]: {
		update?: GraphQLTypes["VideoUpdateInput"],
	create?: GraphQLTypes["VideoCreateInput"]
};
	["MediumGalleryUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["MediumGalleryItemUniqueWhere"],
	update?: GraphQLTypes["MediumGalleryItemWithoutGalleryUpdateInput"],
	create?: GraphQLTypes["MediumGalleryItemWithoutGalleryCreateInput"]
};
	["ShowUpsertGalleryRelationInput"]: {
		update?: GraphQLTypes["MediumGalleryUpdateInput"],
	create?: GraphQLTypes["MediumGalleryCreateInput"]
};
	["ShowUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["ShowUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ShowUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LinkableUpsertShowPageRelationInput"]: {
		update?: GraphQLTypes["ShowWithoutLinkUpdateInput"],
	create?: GraphQLTypes["ShowWithoutLinkCreateInput"]
};
	["LinkableUpdateRedirectEntityRelationInput"]: {
		create?: GraphQLTypes["RedirectWithoutLinkCreateInput"],
	update?: GraphQLTypes["RedirectWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertRedirectRelationInput"],
	connect?: GraphQLTypes["RedirectUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["RedirectWithoutLinkUpdateInput"]: {
		target?: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateTargetEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableCreateInput"],
	update?: GraphQLTypes["LinkableUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertTargetRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	delete?: boolean
};
	["LinkableUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	portfolioPage?: GraphQLTypes["LinkableUpdatePortfolioPageEntityRelationInput"],
	showPage?: GraphQLTypes["LinkableUpdateShowPageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableUpdateHomePageEntityRelationInput"]: {
		create?: GraphQLTypes["HomePageWithoutLinkCreateInput"],
	update?: GraphQLTypes["HomePageWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertHomePageRelationInput"],
	connect?: GraphQLTypes["HomePageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HomePageWithoutLinkUpdateInput"]: {
		name?: string,
	seo?: GraphQLTypes["HomePageUpdateSeoEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	blocks?: Array<GraphQLTypes["HomePageUpdateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["HomePageUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["HomePageUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HomePageUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["HomePageUpdateBlocksEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutHomePageCreateInput"],
	update?: GraphQLTypes["HomePageUpdateBlocksRelationInput"],
	upsert?: GraphQLTypes["HomePageUpsertBlocksRelationInput"],
	connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	disconnect?: GraphQLTypes["ContentBlockUniqueWhere"],
	delete?: GraphQLTypes["ContentBlockUniqueWhere"],
	alias?: string
};
	["HomePageUpdateBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"],
	data?: GraphQLTypes["ContentBlockWithoutHomePageUpdateInput"]
};
	["ContentBlockWithoutHomePageUpdateInput"]: {
		order?: number,
	type?: GraphQLTypes["ContentBlockType"],
	primaryText?: string,
	secondaryText?: string,
	gallery?: GraphQLTypes["ContentBlockUpdateGalleryEntityRelationInput"],
	video?: GraphQLTypes["ContentBlockUpdateVideoEntityRelationInput"],
	link?: GraphQLTypes["ContentBlockUpdateLinkEntityRelationInput"],
	members?: GraphQLTypes["ContentBlockUpdateMembersEntityRelationInput"],
	portfolio?: GraphQLTypes["ContentBlockUpdatePortfolioEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentBlockUpdateGalleryEntityRelationInput"]: {
		create?: GraphQLTypes["MediumGalleryCreateInput"],
	update?: GraphQLTypes["MediumGalleryUpdateInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertGalleryRelationInput"],
	connect?: GraphQLTypes["MediumGalleryUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentBlockUpsertGalleryRelationInput"]: {
		update?: GraphQLTypes["MediumGalleryUpdateInput"],
	create?: GraphQLTypes["MediumGalleryCreateInput"]
};
	["ContentBlockUpdateVideoEntityRelationInput"]: {
		create?: GraphQLTypes["VideoCreateInput"],
	update?: GraphQLTypes["VideoUpdateInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertVideoRelationInput"],
	connect?: GraphQLTypes["VideoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentBlockUpsertVideoRelationInput"]: {
		update?: GraphQLTypes["VideoUpdateInput"],
	create?: GraphQLTypes["VideoCreateInput"]
};
	["ContentBlockUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkUpdateInput"]: {
		type?: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableCreateInput"],
	update?: GraphQLTypes["LinkableUpdateInput"],
	upsert?: GraphQLTypes["LinkUpsertInternalLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkUpsertInternalLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableUpdateInput"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["ContentBlockUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentBlockUpdateMembersEntityRelationInput"]: {
		create?: GraphQLTypes["MemberListCreateInput"],
	update?: GraphQLTypes["MemberListUpdateInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertMembersRelationInput"],
	connect?: GraphQLTypes["MemberListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["MemberListUpdateInput"]: {
		items?: Array<GraphQLTypes["MemberListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["MemberListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["MemberItemWithoutListCreateInput"],
	update?: GraphQLTypes["MemberListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["MemberListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["MemberItemUniqueWhere"],
	disconnect?: GraphQLTypes["MemberItemUniqueWhere"],
	delete?: GraphQLTypes["MemberItemUniqueWhere"],
	alias?: string
};
	["MemberListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["MemberItemUniqueWhere"],
	data?: GraphQLTypes["MemberItemWithoutListUpdateInput"]
};
	["MemberItemWithoutListUpdateInput"]: {
		order?: number,
	member?: GraphQLTypes["MemberItemUpdateMemberEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MemberItemUpdateMemberEntityRelationInput"]: {
		create?: GraphQLTypes["MemberCreateInput"],
	update?: GraphQLTypes["MemberUpdateInput"],
	upsert?: GraphQLTypes["MemberItemUpsertMemberRelationInput"],
	connect?: GraphQLTypes["MemberUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["MemberUpdateInput"]: {
		firstName?: string,
	lastName?: string,
	position?: string,
	email?: string,
	telephone?: string,
	image?: GraphQLTypes["MemberUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MemberUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["MemberUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["MemberUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["MemberItemUpsertMemberRelationInput"]: {
		update?: GraphQLTypes["MemberUpdateInput"],
	create?: GraphQLTypes["MemberCreateInput"]
};
	["MemberListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["MemberItemUniqueWhere"],
	update?: GraphQLTypes["MemberItemWithoutListUpdateInput"],
	create?: GraphQLTypes["MemberItemWithoutListCreateInput"]
};
	["ContentBlockUpsertMembersRelationInput"]: {
		update?: GraphQLTypes["MemberListUpdateInput"],
	create?: GraphQLTypes["MemberListCreateInput"]
};
	["ContentBlockUpdatePortfolioEntityRelationInput"]: {
		create?: GraphQLTypes["ShowYearListCreateInput"],
	update?: GraphQLTypes["ShowYearListUpdateInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertPortfolioRelationInput"],
	connect?: GraphQLTypes["ShowYearListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ShowYearListUpdateInput"]: {
		items?: Array<GraphQLTypes["ShowYearListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ShowYearListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ShowYearItemWithoutListCreateInput"],
	update?: GraphQLTypes["ShowYearListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ShowYearListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ShowYearItemUniqueWhere"],
	disconnect?: GraphQLTypes["ShowYearItemUniqueWhere"],
	delete?: GraphQLTypes["ShowYearItemUniqueWhere"],
	alias?: string
};
	["ShowYearListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ShowYearItemUniqueWhere"],
	data?: GraphQLTypes["ShowYearItemWithoutListUpdateInput"]
};
	["ShowYearItemWithoutListUpdateInput"]: {
		order?: number,
	showYear?: GraphQLTypes["ShowYearItemUpdateShowYearEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ShowYearItemUpdateShowYearEntityRelationInput"]: {
		create?: GraphQLTypes["ShowYearCreateInput"],
	update?: GraphQLTypes["ShowYearUpdateInput"],
	upsert?: GraphQLTypes["ShowYearItemUpsertShowYearRelationInput"],
	connect?: GraphQLTypes["ShowYearUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ShowYearUpdateInput"]: {
		order?: number,
	name?: string,
	showList?: Array<GraphQLTypes["ShowYearUpdateShowListEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ShowYearUpdateShowListEntityRelationInput"]: {
		create?: GraphQLTypes["ShowWithoutCategoryYearCreateInput"],
	update?: GraphQLTypes["ShowYearUpdateShowListRelationInput"],
	upsert?: GraphQLTypes["ShowYearUpsertShowListRelationInput"],
	connect?: GraphQLTypes["ShowUniqueWhere"],
	disconnect?: GraphQLTypes["ShowUniqueWhere"],
	delete?: GraphQLTypes["ShowUniqueWhere"],
	alias?: string
};
	["ShowYearUpdateShowListRelationInput"]: {
		by?: GraphQLTypes["ShowUniqueWhere"],
	data?: GraphQLTypes["ShowWithoutCategoryYearUpdateInput"]
};
	["ShowWithoutCategoryYearUpdateInput"]: {
		title?: string,
	description?: string,
	posterType?: GraphQLTypes["ShowPosterType"],
	poster?: GraphQLTypes["ShowUpdatePosterEntityRelationInput"],
	showItem?: Array<GraphQLTypes["ShowUpdateShowItemEntityRelationInput"]>,
	posterSizeType?: GraphQLTypes["ShowPosterSizeType"],
	production?: string,
	directors?: string,
	starrings?: string,
	gallery?: GraphQLTypes["ShowUpdateGalleryEntityRelationInput"],
	seo?: GraphQLTypes["ShowUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["ShowUpdateLinkEntityRelationInput"],
	synopsis?: string,
	_dummy_field_?: boolean
};
	["ShowUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutShowPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutShowPageUpdateInput"],
	upsert?: GraphQLTypes["ShowUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutShowPageUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	portfolioPage?: GraphQLTypes["LinkableUpdatePortfolioPageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ShowUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutShowPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutShowPageCreateInput"]
};
	["ShowYearUpsertShowListRelationInput"]: {
		by?: GraphQLTypes["ShowUniqueWhere"],
	update?: GraphQLTypes["ShowWithoutCategoryYearUpdateInput"],
	create?: GraphQLTypes["ShowWithoutCategoryYearCreateInput"]
};
	["ShowYearItemUpsertShowYearRelationInput"]: {
		update?: GraphQLTypes["ShowYearUpdateInput"],
	create?: GraphQLTypes["ShowYearCreateInput"]
};
	["ShowYearListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ShowYearItemUniqueWhere"],
	update?: GraphQLTypes["ShowYearItemWithoutListUpdateInput"],
	create?: GraphQLTypes["ShowYearItemWithoutListCreateInput"]
};
	["ContentBlockUpsertPortfolioRelationInput"]: {
		update?: GraphQLTypes["ShowYearListUpdateInput"],
	create?: GraphQLTypes["ShowYearListCreateInput"]
};
	["HomePageUpsertBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"],
	update?: GraphQLTypes["ContentBlockWithoutHomePageUpdateInput"],
	create?: GraphQLTypes["ContentBlockWithoutHomePageCreateInput"]
};
	["LinkableUpsertHomePageRelationInput"]: {
		update?: GraphQLTypes["HomePageWithoutLinkUpdateInput"],
	create?: GraphQLTypes["HomePageWithoutLinkCreateInput"]
};
	["RedirectUpsertTargetRelationInput"]: {
		update?: GraphQLTypes["LinkableUpdateInput"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["LinkableUpsertRedirectRelationInput"]: {
		update?: GraphQLTypes["RedirectWithoutLinkUpdateInput"],
	create?: GraphQLTypes["RedirectWithoutLinkCreateInput"]
};
	["HomePageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutHomePageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutHomePageCreateInput"]
};
	["ContentBlockUpsertHomePageRelationInput"]: {
		update?: GraphQLTypes["HomePageWithoutBlocksUpdateInput"],
	create?: GraphQLTypes["HomePageWithoutBlocksCreateInput"]
};
	["ImageConnection"]: {
	__typename: "ImageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageEdge"]>
};
	["ImageEdge"]: {
	__typename: "ImageEdge",
	node: GraphQLTypes["Image"]
};
	["LinkConnection"]: {
	__typename: "LinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkEdge"]>
};
	["LinkEdge"]: {
	__typename: "LinkEdge",
	node: GraphQLTypes["Link"]
};
	["SeoConnection"]: {
	__typename: "SeoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoEdge"]>
};
	["SeoEdge"]: {
	__typename: "SeoEdge",
	node: GraphQLTypes["Seo"]
};
	["HomePageConnection"]: {
	__typename: "HomePageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HomePageEdge"]>
};
	["HomePageEdge"]: {
	__typename: "HomePageEdge",
	node: GraphQLTypes["HomePage"]
};
	["HomePageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	link?: GraphQLTypes["HomePageCreateLinkEntityRelationInput"],
	seo?: GraphQLTypes["HomePageCreateSeoEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	blocks?: Array<GraphQLTypes["HomePageCreateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["HomePageUpdateInput"]: {
		name?: string,
	link?: GraphQLTypes["HomePageUpdateLinkEntityRelationInput"],
	seo?: GraphQLTypes["HomePageUpdateSeoEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	blocks?: Array<GraphQLTypes["HomePageUpdateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LinkableConnection"]: {
	__typename: "LinkableConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkableEdge"]>
};
	["LinkableEdge"]: {
	__typename: "LinkableEdge",
	node: GraphQLTypes["Linkable"]
};
	["MediumGalleryConnection"]: {
	__typename: "MediumGalleryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MediumGalleryEdge"]>
};
	["MediumGalleryEdge"]: {
	__typename: "MediumGalleryEdge",
	node: GraphQLTypes["MediumGallery"]
};
	["MediumGalleryItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	type?: GraphQLTypes["MediumType"],
	gallery?: GraphQLTypes["MediumGalleryItemCreateGalleryEntityRelationInput"],
	image?: GraphQLTypes["MediumGalleryItemCreateImageEntityRelationInput"],
	video?: GraphQLTypes["MediumGalleryItemCreateVideoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MediumGalleryItemCreateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumGalleryUniqueWhere"],
	create?: GraphQLTypes["MediumGalleryWithoutItemsCreateInput"]
};
	["MediumGalleryWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["MediumGalleryItemUpdateInput"]: {
		order?: number,
	type?: GraphQLTypes["MediumType"],
	gallery?: GraphQLTypes["MediumGalleryItemUpdateGalleryEntityRelationInput"],
	image?: GraphQLTypes["MediumGalleryItemUpdateImageEntityRelationInput"],
	video?: GraphQLTypes["MediumGalleryItemUpdateVideoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MediumGalleryItemUpdateGalleryEntityRelationInput"]: {
		create?: GraphQLTypes["MediumGalleryWithoutItemsCreateInput"],
	update?: GraphQLTypes["MediumGalleryWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["MediumGalleryItemUpsertGalleryRelationInput"],
	connect?: GraphQLTypes["MediumGalleryUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["MediumGalleryWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["MediumGalleryItemUpsertGalleryRelationInput"]: {
		update?: GraphQLTypes["MediumGalleryWithoutItemsUpdateInput"],
	create?: GraphQLTypes["MediumGalleryWithoutItemsCreateInput"]
};
	["MemberConnection"]: {
	__typename: "MemberConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MemberEdge"]>
};
	["MemberEdge"]: {
	__typename: "MemberEdge",
	node: GraphQLTypes["Member"]
};
	["MemberItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["MemberItemCreateListEntityRelationInput"],
	member?: GraphQLTypes["MemberItemCreateMemberEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MemberItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["MemberListUniqueWhere"],
	create?: GraphQLTypes["MemberListWithoutItemsCreateInput"]
};
	["MemberListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["MemberItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["MemberItemUpdateListEntityRelationInput"],
	member?: GraphQLTypes["MemberItemUpdateMemberEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MemberItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["MemberListWithoutItemsCreateInput"],
	update?: GraphQLTypes["MemberListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["MemberItemUpsertListRelationInput"],
	connect?: GraphQLTypes["MemberListUniqueWhere"],
	delete?: boolean
};
	["MemberListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["MemberItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["MemberListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["MemberListWithoutItemsCreateInput"]
};
	["MemberListConnection"]: {
	__typename: "MemberListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MemberListEdge"]>
};
	["MemberListEdge"]: {
	__typename: "MemberListEdge",
	node: GraphQLTypes["MemberList"]
};
	["ShowCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	posterType?: GraphQLTypes["ShowPosterType"],
	poster?: GraphQLTypes["ShowCreatePosterEntityRelationInput"],
	showItem?: Array<GraphQLTypes["ShowCreateShowItemEntityRelationInput"]>,
	posterSizeType?: GraphQLTypes["ShowPosterSizeType"],
	categoryYear?: GraphQLTypes["ShowCreateCategoryYearEntityRelationInput"],
	production?: string,
	directors?: string,
	starrings?: string,
	gallery?: GraphQLTypes["ShowCreateGalleryEntityRelationInput"],
	seo?: GraphQLTypes["ShowCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["ShowCreateLinkEntityRelationInput"],
	synopsis?: string,
	_dummy_field_?: boolean
};
	["ShowUpdateInput"]: {
		title?: string,
	description?: string,
	posterType?: GraphQLTypes["ShowPosterType"],
	poster?: GraphQLTypes["ShowUpdatePosterEntityRelationInput"],
	showItem?: Array<GraphQLTypes["ShowUpdateShowItemEntityRelationInput"]>,
	posterSizeType?: GraphQLTypes["ShowPosterSizeType"],
	categoryYear?: GraphQLTypes["ShowUpdateCategoryYearEntityRelationInput"],
	production?: string,
	directors?: string,
	starrings?: string,
	gallery?: GraphQLTypes["ShowUpdateGalleryEntityRelationInput"],
	seo?: GraphQLTypes["ShowUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["ShowUpdateLinkEntityRelationInput"],
	synopsis?: string,
	_dummy_field_?: boolean
};
	["ShowListConnection"]: {
	__typename: "ShowListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ShowListEdge"]>
};
	["ShowListEdge"]: {
	__typename: "ShowListEdge",
	node: GraphQLTypes["ShowList"]
};
	["ShowListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["ShowListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ShowListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ShowItemUniqueWhere"],
	create?: GraphQLTypes["ShowItemWithoutListCreateInput"],
	alias?: string
};
	["ShowItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	show?: GraphQLTypes["ShowItemCreateShowEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ShowItemCreateShowEntityRelationInput"]: {
		connect?: GraphQLTypes["ShowUniqueWhere"],
	create?: GraphQLTypes["ShowWithoutShowItemCreateInput"]
};
	["ShowWithoutShowItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	posterType?: GraphQLTypes["ShowPosterType"],
	poster?: GraphQLTypes["ShowCreatePosterEntityRelationInput"],
	posterSizeType?: GraphQLTypes["ShowPosterSizeType"],
	categoryYear?: GraphQLTypes["ShowCreateCategoryYearEntityRelationInput"],
	production?: string,
	directors?: string,
	starrings?: string,
	gallery?: GraphQLTypes["ShowCreateGalleryEntityRelationInput"],
	seo?: GraphQLTypes["ShowCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["ShowCreateLinkEntityRelationInput"],
	synopsis?: string,
	_dummy_field_?: boolean
};
	["ShowListUpdateInput"]: {
		items?: Array<GraphQLTypes["ShowListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ShowListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ShowItemWithoutListCreateInput"],
	update?: GraphQLTypes["ShowListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ShowListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ShowItemUniqueWhere"],
	disconnect?: GraphQLTypes["ShowItemUniqueWhere"],
	delete?: GraphQLTypes["ShowItemUniqueWhere"],
	alias?: string
};
	["ShowListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ShowItemUniqueWhere"],
	data?: GraphQLTypes["ShowItemWithoutListUpdateInput"]
};
	["ShowItemWithoutListUpdateInput"]: {
		order?: number,
	show?: GraphQLTypes["ShowItemUpdateShowEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ShowItemUpdateShowEntityRelationInput"]: {
		create?: GraphQLTypes["ShowWithoutShowItemCreateInput"],
	update?: GraphQLTypes["ShowWithoutShowItemUpdateInput"],
	upsert?: GraphQLTypes["ShowItemUpsertShowRelationInput"],
	connect?: GraphQLTypes["ShowUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ShowWithoutShowItemUpdateInput"]: {
		title?: string,
	description?: string,
	posterType?: GraphQLTypes["ShowPosterType"],
	poster?: GraphQLTypes["ShowUpdatePosterEntityRelationInput"],
	posterSizeType?: GraphQLTypes["ShowPosterSizeType"],
	categoryYear?: GraphQLTypes["ShowUpdateCategoryYearEntityRelationInput"],
	production?: string,
	directors?: string,
	starrings?: string,
	gallery?: GraphQLTypes["ShowUpdateGalleryEntityRelationInput"],
	seo?: GraphQLTypes["ShowUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["ShowUpdateLinkEntityRelationInput"],
	synopsis?: string,
	_dummy_field_?: boolean
};
	["ShowItemUpsertShowRelationInput"]: {
		update?: GraphQLTypes["ShowWithoutShowItemUpdateInput"],
	create?: GraphQLTypes["ShowWithoutShowItemCreateInput"]
};
	["ShowListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ShowItemUniqueWhere"],
	update?: GraphQLTypes["ShowItemWithoutListUpdateInput"],
	create?: GraphQLTypes["ShowItemWithoutListCreateInput"]
};
	["ShowYearConnection"]: {
	__typename: "ShowYearConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ShowYearEdge"]>
};
	["ShowYearEdge"]: {
	__typename: "ShowYearEdge",
	node: GraphQLTypes["ShowYear"]
};
	["ShowYearItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["ShowYearItemCreateListEntityRelationInput"],
	showYear?: GraphQLTypes["ShowYearItemCreateShowYearEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ShowYearItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ShowYearListUniqueWhere"],
	create?: GraphQLTypes["ShowYearListWithoutItemsCreateInput"]
};
	["ShowYearListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ShowYearItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["ShowYearItemUpdateListEntityRelationInput"],
	showYear?: GraphQLTypes["ShowYearItemUpdateShowYearEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ShowYearItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ShowYearListWithoutItemsCreateInput"],
	update?: GraphQLTypes["ShowYearListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ShowYearItemUpsertListRelationInput"],
	connect?: GraphQLTypes["ShowYearListUniqueWhere"],
	delete?: boolean
};
	["ShowYearListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ShowYearItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["ShowYearListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["ShowYearListWithoutItemsCreateInput"]
};
	["ShowYearListConnection"]: {
	__typename: "ShowYearListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ShowYearListEdge"]>
};
	["ShowYearListEdge"]: {
	__typename: "ShowYearListEdge",
	node: GraphQLTypes["ShowYearList"]
};
	["SocialLink"]: {
	__typename: "SocialLink",
	_meta?: GraphQLTypes["SocialLinkMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	icon?: GraphQLTypes["Image"],
	link?: GraphQLTypes["Link"]
};
	["SocialLinkMeta"]: {
	__typename: "SocialLinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	icon?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["SocialLinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["SocialLinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	icon?: GraphQLTypes["ImageWhere"],
	link?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["SocialLinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["SocialLinkWhere"] | undefined>,
	not?: GraphQLTypes["SocialLinkWhere"]
};
	["SocialLinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	icon?: GraphQLTypes["ImageOrderBy"],
	link?: GraphQLTypes["LinkOrderBy"]
};
	["SocialLinkConnection"]: {
	__typename: "SocialLinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SocialLinkEdge"]>
};
	["SocialLinkEdge"]: {
	__typename: "SocialLinkEdge",
	node: GraphQLTypes["SocialLink"]
};
	["SocialLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	icon?: GraphQLTypes["SocialLinkCreateIconEntityRelationInput"],
	link?: GraphQLTypes["SocialLinkCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SocialLinkCreateIconEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["SocialLinkCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["SocialLinkUpdateInput"]: {
		name?: string,
	icon?: GraphQLTypes["SocialLinkUpdateIconEntityRelationInput"],
	link?: GraphQLTypes["SocialLinkUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SocialLinkUpdateIconEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["SocialLinkUpsertIconRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SocialLinkUpsertIconRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["SocialLinkUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["SocialLinkUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SocialLinkUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["SocialLinkItem"]: {
	__typename: "SocialLinkItem",
	_meta?: GraphQLTypes["SocialLinkItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["SocialLinkList"],
	socialLink?: GraphQLTypes["SocialLink"]
};
	["SocialLinkItemMeta"]: {
	__typename: "SocialLinkItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	socialLink?: GraphQLTypes["FieldMeta"]
};
	["SocialLinkList"]: {
	__typename: "SocialLinkList",
	_meta?: GraphQLTypes["SocialLinkListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["SocialLinkItem"]>,
	paginateItems: GraphQLTypes["SocialLinkItemConnection"]
};
	["SocialLinkListMeta"]: {
	__typename: "SocialLinkListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["SocialLinkItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["SocialLinkListWhere"],
	socialLink?: GraphQLTypes["SocialLinkWhere"],
	and?: Array<GraphQLTypes["SocialLinkItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["SocialLinkItemWhere"] | undefined>,
	not?: GraphQLTypes["SocialLinkItemWhere"]
};
	["SocialLinkListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["SocialLinkItemWhere"],
	and?: Array<GraphQLTypes["SocialLinkListWhere"] | undefined>,
	or?: Array<GraphQLTypes["SocialLinkListWhere"] | undefined>,
	not?: GraphQLTypes["SocialLinkListWhere"]
};
	["SocialLinkItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["SocialLinkListOrderBy"],
	socialLink?: GraphQLTypes["SocialLinkOrderBy"]
};
	["SocialLinkListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["SocialLinkItemConnection"]: {
	__typename: "SocialLinkItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SocialLinkItemEdge"]>
};
	["SocialLinkItemEdge"]: {
	__typename: "SocialLinkItemEdge",
	node: GraphQLTypes["SocialLinkItem"]
};
	["SocialLinkItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["SocialLinkItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["SocialLinkItemCreateListEntityRelationInput"],
	socialLink?: GraphQLTypes["SocialLinkItemCreateSocialLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SocialLinkItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialLinkListUniqueWhere"],
	create?: GraphQLTypes["SocialLinkListWithoutItemsCreateInput"]
};
	["SocialLinkListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["SocialLinkItemUniqueWhere"]
};
	["SocialLinkListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["SocialLinkItemCreateSocialLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialLinkUniqueWhere"],
	create?: GraphQLTypes["SocialLinkCreateInput"]
};
	["SocialLinkItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["SocialLinkItemUpdateListEntityRelationInput"],
	socialLink?: GraphQLTypes["SocialLinkItemUpdateSocialLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SocialLinkItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["SocialLinkListWithoutItemsCreateInput"],
	update?: GraphQLTypes["SocialLinkListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["SocialLinkItemUpsertListRelationInput"],
	connect?: GraphQLTypes["SocialLinkListUniqueWhere"],
	delete?: boolean
};
	["SocialLinkListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["SocialLinkItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["SocialLinkListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["SocialLinkListWithoutItemsCreateInput"]
};
	["SocialLinkItemUpdateSocialLinkEntityRelationInput"]: {
		create?: GraphQLTypes["SocialLinkCreateInput"],
	update?: GraphQLTypes["SocialLinkUpdateInput"],
	upsert?: GraphQLTypes["SocialLinkItemUpsertSocialLinkRelationInput"],
	connect?: GraphQLTypes["SocialLinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SocialLinkItemUpsertSocialLinkRelationInput"]: {
		update?: GraphQLTypes["SocialLinkUpdateInput"],
	create?: GraphQLTypes["SocialLinkCreateInput"]
};
	["SocialLinkListConnection"]: {
	__typename: "SocialLinkListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SocialLinkListEdge"]>
};
	["SocialLinkListEdge"]: {
	__typename: "SocialLinkListEdge",
	node: GraphQLTypes["SocialLinkList"]
};
	["SocialLinkListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["SocialLinkListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SocialLinkListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	create?: GraphQLTypes["SocialLinkItemWithoutListCreateInput"],
	alias?: string
};
	["SocialLinkItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	socialLink?: GraphQLTypes["SocialLinkItemCreateSocialLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SocialLinkListUpdateInput"]: {
		items?: Array<GraphQLTypes["SocialLinkListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SocialLinkListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["SocialLinkItemWithoutListCreateInput"],
	update?: GraphQLTypes["SocialLinkListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["SocialLinkListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	disconnect?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	delete?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	alias?: string
};
	["SocialLinkListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	data?: GraphQLTypes["SocialLinkItemWithoutListUpdateInput"]
};
	["SocialLinkItemWithoutListUpdateInput"]: {
		order?: number,
	socialLink?: GraphQLTypes["SocialLinkItemUpdateSocialLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SocialLinkListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["SocialLinkItemUniqueWhere"],
	update?: GraphQLTypes["SocialLinkItemWithoutListUpdateInput"],
	create?: GraphQLTypes["SocialLinkItemWithoutListCreateInput"]
};
	["VideoConnection"]: {
	__typename: "VideoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VideoEdge"]>
};
	["VideoEdge"]: {
	__typename: "VideoEdge",
	node: GraphQLTypes["Video"]
};
	["YoutubeVideo"]: {
	__typename: "YoutubeVideo",
	_meta?: GraphQLTypes["YoutubeVideoMeta"],
	id: GraphQLTypes["UUID"],
	videoId: string
};
	["YoutubeVideoMeta"]: {
	__typename: "YoutubeVideoMeta",
	id?: GraphQLTypes["FieldMeta"],
	videoId?: GraphQLTypes["FieldMeta"]
};
	["YoutubeVideoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["YoutubeVideoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	videoId?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["YoutubeVideoWhere"] | undefined>,
	or?: Array<GraphQLTypes["YoutubeVideoWhere"] | undefined>,
	not?: GraphQLTypes["YoutubeVideoWhere"]
};
	["YoutubeVideoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	videoId?: GraphQLTypes["OrderDirection"]
};
	["YoutubeVideoConnection"]: {
	__typename: "YoutubeVideoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["YoutubeVideoEdge"]>
};
	["YoutubeVideoEdge"]: {
	__typename: "YoutubeVideoEdge",
	node: GraphQLTypes["YoutubeVideo"]
};
	["YoutubeVideoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	videoId?: string,
	_dummy_field_?: boolean
};
	["YoutubeVideoUpdateInput"]: {
		videoId?: string,
	_dummy_field_?: boolean
};
	["Header"]: {
	__typename: "Header",
	_meta?: GraphQLTypes["HeaderMeta"],
	id: GraphQLTypes["UUID"],
	logo?: GraphQLTypes["Image"],
	socialLinks?: GraphQLTypes["SocialLinkList"],
	unique: GraphQLTypes["One"]
};
	["HeaderMeta"]: {
	__typename: "HeaderMeta",
	id?: GraphQLTypes["FieldMeta"],
	logo?: GraphQLTypes["FieldMeta"],
	socialLinks?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"]
};
	["HeaderUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	socialLinks?: GraphQLTypes["SocialLinkListUniqueWhere"]
};
	["HeaderWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	logo?: GraphQLTypes["ImageWhere"],
	socialLinks?: GraphQLTypes["SocialLinkListWhere"],
	unique?: GraphQLTypes["OneCondition"],
	and?: Array<GraphQLTypes["HeaderWhere"] | undefined>,
	or?: Array<GraphQLTypes["HeaderWhere"] | undefined>,
	not?: GraphQLTypes["HeaderWhere"]
};
	["HeaderOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	logo?: GraphQLTypes["ImageOrderBy"],
	socialLinks?: GraphQLTypes["SocialLinkListOrderBy"],
	unique?: GraphQLTypes["OrderDirection"]
};
	["HeaderConnection"]: {
	__typename: "HeaderConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeaderEdge"]>
};
	["HeaderEdge"]: {
	__typename: "HeaderEdge",
	node: GraphQLTypes["Header"]
};
	["HeaderCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	logo?: GraphQLTypes["HeaderCreateLogoEntityRelationInput"],
	socialLinks?: GraphQLTypes["HeaderCreateSocialLinksEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["HeaderCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HeaderCreateSocialLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialLinkListUniqueWhere"],
	create?: GraphQLTypes["SocialLinkListCreateInput"]
};
	["HeaderUpdateInput"]: {
		logo?: GraphQLTypes["HeaderUpdateLogoEntityRelationInput"],
	socialLinks?: GraphQLTypes["HeaderUpdateSocialLinksEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["HeaderUpdateLogoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["HeaderUpsertLogoRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HeaderUpsertLogoRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HeaderUpdateSocialLinksEntityRelationInput"]: {
		create?: GraphQLTypes["SocialLinkListCreateInput"],
	update?: GraphQLTypes["SocialLinkListUpdateInput"],
	upsert?: GraphQLTypes["HeaderUpsertSocialLinksRelationInput"],
	connect?: GraphQLTypes["SocialLinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HeaderUpsertSocialLinksRelationInput"]: {
		update?: GraphQLTypes["SocialLinkListUpdateInput"],
	create?: GraphQLTypes["SocialLinkListCreateInput"]
};
	["Footer"]: {
	__typename: "Footer",
	_meta?: GraphQLTypes["FooterMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	info?: string,
	address?: GraphQLTypes["FooterAddress"],
	members?: GraphQLTypes["MemberList"],
	logo?: GraphQLTypes["Image"],
	socialLinks?: GraphQLTypes["SocialLinkList"],
	unique: GraphQLTypes["One"],
	generalContact?: GraphQLTypes["FooterGeneralContact"]
};
	["FooterMeta"]: {
	__typename: "FooterMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	info?: GraphQLTypes["FieldMeta"],
	address?: GraphQLTypes["FieldMeta"],
	members?: GraphQLTypes["FieldMeta"],
	logo?: GraphQLTypes["FieldMeta"],
	socialLinks?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	generalContact?: GraphQLTypes["FieldMeta"]
};
	["FooterAddress"]: {
	__typename: "FooterAddress",
	_meta?: GraphQLTypes["FooterAddressMeta"],
	id: GraphQLTypes["UUID"],
	label?: string,
	address?: string,
	addressLink?: GraphQLTypes["Link"]
};
	["FooterAddressMeta"]: {
	__typename: "FooterAddressMeta",
	id?: GraphQLTypes["FieldMeta"],
	label?: GraphQLTypes["FieldMeta"],
	address?: GraphQLTypes["FieldMeta"],
	addressLink?: GraphQLTypes["FieldMeta"]
};
	["FooterAddressWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	label?: GraphQLTypes["StringCondition"],
	address?: GraphQLTypes["StringCondition"],
	addressLink?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["FooterAddressWhere"] | undefined>,
	or?: Array<GraphQLTypes["FooterAddressWhere"] | undefined>,
	not?: GraphQLTypes["FooterAddressWhere"]
};
	["FooterGeneralContact"]: {
	__typename: "FooterGeneralContact",
	_meta?: GraphQLTypes["FooterGeneralContactMeta"],
	id: GraphQLTypes["UUID"],
	label?: string,
	email?: string,
	info?: string
};
	["FooterGeneralContactMeta"]: {
	__typename: "FooterGeneralContactMeta",
	id?: GraphQLTypes["FieldMeta"],
	label?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	info?: GraphQLTypes["FieldMeta"]
};
	["FooterGeneralContactWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	label?: GraphQLTypes["StringCondition"],
	email?: GraphQLTypes["StringCondition"],
	info?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["FooterGeneralContactWhere"] | undefined>,
	or?: Array<GraphQLTypes["FooterGeneralContactWhere"] | undefined>,
	not?: GraphQLTypes["FooterGeneralContactWhere"]
};
	["FooterUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	members?: GraphQLTypes["MemberListUniqueWhere"],
	socialLinks?: GraphQLTypes["SocialLinkListUniqueWhere"]
};
	["FooterWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	info?: GraphQLTypes["StringCondition"],
	address?: GraphQLTypes["FooterAddressWhere"],
	members?: GraphQLTypes["MemberListWhere"],
	logo?: GraphQLTypes["ImageWhere"],
	socialLinks?: GraphQLTypes["SocialLinkListWhere"],
	unique?: GraphQLTypes["OneCondition"],
	generalContact?: GraphQLTypes["FooterGeneralContactWhere"],
	and?: Array<GraphQLTypes["FooterWhere"] | undefined>,
	or?: Array<GraphQLTypes["FooterWhere"] | undefined>,
	not?: GraphQLTypes["FooterWhere"]
};
	["FooterOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	info?: GraphQLTypes["OrderDirection"],
	address?: GraphQLTypes["FooterAddressOrderBy"],
	members?: GraphQLTypes["MemberListOrderBy"],
	logo?: GraphQLTypes["ImageOrderBy"],
	socialLinks?: GraphQLTypes["SocialLinkListOrderBy"],
	unique?: GraphQLTypes["OrderDirection"],
	generalContact?: GraphQLTypes["FooterGeneralContactOrderBy"]
};
	["FooterAddressOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	label?: GraphQLTypes["OrderDirection"],
	address?: GraphQLTypes["OrderDirection"],
	addressLink?: GraphQLTypes["LinkOrderBy"]
};
	["FooterGeneralContactOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	label?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"],
	info?: GraphQLTypes["OrderDirection"]
};
	["FooterConnection"]: {
	__typename: "FooterConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterEdge"]>
};
	["FooterEdge"]: {
	__typename: "FooterEdge",
	node: GraphQLTypes["Footer"]
};
	["FooterCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	info?: string,
	address?: GraphQLTypes["FooterCreateAddressEntityRelationInput"],
	members?: GraphQLTypes["FooterCreateMembersEntityRelationInput"],
	logo?: GraphQLTypes["FooterCreateLogoEntityRelationInput"],
	socialLinks?: GraphQLTypes["FooterCreateSocialLinksEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	generalContact?: GraphQLTypes["FooterCreateGeneralContactEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterCreateAddressEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterAddressUniqueWhere"],
	create?: GraphQLTypes["FooterAddressCreateInput"]
};
	["FooterAddressUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	addressLink?: GraphQLTypes["LinkUniqueWhere"]
};
	["FooterAddressCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	label?: string,
	address?: string,
	addressLink?: GraphQLTypes["FooterAddressCreateAddressLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterAddressCreateAddressLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FooterCreateMembersEntityRelationInput"]: {
		connect?: GraphQLTypes["MemberListUniqueWhere"],
	create?: GraphQLTypes["MemberListCreateInput"]
};
	["FooterCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FooterCreateSocialLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["SocialLinkListUniqueWhere"],
	create?: GraphQLTypes["SocialLinkListCreateInput"]
};
	["FooterCreateGeneralContactEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterGeneralContactUniqueWhere"],
	create?: GraphQLTypes["FooterGeneralContactCreateInput"]
};
	["FooterGeneralContactUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["FooterGeneralContactCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	label?: string,
	email?: string,
	info?: string,
	_dummy_field_?: boolean
};
	["FooterUpdateInput"]: {
		title?: string,
	info?: string,
	address?: GraphQLTypes["FooterUpdateAddressEntityRelationInput"],
	members?: GraphQLTypes["FooterUpdateMembersEntityRelationInput"],
	logo?: GraphQLTypes["FooterUpdateLogoEntityRelationInput"],
	socialLinks?: GraphQLTypes["FooterUpdateSocialLinksEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	generalContact?: GraphQLTypes["FooterUpdateGeneralContactEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterUpdateAddressEntityRelationInput"]: {
		create?: GraphQLTypes["FooterAddressCreateInput"],
	update?: GraphQLTypes["FooterAddressUpdateInput"],
	upsert?: GraphQLTypes["FooterUpsertAddressRelationInput"],
	connect?: GraphQLTypes["FooterAddressUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterAddressUpdateInput"]: {
		label?: string,
	address?: string,
	addressLink?: GraphQLTypes["FooterAddressUpdateAddressLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterAddressUpdateAddressLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["FooterAddressUpsertAddressLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterAddressUpsertAddressLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FooterUpsertAddressRelationInput"]: {
		update?: GraphQLTypes["FooterAddressUpdateInput"],
	create?: GraphQLTypes["FooterAddressCreateInput"]
};
	["FooterUpdateMembersEntityRelationInput"]: {
		create?: GraphQLTypes["MemberListCreateInput"],
	update?: GraphQLTypes["MemberListUpdateInput"],
	upsert?: GraphQLTypes["FooterUpsertMembersRelationInput"],
	connect?: GraphQLTypes["MemberListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterUpsertMembersRelationInput"]: {
		update?: GraphQLTypes["MemberListUpdateInput"],
	create?: GraphQLTypes["MemberListCreateInput"]
};
	["FooterUpdateLogoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["FooterUpsertLogoRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterUpsertLogoRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FooterUpdateSocialLinksEntityRelationInput"]: {
		create?: GraphQLTypes["SocialLinkListCreateInput"],
	update?: GraphQLTypes["SocialLinkListUpdateInput"],
	upsert?: GraphQLTypes["FooterUpsertSocialLinksRelationInput"],
	connect?: GraphQLTypes["SocialLinkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterUpsertSocialLinksRelationInput"]: {
		update?: GraphQLTypes["SocialLinkListUpdateInput"],
	create?: GraphQLTypes["SocialLinkListCreateInput"]
};
	["FooterUpdateGeneralContactEntityRelationInput"]: {
		create?: GraphQLTypes["FooterGeneralContactCreateInput"],
	update?: GraphQLTypes["FooterGeneralContactUpdateInput"],
	upsert?: GraphQLTypes["FooterUpsertGeneralContactRelationInput"],
	connect?: GraphQLTypes["FooterGeneralContactUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterGeneralContactUpdateInput"]: {
		label?: string,
	email?: string,
	info?: string,
	_dummy_field_?: boolean
};
	["FooterUpsertGeneralContactRelationInput"]: {
		update?: GraphQLTypes["FooterGeneralContactUpdateInput"],
	create?: GraphQLTypes["FooterGeneralContactCreateInput"]
};
	["FooterAddressConnection"]: {
	__typename: "FooterAddressConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterAddressEdge"]>
};
	["FooterAddressEdge"]: {
	__typename: "FooterAddressEdge",
	node: GraphQLTypes["FooterAddress"]
};
	["PortfolioPageConnection"]: {
	__typename: "PortfolioPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PortfolioPageEdge"]>
};
	["PortfolioPageEdge"]: {
	__typename: "PortfolioPageEdge",
	node: GraphQLTypes["PortfolioPage"]
};
	["PortfolioPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	link?: GraphQLTypes["PortfolioPageCreateLinkEntityRelationInput"],
	seo?: GraphQLTypes["PortfolioPageCreateSeoEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	title?: string,
	text?: string,
	_dummy_field_?: boolean
};
	["PortfolioPageCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutPortfolioPageCreateInput"]
};
	["LinkableWithoutPortfolioPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	showPage?: GraphQLTypes["LinkableCreateShowPageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PortfolioPageUpdateInput"]: {
		name?: string,
	link?: GraphQLTypes["PortfolioPageUpdateLinkEntityRelationInput"],
	seo?: GraphQLTypes["PortfolioPageUpdateSeoEntityRelationInput"],
	unique?: GraphQLTypes["One"],
	title?: string,
	text?: string,
	_dummy_field_?: boolean
};
	["PortfolioPageUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutPortfolioPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutPortfolioPageUpdateInput"],
	upsert?: GraphQLTypes["PortfolioPageUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutPortfolioPageUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	showPage?: GraphQLTypes["LinkableUpdateShowPageEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PortfolioPageUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutPortfolioPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutPortfolioPageCreateInput"]
};
	["ShowItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["ShowItemCreateListEntityRelationInput"],
	show?: GraphQLTypes["ShowItemCreateShowEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ShowItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["ShowItemUpdateListEntityRelationInput"],
	show?: GraphQLTypes["ShowItemUpdateShowEntityRelationInput"],
	_dummy_field_?: boolean
};
	["Settings"]: {
	__typename: "Settings",
	_meta?: GraphQLTypes["SettingsMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	seo?: GraphQLTypes["Seo"]
};
	["SettingsMeta"]: {
	__typename: "SettingsMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["SettingsUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["SettingsWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["SettingsWhere"] | undefined>,
	or?: Array<GraphQLTypes["SettingsWhere"] | undefined>,
	not?: GraphQLTypes["SettingsWhere"]
};
	["SettingsOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["SettingsConnection"]: {
	__typename: "SettingsConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SettingsEdge"]>
};
	["SettingsEdge"]: {
	__typename: "SettingsEdge",
	node: GraphQLTypes["Settings"]
};
	["SettingsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["SettingsCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SettingsCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["SettingsUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	seo?: GraphQLTypes["SettingsUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SettingsUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["SettingsUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SettingsUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["FooterGeneralContactConnection"]: {
	__typename: "FooterGeneralContactConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterGeneralContactEdge"]>
};
	["FooterGeneralContactEdge"]: {
	__typename: "FooterGeneralContactEdge",
	node: GraphQLTypes["FooterGeneralContact"]
};
	["RedirectConnection"]: {
	__typename: "RedirectConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RedirectEdge"]>
};
	["RedirectEdge"]: {
	__typename: "RedirectEdge",
	node: GraphQLTypes["Redirect"]
};
	["RedirectCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["RedirectCreateLinkEntityRelationInput"],
	target?: GraphQLTypes["RedirectCreateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"]
};
	["LinkableWithoutRedirectCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	portfolioPage?: GraphQLTypes["LinkableCreatePortfolioPageEntityRelationInput"],
	showPage?: GraphQLTypes["LinkableCreateShowPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateInput"]: {
		link?: GraphQLTypes["RedirectUpdateLinkEntityRelationInput"],
	target?: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"],
	update?: GraphQLTypes["LinkableWithoutRedirectUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutRedirectUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	portfolioPage?: GraphQLTypes["LinkableUpdatePortfolioPageEntityRelationInput"],
	showPage?: GraphQLTypes["LinkableUpdateShowPageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutRedirectUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"]
};
	["QueryTransaction"]: {
	__typename: "QueryTransaction",
	getContentBlock?: GraphQLTypes["ContentBlock"],
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getHomePage?: GraphQLTypes["HomePage"],
	listHomePage: Array<GraphQLTypes["HomePage"]>,
	paginateHomePage: GraphQLTypes["HomePageConnection"],
	validateCreateHomePage: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePage: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"],
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getMediumGallery?: GraphQLTypes["MediumGallery"],
	listMediumGallery: Array<GraphQLTypes["MediumGallery"]>,
	paginateMediumGallery: GraphQLTypes["MediumGalleryConnection"],
	validateCreateMediumGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateMediumGallery: GraphQLTypes["_ValidationResult"],
	getMediumGalleryItem?: GraphQLTypes["MediumGalleryItem"],
	listMediumGalleryItem: Array<GraphQLTypes["MediumGalleryItem"]>,
	paginateMediumGalleryItem: GraphQLTypes["MediumGalleryItemConnection"],
	validateCreateMediumGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMediumGalleryItem: GraphQLTypes["_ValidationResult"],
	getMember?: GraphQLTypes["Member"],
	listMember: Array<GraphQLTypes["Member"]>,
	paginateMember: GraphQLTypes["MemberConnection"],
	validateCreateMember: GraphQLTypes["_ValidationResult"],
	validateUpdateMember: GraphQLTypes["_ValidationResult"],
	getMemberItem?: GraphQLTypes["MemberItem"],
	listMemberItem: Array<GraphQLTypes["MemberItem"]>,
	paginateMemberItem: GraphQLTypes["MemberItemConnection"],
	validateCreateMemberItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMemberItem: GraphQLTypes["_ValidationResult"],
	getMemberList?: GraphQLTypes["MemberList"],
	listMemberList: Array<GraphQLTypes["MemberList"]>,
	paginateMemberList: GraphQLTypes["MemberListConnection"],
	validateCreateMemberList: GraphQLTypes["_ValidationResult"],
	validateUpdateMemberList: GraphQLTypes["_ValidationResult"],
	getShow?: GraphQLTypes["Show"],
	listShow: Array<GraphQLTypes["Show"]>,
	paginateShow: GraphQLTypes["ShowConnection"],
	validateCreateShow: GraphQLTypes["_ValidationResult"],
	validateUpdateShow: GraphQLTypes["_ValidationResult"],
	getShowList?: GraphQLTypes["ShowList"],
	listShowList: Array<GraphQLTypes["ShowList"]>,
	paginateShowList: GraphQLTypes["ShowListConnection"],
	validateCreateShowList: GraphQLTypes["_ValidationResult"],
	validateUpdateShowList: GraphQLTypes["_ValidationResult"],
	getShowYear?: GraphQLTypes["ShowYear"],
	listShowYear: Array<GraphQLTypes["ShowYear"]>,
	paginateShowYear: GraphQLTypes["ShowYearConnection"],
	validateCreateShowYear: GraphQLTypes["_ValidationResult"],
	validateUpdateShowYear: GraphQLTypes["_ValidationResult"],
	getShowYearItem?: GraphQLTypes["ShowYearItem"],
	listShowYearItem: Array<GraphQLTypes["ShowYearItem"]>,
	paginateShowYearItem: GraphQLTypes["ShowYearItemConnection"],
	validateCreateShowYearItem: GraphQLTypes["_ValidationResult"],
	validateUpdateShowYearItem: GraphQLTypes["_ValidationResult"],
	getShowYearList?: GraphQLTypes["ShowYearList"],
	listShowYearList: Array<GraphQLTypes["ShowYearList"]>,
	paginateShowYearList: GraphQLTypes["ShowYearListConnection"],
	validateCreateShowYearList: GraphQLTypes["_ValidationResult"],
	validateUpdateShowYearList: GraphQLTypes["_ValidationResult"],
	getSocialLink?: GraphQLTypes["SocialLink"],
	listSocialLink: Array<GraphQLTypes["SocialLink"]>,
	paginateSocialLink: GraphQLTypes["SocialLinkConnection"],
	validateCreateSocialLink: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLink: GraphQLTypes["_ValidationResult"],
	getSocialLinkItem?: GraphQLTypes["SocialLinkItem"],
	listSocialLinkItem: Array<GraphQLTypes["SocialLinkItem"]>,
	paginateSocialLinkItem: GraphQLTypes["SocialLinkItemConnection"],
	validateCreateSocialLinkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLinkItem: GraphQLTypes["_ValidationResult"],
	getSocialLinkList?: GraphQLTypes["SocialLinkList"],
	listSocialLinkList: Array<GraphQLTypes["SocialLinkList"]>,
	paginateSocialLinkList: GraphQLTypes["SocialLinkListConnection"],
	validateCreateSocialLinkList: GraphQLTypes["_ValidationResult"],
	validateUpdateSocialLinkList: GraphQLTypes["_ValidationResult"],
	getVideo?: GraphQLTypes["Video"],
	listVideo: Array<GraphQLTypes["Video"]>,
	paginateVideo: GraphQLTypes["VideoConnection"],
	validateCreateVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateVideo: GraphQLTypes["_ValidationResult"],
	getYoutubeVideo?: GraphQLTypes["YoutubeVideo"],
	listYoutubeVideo: Array<GraphQLTypes["YoutubeVideo"]>,
	paginateYoutubeVideo: GraphQLTypes["YoutubeVideoConnection"],
	validateCreateYoutubeVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateYoutubeVideo: GraphQLTypes["_ValidationResult"],
	getHeader?: GraphQLTypes["Header"],
	listHeader: Array<GraphQLTypes["Header"]>,
	paginateHeader: GraphQLTypes["HeaderConnection"],
	validateCreateHeader: GraphQLTypes["_ValidationResult"],
	validateUpdateHeader: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"],
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getFooterAddress?: GraphQLTypes["FooterAddress"],
	listFooterAddress: Array<GraphQLTypes["FooterAddress"]>,
	paginateFooterAddress: GraphQLTypes["FooterAddressConnection"],
	validateCreateFooterAddress: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterAddress: GraphQLTypes["_ValidationResult"],
	getPortfolioPage?: GraphQLTypes["PortfolioPage"],
	listPortfolioPage: Array<GraphQLTypes["PortfolioPage"]>,
	paginatePortfolioPage: GraphQLTypes["PortfolioPageConnection"],
	validateCreatePortfolioPage: GraphQLTypes["_ValidationResult"],
	validateUpdatePortfolioPage: GraphQLTypes["_ValidationResult"],
	getShowItem?: GraphQLTypes["ShowItem"],
	listShowItem: Array<GraphQLTypes["ShowItem"]>,
	paginateShowItem: GraphQLTypes["ShowItemConnection"],
	validateCreateShowItem: GraphQLTypes["_ValidationResult"],
	validateUpdateShowItem: GraphQLTypes["_ValidationResult"],
	getSettings?: GraphQLTypes["Settings"],
	listSettings: Array<GraphQLTypes["Settings"]>,
	paginateSettings: GraphQLTypes["SettingsConnection"],
	validateCreateSettings: GraphQLTypes["_ValidationResult"],
	validateUpdateSettings: GraphQLTypes["_ValidationResult"],
	getFooterGeneralContact?: GraphQLTypes["FooterGeneralContact"],
	listFooterGeneralContact: Array<GraphQLTypes["FooterGeneralContact"]>,
	paginateFooterGeneralContact: GraphQLTypes["FooterGeneralContactConnection"],
	validateCreateFooterGeneralContact: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterGeneralContact: GraphQLTypes["_ValidationResult"],
	getRedirect?: GraphQLTypes["Redirect"],
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"]
};
	["Info"]: {
	__typename: "Info",
	description?: string
};
	["Mutation"]: {
	__typename: "Mutation",
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createHomePage: GraphQLTypes["HomePageCreateResult"],
	deleteHomePage: GraphQLTypes["HomePageDeleteResult"],
	updateHomePage: GraphQLTypes["HomePageUpdateResult"],
	upsertHomePage: GraphQLTypes["HomePageUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createMediumGallery: GraphQLTypes["MediumGalleryCreateResult"],
	deleteMediumGallery: GraphQLTypes["MediumGalleryDeleteResult"],
	updateMediumGallery: GraphQLTypes["MediumGalleryUpdateResult"],
	upsertMediumGallery: GraphQLTypes["MediumGalleryUpsertResult"],
	createMediumGalleryItem: GraphQLTypes["MediumGalleryItemCreateResult"],
	deleteMediumGalleryItem: GraphQLTypes["MediumGalleryItemDeleteResult"],
	updateMediumGalleryItem: GraphQLTypes["MediumGalleryItemUpdateResult"],
	upsertMediumGalleryItem: GraphQLTypes["MediumGalleryItemUpsertResult"],
	createMember: GraphQLTypes["MemberCreateResult"],
	deleteMember: GraphQLTypes["MemberDeleteResult"],
	updateMember: GraphQLTypes["MemberUpdateResult"],
	upsertMember: GraphQLTypes["MemberUpsertResult"],
	createMemberItem: GraphQLTypes["MemberItemCreateResult"],
	deleteMemberItem: GraphQLTypes["MemberItemDeleteResult"],
	updateMemberItem: GraphQLTypes["MemberItemUpdateResult"],
	upsertMemberItem: GraphQLTypes["MemberItemUpsertResult"],
	createMemberList: GraphQLTypes["MemberListCreateResult"],
	deleteMemberList: GraphQLTypes["MemberListDeleteResult"],
	updateMemberList: GraphQLTypes["MemberListUpdateResult"],
	upsertMemberList: GraphQLTypes["MemberListUpsertResult"],
	createShow: GraphQLTypes["ShowCreateResult"],
	deleteShow: GraphQLTypes["ShowDeleteResult"],
	updateShow: GraphQLTypes["ShowUpdateResult"],
	upsertShow: GraphQLTypes["ShowUpsertResult"],
	createShowList: GraphQLTypes["ShowListCreateResult"],
	deleteShowList: GraphQLTypes["ShowListDeleteResult"],
	updateShowList: GraphQLTypes["ShowListUpdateResult"],
	upsertShowList: GraphQLTypes["ShowListUpsertResult"],
	createShowYear: GraphQLTypes["ShowYearCreateResult"],
	deleteShowYear: GraphQLTypes["ShowYearDeleteResult"],
	updateShowYear: GraphQLTypes["ShowYearUpdateResult"],
	upsertShowYear: GraphQLTypes["ShowYearUpsertResult"],
	createShowYearItem: GraphQLTypes["ShowYearItemCreateResult"],
	deleteShowYearItem: GraphQLTypes["ShowYearItemDeleteResult"],
	updateShowYearItem: GraphQLTypes["ShowYearItemUpdateResult"],
	upsertShowYearItem: GraphQLTypes["ShowYearItemUpsertResult"],
	createShowYearList: GraphQLTypes["ShowYearListCreateResult"],
	deleteShowYearList: GraphQLTypes["ShowYearListDeleteResult"],
	updateShowYearList: GraphQLTypes["ShowYearListUpdateResult"],
	upsertShowYearList: GraphQLTypes["ShowYearListUpsertResult"],
	createSocialLink: GraphQLTypes["SocialLinkCreateResult"],
	deleteSocialLink: GraphQLTypes["SocialLinkDeleteResult"],
	updateSocialLink: GraphQLTypes["SocialLinkUpdateResult"],
	upsertSocialLink: GraphQLTypes["SocialLinkUpsertResult"],
	createSocialLinkItem: GraphQLTypes["SocialLinkItemCreateResult"],
	deleteSocialLinkItem: GraphQLTypes["SocialLinkItemDeleteResult"],
	updateSocialLinkItem: GraphQLTypes["SocialLinkItemUpdateResult"],
	upsertSocialLinkItem: GraphQLTypes["SocialLinkItemUpsertResult"],
	createSocialLinkList: GraphQLTypes["SocialLinkListCreateResult"],
	deleteSocialLinkList: GraphQLTypes["SocialLinkListDeleteResult"],
	updateSocialLinkList: GraphQLTypes["SocialLinkListUpdateResult"],
	upsertSocialLinkList: GraphQLTypes["SocialLinkListUpsertResult"],
	createVideo: GraphQLTypes["VideoCreateResult"],
	deleteVideo: GraphQLTypes["VideoDeleteResult"],
	updateVideo: GraphQLTypes["VideoUpdateResult"],
	upsertVideo: GraphQLTypes["VideoUpsertResult"],
	createYoutubeVideo: GraphQLTypes["YoutubeVideoCreateResult"],
	deleteYoutubeVideo: GraphQLTypes["YoutubeVideoDeleteResult"],
	updateYoutubeVideo: GraphQLTypes["YoutubeVideoUpdateResult"],
	upsertYoutubeVideo: GraphQLTypes["YoutubeVideoUpsertResult"],
	createHeader: GraphQLTypes["HeaderCreateResult"],
	deleteHeader: GraphQLTypes["HeaderDeleteResult"],
	updateHeader: GraphQLTypes["HeaderUpdateResult"],
	upsertHeader: GraphQLTypes["HeaderUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createFooterAddress: GraphQLTypes["FooterAddressCreateResult"],
	deleteFooterAddress: GraphQLTypes["FooterAddressDeleteResult"],
	updateFooterAddress: GraphQLTypes["FooterAddressUpdateResult"],
	upsertFooterAddress: GraphQLTypes["FooterAddressUpsertResult"],
	createPortfolioPage: GraphQLTypes["PortfolioPageCreateResult"],
	deletePortfolioPage: GraphQLTypes["PortfolioPageDeleteResult"],
	updatePortfolioPage: GraphQLTypes["PortfolioPageUpdateResult"],
	upsertPortfolioPage: GraphQLTypes["PortfolioPageUpsertResult"],
	createShowItem: GraphQLTypes["ShowItemCreateResult"],
	deleteShowItem: GraphQLTypes["ShowItemDeleteResult"],
	updateShowItem: GraphQLTypes["ShowItemUpdateResult"],
	upsertShowItem: GraphQLTypes["ShowItemUpsertResult"],
	createSettings: GraphQLTypes["SettingsCreateResult"],
	deleteSettings: GraphQLTypes["SettingsDeleteResult"],
	updateSettings: GraphQLTypes["SettingsUpdateResult"],
	upsertSettings: GraphQLTypes["SettingsUpsertResult"],
	createFooterGeneralContact: GraphQLTypes["FooterGeneralContactCreateResult"],
	deleteFooterGeneralContact: GraphQLTypes["FooterGeneralContactDeleteResult"],
	updateFooterGeneralContact: GraphQLTypes["FooterGeneralContactUpdateResult"],
	upsertFooterGeneralContact: GraphQLTypes["FooterGeneralContactUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	transaction: GraphQLTypes["MutationTransaction"],
	query: GraphQLTypes["Query"],
	generateUploadUrl: GraphQLTypes["S3SignedUpload"],
	generateReadUrl: GraphQLTypes["S3SignedRead"]
};
	["ContentBlockCreateResult"]: {
	__typename: "ContentBlockCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationResult"]: {
	__typename:"ContentBlockCreateResult" | "ContentBlockDeleteResult" | "ContentBlockUpdateResult" | "ContentBlockUpsertResult" | "ImageCreateResult" | "ImageDeleteResult" | "ImageUpdateResult" | "ImageUpsertResult" | "LinkCreateResult" | "LinkDeleteResult" | "LinkUpdateResult" | "LinkUpsertResult" | "SeoCreateResult" | "SeoDeleteResult" | "SeoUpdateResult" | "SeoUpsertResult" | "HomePageCreateResult" | "HomePageDeleteResult" | "HomePageUpdateResult" | "HomePageUpsertResult" | "LinkableCreateResult" | "LinkableDeleteResult" | "LinkableUpdateResult" | "LinkableUpsertResult" | "MediumGalleryCreateResult" | "MediumGalleryDeleteResult" | "MediumGalleryUpdateResult" | "MediumGalleryUpsertResult" | "MediumGalleryItemCreateResult" | "MediumGalleryItemDeleteResult" | "MediumGalleryItemUpdateResult" | "MediumGalleryItemUpsertResult" | "MemberCreateResult" | "MemberDeleteResult" | "MemberUpdateResult" | "MemberUpsertResult" | "MemberItemCreateResult" | "MemberItemDeleteResult" | "MemberItemUpdateResult" | "MemberItemUpsertResult" | "MemberListCreateResult" | "MemberListDeleteResult" | "MemberListUpdateResult" | "MemberListUpsertResult" | "ShowCreateResult" | "ShowDeleteResult" | "ShowUpdateResult" | "ShowUpsertResult" | "ShowListCreateResult" | "ShowListDeleteResult" | "ShowListUpdateResult" | "ShowListUpsertResult" | "ShowYearCreateResult" | "ShowYearDeleteResult" | "ShowYearUpdateResult" | "ShowYearUpsertResult" | "ShowYearItemCreateResult" | "ShowYearItemDeleteResult" | "ShowYearItemUpdateResult" | "ShowYearItemUpsertResult" | "ShowYearListCreateResult" | "ShowYearListDeleteResult" | "ShowYearListUpdateResult" | "ShowYearListUpsertResult" | "SocialLinkCreateResult" | "SocialLinkDeleteResult" | "SocialLinkUpdateResult" | "SocialLinkUpsertResult" | "SocialLinkItemCreateResult" | "SocialLinkItemDeleteResult" | "SocialLinkItemUpdateResult" | "SocialLinkItemUpsertResult" | "SocialLinkListCreateResult" | "SocialLinkListDeleteResult" | "SocialLinkListUpdateResult" | "SocialLinkListUpsertResult" | "VideoCreateResult" | "VideoDeleteResult" | "VideoUpdateResult" | "VideoUpsertResult" | "YoutubeVideoCreateResult" | "YoutubeVideoDeleteResult" | "YoutubeVideoUpdateResult" | "YoutubeVideoUpsertResult" | "HeaderCreateResult" | "HeaderDeleteResult" | "HeaderUpdateResult" | "HeaderUpsertResult" | "FooterCreateResult" | "FooterDeleteResult" | "FooterUpdateResult" | "FooterUpsertResult" | "FooterAddressCreateResult" | "FooterAddressDeleteResult" | "FooterAddressUpdateResult" | "FooterAddressUpsertResult" | "PortfolioPageCreateResult" | "PortfolioPageDeleteResult" | "PortfolioPageUpdateResult" | "PortfolioPageUpsertResult" | "ShowItemCreateResult" | "ShowItemDeleteResult" | "ShowItemUpdateResult" | "ShowItemUpsertResult" | "SettingsCreateResult" | "SettingsDeleteResult" | "SettingsUpdateResult" | "SettingsUpsertResult" | "FooterGeneralContactCreateResult" | "FooterGeneralContactDeleteResult" | "FooterGeneralContactUpdateResult" | "FooterGeneralContactUpsertResult" | "RedirectCreateResult" | "RedirectDeleteResult" | "RedirectUpdateResult" | "RedirectUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>
	['...on ContentBlockCreateResult']: '__union' & GraphQLTypes["ContentBlockCreateResult"];
	['...on ContentBlockDeleteResult']: '__union' & GraphQLTypes["ContentBlockDeleteResult"];
	['...on ContentBlockUpdateResult']: '__union' & GraphQLTypes["ContentBlockUpdateResult"];
	['...on ContentBlockUpsertResult']: '__union' & GraphQLTypes["ContentBlockUpsertResult"];
	['...on ImageCreateResult']: '__union' & GraphQLTypes["ImageCreateResult"];
	['...on ImageDeleteResult']: '__union' & GraphQLTypes["ImageDeleteResult"];
	['...on ImageUpdateResult']: '__union' & GraphQLTypes["ImageUpdateResult"];
	['...on ImageUpsertResult']: '__union' & GraphQLTypes["ImageUpsertResult"];
	['...on LinkCreateResult']: '__union' & GraphQLTypes["LinkCreateResult"];
	['...on LinkDeleteResult']: '__union' & GraphQLTypes["LinkDeleteResult"];
	['...on LinkUpdateResult']: '__union' & GraphQLTypes["LinkUpdateResult"];
	['...on LinkUpsertResult']: '__union' & GraphQLTypes["LinkUpsertResult"];
	['...on SeoCreateResult']: '__union' & GraphQLTypes["SeoCreateResult"];
	['...on SeoDeleteResult']: '__union' & GraphQLTypes["SeoDeleteResult"];
	['...on SeoUpdateResult']: '__union' & GraphQLTypes["SeoUpdateResult"];
	['...on SeoUpsertResult']: '__union' & GraphQLTypes["SeoUpsertResult"];
	['...on HomePageCreateResult']: '__union' & GraphQLTypes["HomePageCreateResult"];
	['...on HomePageDeleteResult']: '__union' & GraphQLTypes["HomePageDeleteResult"];
	['...on HomePageUpdateResult']: '__union' & GraphQLTypes["HomePageUpdateResult"];
	['...on HomePageUpsertResult']: '__union' & GraphQLTypes["HomePageUpsertResult"];
	['...on LinkableCreateResult']: '__union' & GraphQLTypes["LinkableCreateResult"];
	['...on LinkableDeleteResult']: '__union' & GraphQLTypes["LinkableDeleteResult"];
	['...on LinkableUpdateResult']: '__union' & GraphQLTypes["LinkableUpdateResult"];
	['...on LinkableUpsertResult']: '__union' & GraphQLTypes["LinkableUpsertResult"];
	['...on MediumGalleryCreateResult']: '__union' & GraphQLTypes["MediumGalleryCreateResult"];
	['...on MediumGalleryDeleteResult']: '__union' & GraphQLTypes["MediumGalleryDeleteResult"];
	['...on MediumGalleryUpdateResult']: '__union' & GraphQLTypes["MediumGalleryUpdateResult"];
	['...on MediumGalleryUpsertResult']: '__union' & GraphQLTypes["MediumGalleryUpsertResult"];
	['...on MediumGalleryItemCreateResult']: '__union' & GraphQLTypes["MediumGalleryItemCreateResult"];
	['...on MediumGalleryItemDeleteResult']: '__union' & GraphQLTypes["MediumGalleryItemDeleteResult"];
	['...on MediumGalleryItemUpdateResult']: '__union' & GraphQLTypes["MediumGalleryItemUpdateResult"];
	['...on MediumGalleryItemUpsertResult']: '__union' & GraphQLTypes["MediumGalleryItemUpsertResult"];
	['...on MemberCreateResult']: '__union' & GraphQLTypes["MemberCreateResult"];
	['...on MemberDeleteResult']: '__union' & GraphQLTypes["MemberDeleteResult"];
	['...on MemberUpdateResult']: '__union' & GraphQLTypes["MemberUpdateResult"];
	['...on MemberUpsertResult']: '__union' & GraphQLTypes["MemberUpsertResult"];
	['...on MemberItemCreateResult']: '__union' & GraphQLTypes["MemberItemCreateResult"];
	['...on MemberItemDeleteResult']: '__union' & GraphQLTypes["MemberItemDeleteResult"];
	['...on MemberItemUpdateResult']: '__union' & GraphQLTypes["MemberItemUpdateResult"];
	['...on MemberItemUpsertResult']: '__union' & GraphQLTypes["MemberItemUpsertResult"];
	['...on MemberListCreateResult']: '__union' & GraphQLTypes["MemberListCreateResult"];
	['...on MemberListDeleteResult']: '__union' & GraphQLTypes["MemberListDeleteResult"];
	['...on MemberListUpdateResult']: '__union' & GraphQLTypes["MemberListUpdateResult"];
	['...on MemberListUpsertResult']: '__union' & GraphQLTypes["MemberListUpsertResult"];
	['...on ShowCreateResult']: '__union' & GraphQLTypes["ShowCreateResult"];
	['...on ShowDeleteResult']: '__union' & GraphQLTypes["ShowDeleteResult"];
	['...on ShowUpdateResult']: '__union' & GraphQLTypes["ShowUpdateResult"];
	['...on ShowUpsertResult']: '__union' & GraphQLTypes["ShowUpsertResult"];
	['...on ShowListCreateResult']: '__union' & GraphQLTypes["ShowListCreateResult"];
	['...on ShowListDeleteResult']: '__union' & GraphQLTypes["ShowListDeleteResult"];
	['...on ShowListUpdateResult']: '__union' & GraphQLTypes["ShowListUpdateResult"];
	['...on ShowListUpsertResult']: '__union' & GraphQLTypes["ShowListUpsertResult"];
	['...on ShowYearCreateResult']: '__union' & GraphQLTypes["ShowYearCreateResult"];
	['...on ShowYearDeleteResult']: '__union' & GraphQLTypes["ShowYearDeleteResult"];
	['...on ShowYearUpdateResult']: '__union' & GraphQLTypes["ShowYearUpdateResult"];
	['...on ShowYearUpsertResult']: '__union' & GraphQLTypes["ShowYearUpsertResult"];
	['...on ShowYearItemCreateResult']: '__union' & GraphQLTypes["ShowYearItemCreateResult"];
	['...on ShowYearItemDeleteResult']: '__union' & GraphQLTypes["ShowYearItemDeleteResult"];
	['...on ShowYearItemUpdateResult']: '__union' & GraphQLTypes["ShowYearItemUpdateResult"];
	['...on ShowYearItemUpsertResult']: '__union' & GraphQLTypes["ShowYearItemUpsertResult"];
	['...on ShowYearListCreateResult']: '__union' & GraphQLTypes["ShowYearListCreateResult"];
	['...on ShowYearListDeleteResult']: '__union' & GraphQLTypes["ShowYearListDeleteResult"];
	['...on ShowYearListUpdateResult']: '__union' & GraphQLTypes["ShowYearListUpdateResult"];
	['...on ShowYearListUpsertResult']: '__union' & GraphQLTypes["ShowYearListUpsertResult"];
	['...on SocialLinkCreateResult']: '__union' & GraphQLTypes["SocialLinkCreateResult"];
	['...on SocialLinkDeleteResult']: '__union' & GraphQLTypes["SocialLinkDeleteResult"];
	['...on SocialLinkUpdateResult']: '__union' & GraphQLTypes["SocialLinkUpdateResult"];
	['...on SocialLinkUpsertResult']: '__union' & GraphQLTypes["SocialLinkUpsertResult"];
	['...on SocialLinkItemCreateResult']: '__union' & GraphQLTypes["SocialLinkItemCreateResult"];
	['...on SocialLinkItemDeleteResult']: '__union' & GraphQLTypes["SocialLinkItemDeleteResult"];
	['...on SocialLinkItemUpdateResult']: '__union' & GraphQLTypes["SocialLinkItemUpdateResult"];
	['...on SocialLinkItemUpsertResult']: '__union' & GraphQLTypes["SocialLinkItemUpsertResult"];
	['...on SocialLinkListCreateResult']: '__union' & GraphQLTypes["SocialLinkListCreateResult"];
	['...on SocialLinkListDeleteResult']: '__union' & GraphQLTypes["SocialLinkListDeleteResult"];
	['...on SocialLinkListUpdateResult']: '__union' & GraphQLTypes["SocialLinkListUpdateResult"];
	['...on SocialLinkListUpsertResult']: '__union' & GraphQLTypes["SocialLinkListUpsertResult"];
	['...on VideoCreateResult']: '__union' & GraphQLTypes["VideoCreateResult"];
	['...on VideoDeleteResult']: '__union' & GraphQLTypes["VideoDeleteResult"];
	['...on VideoUpdateResult']: '__union' & GraphQLTypes["VideoUpdateResult"];
	['...on VideoUpsertResult']: '__union' & GraphQLTypes["VideoUpsertResult"];
	['...on YoutubeVideoCreateResult']: '__union' & GraphQLTypes["YoutubeVideoCreateResult"];
	['...on YoutubeVideoDeleteResult']: '__union' & GraphQLTypes["YoutubeVideoDeleteResult"];
	['...on YoutubeVideoUpdateResult']: '__union' & GraphQLTypes["YoutubeVideoUpdateResult"];
	['...on YoutubeVideoUpsertResult']: '__union' & GraphQLTypes["YoutubeVideoUpsertResult"];
	['...on HeaderCreateResult']: '__union' & GraphQLTypes["HeaderCreateResult"];
	['...on HeaderDeleteResult']: '__union' & GraphQLTypes["HeaderDeleteResult"];
	['...on HeaderUpdateResult']: '__union' & GraphQLTypes["HeaderUpdateResult"];
	['...on HeaderUpsertResult']: '__union' & GraphQLTypes["HeaderUpsertResult"];
	['...on FooterCreateResult']: '__union' & GraphQLTypes["FooterCreateResult"];
	['...on FooterDeleteResult']: '__union' & GraphQLTypes["FooterDeleteResult"];
	['...on FooterUpdateResult']: '__union' & GraphQLTypes["FooterUpdateResult"];
	['...on FooterUpsertResult']: '__union' & GraphQLTypes["FooterUpsertResult"];
	['...on FooterAddressCreateResult']: '__union' & GraphQLTypes["FooterAddressCreateResult"];
	['...on FooterAddressDeleteResult']: '__union' & GraphQLTypes["FooterAddressDeleteResult"];
	['...on FooterAddressUpdateResult']: '__union' & GraphQLTypes["FooterAddressUpdateResult"];
	['...on FooterAddressUpsertResult']: '__union' & GraphQLTypes["FooterAddressUpsertResult"];
	['...on PortfolioPageCreateResult']: '__union' & GraphQLTypes["PortfolioPageCreateResult"];
	['...on PortfolioPageDeleteResult']: '__union' & GraphQLTypes["PortfolioPageDeleteResult"];
	['...on PortfolioPageUpdateResult']: '__union' & GraphQLTypes["PortfolioPageUpdateResult"];
	['...on PortfolioPageUpsertResult']: '__union' & GraphQLTypes["PortfolioPageUpsertResult"];
	['...on ShowItemCreateResult']: '__union' & GraphQLTypes["ShowItemCreateResult"];
	['...on ShowItemDeleteResult']: '__union' & GraphQLTypes["ShowItemDeleteResult"];
	['...on ShowItemUpdateResult']: '__union' & GraphQLTypes["ShowItemUpdateResult"];
	['...on ShowItemUpsertResult']: '__union' & GraphQLTypes["ShowItemUpsertResult"];
	['...on SettingsCreateResult']: '__union' & GraphQLTypes["SettingsCreateResult"];
	['...on SettingsDeleteResult']: '__union' & GraphQLTypes["SettingsDeleteResult"];
	['...on SettingsUpdateResult']: '__union' & GraphQLTypes["SettingsUpdateResult"];
	['...on SettingsUpsertResult']: '__union' & GraphQLTypes["SettingsUpsertResult"];
	['...on FooterGeneralContactCreateResult']: '__union' & GraphQLTypes["FooterGeneralContactCreateResult"];
	['...on FooterGeneralContactDeleteResult']: '__union' & GraphQLTypes["FooterGeneralContactDeleteResult"];
	['...on FooterGeneralContactUpdateResult']: '__union' & GraphQLTypes["FooterGeneralContactUpdateResult"];
	['...on FooterGeneralContactUpsertResult']: '__union' & GraphQLTypes["FooterGeneralContactUpsertResult"];
	['...on RedirectCreateResult']: '__union' & GraphQLTypes["RedirectCreateResult"];
	['...on RedirectDeleteResult']: '__union' & GraphQLTypes["RedirectDeleteResult"];
	['...on RedirectUpdateResult']: '__union' & GraphQLTypes["RedirectUpdateResult"];
	['...on RedirectUpsertResult']: '__union' & GraphQLTypes["RedirectUpsertResult"];
};
	["_MutationError"]: {
	__typename: "_MutationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	paths: Array<GraphQLTypes["_PathFragment"]>,
	type: GraphQLTypes["_MutationErrorType"],
	message?: string
};
	["_MutationErrorType"]: _MutationErrorType;
	["ContentBlockDeleteResult"]: {
	__typename: "ContentBlockDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"]
};
	["ContentBlockUpdateResult"]: {
	__typename: "ContentBlockUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
	__typename: "ContentBlockUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
	__typename: "ImageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
	__typename: "ImageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"]
};
	["ImageUpdateResult"]: {
	__typename: "ImageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
	__typename: "ImageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
	__typename: "LinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
	__typename: "LinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"]
};
	["LinkUpdateResult"]: {
	__typename: "LinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
	__typename: "LinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
	__typename: "SeoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
	__typename: "SeoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"]
};
	["SeoUpdateResult"]: {
	__typename: "SeoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
	__typename: "SeoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageCreateResult"]: {
	__typename: "HomePageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageDeleteResult"]: {
	__typename: "HomePageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"]
};
	["HomePageUpdateResult"]: {
	__typename: "HomePageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageUpsertResult"]: {
	__typename: "HomePageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
	__typename: "LinkableCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
	__typename: "LinkableDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"]
};
	["LinkableUpdateResult"]: {
	__typename: "LinkableUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
	__typename: "LinkableUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumGalleryCreateResult"]: {
	__typename: "MediumGalleryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumGallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumGalleryDeleteResult"]: {
	__typename: "MediumGalleryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumGallery"]
};
	["MediumGalleryUpdateResult"]: {
	__typename: "MediumGalleryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumGallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumGalleryUpsertResult"]: {
	__typename: "MediumGalleryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumGallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumGalleryItemCreateResult"]: {
	__typename: "MediumGalleryItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumGalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumGalleryItemDeleteResult"]: {
	__typename: "MediumGalleryItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumGalleryItem"]
};
	["MediumGalleryItemUpdateResult"]: {
	__typename: "MediumGalleryItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumGalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumGalleryItemUpsertResult"]: {
	__typename: "MediumGalleryItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumGalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MemberCreateResult"]: {
	__typename: "MemberCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Member"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MemberDeleteResult"]: {
	__typename: "MemberDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Member"]
};
	["MemberUpdateResult"]: {
	__typename: "MemberUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Member"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MemberUpsertResult"]: {
	__typename: "MemberUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Member"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MemberItemCreateResult"]: {
	__typename: "MemberItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MemberItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MemberItemDeleteResult"]: {
	__typename: "MemberItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MemberItem"]
};
	["MemberItemUpdateResult"]: {
	__typename: "MemberItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MemberItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MemberItemUpsertResult"]: {
	__typename: "MemberItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MemberItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MemberListCreateResult"]: {
	__typename: "MemberListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MemberList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MemberListDeleteResult"]: {
	__typename: "MemberListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MemberList"]
};
	["MemberListUpdateResult"]: {
	__typename: "MemberListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MemberList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MemberListUpsertResult"]: {
	__typename: "MemberListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MemberList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowCreateResult"]: {
	__typename: "ShowCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Show"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowDeleteResult"]: {
	__typename: "ShowDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Show"]
};
	["ShowUpdateResult"]: {
	__typename: "ShowUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Show"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowUpsertResult"]: {
	__typename: "ShowUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Show"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowListCreateResult"]: {
	__typename: "ShowListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowListDeleteResult"]: {
	__typename: "ShowListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowList"]
};
	["ShowListUpdateResult"]: {
	__typename: "ShowListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowListUpsertResult"]: {
	__typename: "ShowListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowYearCreateResult"]: {
	__typename: "ShowYearCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowYear"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowYearDeleteResult"]: {
	__typename: "ShowYearDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowYear"]
};
	["ShowYearUpdateResult"]: {
	__typename: "ShowYearUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowYear"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowYearUpsertResult"]: {
	__typename: "ShowYearUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowYear"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowYearItemCreateResult"]: {
	__typename: "ShowYearItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowYearItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowYearItemDeleteResult"]: {
	__typename: "ShowYearItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowYearItem"]
};
	["ShowYearItemUpdateResult"]: {
	__typename: "ShowYearItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowYearItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowYearItemUpsertResult"]: {
	__typename: "ShowYearItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowYearItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowYearListCreateResult"]: {
	__typename: "ShowYearListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowYearList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowYearListDeleteResult"]: {
	__typename: "ShowYearListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowYearList"]
};
	["ShowYearListUpdateResult"]: {
	__typename: "ShowYearListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowYearList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowYearListUpsertResult"]: {
	__typename: "ShowYearListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowYearList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkCreateResult"]: {
	__typename: "SocialLinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkDeleteResult"]: {
	__typename: "SocialLinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLink"]
};
	["SocialLinkUpdateResult"]: {
	__typename: "SocialLinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkUpsertResult"]: {
	__typename: "SocialLinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkItemCreateResult"]: {
	__typename: "SocialLinkItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkItemDeleteResult"]: {
	__typename: "SocialLinkItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkItem"]
};
	["SocialLinkItemUpdateResult"]: {
	__typename: "SocialLinkItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkItemUpsertResult"]: {
	__typename: "SocialLinkItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkListCreateResult"]: {
	__typename: "SocialLinkListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkListDeleteResult"]: {
	__typename: "SocialLinkListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkList"]
};
	["SocialLinkListUpdateResult"]: {
	__typename: "SocialLinkListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SocialLinkListUpsertResult"]: {
	__typename: "SocialLinkListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SocialLinkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoCreateResult"]: {
	__typename: "VideoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoDeleteResult"]: {
	__typename: "VideoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"]
};
	["VideoUpdateResult"]: {
	__typename: "VideoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoUpsertResult"]: {
	__typename: "VideoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["YoutubeVideoCreateResult"]: {
	__typename: "YoutubeVideoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["YoutubeVideo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["YoutubeVideoDeleteResult"]: {
	__typename: "YoutubeVideoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["YoutubeVideo"]
};
	["YoutubeVideoUpdateResult"]: {
	__typename: "YoutubeVideoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["YoutubeVideo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["YoutubeVideoUpsertResult"]: {
	__typename: "YoutubeVideoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["YoutubeVideo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderCreateResult"]: {
	__typename: "HeaderCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderDeleteResult"]: {
	__typename: "HeaderDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"]
};
	["HeaderUpdateResult"]: {
	__typename: "HeaderUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderUpsertResult"]: {
	__typename: "HeaderUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
	__typename: "FooterCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
	__typename: "FooterDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"]
};
	["FooterUpdateResult"]: {
	__typename: "FooterUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
	__typename: "FooterUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterAddressCreateResult"]: {
	__typename: "FooterAddressCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterAddress"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterAddressDeleteResult"]: {
	__typename: "FooterAddressDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterAddress"]
};
	["FooterAddressUpdateResult"]: {
	__typename: "FooterAddressUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterAddress"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterAddressUpsertResult"]: {
	__typename: "FooterAddressUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterAddress"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PortfolioPageCreateResult"]: {
	__typename: "PortfolioPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PortfolioPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PortfolioPageDeleteResult"]: {
	__typename: "PortfolioPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PortfolioPage"]
};
	["PortfolioPageUpdateResult"]: {
	__typename: "PortfolioPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PortfolioPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PortfolioPageUpsertResult"]: {
	__typename: "PortfolioPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PortfolioPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowItemCreateResult"]: {
	__typename: "ShowItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowItemDeleteResult"]: {
	__typename: "ShowItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowItem"]
};
	["ShowItemUpdateResult"]: {
	__typename: "ShowItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ShowItemUpsertResult"]: {
	__typename: "ShowItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ShowItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SettingsCreateResult"]: {
	__typename: "SettingsCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Settings"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SettingsDeleteResult"]: {
	__typename: "SettingsDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Settings"]
};
	["SettingsUpdateResult"]: {
	__typename: "SettingsUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Settings"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SettingsUpsertResult"]: {
	__typename: "SettingsUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Settings"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterGeneralContactCreateResult"]: {
	__typename: "FooterGeneralContactCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterGeneralContact"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterGeneralContactDeleteResult"]: {
	__typename: "FooterGeneralContactDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterGeneralContact"]
};
	["FooterGeneralContactUpdateResult"]: {
	__typename: "FooterGeneralContactUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterGeneralContact"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterGeneralContactUpsertResult"]: {
	__typename: "FooterGeneralContactUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterGeneralContact"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectCreateResult"]: {
	__typename: "RedirectCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectDeleteResult"]: {
	__typename: "RedirectDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"]
};
	["RedirectUpdateResult"]: {
	__typename: "RedirectUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectUpsertResult"]: {
	__typename: "RedirectUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
	__typename: "MutationTransaction",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	validation: GraphQLTypes["_ValidationResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createHomePage: GraphQLTypes["HomePageCreateResult"],
	deleteHomePage: GraphQLTypes["HomePageDeleteResult"],
	updateHomePage: GraphQLTypes["HomePageUpdateResult"],
	upsertHomePage: GraphQLTypes["HomePageUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createMediumGallery: GraphQLTypes["MediumGalleryCreateResult"],
	deleteMediumGallery: GraphQLTypes["MediumGalleryDeleteResult"],
	updateMediumGallery: GraphQLTypes["MediumGalleryUpdateResult"],
	upsertMediumGallery: GraphQLTypes["MediumGalleryUpsertResult"],
	createMediumGalleryItem: GraphQLTypes["MediumGalleryItemCreateResult"],
	deleteMediumGalleryItem: GraphQLTypes["MediumGalleryItemDeleteResult"],
	updateMediumGalleryItem: GraphQLTypes["MediumGalleryItemUpdateResult"],
	upsertMediumGalleryItem: GraphQLTypes["MediumGalleryItemUpsertResult"],
	createMember: GraphQLTypes["MemberCreateResult"],
	deleteMember: GraphQLTypes["MemberDeleteResult"],
	updateMember: GraphQLTypes["MemberUpdateResult"],
	upsertMember: GraphQLTypes["MemberUpsertResult"],
	createMemberItem: GraphQLTypes["MemberItemCreateResult"],
	deleteMemberItem: GraphQLTypes["MemberItemDeleteResult"],
	updateMemberItem: GraphQLTypes["MemberItemUpdateResult"],
	upsertMemberItem: GraphQLTypes["MemberItemUpsertResult"],
	createMemberList: GraphQLTypes["MemberListCreateResult"],
	deleteMemberList: GraphQLTypes["MemberListDeleteResult"],
	updateMemberList: GraphQLTypes["MemberListUpdateResult"],
	upsertMemberList: GraphQLTypes["MemberListUpsertResult"],
	createShow: GraphQLTypes["ShowCreateResult"],
	deleteShow: GraphQLTypes["ShowDeleteResult"],
	updateShow: GraphQLTypes["ShowUpdateResult"],
	upsertShow: GraphQLTypes["ShowUpsertResult"],
	createShowList: GraphQLTypes["ShowListCreateResult"],
	deleteShowList: GraphQLTypes["ShowListDeleteResult"],
	updateShowList: GraphQLTypes["ShowListUpdateResult"],
	upsertShowList: GraphQLTypes["ShowListUpsertResult"],
	createShowYear: GraphQLTypes["ShowYearCreateResult"],
	deleteShowYear: GraphQLTypes["ShowYearDeleteResult"],
	updateShowYear: GraphQLTypes["ShowYearUpdateResult"],
	upsertShowYear: GraphQLTypes["ShowYearUpsertResult"],
	createShowYearItem: GraphQLTypes["ShowYearItemCreateResult"],
	deleteShowYearItem: GraphQLTypes["ShowYearItemDeleteResult"],
	updateShowYearItem: GraphQLTypes["ShowYearItemUpdateResult"],
	upsertShowYearItem: GraphQLTypes["ShowYearItemUpsertResult"],
	createShowYearList: GraphQLTypes["ShowYearListCreateResult"],
	deleteShowYearList: GraphQLTypes["ShowYearListDeleteResult"],
	updateShowYearList: GraphQLTypes["ShowYearListUpdateResult"],
	upsertShowYearList: GraphQLTypes["ShowYearListUpsertResult"],
	createSocialLink: GraphQLTypes["SocialLinkCreateResult"],
	deleteSocialLink: GraphQLTypes["SocialLinkDeleteResult"],
	updateSocialLink: GraphQLTypes["SocialLinkUpdateResult"],
	upsertSocialLink: GraphQLTypes["SocialLinkUpsertResult"],
	createSocialLinkItem: GraphQLTypes["SocialLinkItemCreateResult"],
	deleteSocialLinkItem: GraphQLTypes["SocialLinkItemDeleteResult"],
	updateSocialLinkItem: GraphQLTypes["SocialLinkItemUpdateResult"],
	upsertSocialLinkItem: GraphQLTypes["SocialLinkItemUpsertResult"],
	createSocialLinkList: GraphQLTypes["SocialLinkListCreateResult"],
	deleteSocialLinkList: GraphQLTypes["SocialLinkListDeleteResult"],
	updateSocialLinkList: GraphQLTypes["SocialLinkListUpdateResult"],
	upsertSocialLinkList: GraphQLTypes["SocialLinkListUpsertResult"],
	createVideo: GraphQLTypes["VideoCreateResult"],
	deleteVideo: GraphQLTypes["VideoDeleteResult"],
	updateVideo: GraphQLTypes["VideoUpdateResult"],
	upsertVideo: GraphQLTypes["VideoUpsertResult"],
	createYoutubeVideo: GraphQLTypes["YoutubeVideoCreateResult"],
	deleteYoutubeVideo: GraphQLTypes["YoutubeVideoDeleteResult"],
	updateYoutubeVideo: GraphQLTypes["YoutubeVideoUpdateResult"],
	upsertYoutubeVideo: GraphQLTypes["YoutubeVideoUpsertResult"],
	createHeader: GraphQLTypes["HeaderCreateResult"],
	deleteHeader: GraphQLTypes["HeaderDeleteResult"],
	updateHeader: GraphQLTypes["HeaderUpdateResult"],
	upsertHeader: GraphQLTypes["HeaderUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createFooterAddress: GraphQLTypes["FooterAddressCreateResult"],
	deleteFooterAddress: GraphQLTypes["FooterAddressDeleteResult"],
	updateFooterAddress: GraphQLTypes["FooterAddressUpdateResult"],
	upsertFooterAddress: GraphQLTypes["FooterAddressUpsertResult"],
	createPortfolioPage: GraphQLTypes["PortfolioPageCreateResult"],
	deletePortfolioPage: GraphQLTypes["PortfolioPageDeleteResult"],
	updatePortfolioPage: GraphQLTypes["PortfolioPageUpdateResult"],
	upsertPortfolioPage: GraphQLTypes["PortfolioPageUpsertResult"],
	createShowItem: GraphQLTypes["ShowItemCreateResult"],
	deleteShowItem: GraphQLTypes["ShowItemDeleteResult"],
	updateShowItem: GraphQLTypes["ShowItemUpdateResult"],
	upsertShowItem: GraphQLTypes["ShowItemUpsertResult"],
	createSettings: GraphQLTypes["SettingsCreateResult"],
	deleteSettings: GraphQLTypes["SettingsDeleteResult"],
	updateSettings: GraphQLTypes["SettingsUpdateResult"],
	upsertSettings: GraphQLTypes["SettingsUpsertResult"],
	createFooterGeneralContact: GraphQLTypes["FooterGeneralContactCreateResult"],
	deleteFooterGeneralContact: GraphQLTypes["FooterGeneralContactDeleteResult"],
	updateFooterGeneralContact: GraphQLTypes["FooterGeneralContactUpdateResult"],
	upsertFooterGeneralContact: GraphQLTypes["FooterGeneralContactUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	query?: GraphQLTypes["Query"]
};
	["MutationTransactionOptions"]: {
		deferForeignKeyConstraints?: boolean
};
	["Json"]:any;
	["_Schema"]: {
	__typename: "_Schema",
	enums: Array<GraphQLTypes["_Enum"]>,
	entities: Array<GraphQLTypes["_Entity"]>
};
	["_Entity"]: {
	__typename: "_Entity",
	name: string,
	customPrimaryAllowed: boolean,
	fields: Array<GraphQLTypes["_Field"]>,
	unique: Array<GraphQLTypes["_UniqueConstraint"]>
};
	["_UniqueConstraint"]: {
	__typename: "_UniqueConstraint",
	fields: Array<string>
};
	["_Field"]: {
	__typename:"_Column" | "_Relation",
	name: string,
	type: string,
	nullable?: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
	['...on _Column']: '__union' & GraphQLTypes["_Column"];
	['...on _Relation']: '__union' & GraphQLTypes["_Relation"];
};
	["_Column"]: {
	__typename: "_Column",
	name: string,
	type: string,
	enumName?: string,
	defaultValue?: GraphQLTypes["Json"],
	nullable: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_OnDeleteBehaviour"]: _OnDeleteBehaviour;
	["_RelationSide"]: _RelationSide;
	["_OrderByDirection"]: _OrderByDirection;
	["_OrderBy"]: {
	__typename: "_OrderBy",
	path: Array<string>,
	direction: GraphQLTypes["_OrderByDirection"]
};
	["_Relation"]: {
	__typename: "_Relation",
	name: string,
	type: string,
	side: GraphQLTypes["_RelationSide"],
	targetEntity: string,
	ownedBy?: string,
	inversedBy?: string,
	nullable?: boolean,
	onDelete?: GraphQLTypes["_OnDeleteBehaviour"],
	orphanRemoval?: boolean,
	orderBy?: Array<GraphQLTypes["_OrderBy"]>,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_Rule"]: {
	__typename: "_Rule",
	message?: GraphQLTypes["_RuleMessage"],
	validator: number
};
	["_Validator"]: {
	__typename: "_Validator",
	operation: string,
	arguments: Array<GraphQLTypes["_Argument"]>
};
	["_Argument"]:{
	__typename:"_ValidatorArgument" | "_PathArgument" | "_LiteralArgument"
	['...on _ValidatorArgument']: '__union' & GraphQLTypes["_ValidatorArgument"];
	['...on _PathArgument']: '__union' & GraphQLTypes["_PathArgument"];
	['...on _LiteralArgument']: '__union' & GraphQLTypes["_LiteralArgument"];
};
	["_ValidatorArgument"]: {
	__typename: "_ValidatorArgument",
	validator: number
};
	["_PathArgument"]: {
	__typename: "_PathArgument",
	path: Array<string>
};
	["_LiteralArgument"]: {
	__typename: "_LiteralArgument",
	value?: GraphQLTypes["Json"]
};
	["_RuleMessage"]: {
	__typename: "_RuleMessage",
	text?: string
};
	["_Enum"]: {
	__typename: "_Enum",
	name: string,
	values: Array<string>
};
	["S3SignedUpload"]: {
	__typename: "S3SignedUpload",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string,
	publicUrl: string
};
	["S3Header"]: {
	__typename: "S3Header",
	key: string,
	value: string
};
	["S3SignedRead"]: {
	__typename: "S3SignedRead",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string
}
    }
export const enum ContentBlockType {
	coverVideo = "coverVideo",
	collaboration = "collaboration",
	members = "members",
	jumbotronWithLogos = "jumbotronWithLogos",
	portfolio = "portfolio",
	title = "title"
}
export const enum One {
	One = "One"
}
export const enum ShowPosterType {
	default = "default",
	vertical = "vertical",
	horizontal = "horizontal"
}
export const enum ShowPosterSizeType {
	default = "default",
	small = "small",
	big = "big"
}
export const enum MediumType {
	image = "image",
	video = "video"
}
export const enum LinkType {
	internal = "internal",
	external = "external"
}
export const enum OrderDirection {
	asc = "asc",
	desc = "desc",
	ascNullsFirst = "ascNullsFirst",
	descNullsLast = "descNullsLast"
}
export const enum _MutationErrorType {
	NotNullConstraintViolation = "NotNullConstraintViolation",
	UniqueConstraintViolation = "UniqueConstraintViolation",
	ForeignKeyConstraintViolation = "ForeignKeyConstraintViolation",
	NotFoundOrDenied = "NotFoundOrDenied",
	NonUniqueWhereInput = "NonUniqueWhereInput",
	InvalidDataInput = "InvalidDataInput",
	SqlError = "SqlError"
}
export const enum _OnDeleteBehaviour {
	restrict = "restrict",
	cascade = "cascade",
	setNull = "setNull"
}
export const enum _RelationSide {
	owning = "owning",
	inverse = "inverse"
}
export const enum _OrderByDirection {
	asc = "asc",
	desc = "desc"
}
export class GraphQLError extends Error {
    constructor(public response: GraphQLResponse) {
      super("");
      console.error(response);
    }
    override toString() {
      return "GraphQL Response Error";
    }
  }


export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<
  UnwrapPromise<ReturnType<T>>
>;
export type ZeusHook<
  T extends (
    ...args: any[]
  ) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>
> = ZeusState<ReturnType<T>[N]>;

type WithTypeNameValue<T> = T & {
  __typename?: true;
};
type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
type IsArray<T, U> = T extends Array<infer R> ? InputType<R, U>[] : InputType<T, U>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;

type IsInterfaced<SRC extends DeepAnify<DST>, DST> = FlattenArray<SRC> extends ZEUS_INTERFACES | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P]>
          : {}
        : never;
    }[keyof DST] &
      {
        [P in keyof Omit<
          Pick<
            SRC,
            {
              [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
            }[keyof DST]
          >,
          '__typename'
        >]: IsPayLoad<DST[P]> extends true ? SRC[P] : IsArray<SRC[P], DST[P]>;
      }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends true ? SRC[P] : IsArray<SRC[P], DST[P]>;
    };

export type MapType<SRC, DST> = SRC extends DeepAnify<DST> ? IsInterfaced<SRC, DST> : never;
export type InputType<SRC, DST> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P]>;
    } &
      MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>>
  : MapType<SRC, IsPayLoad<DST>>;
type Func<P extends any[], R> = (...args: P) => R;
type AnyFunc = Func<any, any>;
export type ArgsType<F extends AnyFunc> = F extends Func<infer P, any> ? P : never;
export type OperationOptions = {
  variables?: Record<string, any>;
  operationName?: string;
};
export type OperationToGraphQL<V, T> = <Z extends V>(o: Z | V, options?: OperationOptions) => Promise<InputType<T, Z>>;
export type SubscriptionToGraphQL<V, T> = <Z extends V>(
  o: Z | V,
  options?: OperationOptions,
) => {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z>; errors?:string[] }) => void) => void;
  open: () => void;
};
export type SelectionFunction<V> = <T>(t: T | V) => T;
export type fetchOptions = ArgsType<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (
  ...args: infer R
) => WebSocket
  ? R
  : never;
export type chainOptions =
  | [fetchOptions[0], fetchOptions[1] & {websocket?: websocketOptions}]
  | [fetchOptions[0]];
export type FetchFunction = (
  query: string,
  variables?: Record<string, any>,
) => Promise<any>;
export type SubscriptionFunction = (query: string) => void;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;



export const ZeusSelect = <T>() => ((t: any) => t) as SelectionFunction<T>;

export const ScalarResolver = (scalar: string, value: any) => {
  switch (scalar) {
    case 'String':
      return  `${JSON.stringify(value)}`;
    case 'Int':
      return `${value}`;
    case 'Float':
      return `${value}`;
    case 'Boolean':
      return `${value}`;
    case 'ID':
      return `"${value}"`;
    case 'enum':
      return `${value}`;
    case 'scalar':
      return `${value}`;
    default:
      return false;
  }
};


export const TypesPropsResolver = ({
    value,
    type,
    name,
    key,
    blockArrays
}: {
    value: any;
    type: string;
    name: string;
    key?: string;
    blockArrays?: boolean;
}): string => {
    if (value === null) {
        return `null`;
    }
    let resolvedValue = AllTypesProps[type][name];
    if (key) {
        resolvedValue = resolvedValue[key];
    }
    if (!resolvedValue) {
        throw new Error(`Cannot resolve ${type} ${name}${key ? ` ${key}` : ''}`)
    }
    const typeResolved = resolvedValue.type;
    const isArray = resolvedValue.array;
    const isArrayRequired = resolvedValue.arrayRequired;
    if (typeof value === 'string' && value.startsWith(`ZEUS_VAR$`)) {
        const isRequired = resolvedValue.required ? '!' : '';
        let t = `${typeResolved}`;
        if (isArray) {
          if (isRequired) {
              t = `${t}!`;
          }
          t = `[${t}]`;
          if(isArrayRequired){
            t = `${t}!`;
          }
        }else{
          if (isRequired) {
                t = `${t}!`;
          }
        }
        return `\$${value.split(`ZEUS_VAR$`)[1]}__ZEUS_VAR__${t}`;
    }
    if (isArray && !blockArrays) {
        return `[${value
        .map((v: any) => TypesPropsResolver({ value: v, type, name, key, blockArrays: true }))
        .join(',')}]`;
    }
    const reslovedScalar = ScalarResolver(typeResolved, value);
    if (!reslovedScalar) {
        const resolvedType = AllTypesProps[typeResolved];
        if (typeof resolvedType === 'object') {
        const argsKeys = Object.keys(resolvedType);
        return `{${argsKeys
            .filter((ak) => value[ak] !== undefined)
            .map(
            (ak) => `${ak}:${TypesPropsResolver({ value: value[ak], type: typeResolved, name: ak })}`
            )}}`;
        }
        return ScalarResolver(AllTypesProps[typeResolved], value) as string;
    }
    return reslovedScalar;
};


const isArrayFunction = (
  parent: string[],
  a: any[]
) => {
  const [values, r] = a;
  const [mainKey, key, ...keys] = parent;
  const keyValues = Object.keys(values).filter((k) => typeof values[k] !== 'undefined');

  if (!keys.length) {
      return keyValues.length > 0
        ? `(${keyValues
            .map(
              (v) =>
                `${v}:${TypesPropsResolver({
                  value: values[v],
                  type: mainKey,
                  name: key,
                  key: v
                })}`
            )
            .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
        : traverseToSeekArrays(parent, r);
    }

  const [typeResolverKey] = keys.splice(keys.length - 1, 1);
  let valueToResolve = ReturnTypes[mainKey][key];
  for (const k of keys) {
    valueToResolve = ReturnTypes[valueToResolve][k];
  }

  const argumentString =
    keyValues.length > 0
      ? `(${keyValues
          .map(
            (v) =>
              `${v}:${TypesPropsResolver({
                value: values[v],
                type: valueToResolve,
                name: typeResolverKey,
                key: v
              })}`
          )
          .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
      : traverseToSeekArrays(parent, r);
  return argumentString;
};


const resolveKV = (k: string, v: boolean | string | { [x: string]: boolean | string }) =>
  typeof v === 'boolean' ? k : typeof v === 'object' ? `${k}{${objectToTree(v)}}` : `${k}${v}`;


const objectToTree = (o: { [x: string]: boolean | string }): string =>
  `{${Object.keys(o).map((k) => `${resolveKV(k, o[k])}`).join(' ')}}`;


const traverseToSeekArrays = (parent: string[], a?: any): string => {
  if (!a) return '';
  if (Object.keys(a).length === 0) {
    return '';
  }
  let b: Record<string, any> = {};
  if (Array.isArray(a)) {
    return isArrayFunction([...parent], a);
  } else {
    if (typeof a === 'object') {
      Object.keys(a)
        .filter((k) => typeof a[k] !== 'undefined')
        .forEach((k) => {
        if (k === '__alias') {
          Object.keys(a[k]).forEach((aliasKey) => {
            const aliasOperations = a[k][aliasKey];
            const aliasOperationName = Object.keys(aliasOperations)[0];
            const aliasOperation = aliasOperations[aliasOperationName];
            b[
              `${aliasOperationName}__alias__${aliasKey}: ${aliasOperationName}`
            ] = traverseToSeekArrays([...parent, aliasOperationName], aliasOperation);
          });
        } else {
          b[k] = traverseToSeekArrays([...parent, k], a[k]);
        }
      });
    } else {
      return '';
    }
  }
  return objectToTree(b);
};  


const buildQuery = (type: string, a?: Record<any, any>) => 
  traverseToSeekArrays([type], a);


const inspectVariables = (query: string) => {
  const regex = /\$\b\w*__ZEUS_VAR__\[?[^!^\]^\s^,^\)^\}]*[!]?[\]]?[!]?/g;
  let result;
  const AllVariables: string[] = [];
  while ((result = regex.exec(query))) {
    if (AllVariables.includes(result[0])) {
      continue;
    }
    AllVariables.push(result[0]);
  }
  if (!AllVariables.length) {
    return query;
  }
  let filteredQuery = query;
  AllVariables.forEach((variable) => {
    while (filteredQuery.includes(variable)) {
      filteredQuery = filteredQuery.replace(variable, variable.split('__ZEUS_VAR__')[0]);
    }
  });
  return `(${AllVariables.map((a) => a.split('__ZEUS_VAR__'))
    .map(([variableName, variableType]) => `${variableName}:${variableType}`)
    .join(', ')})${filteredQuery}`;
};


export const queryConstruct = (t: 'query' | 'mutation' | 'subscription', tName: string, operationName?: string) => (o: Record<any, any>) =>
  `${t.toLowerCase()}${operationName ? ' ' + operationName : ''}${inspectVariables(buildQuery(tName, o))}`;
  

const fullChainConstruct = (fn: FetchFunction) => (t: 'query' | 'mutation' | 'subscription', tName: string) => (
  o: Record<any, any>,
  options?: OperationOptions,
) => fn(queryConstruct(t, tName, options?.operationName)(o), options?.variables).then((r:any) => { 
  seekForAliases(r)
  return r
});

export const fullChainConstructor = <F extends FetchFunction, R extends keyof ValueTypes>(
  fn: F,
  operation: 'query' | 'mutation' | 'subscription',
  key: R,
) =>
  ((o, options) => fullChainConstruct(fn)(operation, key)(o as any, options)) as OperationToGraphQL<
    ValueTypes[R],
    GraphQLTypes[R]
  >;


const fullSubscriptionConstruct = (fn: SubscriptionFunction) => (
  t: 'query' | 'mutation' | 'subscription',
  tName: string,
) => (o: Record<any, any>, options?: OperationOptions) =>
  fn(queryConstruct(t, tName, options?.operationName)(o));

export const fullSubscriptionConstructor = <F extends SubscriptionFunction, R extends keyof ValueTypes>(
  fn: F,
  operation: 'query' | 'mutation' | 'subscription',
  key: R,
) =>
  ((o, options) => fullSubscriptionConstruct(fn)(operation, key)(o as any, options)) as SubscriptionToGraphQL<
    ValueTypes[R],
    GraphQLTypes[R]
  >;


const seekForAliases = (response: any) => {
  const traverseAlias = (value: any) => {
    if (Array.isArray(value)) {
      value.forEach(seekForAliases);
    } else {
      if (typeof value === 'object') {
        seekForAliases(value);
      }
    }
  };
  if (typeof response === 'object' && response) {
    const keys = Object.keys(response);
    if (keys.length < 1) {
      return;
    }
    keys.forEach((k) => {
      const value = response[k];
      if (k.indexOf('__alias__') !== -1) {
        const [operation, alias] = k.split('__alias__');
        response[alias] = {
          [operation]: value,
        };
        delete response[k];
      }
      traverseAlias(value);
    });
  }
};


export const $ = (t: TemplateStringsArray): any => `ZEUS_VAR$${t.join('')}`;


export const resolverFor = <
  X,
  T extends keyof ValueTypes,
  Z extends keyof ValueTypes[T],
>(
  type: T,
  field: Z,
  fn: (
    args: Required<ValueTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : any,
) => fn as (args?: any,source?: any) => any;


const handleFetchResponse = (
  response: Parameters<Extract<Parameters<ReturnType<typeof fetch>['then']>[0], Function>>[0]
): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response.text().then(text => {
        try { reject(JSON.parse(text)); }
        catch (err) { reject(text); }
      }).catch(reject);
    });
  }
  return response.json();
};

export const apiFetch = (options: fetchOptions) => (query: string, variables: Record<string, any> = {}) => {
    let fetchFunction = fetch;
    let queryString = query;
    let fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      queryString = encodeURIComponent(query);
      return fetchFunction(`${options[0]}?query=${queryString}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetchFunction(`${options[0]}`, {
      body: JSON.stringify({ query: queryString, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      ...fetchOptions
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };
  

export const apiSubscription = (options: chainOptions) => (
    query: string,
  ) => {
    try {
      const queryString = options[0] + '?query=' + encodeURIComponent(query);
      const wsString = queryString.replace('http', 'ws');
      const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
      const webSocketOptions = options[1]?.websocket || [host];
      const ws = new WebSocket(...webSocketOptions);
      return {
        ws,
        on: (e: (args: any) => void) => {
          ws.onmessage = (event:any) => {
            if(event.data){
              const parsed = JSON.parse(event.data)
              const data = parsed.data
              if (data) {
                seekForAliases(data);
              }
              return e(data);
            }
          };
        },
        off: (e: (args: any) => void) => {
          ws.onclose = e;
        },
        error: (e: (args: any) => void) => {
          ws.onerror = e;
        },
        open: (e: () => void) => {
          ws.onopen = e;
        },
      };
    } catch {
      throw new Error('No websockets implemented');
    }
  };


export const Thunder = (fn: FetchFunction, subscriptionFn: SubscriptionFunction) => ({
  query: fullChainConstructor(fn,'query', 'Query'),
mutation: fullChainConstructor(fn,'mutation', 'Mutation')
});

export const Chain = (...options: chainOptions) => ({
  query: fullChainConstructor(apiFetch(options),'query', 'Query'),
mutation: fullChainConstructor(apiFetch(options),'mutation', 'Mutation')
});
export const Zeus = {
  query: (o:ValueTypes["Query"], operationName?: string) => queryConstruct('query', 'Query', operationName)(o),
mutation: (o:ValueTypes["Mutation"], operationName?: string) => queryConstruct('mutation', 'Mutation', operationName)(o)
};
export const Selectors = {
  query: ZeusSelect<ValueTypes["Query"]>(),
mutation: ZeusSelect<ValueTypes["Mutation"]>()
};
  
export type FragmentResult<K extends keyof GraphQLTypes, Q extends unknown | ((...args: any[]) => unknown)> = InputType<
	GraphQLTypes[K],
	Q extends (...args: any[]) => unknown ? ReturnType<Q> : Q
>